import type { RSYS, USYS } from '../../../../schema/system/entry.js';

type SystemLabels = RSYS | USYS;

export type SystemKeyTable = {
  guaranty?: number;
  numFullHedges: number;
  numHalfHedges: number;
  rows: readonly (readonly number[])[];
  systemType: 'R' | 'U';
  systemNum: number;
  hasXpert: boolean;
};

// // IMPORTANT NOTE: Some of these systems doesn't have an xpert because the API doesn't support them
// // because the xpertwager API receives the size of the system which conflicts with systems with equal sizes
export const systems: Record<SystemLabels, SystemKeyTable> = {
  'R0-11-16': {
    guaranty: 10,
    numFullHedges: 0,
    numHalfHedges: 11,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
      [0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1],
      [0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0],
      [1, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1],
      [1, 1, 0, 0, 1, 1, 1, 0, 1, 0, 0],
      [1, 1, 1, 1, 0, 0, 0, 1, 1, 0, 0],
      [1, 1, 1, 1, 0, 1, 1, 0, 0, 1, 1],
      [0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
      [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
      [0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0],
      [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1],
      [1, 0, 0, 1, 1, 0, 1, 1, 1, 1, 0],
      [1, 0, 0, 1, 1, 1, 0, 0, 0, 0, 1],
      [1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1],
      [1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0],
    ] as const,
    systemType: 'R',
    systemNum: 34,
    hasXpert: false,
  } as const,
  'R10-0-153': {
    guaranty: 10,
    numFullHedges: 10,
    numHalfHedges: 0,
    rows: [
      [2, 1, 1, 1, 0, 1, 2, 2, 2, 2],
      [2, 2, 2, 2, 2, 1, 2, 1, 2, 1],
      [2, 2, 2, 2, 2, 1, 0, 1, 0, 2],
      [1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
      [1, 2, 1, 1, 2, 1, 1, 0, 0, 1],
      [1, 2, 1, 1, 2, 1, 0, 1, 0, 2],
      [0, 1, 0, 2, 1, 0, 0, 1, 1, 1],
      [0, 0, 1, 0, 2, 0, 0, 0, 0, 0],
      [2, 1, 2, 1, 1, 0, 2, 2, 0, 2],
      [1, 0, 0, 0, 1, 1, 2, 1, 0, 2],
      [0, 2, 0, 1, 1, 1, 0, 0, 1, 0],
      [1, 1, 1, 2, 2, 0, 1, 0, 2, 2],
      [0, 1, 0, 2, 1, 0, 2, 1, 0, 0],
      [2, 0, 2, 0, 0, 2, 2, 1, 0, 0],
      [1, 1, 0, 0, 2, 2, 1, 0, 2, 1],
      [0, 1, 0, 2, 1, 0, 0, 0, 0, 2],
      [0, 1, 2, 2, 0, 1, 0, 2, 2, 2],
      [0, 0, 1, 0, 2, 0, 2, 0, 2, 2],
      [0, 2, 1, 0, 1, 2, 1, 2, 1, 0],
      [0, 1, 2, 2, 0, 1, 1, 1, 2, 1],
      [0, 1, 2, 2, 0, 1, 2, 2, 1, 1],
      [1, 0, 0, 0, 1, 1, 0, 1, 1, 0],
      [1, 2, 1, 1, 2, 1, 0, 0, 2, 0],
      [0, 0, 0, 1, 2, 2, 2, 0, 0, 1],
      [2, 2, 0, 2, 0, 0, 0, 1, 0, 0],
      [0, 2, 1, 0, 1, 2, 1, 1, 0, 1],
      [0, 1, 2, 2, 0, 1, 2, 1, 0, 2],
      [1, 2, 2, 1, 0, 0, 0, 2, 2, 1],
      [2, 2, 0, 2, 0, 0, 1, 1, 1, 1],
      [2, 1, 2, 1, 1, 0, 1, 2, 2, 1],
      [2, 2, 2, 2, 2, 1, 0, 0, 2, 0],
      [2, 2, 2, 2, 2, 1, 2, 2, 0, 0],
      [2, 2, 0, 2, 0, 0, 2, 0, 1, 0],
      [1, 0, 1, 2, 1, 2, 2, 1, 2, 0],
      [2, 1, 1, 1, 0, 1, 1, 1, 0, 2],
      [0, 0, 0, 1, 2, 2, 1, 1, 0, 2],
      [0, 0, 1, 0, 2, 0, 2, 1, 0, 1],
      [0, 0, 1, 0, 2, 0, 0, 2, 2, 1],
      [1, 1, 1, 2, 2, 0, 2, 0, 0, 0],
      [1, 0, 0, 0, 1, 1, 1, 0, 1, 2],
      [1, 1, 0, 0, 2, 2, 1, 1, 0, 0],
      [0, 1, 0, 2, 1, 0, 2, 2, 1, 2],
      [1, 2, 2, 1, 0, 0, 1, 1, 2, 0],
      [0, 2, 1, 0, 1, 2, 0, 0, 1, 1],
      [1, 0, 1, 2, 1, 2, 0, 2, 1, 0],
      [1, 1, 1, 2, 2, 0, 0, 0, 1, 1],
      [1, 2, 2, 1, 0, 0, 1, 0, 1, 1],
      [1, 0, 0, 0, 1, 1, 2, 0, 2, 0],
      [1, 2, 2, 1, 0, 0, 1, 2, 0, 2],
      [0, 1, 2, 2, 0, 1, 1, 0, 1, 2],
      [0, 0, 0, 1, 2, 2, 1, 2, 1, 1],
      [1, 0, 0, 0, 1, 1, 1, 2, 0, 0],
      [0, 0, 0, 1, 2, 2, 1, 0, 2, 0],
      [1, 1, 0, 0, 2, 2, 1, 2, 1, 2],
      [0, 0, 0, 1, 2, 2, 0, 2, 0, 0],
      [2, 1, 2, 1, 1, 0, 2, 0, 1, 1],
      [1, 2, 1, 1, 2, 1, 0, 2, 1, 1],
      [2, 2, 2, 2, 2, 1, 1, 1, 1, 0],
      [0, 0, 0, 1, 2, 2, 0, 1, 2, 1],
      [0, 1, 0, 2, 1, 0, 1, 2, 0, 1],
      [0, 2, 0, 1, 1, 1, 2, 2, 2, 0],
      [0, 2, 1, 0, 1, 2, 2, 1, 1, 2],
      [2, 1, 2, 1, 1, 0, 0, 2, 1, 0],
      [1, 2, 1, 1, 2, 1, 2, 2, 0, 0],
      [1, 0, 1, 2, 1, 2, 2, 2, 0, 2],
      [1, 1, 0, 0, 2, 2, 0, 1, 2, 2],
      [0, 2, 0, 1, 1, 1, 1, 2, 1, 2],
      [1, 1, 1, 2, 2, 0, 1, 1, 0, 1],
      [1, 1, 0, 0, 2, 2, 0, 0, 1, 0],
      [2, 2, 0, 2, 0, 0, 0, 2, 1, 2],
      [1, 1, 1, 2, 2, 0, 1, 2, 1, 0],
      [1, 2, 2, 1, 0, 0, 2, 1, 0, 1],
      [1, 0, 1, 2, 1, 2, 1, 0, 0, 0],
      [0, 2, 1, 0, 1, 2, 2, 0, 0, 0],
      [0, 2, 1, 0, 1, 2, 0, 1, 2, 0],
      [2, 1, 1, 1, 0, 1, 2, 1, 1, 0],
      [2, 1, 1, 1, 0, 1, 1, 0, 2, 0],
      [1, 0, 1, 2, 1, 2, 0, 1, 0, 1],
      [1, 0, 0, 0, 1, 1, 0, 0, 0, 1],
      [0, 0, 1, 0, 2, 0, 2, 2, 1, 0],
      [2, 1, 2, 1, 1, 0, 0, 0, 2, 2],
      [2, 0, 2, 0, 0, 2, 1, 2, 0, 1],
      [2, 0, 2, 0, 0, 2, 1, 1, 2, 2],
      [0, 0, 1, 0, 2, 0, 1, 0, 1, 1],
      [0, 0, 0, 1, 2, 2, 2, 1, 1, 0],
      [2, 0, 2, 0, 0, 2, 0, 0, 0, 2],
      [1, 1, 0, 0, 2, 2, 0, 2, 0, 1],
      [0, 2, 0, 1, 1, 1, 1, 1, 0, 0],
      [0, 1, 2, 2, 0, 1, 0, 1, 1, 0],
      [0, 1, 0, 2, 1, 0, 1, 1, 2, 2],
      [1, 2, 1, 1, 2, 1, 1, 1, 1, 0],
      [1, 1, 1, 2, 2, 0, 0, 2, 0, 2],
      [1, 1, 1, 2, 2, 0, 2, 1, 1, 2],
      [0, 2, 0, 1, 1, 1, 1, 0, 2, 1],
      [1, 0, 0, 0, 1, 1, 2, 2, 1, 1],
      [2, 2, 0, 2, 0, 0, 1, 0, 0, 2],
      [1, 0, 0, 0, 1, 1, 0, 2, 2, 2],
      [2, 1, 1, 1, 0, 1, 1, 2, 1, 1],
      [1, 2, 2, 1, 0, 0, 2, 2, 1, 0],
      [2, 0, 2, 0, 0, 2, 0, 1, 1, 1],
      [2, 2, 0, 2, 0, 0, 1, 2, 2, 0],
      [0, 1, 2, 2, 0, 1, 2, 0, 2, 0],
      [2, 1, 2, 1, 1, 0, 1, 1, 1, 2],
      [2, 1, 1, 1, 0, 1, 2, 0, 0, 1],
      [2, 2, 0, 2, 0, 0, 2, 1, 2, 2],
      [0, 1, 0, 2, 1, 0, 0, 2, 2, 0],
      [1, 2, 2, 1, 0, 0, 2, 0, 2, 2],
      [1, 0, 1, 2, 1, 2, 2, 0, 1, 1],
      [0, 0, 1, 0, 2, 0, 1, 2, 0, 2],
      [1, 2, 1, 1, 2, 1, 1, 2, 2, 2],
      [2, 1, 1, 1, 0, 1, 0, 2, 0, 0],
      [1, 0, 1, 2, 1, 2, 1, 2, 2, 1],
      [1, 0, 1, 2, 1, 2, 1, 1, 1, 2],
      [0, 2, 1, 0, 1, 2, 1, 0, 2, 2],
      [2, 2, 0, 2, 0, 0, 2, 2, 0, 1],
      [2, 2, 2, 2, 2, 1, 1, 2, 2, 2],
      [1, 1, 0, 0, 2, 2, 2, 1, 1, 1],
      [0, 1, 2, 2, 0, 1, 1, 2, 0, 0],
      [2, 1, 1, 1, 0, 1, 0, 0, 1, 2],
      [0, 2, 0, 1, 1, 1, 0, 1, 2, 2],
      [0, 2, 0, 1, 1, 1, 2, 1, 1, 1],
      [1, 1, 1, 2, 2, 0, 2, 2, 2, 1],
      [2, 0, 2, 0, 0, 2, 2, 2, 1, 2],
      [0, 1, 2, 2, 0, 1, 0, 0, 0, 1],
      [1, 0, 1, 2, 1, 2, 0, 0, 2, 2],
      [0, 2, 0, 1, 1, 1, 0, 2, 0, 1],
      [2, 2, 0, 2, 0, 0, 0, 0, 2, 1],
      [0, 2, 1, 0, 1, 2, 0, 2, 0, 2],
      [0, 2, 0, 1, 1, 1, 2, 0, 0, 2],
      [1, 1, 0, 0, 2, 2, 2, 0, 0, 2],
      [1, 2, 2, 1, 0, 0, 0, 1, 1, 2],
      [2, 2, 2, 2, 2, 1, 0, 2, 1, 1],
      [0, 0, 0, 1, 2, 2, 0, 0, 1, 2],
      [2, 0, 2, 0, 0, 2, 0, 2, 2, 0],
      [0, 0, 0, 1, 2, 2, 2, 2, 2, 2],
      [2, 2, 2, 2, 2, 1, 1, 0, 0, 1],
      [2, 1, 2, 1, 1, 0, 1, 0, 0, 0],
      [2, 2, 2, 2, 2, 1, 2, 0, 1, 2],
      [2, 1, 2, 1, 1, 0, 2, 1, 2, 0],
      [2, 0, 2, 0, 0, 2, 1, 0, 1, 0],
      [2, 1, 1, 1, 0, 1, 0, 1, 2, 1],
      [1, 1, 1, 2, 2, 0, 0, 1, 2, 0],
      [1, 2, 1, 1, 2, 1, 2, 1, 2, 1],
      [0, 1, 0, 2, 1, 0, 1, 0, 1, 0],
      [1, 1, 0, 0, 2, 2, 2, 2, 2, 0],
      [2, 0, 2, 0, 0, 2, 2, 0, 2, 1],
      [0, 0, 1, 0, 2, 0, 1, 1, 2, 0],
      [1, 0, 0, 0, 1, 1, 1, 1, 2, 1],
      [1, 2, 1, 1, 2, 1, 2, 0, 1, 2],
      [0, 0, 1, 0, 2, 0, 0, 1, 1, 2],
      [2, 1, 2, 1, 1, 0, 0, 1, 0, 1],
      [0, 2, 1, 0, 1, 2, 2, 2, 2, 1],
      [0, 1, 0, 2, 1, 0, 2, 0, 2, 1],
    ] as const,
    systemType: 'R',
    systemNum: 58,
    hasXpert: true,
  } as const,
  'R10-0-567': {
    guaranty: 11,
    numFullHedges: 10,
    numHalfHedges: 0,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 2, 2, 2],
      [0, 0, 0, 0, 0, 1, 2, 0, 0, 1],
      [0, 0, 0, 0, 0, 1, 2, 1, 1, 2],
      [0, 0, 0, 0, 0, 1, 2, 2, 2, 0],
      [0, 0, 0, 0, 0, 2, 1, 0, 0, 2],
      [0, 0, 0, 0, 0, 2, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 2, 1, 2, 2, 1],
      [0, 0, 0, 0, 1, 0, 1, 0, 0, 1],
      [0, 0, 0, 0, 1, 0, 1, 1, 1, 2],
      [0, 0, 0, 0, 1, 0, 1, 2, 2, 0],
      [0, 0, 0, 0, 1, 1, 2, 0, 1, 1],
      [0, 0, 0, 0, 1, 1, 2, 1, 2, 2],
      [0, 0, 0, 0, 1, 1, 2, 2, 0, 0],
      [0, 0, 0, 0, 2, 0, 2, 0, 0, 2],
      [0, 0, 0, 0, 2, 0, 2, 1, 1, 0],
      [0, 0, 0, 0, 2, 0, 2, 2, 2, 1],
      [0, 0, 0, 0, 2, 2, 1, 0, 1, 0],
      [0, 0, 0, 0, 2, 2, 1, 1, 2, 1],
      [0, 0, 0, 0, 2, 2, 1, 2, 0, 2],
      [0, 0, 0, 1, 0, 0, 2, 0, 2, 2],
      [0, 0, 0, 1, 0, 0, 2, 1, 0, 0],
      [0, 0, 0, 1, 0, 0, 2, 2, 1, 1],
      [0, 0, 0, 1, 0, 1, 0, 0, 2, 0],
      [0, 0, 0, 1, 0, 1, 0, 1, 0, 1],
      [0, 0, 0, 1, 0, 1, 0, 2, 1, 2],
      [0, 0, 0, 1, 1, 0, 2, 0, 2, 0],
      [0, 0, 0, 1, 1, 0, 2, 1, 0, 1],
      [0, 0, 0, 1, 1, 0, 2, 2, 1, 2],
      [0, 0, 0, 1, 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 1, 1, 1, 1, 2, 2, 2],
      [0, 0, 0, 1, 1, 2, 0, 0, 1, 0],
      [0, 0, 0, 1, 1, 2, 0, 1, 2, 1],
      [0, 0, 0, 1, 1, 2, 0, 2, 0, 2],
      [0, 0, 0, 1, 2, 1, 2, 0, 1, 0],
      [0, 0, 0, 1, 2, 1, 2, 1, 2, 1],
      [0, 0, 0, 1, 2, 1, 2, 2, 0, 2],
      [0, 0, 0, 1, 2, 2, 0, 0, 0, 2],
      [0, 0, 0, 1, 2, 2, 0, 1, 1, 0],
      [0, 0, 0, 1, 2, 2, 0, 2, 2, 1],
      [0, 0, 0, 2, 0, 0, 1, 0, 2, 0],
      [0, 0, 0, 2, 0, 0, 1, 1, 0, 1],
      [0, 0, 0, 2, 0, 0, 1, 2, 1, 2],
      [0, 0, 0, 2, 0, 2, 0, 0, 2, 2],
      [0, 0, 0, 2, 0, 2, 0, 1, 0, 0],
      [0, 0, 0, 2, 0, 2, 0, 2, 1, 1],
      [0, 0, 0, 2, 1, 1, 0, 0, 0, 1],
      [0, 0, 0, 2, 1, 1, 0, 1, 1, 2],
      [0, 0, 0, 2, 1, 1, 0, 2, 2, 0],
      [0, 0, 0, 2, 1, 2, 1, 0, 1, 1],
      [0, 0, 0, 2, 1, 2, 1, 1, 2, 2],
      [0, 0, 0, 2, 1, 2, 1, 2, 0, 0],
      [0, 0, 0, 2, 2, 0, 1, 0, 2, 2],
      [0, 0, 0, 2, 2, 0, 1, 1, 0, 0],
      [0, 0, 0, 2, 2, 0, 1, 2, 1, 1],
      [0, 0, 0, 2, 2, 1, 0, 0, 1, 1],
      [0, 0, 0, 2, 2, 1, 0, 1, 2, 2],
      [0, 0, 0, 2, 2, 1, 0, 2, 0, 0],
      [0, 0, 0, 2, 2, 2, 2, 0, 0, 0],
      [0, 0, 0, 2, 2, 2, 2, 1, 1, 1],
      [0, 0, 0, 2, 2, 2, 2, 2, 2, 2],
      [0, 1, 2, 0, 0, 0, 0, 0, 1, 2],
      [0, 1, 2, 0, 0, 0, 0, 1, 2, 0],
      [0, 1, 2, 0, 0, 0, 0, 2, 0, 1],
      [0, 1, 2, 0, 0, 1, 1, 0, 1, 0],
      [0, 1, 2, 0, 0, 1, 1, 1, 2, 1],
      [0, 1, 2, 0, 0, 1, 1, 2, 0, 2],
      [0, 1, 2, 0, 0, 2, 2, 0, 1, 1],
      [0, 1, 2, 0, 0, 2, 2, 1, 2, 2],
      [0, 1, 2, 0, 0, 2, 2, 2, 0, 0],
      [0, 1, 2, 0, 1, 2, 0, 0, 1, 0],
      [0, 1, 2, 0, 1, 2, 0, 1, 2, 1],
      [0, 1, 2, 0, 1, 2, 0, 2, 0, 2],
      [0, 1, 2, 0, 1, 2, 1, 0, 2, 0],
      [0, 1, 2, 0, 1, 2, 1, 1, 0, 1],
      [0, 1, 2, 0, 1, 2, 1, 2, 1, 2],
      [0, 1, 2, 0, 2, 1, 0, 0, 1, 1],
      [0, 1, 2, 0, 2, 1, 0, 1, 2, 2],
      [0, 1, 2, 0, 2, 1, 0, 2, 0, 0],
      [0, 1, 2, 0, 2, 1, 2, 0, 2, 2],
      [0, 1, 2, 0, 2, 1, 2, 1, 0, 0],
      [0, 1, 2, 0, 2, 1, 2, 2, 1, 1],
      [0, 1, 2, 1, 0, 2, 0, 0, 0, 1],
      [0, 1, 2, 1, 0, 2, 0, 1, 1, 2],
      [0, 1, 2, 1, 0, 2, 0, 2, 2, 0],
      [0, 1, 2, 1, 0, 2, 1, 0, 0, 2],
      [0, 1, 2, 1, 0, 2, 1, 1, 1, 0],
      [0, 1, 2, 1, 0, 2, 1, 2, 2, 1],
      [0, 1, 2, 1, 1, 0, 0, 0, 0, 2],
      [0, 1, 2, 1, 1, 0, 0, 1, 1, 0],
      [0, 1, 2, 1, 1, 0, 0, 2, 2, 1],
      [0, 1, 2, 1, 1, 1, 1, 0, 1, 2],
      [0, 1, 2, 1, 1, 1, 1, 1, 2, 0],
      [0, 1, 2, 1, 1, 1, 1, 2, 0, 1],
      [0, 1, 2, 1, 1, 2, 2, 0, 2, 2],
      [0, 1, 2, 1, 1, 2, 2, 1, 0, 0],
      [0, 1, 2, 1, 1, 2, 2, 2, 1, 1],
      [0, 1, 2, 1, 2, 0, 1, 0, 2, 2],
      [0, 1, 2, 1, 2, 0, 1, 1, 0, 0],
      [0, 1, 2, 1, 2, 0, 1, 2, 1, 1],
      [0, 1, 2, 1, 2, 0, 2, 0, 1, 1],
      [0, 1, 2, 1, 2, 0, 2, 1, 2, 2],
      [0, 1, 2, 1, 2, 0, 2, 2, 0, 0],
      [0, 1, 2, 2, 0, 1, 0, 0, 0, 2],
      [0, 1, 2, 2, 0, 1, 0, 1, 1, 0],
      [0, 1, 2, 2, 0, 1, 0, 2, 2, 1],
      [0, 1, 2, 2, 0, 1, 2, 0, 0, 1],
      [0, 1, 2, 2, 0, 1, 2, 1, 1, 2],
      [0, 1, 2, 2, 0, 1, 2, 2, 2, 0],
      [0, 1, 2, 2, 1, 0, 1, 0, 1, 0],
      [0, 1, 2, 2, 1, 0, 1, 1, 2, 1],
      [0, 1, 2, 2, 1, 0, 1, 2, 0, 2],
      [0, 1, 2, 2, 1, 0, 2, 0, 2, 0],
      [0, 1, 2, 2, 1, 0, 2, 1, 0, 1],
      [0, 1, 2, 2, 1, 0, 2, 2, 1, 2],
      [0, 1, 2, 2, 2, 0, 0, 0, 0, 1],
      [0, 1, 2, 2, 2, 0, 0, 1, 1, 2],
      [0, 1, 2, 2, 2, 0, 0, 2, 2, 0],
      [0, 1, 2, 2, 2, 1, 1, 0, 2, 0],
      [0, 1, 2, 2, 2, 1, 1, 1, 0, 1],
      [0, 1, 2, 2, 2, 1, 1, 2, 1, 2],
      [0, 1, 2, 2, 2, 2, 2, 0, 1, 2],
      [0, 1, 2, 2, 2, 2, 2, 1, 2, 0],
      [0, 1, 2, 2, 2, 2, 2, 2, 0, 1],
      [0, 2, 1, 0, 0, 0, 0, 0, 2, 1],
      [0, 2, 1, 0, 0, 0, 0, 1, 0, 2],
      [0, 2, 1, 0, 0, 0, 0, 2, 1, 0],
      [0, 2, 1, 0, 1, 0, 2, 0, 2, 0],
      [0, 2, 1, 0, 1, 0, 2, 1, 0, 1],
      [0, 2, 1, 0, 1, 0, 2, 2, 1, 2],
      [0, 2, 1, 0, 1, 1, 0, 0, 2, 2],
      [0, 2, 1, 0, 1, 1, 0, 1, 0, 0],
      [0, 2, 1, 0, 1, 1, 0, 2, 1, 1],
      [0, 2, 1, 0, 1, 2, 2, 0, 0, 1],
      [0, 2, 1, 0, 1, 2, 2, 1, 1, 2],
      [0, 2, 1, 0, 1, 2, 2, 2, 2, 0],
      [0, 2, 1, 0, 2, 0, 1, 0, 2, 2],
      [0, 2, 1, 0, 2, 0, 1, 1, 0, 0],
      [0, 2, 1, 0, 2, 0, 1, 2, 1, 1],
      [0, 2, 1, 0, 2, 1, 1, 0, 0, 2],
      [0, 2, 1, 0, 2, 1, 1, 1, 1, 0],
      [0, 2, 1, 0, 2, 1, 1, 2, 2, 1],
      [0, 2, 1, 0, 2, 2, 0, 0, 2, 0],
      [0, 2, 1, 0, 2, 2, 0, 1, 0, 1],
      [0, 2, 1, 0, 2, 2, 0, 2, 1, 2],
      [0, 2, 1, 1, 0, 0, 1, 0, 1, 1],
      [0, 2, 1, 1, 0, 0, 1, 1, 2, 2],
      [0, 2, 1, 1, 0, 0, 1, 2, 0, 0],
      [0, 2, 1, 1, 0, 1, 2, 0, 0, 1],
      [0, 2, 1, 1, 0, 1, 2, 1, 1, 2],
      [0, 2, 1, 1, 0, 1, 2, 2, 2, 0],
      [0, 2, 1, 1, 0, 2, 2, 0, 2, 0],
      [0, 2, 1, 1, 0, 2, 2, 1, 0, 1],
      [0, 2, 1, 1, 0, 2, 2, 2, 1, 2],
      [0, 2, 1, 1, 1, 1, 1, 0, 2, 1],
      [0, 2, 1, 1, 1, 1, 1, 1, 0, 2],
      [0, 2, 1, 1, 1, 1, 1, 2, 1, 0],
      [0, 2, 1, 1, 2, 0, 0, 0, 1, 0],
      [0, 2, 1, 1, 2, 0, 0, 1, 2, 1],
      [0, 2, 1, 1, 2, 0, 0, 2, 0, 2],
      [0, 2, 1, 1, 2, 1, 0, 0, 1, 1],
      [0, 2, 1, 1, 2, 1, 0, 1, 2, 2],
      [0, 2, 1, 1, 2, 1, 0, 2, 0, 0],
      [0, 2, 1, 1, 2, 2, 1, 0, 0, 1],
      [0, 2, 1, 1, 2, 2, 1, 1, 1, 2],
      [0, 2, 1, 1, 2, 2, 1, 2, 2, 0],
      [0, 2, 1, 2, 0, 0, 2, 0, 1, 0],
      [0, 2, 1, 2, 0, 0, 2, 1, 2, 1],
      [0, 2, 1, 2, 0, 0, 2, 2, 0, 2],
      [0, 2, 1, 2, 0, 1, 1, 0, 2, 2],
      [0, 2, 1, 2, 0, 1, 1, 1, 0, 0],
      [0, 2, 1, 2, 0, 1, 1, 2, 1, 1],
      [0, 2, 1, 2, 0, 2, 1, 0, 0, 2],
      [0, 2, 1, 2, 0, 2, 1, 1, 1, 0],
      [0, 2, 1, 2, 0, 2, 1, 2, 2, 1],
      [0, 2, 1, 2, 1, 0, 0, 0, 1, 1],
      [0, 2, 1, 2, 1, 0, 0, 1, 2, 2],
      [0, 2, 1, 2, 1, 0, 0, 2, 0, 0],
      [0, 2, 1, 2, 1, 1, 2, 0, 0, 2],
      [0, 2, 1, 2, 1, 1, 2, 1, 1, 0],
      [0, 2, 1, 2, 1, 1, 2, 2, 2, 1],
      [0, 2, 1, 2, 1, 2, 0, 0, 1, 0],
      [0, 2, 1, 2, 1, 2, 0, 1, 2, 1],
      [0, 2, 1, 2, 1, 2, 0, 2, 0, 2],
      [0, 2, 1, 2, 2, 2, 2, 0, 2, 1],
      [0, 2, 1, 2, 2, 2, 2, 1, 0, 2],
      [0, 2, 1, 2, 2, 2, 2, 2, 1, 0],
      [1, 0, 2, 0, 0, 0, 0, 0, 2, 1],
      [1, 0, 2, 0, 0, 0, 0, 1, 0, 2],
      [1, 0, 2, 0, 0, 0, 0, 2, 1, 0],
      [1, 0, 2, 0, 1, 0, 2, 0, 2, 0],
      [1, 0, 2, 0, 1, 0, 2, 1, 0, 1],
      [1, 0, 2, 0, 1, 0, 2, 2, 1, 2],
      [1, 0, 2, 0, 1, 1, 0, 0, 2, 2],
      [1, 0, 2, 0, 1, 1, 0, 1, 0, 0],
      [1, 0, 2, 0, 1, 1, 0, 2, 1, 1],
      [1, 0, 2, 0, 1, 2, 2, 0, 0, 1],
      [1, 0, 2, 0, 1, 2, 2, 1, 1, 2],
      [1, 0, 2, 0, 1, 2, 2, 2, 2, 0],
      [1, 0, 2, 0, 2, 0, 1, 0, 2, 2],
      [1, 0, 2, 0, 2, 0, 1, 1, 0, 0],
      [1, 0, 2, 0, 2, 0, 1, 2, 1, 1],
      [1, 0, 2, 0, 2, 1, 1, 0, 0, 2],
      [1, 0, 2, 0, 2, 1, 1, 1, 1, 0],
      [1, 0, 2, 0, 2, 1, 1, 2, 2, 1],
      [1, 0, 2, 0, 2, 2, 0, 0, 2, 0],
      [1, 0, 2, 0, 2, 2, 0, 1, 0, 1],
      [1, 0, 2, 0, 2, 2, 0, 2, 1, 2],
      [1, 0, 2, 1, 0, 0, 1, 0, 1, 1],
      [1, 0, 2, 1, 0, 0, 1, 1, 2, 2],
      [1, 0, 2, 1, 0, 0, 1, 2, 0, 0],
      [1, 0, 2, 1, 0, 1, 2, 0, 0, 1],
      [1, 0, 2, 1, 0, 1, 2, 1, 1, 2],
      [1, 0, 2, 1, 0, 1, 2, 2, 2, 0],
      [1, 0, 2, 1, 0, 2, 2, 0, 2, 0],
      [1, 0, 2, 1, 0, 2, 2, 1, 0, 1],
      [1, 0, 2, 1, 0, 2, 2, 2, 1, 2],
      [1, 0, 2, 1, 1, 1, 1, 0, 2, 1],
      [1, 0, 2, 1, 1, 1, 1, 1, 0, 2],
      [1, 0, 2, 1, 1, 1, 1, 2, 1, 0],
      [1, 0, 2, 1, 2, 0, 0, 0, 1, 0],
      [1, 0, 2, 1, 2, 0, 0, 1, 2, 1],
      [1, 0, 2, 1, 2, 0, 0, 2, 0, 2],
      [1, 0, 2, 1, 2, 1, 0, 0, 1, 1],
      [1, 0, 2, 1, 2, 1, 0, 1, 2, 2],
      [1, 0, 2, 1, 2, 1, 0, 2, 0, 0],
      [1, 0, 2, 1, 2, 2, 1, 0, 0, 1],
      [1, 0, 2, 1, 2, 2, 1, 1, 1, 2],
      [1, 0, 2, 1, 2, 2, 1, 2, 2, 0],
      [1, 0, 2, 2, 0, 0, 2, 0, 1, 0],
      [1, 0, 2, 2, 0, 0, 2, 1, 2, 1],
      [1, 0, 2, 2, 0, 0, 2, 2, 0, 2],
      [1, 0, 2, 2, 0, 1, 1, 0, 2, 2],
      [1, 0, 2, 2, 0, 1, 1, 1, 0, 0],
      [1, 0, 2, 2, 0, 1, 1, 2, 1, 1],
      [1, 0, 2, 2, 0, 2, 1, 0, 0, 2],
      [1, 0, 2, 2, 0, 2, 1, 1, 1, 0],
      [1, 0, 2, 2, 0, 2, 1, 2, 2, 1],
      [1, 0, 2, 2, 1, 0, 0, 0, 1, 1],
      [1, 0, 2, 2, 1, 0, 0, 1, 2, 2],
      [1, 0, 2, 2, 1, 0, 0, 2, 0, 0],
      [1, 0, 2, 2, 1, 1, 2, 0, 0, 2],
      [1, 0, 2, 2, 1, 1, 2, 1, 1, 0],
      [1, 0, 2, 2, 1, 1, 2, 2, 2, 1],
      [1, 0, 2, 2, 1, 2, 0, 0, 1, 0],
      [1, 0, 2, 2, 1, 2, 0, 1, 2, 1],
      [1, 0, 2, 2, 1, 2, 0, 2, 0, 2],
      [1, 0, 2, 2, 2, 2, 2, 0, 2, 1],
      [1, 0, 2, 2, 2, 2, 2, 1, 0, 2],
      [1, 0, 2, 2, 2, 2, 2, 2, 1, 0],
      [1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 1, 1, 1],
      [1, 1, 1, 0, 0, 0, 0, 2, 2, 2],
      [1, 1, 1, 0, 0, 1, 2, 0, 0, 1],
      [1, 1, 1, 0, 0, 1, 2, 1, 1, 2],
      [1, 1, 1, 0, 0, 1, 2, 2, 2, 0],
      [1, 1, 1, 0, 0, 2, 1, 0, 0, 2],
      [1, 1, 1, 0, 0, 2, 1, 1, 1, 0],
      [1, 1, 1, 0, 0, 2, 1, 2, 2, 1],
      [1, 1, 1, 0, 1, 0, 1, 0, 0, 1],
      [1, 1, 1, 0, 1, 0, 1, 1, 1, 2],
      [1, 1, 1, 0, 1, 0, 1, 2, 2, 0],
      [1, 1, 1, 0, 1, 1, 2, 0, 1, 1],
      [1, 1, 1, 0, 1, 1, 2, 1, 2, 2],
      [1, 1, 1, 0, 1, 1, 2, 2, 0, 0],
      [1, 1, 1, 0, 2, 0, 2, 0, 0, 2],
      [1, 1, 1, 0, 2, 0, 2, 1, 1, 0],
      [1, 1, 1, 0, 2, 0, 2, 2, 2, 1],
      [1, 1, 1, 0, 2, 2, 1, 0, 1, 0],
      [1, 1, 1, 0, 2, 2, 1, 1, 2, 1],
      [1, 1, 1, 0, 2, 2, 1, 2, 0, 2],
      [1, 1, 1, 1, 0, 0, 2, 0, 2, 2],
      [1, 1, 1, 1, 0, 0, 2, 1, 0, 0],
      [1, 1, 1, 1, 0, 0, 2, 2, 1, 1],
      [1, 1, 1, 1, 0, 1, 0, 0, 2, 0],
      [1, 1, 1, 1, 0, 1, 0, 1, 0, 1],
      [1, 1, 1, 1, 0, 1, 0, 2, 1, 2],
      [1, 1, 1, 1, 1, 0, 2, 0, 2, 0],
      [1, 1, 1, 1, 1, 0, 2, 1, 0, 1],
      [1, 1, 1, 1, 1, 0, 2, 2, 1, 2],
      [1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 2, 2, 2],
      [1, 1, 1, 1, 1, 2, 0, 0, 1, 0],
      [1, 1, 1, 1, 1, 2, 0, 1, 2, 1],
      [1, 1, 1, 1, 1, 2, 0, 2, 0, 2],
      [1, 1, 1, 1, 2, 1, 2, 0, 1, 0],
      [1, 1, 1, 1, 2, 1, 2, 1, 2, 1],
      [1, 1, 1, 1, 2, 1, 2, 2, 0, 2],
      [1, 1, 1, 1, 2, 2, 0, 0, 0, 2],
      [1, 1, 1, 1, 2, 2, 0, 1, 1, 0],
      [1, 1, 1, 1, 2, 2, 0, 2, 2, 1],
      [1, 1, 1, 2, 0, 0, 1, 0, 2, 0],
      [1, 1, 1, 2, 0, 0, 1, 1, 0, 1],
      [1, 1, 1, 2, 0, 0, 1, 2, 1, 2],
      [1, 1, 1, 2, 0, 2, 0, 0, 2, 2],
      [1, 1, 1, 2, 0, 2, 0, 1, 0, 0],
      [1, 1, 1, 2, 0, 2, 0, 2, 1, 1],
      [1, 1, 1, 2, 1, 1, 0, 0, 0, 1],
      [1, 1, 1, 2, 1, 1, 0, 1, 1, 2],
      [1, 1, 1, 2, 1, 1, 0, 2, 2, 0],
      [1, 1, 1, 2, 1, 2, 1, 0, 1, 1],
      [1, 1, 1, 2, 1, 2, 1, 1, 2, 2],
      [1, 1, 1, 2, 1, 2, 1, 2, 0, 0],
      [1, 1, 1, 2, 2, 0, 1, 0, 2, 2],
      [1, 1, 1, 2, 2, 0, 1, 1, 0, 0],
      [1, 1, 1, 2, 2, 0, 1, 2, 1, 1],
      [1, 1, 1, 2, 2, 1, 0, 0, 1, 1],
      [1, 1, 1, 2, 2, 1, 0, 1, 2, 2],
      [1, 1, 1, 2, 2, 1, 0, 2, 0, 0],
      [1, 1, 1, 2, 2, 2, 2, 0, 0, 0],
      [1, 1, 1, 2, 2, 2, 2, 1, 1, 1],
      [1, 1, 1, 2, 2, 2, 2, 2, 2, 2],
      [1, 2, 0, 0, 0, 0, 0, 0, 1, 2],
      [1, 2, 0, 0, 0, 0, 0, 1, 2, 0],
      [1, 2, 0, 0, 0, 0, 0, 2, 0, 1],
      [1, 2, 0, 0, 0, 1, 1, 0, 1, 0],
      [1, 2, 0, 0, 0, 1, 1, 1, 2, 1],
      [1, 2, 0, 0, 0, 1, 1, 2, 0, 2],
      [1, 2, 0, 0, 0, 2, 2, 0, 1, 1],
      [1, 2, 0, 0, 0, 2, 2, 1, 2, 2],
      [1, 2, 0, 0, 0, 2, 2, 2, 0, 0],
      [1, 2, 0, 0, 1, 2, 0, 0, 1, 0],
      [1, 2, 0, 0, 1, 2, 0, 1, 2, 1],
      [1, 2, 0, 0, 1, 2, 0, 2, 0, 2],
      [1, 2, 0, 0, 1, 2, 1, 0, 2, 0],
      [1, 2, 0, 0, 1, 2, 1, 1, 0, 1],
      [1, 2, 0, 0, 1, 2, 1, 2, 1, 2],
      [1, 2, 0, 0, 2, 1, 0, 0, 1, 1],
      [1, 2, 0, 0, 2, 1, 0, 1, 2, 2],
      [1, 2, 0, 0, 2, 1, 0, 2, 0, 0],
      [1, 2, 0, 0, 2, 1, 2, 0, 2, 2],
      [1, 2, 0, 0, 2, 1, 2, 1, 0, 0],
      [1, 2, 0, 0, 2, 1, 2, 2, 1, 1],
      [1, 2, 0, 1, 0, 2, 0, 0, 0, 1],
      [1, 2, 0, 1, 0, 2, 0, 1, 1, 2],
      [1, 2, 0, 1, 0, 2, 0, 2, 2, 0],
      [1, 2, 0, 1, 0, 2, 1, 0, 0, 2],
      [1, 2, 0, 1, 0, 2, 1, 1, 1, 0],
      [1, 2, 0, 1, 0, 2, 1, 2, 2, 1],
      [1, 2, 0, 1, 1, 0, 0, 0, 0, 2],
      [1, 2, 0, 1, 1, 0, 0, 1, 1, 0],
      [1, 2, 0, 1, 1, 0, 0, 2, 2, 1],
      [1, 2, 0, 1, 1, 1, 1, 0, 1, 2],
      [1, 2, 0, 1, 1, 1, 1, 1, 2, 0],
      [1, 2, 0, 1, 1, 1, 1, 2, 0, 1],
      [1, 2, 0, 1, 1, 2, 2, 0, 2, 2],
      [1, 2, 0, 1, 1, 2, 2, 1, 0, 0],
      [1, 2, 0, 1, 1, 2, 2, 2, 1, 1],
      [1, 2, 0, 1, 2, 0, 1, 0, 2, 2],
      [1, 2, 0, 1, 2, 0, 1, 1, 0, 0],
      [1, 2, 0, 1, 2, 0, 1, 2, 1, 1],
      [1, 2, 0, 1, 2, 0, 2, 0, 1, 1],
      [1, 2, 0, 1, 2, 0, 2, 1, 2, 2],
      [1, 2, 0, 1, 2, 0, 2, 2, 0, 0],
      [1, 2, 0, 2, 0, 1, 0, 0, 0, 2],
      [1, 2, 0, 2, 0, 1, 0, 1, 1, 0],
      [1, 2, 0, 2, 0, 1, 0, 2, 2, 1],
      [1, 2, 0, 2, 0, 1, 2, 0, 0, 1],
      [1, 2, 0, 2, 0, 1, 2, 1, 1, 2],
      [1, 2, 0, 2, 0, 1, 2, 2, 2, 0],
      [1, 2, 0, 2, 1, 0, 1, 0, 1, 0],
      [1, 2, 0, 2, 1, 0, 1, 1, 2, 1],
      [1, 2, 0, 2, 1, 0, 1, 2, 0, 2],
      [1, 2, 0, 2, 1, 0, 2, 0, 2, 0],
      [1, 2, 0, 2, 1, 0, 2, 1, 0, 1],
      [1, 2, 0, 2, 1, 0, 2, 2, 1, 2],
      [1, 2, 0, 2, 2, 0, 0, 0, 0, 1],
      [1, 2, 0, 2, 2, 0, 0, 1, 1, 2],
      [1, 2, 0, 2, 2, 0, 0, 2, 2, 0],
      [1, 2, 0, 2, 2, 1, 1, 0, 2, 0],
      [1, 2, 0, 2, 2, 1, 1, 1, 0, 1],
      [1, 2, 0, 2, 2, 1, 1, 2, 1, 2],
      [1, 2, 0, 2, 2, 2, 2, 0, 1, 2],
      [1, 2, 0, 2, 2, 2, 2, 1, 2, 0],
      [1, 2, 0, 2, 2, 2, 2, 2, 0, 1],
      [2, 0, 1, 0, 0, 0, 0, 0, 1, 2],
      [2, 0, 1, 0, 0, 0, 0, 1, 2, 0],
      [2, 0, 1, 0, 0, 0, 0, 2, 0, 1],
      [2, 0, 1, 0, 0, 1, 1, 0, 1, 0],
      [2, 0, 1, 0, 0, 1, 1, 1, 2, 1],
      [2, 0, 1, 0, 0, 1, 1, 2, 0, 2],
      [2, 0, 1, 0, 0, 2, 2, 0, 1, 1],
      [2, 0, 1, 0, 0, 2, 2, 1, 2, 2],
      [2, 0, 1, 0, 0, 2, 2, 2, 0, 0],
      [2, 0, 1, 0, 1, 2, 0, 0, 1, 0],
      [2, 0, 1, 0, 1, 2, 0, 1, 2, 1],
      [2, 0, 1, 0, 1, 2, 0, 2, 0, 2],
      [2, 0, 1, 0, 1, 2, 1, 0, 2, 0],
      [2, 0, 1, 0, 1, 2, 1, 1, 0, 1],
      [2, 0, 1, 0, 1, 2, 1, 2, 1, 2],
      [2, 0, 1, 0, 2, 1, 0, 0, 1, 1],
      [2, 0, 1, 0, 2, 1, 0, 1, 2, 2],
      [2, 0, 1, 0, 2, 1, 0, 2, 0, 0],
      [2, 0, 1, 0, 2, 1, 2, 0, 2, 2],
      [2, 0, 1, 0, 2, 1, 2, 1, 0, 0],
      [2, 0, 1, 0, 2, 1, 2, 2, 1, 1],
      [2, 0, 1, 1, 0, 2, 0, 0, 0, 1],
      [2, 0, 1, 1, 0, 2, 0, 1, 1, 2],
      [2, 0, 1, 1, 0, 2, 0, 2, 2, 0],
      [2, 0, 1, 1, 0, 2, 1, 0, 0, 2],
      [2, 0, 1, 1, 0, 2, 1, 1, 1, 0],
      [2, 0, 1, 1, 0, 2, 1, 2, 2, 1],
      [2, 0, 1, 1, 1, 0, 0, 0, 0, 2],
      [2, 0, 1, 1, 1, 0, 0, 1, 1, 0],
      [2, 0, 1, 1, 1, 0, 0, 2, 2, 1],
      [2, 0, 1, 1, 1, 1, 1, 0, 1, 2],
      [2, 0, 1, 1, 1, 1, 1, 1, 2, 0],
      [2, 0, 1, 1, 1, 1, 1, 2, 0, 1],
      [2, 0, 1, 1, 1, 2, 2, 0, 2, 2],
      [2, 0, 1, 1, 1, 2, 2, 1, 0, 0],
      [2, 0, 1, 1, 1, 2, 2, 2, 1, 1],
      [2, 0, 1, 1, 2, 0, 1, 0, 2, 2],
      [2, 0, 1, 1, 2, 0, 1, 1, 0, 0],
      [2, 0, 1, 1, 2, 0, 1, 2, 1, 1],
      [2, 0, 1, 1, 2, 0, 2, 0, 1, 1],
      [2, 0, 1, 1, 2, 0, 2, 1, 2, 2],
      [2, 0, 1, 1, 2, 0, 2, 2, 0, 0],
      [2, 0, 1, 2, 0, 1, 0, 0, 0, 2],
      [2, 0, 1, 2, 0, 1, 0, 1, 1, 0],
      [2, 0, 1, 2, 0, 1, 0, 2, 2, 1],
      [2, 0, 1, 2, 0, 1, 2, 0, 0, 1],
      [2, 0, 1, 2, 0, 1, 2, 1, 1, 2],
      [2, 0, 1, 2, 0, 1, 2, 2, 2, 0],
      [2, 0, 1, 2, 1, 0, 1, 0, 1, 0],
      [2, 0, 1, 2, 1, 0, 1, 1, 2, 1],
      [2, 0, 1, 2, 1, 0, 1, 2, 0, 2],
      [2, 0, 1, 2, 1, 0, 2, 0, 2, 0],
      [2, 0, 1, 2, 1, 0, 2, 1, 0, 1],
      [2, 0, 1, 2, 1, 0, 2, 2, 1, 2],
      [2, 0, 1, 2, 2, 0, 0, 0, 0, 1],
      [2, 0, 1, 2, 2, 0, 0, 1, 1, 2],
      [2, 0, 1, 2, 2, 0, 0, 2, 2, 0],
      [2, 0, 1, 2, 2, 1, 1, 0, 2, 0],
      [2, 0, 1, 2, 2, 1, 1, 1, 0, 1],
      [2, 0, 1, 2, 2, 1, 1, 2, 1, 2],
      [2, 0, 1, 2, 2, 2, 2, 0, 1, 2],
      [2, 0, 1, 2, 2, 2, 2, 1, 2, 0],
      [2, 0, 1, 2, 2, 2, 2, 2, 0, 1],
      [2, 1, 0, 0, 0, 0, 0, 0, 2, 1],
      [2, 1, 0, 0, 0, 0, 0, 1, 0, 2],
      [2, 1, 0, 0, 0, 0, 0, 2, 1, 0],
      [2, 1, 0, 0, 1, 0, 2, 0, 2, 0],
      [2, 1, 0, 0, 1, 0, 2, 1, 0, 1],
      [2, 1, 0, 0, 1, 0, 2, 2, 1, 2],
      [2, 1, 0, 0, 1, 1, 0, 0, 2, 2],
      [2, 1, 0, 0, 1, 1, 0, 1, 0, 0],
      [2, 1, 0, 0, 1, 1, 0, 2, 1, 1],
      [2, 1, 0, 0, 1, 2, 2, 0, 0, 1],
      [2, 1, 0, 0, 1, 2, 2, 1, 1, 2],
      [2, 1, 0, 0, 1, 2, 2, 2, 2, 0],
      [2, 1, 0, 0, 2, 0, 1, 0, 2, 2],
      [2, 1, 0, 0, 2, 0, 1, 1, 0, 0],
      [2, 1, 0, 0, 2, 0, 1, 2, 1, 1],
      [2, 1, 0, 0, 2, 1, 1, 0, 0, 2],
      [2, 1, 0, 0, 2, 1, 1, 1, 1, 0],
      [2, 1, 0, 0, 2, 1, 1, 2, 2, 1],
      [2, 1, 0, 0, 2, 2, 0, 0, 2, 0],
      [2, 1, 0, 0, 2, 2, 0, 1, 0, 1],
      [2, 1, 0, 0, 2, 2, 0, 2, 1, 2],
      [2, 1, 0, 1, 0, 0, 1, 0, 1, 1],
      [2, 1, 0, 1, 0, 0, 1, 1, 2, 2],
      [2, 1, 0, 1, 0, 0, 1, 2, 0, 0],
      [2, 1, 0, 1, 0, 1, 2, 0, 0, 1],
      [2, 1, 0, 1, 0, 1, 2, 1, 1, 2],
      [2, 1, 0, 1, 0, 1, 2, 2, 2, 0],
      [2, 1, 0, 1, 0, 2, 2, 0, 2, 0],
      [2, 1, 0, 1, 0, 2, 2, 1, 0, 1],
      [2, 1, 0, 1, 0, 2, 2, 2, 1, 2],
      [2, 1, 0, 1, 1, 1, 1, 0, 2, 1],
      [2, 1, 0, 1, 1, 1, 1, 1, 0, 2],
      [2, 1, 0, 1, 1, 1, 1, 2, 1, 0],
      [2, 1, 0, 1, 2, 0, 0, 0, 1, 0],
      [2, 1, 0, 1, 2, 0, 0, 1, 2, 1],
      [2, 1, 0, 1, 2, 0, 0, 2, 0, 2],
      [2, 1, 0, 1, 2, 1, 0, 0, 1, 1],
      [2, 1, 0, 1, 2, 1, 0, 1, 2, 2],
      [2, 1, 0, 1, 2, 1, 0, 2, 0, 0],
      [2, 1, 0, 1, 2, 2, 1, 0, 0, 1],
      [2, 1, 0, 1, 2, 2, 1, 1, 1, 2],
      [2, 1, 0, 1, 2, 2, 1, 2, 2, 0],
      [2, 1, 0, 2, 0, 0, 2, 0, 1, 0],
      [2, 1, 0, 2, 0, 0, 2, 1, 2, 1],
      [2, 1, 0, 2, 0, 0, 2, 2, 0, 2],
      [2, 1, 0, 2, 0, 1, 1, 0, 2, 2],
      [2, 1, 0, 2, 0, 1, 1, 1, 0, 0],
      [2, 1, 0, 2, 0, 1, 1, 2, 1, 1],
      [2, 1, 0, 2, 0, 2, 1, 0, 0, 2],
      [2, 1, 0, 2, 0, 2, 1, 1, 1, 0],
      [2, 1, 0, 2, 0, 2, 1, 2, 2, 1],
      [2, 1, 0, 2, 1, 0, 0, 0, 1, 1],
      [2, 1, 0, 2, 1, 0, 0, 1, 2, 2],
      [2, 1, 0, 2, 1, 0, 0, 2, 0, 0],
      [2, 1, 0, 2, 1, 1, 2, 0, 0, 2],
      [2, 1, 0, 2, 1, 1, 2, 1, 1, 0],
      [2, 1, 0, 2, 1, 1, 2, 2, 2, 1],
      [2, 1, 0, 2, 1, 2, 0, 0, 1, 0],
      [2, 1, 0, 2, 1, 2, 0, 1, 2, 1],
      [2, 1, 0, 2, 1, 2, 0, 2, 0, 2],
      [2, 1, 0, 2, 2, 2, 2, 0, 2, 1],
      [2, 1, 0, 2, 2, 2, 2, 1, 0, 2],
      [2, 1, 0, 2, 2, 2, 2, 2, 1, 0],
      [2, 2, 2, 0, 0, 0, 0, 0, 0, 0],
      [2, 2, 2, 0, 0, 0, 0, 1, 1, 1],
      [2, 2, 2, 0, 0, 0, 0, 2, 2, 2],
      [2, 2, 2, 0, 0, 1, 2, 0, 0, 1],
      [2, 2, 2, 0, 0, 1, 2, 1, 1, 2],
      [2, 2, 2, 0, 0, 1, 2, 2, 2, 0],
      [2, 2, 2, 0, 0, 2, 1, 0, 0, 2],
      [2, 2, 2, 0, 0, 2, 1, 1, 1, 0],
      [2, 2, 2, 0, 0, 2, 1, 2, 2, 1],
      [2, 2, 2, 0, 1, 0, 1, 0, 0, 1],
      [2, 2, 2, 0, 1, 0, 1, 1, 1, 2],
      [2, 2, 2, 0, 1, 0, 1, 2, 2, 0],
      [2, 2, 2, 0, 1, 1, 2, 0, 1, 1],
      [2, 2, 2, 0, 1, 1, 2, 1, 2, 2],
      [2, 2, 2, 0, 1, 1, 2, 2, 0, 0],
      [2, 2, 2, 0, 2, 0, 2, 0, 0, 2],
      [2, 2, 2, 0, 2, 0, 2, 1, 1, 0],
      [2, 2, 2, 0, 2, 0, 2, 2, 2, 1],
      [2, 2, 2, 0, 2, 2, 1, 0, 1, 0],
      [2, 2, 2, 0, 2, 2, 1, 1, 2, 1],
      [2, 2, 2, 0, 2, 2, 1, 2, 0, 2],
      [2, 2, 2, 1, 0, 0, 2, 0, 2, 2],
      [2, 2, 2, 1, 0, 0, 2, 1, 0, 0],
      [2, 2, 2, 1, 0, 0, 2, 2, 1, 1],
      [2, 2, 2, 1, 0, 1, 0, 0, 2, 0],
      [2, 2, 2, 1, 0, 1, 0, 1, 0, 1],
      [2, 2, 2, 1, 0, 1, 0, 2, 1, 2],
      [2, 2, 2, 1, 1, 0, 2, 0, 2, 0],
      [2, 2, 2, 1, 1, 0, 2, 1, 0, 1],
      [2, 2, 2, 1, 1, 0, 2, 2, 1, 2],
      [2, 2, 2, 1, 1, 1, 1, 0, 0, 0],
      [2, 2, 2, 1, 1, 1, 1, 1, 1, 1],
      [2, 2, 2, 1, 1, 1, 1, 2, 2, 2],
      [2, 2, 2, 1, 1, 2, 0, 0, 1, 0],
      [2, 2, 2, 1, 1, 2, 0, 1, 2, 1],
      [2, 2, 2, 1, 1, 2, 0, 2, 0, 2],
      [2, 2, 2, 1, 2, 1, 2, 0, 1, 0],
      [2, 2, 2, 1, 2, 1, 2, 1, 2, 1],
      [2, 2, 2, 1, 2, 1, 2, 2, 0, 2],
      [2, 2, 2, 1, 2, 2, 0, 0, 0, 2],
      [2, 2, 2, 1, 2, 2, 0, 1, 1, 0],
      [2, 2, 2, 1, 2, 2, 0, 2, 2, 1],
      [2, 2, 2, 2, 0, 0, 1, 0, 2, 0],
      [2, 2, 2, 2, 0, 0, 1, 1, 0, 1],
      [2, 2, 2, 2, 0, 0, 1, 2, 1, 2],
      [2, 2, 2, 2, 0, 2, 0, 0, 2, 2],
      [2, 2, 2, 2, 0, 2, 0, 1, 0, 0],
      [2, 2, 2, 2, 0, 2, 0, 2, 1, 1],
      [2, 2, 2, 2, 1, 1, 0, 0, 0, 1],
      [2, 2, 2, 2, 1, 1, 0, 1, 1, 2],
      [2, 2, 2, 2, 1, 1, 0, 2, 2, 0],
      [2, 2, 2, 2, 1, 2, 1, 0, 1, 1],
      [2, 2, 2, 2, 1, 2, 1, 1, 2, 2],
      [2, 2, 2, 2, 1, 2, 1, 2, 0, 0],
      [2, 2, 2, 2, 2, 0, 1, 0, 2, 2],
      [2, 2, 2, 2, 2, 0, 1, 1, 0, 0],
      [2, 2, 2, 2, 2, 0, 1, 2, 1, 1],
      [2, 2, 2, 2, 2, 1, 0, 0, 1, 1],
      [2, 2, 2, 2, 2, 1, 0, 1, 2, 2],
      [2, 2, 2, 2, 2, 1, 0, 2, 0, 0],
      [2, 2, 2, 2, 2, 2, 2, 0, 0, 0],
      [2, 2, 2, 2, 2, 2, 2, 1, 1, 1],
      [2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    ] as const,
    systemType: 'R',
    systemNum: 31,
    hasXpert: true,
  } as const,
  'R11-0-729': {
    guaranty: 11,
    numFullHedges: 11,
    numHalfHedges: 0,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2],
      [0, 0, 0, 0, 1, 0, 1, 2, 2, 1, 0],
      [0, 0, 0, 0, 1, 1, 2, 0, 0, 2, 1],
      [0, 0, 0, 0, 1, 2, 0, 1, 1, 0, 2],
      [0, 0, 0, 0, 2, 0, 2, 1, 1, 2, 0],
      [0, 0, 0, 0, 2, 1, 0, 2, 2, 0, 1],
      [0, 0, 0, 0, 2, 2, 1, 0, 0, 1, 2],
      [0, 0, 0, 1, 0, 0, 2, 2, 1, 0, 1],
      [0, 0, 0, 1, 0, 1, 0, 0, 2, 1, 2],
      [0, 0, 0, 1, 0, 2, 1, 1, 0, 2, 0],
      [0, 0, 0, 1, 1, 0, 0, 1, 0, 1, 1],
      [0, 0, 0, 1, 1, 1, 1, 2, 1, 2, 2],
      [0, 0, 0, 1, 1, 2, 2, 0, 2, 0, 0],
      [0, 0, 0, 1, 2, 0, 1, 0, 2, 2, 1],
      [0, 0, 0, 1, 2, 1, 2, 1, 0, 0, 2],
      [0, 0, 0, 1, 2, 2, 0, 2, 1, 1, 0],
      [0, 0, 0, 2, 0, 0, 1, 1, 2, 0, 2],
      [0, 0, 0, 2, 0, 1, 2, 2, 0, 1, 0],
      [0, 0, 0, 2, 0, 2, 0, 0, 1, 2, 1],
      [0, 0, 0, 2, 1, 0, 2, 0, 1, 1, 2],
      [0, 0, 0, 2, 1, 1, 0, 1, 2, 2, 0],
      [0, 0, 0, 2, 1, 2, 1, 2, 0, 0, 1],
      [0, 0, 0, 2, 2, 0, 0, 2, 0, 2, 2],
      [0, 0, 0, 2, 2, 1, 1, 0, 1, 0, 0],
      [0, 0, 0, 2, 2, 2, 2, 1, 2, 1, 1],
      [0, 0, 1, 0, 0, 0, 0, 1, 2, 2, 1],
      [0, 0, 1, 0, 0, 1, 1, 2, 0, 0, 2],
      [0, 0, 1, 0, 0, 2, 2, 0, 1, 1, 0],
      [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
      [0, 0, 1, 0, 1, 1, 2, 1, 2, 1, 2],
      [0, 0, 1, 0, 1, 2, 0, 2, 0, 2, 0],
      [0, 0, 1, 0, 2, 0, 2, 2, 0, 1, 1],
      [0, 0, 1, 0, 2, 1, 0, 0, 1, 2, 2],
      [0, 0, 1, 0, 2, 2, 1, 1, 2, 0, 0],
      [0, 0, 1, 1, 0, 0, 2, 0, 0, 2, 2],
      [0, 0, 1, 1, 0, 1, 0, 1, 1, 0, 0],
      [0, 0, 1, 1, 0, 2, 1, 2, 2, 1, 1],
      [0, 0, 1, 1, 1, 0, 0, 2, 2, 0, 2],
      [0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 0],
      [0, 0, 1, 1, 1, 2, 2, 1, 1, 2, 1],
      [0, 0, 1, 1, 2, 0, 1, 1, 1, 1, 2],
      [0, 0, 1, 1, 2, 1, 2, 2, 2, 2, 0],
      [0, 0, 1, 1, 2, 2, 0, 0, 0, 0, 1],
      [0, 0, 1, 2, 0, 0, 1, 2, 1, 2, 0],
      [0, 0, 1, 2, 0, 1, 2, 0, 2, 0, 1],
      [0, 0, 1, 2, 0, 2, 0, 1, 0, 1, 2],
      [0, 0, 1, 2, 1, 0, 2, 1, 0, 0, 0],
      [0, 0, 1, 2, 1, 1, 0, 2, 1, 1, 1],
      [0, 0, 1, 2, 1, 2, 1, 0, 2, 2, 2],
      [0, 0, 1, 2, 2, 0, 0, 0, 2, 1, 0],
      [0, 0, 1, 2, 2, 1, 1, 1, 0, 2, 1],
      [0, 0, 1, 2, 2, 2, 2, 2, 1, 0, 2],
      [0, 0, 2, 0, 0, 0, 0, 2, 1, 1, 2],
      [0, 0, 2, 0, 0, 1, 1, 0, 2, 2, 0],
      [0, 0, 2, 0, 0, 2, 2, 1, 0, 0, 1],
      [0, 0, 2, 0, 1, 0, 1, 1, 0, 2, 2],
      [0, 0, 2, 0, 1, 1, 2, 2, 1, 0, 0],
      [0, 0, 2, 0, 1, 2, 0, 0, 2, 1, 1],
      [0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2],
      [0, 0, 2, 0, 2, 1, 0, 1, 0, 1, 0],
      [0, 0, 2, 0, 2, 2, 1, 2, 1, 2, 1],
      [0, 0, 2, 1, 0, 0, 2, 1, 2, 1, 0],
      [0, 0, 2, 1, 0, 1, 0, 2, 0, 2, 1],
      [0, 0, 2, 1, 0, 2, 1, 0, 1, 0, 2],
      [0, 0, 2, 1, 1, 0, 0, 0, 1, 2, 0],
      [0, 0, 2, 1, 1, 1, 1, 1, 2, 0, 1],
      [0, 0, 2, 1, 1, 2, 2, 2, 0, 1, 2],
      [0, 0, 2, 1, 2, 0, 1, 2, 0, 0, 0],
      [0, 0, 2, 1, 2, 1, 2, 0, 1, 1, 1],
      [0, 0, 2, 1, 2, 2, 0, 1, 2, 2, 2],
      [0, 0, 2, 2, 0, 0, 1, 0, 0, 1, 1],
      [0, 0, 2, 2, 0, 1, 2, 1, 1, 2, 2],
      [0, 0, 2, 2, 0, 2, 0, 2, 2, 0, 0],
      [0, 0, 2, 2, 1, 0, 2, 2, 2, 2, 1],
      [0, 0, 2, 2, 1, 1, 0, 0, 0, 0, 2],
      [0, 0, 2, 2, 1, 2, 1, 1, 1, 1, 0],
      [0, 0, 2, 2, 2, 0, 0, 1, 1, 0, 1],
      [0, 0, 2, 2, 2, 1, 1, 2, 2, 1, 2],
      [0, 0, 2, 2, 2, 2, 2, 0, 0, 2, 0],
      [0, 1, 0, 0, 0, 0, 1, 2, 0, 2, 1],
      [0, 1, 0, 0, 0, 1, 2, 0, 1, 0, 2],
      [0, 1, 0, 0, 0, 2, 0, 1, 2, 1, 0],
      [0, 1, 0, 0, 1, 0, 2, 1, 2, 0, 1],
      [0, 1, 0, 0, 1, 1, 0, 2, 0, 1, 2],
      [0, 1, 0, 0, 1, 2, 1, 0, 1, 2, 0],
      [0, 1, 0, 0, 2, 0, 0, 0, 1, 1, 1],
      [0, 1, 0, 0, 2, 1, 1, 1, 2, 2, 2],
      [0, 1, 0, 0, 2, 2, 2, 2, 0, 0, 0],
      [0, 1, 0, 1, 0, 0, 0, 1, 1, 2, 2],
      [0, 1, 0, 1, 0, 1, 1, 2, 2, 0, 0],
      [0, 1, 0, 1, 0, 2, 2, 0, 0, 1, 1],
      [0, 1, 0, 1, 1, 0, 1, 0, 0, 0, 2],
      [0, 1, 0, 1, 1, 1, 2, 1, 1, 1, 0],
      [0, 1, 0, 1, 1, 2, 0, 2, 2, 2, 1],
      [0, 1, 0, 1, 2, 0, 2, 2, 2, 1, 2],
      [0, 1, 0, 1, 2, 1, 0, 0, 0, 2, 0],
      [0, 1, 0, 1, 2, 2, 1, 1, 1, 0, 1],
      [0, 1, 0, 2, 0, 0, 2, 0, 2, 2, 0],
      [0, 1, 0, 2, 0, 1, 0, 1, 0, 0, 1],
      [0, 1, 0, 2, 0, 2, 1, 2, 1, 1, 2],
      [0, 1, 0, 2, 1, 0, 0, 2, 1, 0, 0],
      [0, 1, 0, 2, 1, 1, 1, 0, 2, 1, 1],
      [0, 1, 0, 2, 1, 2, 2, 1, 0, 2, 2],
      [0, 1, 0, 2, 2, 0, 1, 1, 0, 1, 0],
      [0, 1, 0, 2, 2, 1, 2, 2, 1, 2, 1],
      [0, 1, 0, 2, 2, 2, 0, 0, 2, 0, 2],
      [0, 1, 1, 0, 0, 0, 1, 0, 2, 1, 2],
      [0, 1, 1, 0, 0, 1, 2, 1, 0, 2, 0],
      [0, 1, 1, 0, 0, 2, 0, 2, 1, 0, 1],
      [0, 1, 1, 0, 1, 0, 2, 2, 1, 2, 2],
      [0, 1, 1, 0, 1, 1, 0, 0, 2, 0, 0],
      [0, 1, 1, 0, 1, 2, 1, 1, 0, 1, 1],
      [0, 1, 1, 0, 2, 0, 0, 1, 0, 0, 2],
      [0, 1, 1, 0, 2, 1, 1, 2, 1, 1, 0],
      [0, 1, 1, 0, 2, 2, 2, 0, 2, 2, 1],
      [0, 1, 1, 1, 0, 0, 0, 2, 0, 1, 0],
      [0, 1, 1, 1, 0, 1, 1, 0, 1, 2, 1],
      [0, 1, 1, 1, 0, 2, 2, 1, 2, 0, 2],
      [0, 1, 1, 1, 1, 0, 1, 1, 2, 2, 0],
      [0, 1, 1, 1, 1, 1, 2, 2, 0, 0, 1],
      [0, 1, 1, 1, 1, 2, 0, 0, 1, 1, 2],
      [0, 1, 1, 1, 2, 0, 2, 0, 1, 0, 0],
      [0, 1, 1, 1, 2, 1, 0, 1, 2, 1, 1],
      [0, 1, 1, 1, 2, 2, 1, 2, 0, 2, 2],
      [0, 1, 1, 2, 0, 0, 2, 1, 1, 1, 1],
      [0, 1, 1, 2, 0, 1, 0, 2, 2, 2, 2],
      [0, 1, 1, 2, 0, 2, 1, 0, 0, 0, 0],
      [0, 1, 1, 2, 1, 0, 0, 0, 0, 2, 1],
      [0, 1, 1, 2, 1, 1, 1, 1, 1, 0, 2],
      [0, 1, 1, 2, 1, 2, 2, 2, 2, 1, 0],
      [0, 1, 1, 2, 2, 0, 1, 2, 2, 0, 1],
      [0, 1, 1, 2, 2, 1, 2, 0, 0, 1, 2],
      [0, 1, 1, 2, 2, 2, 0, 1, 1, 2, 0],
      [0, 1, 2, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 1, 2, 0, 0, 1, 2, 2, 2, 1, 1],
      [0, 1, 2, 0, 0, 2, 0, 0, 0, 2, 2],
      [0, 1, 2, 0, 1, 0, 2, 0, 0, 1, 0],
      [0, 1, 2, 0, 1, 1, 0, 1, 1, 2, 1],
      [0, 1, 2, 0, 1, 2, 1, 2, 2, 0, 2],
      [0, 1, 2, 0, 2, 0, 0, 2, 2, 2, 0],
      [0, 1, 2, 0, 2, 1, 1, 0, 0, 0, 1],
      [0, 1, 2, 0, 2, 2, 2, 1, 1, 1, 2],
      [0, 1, 2, 1, 0, 0, 0, 0, 2, 0, 1],
      [0, 1, 2, 1, 0, 1, 1, 1, 0, 1, 2],
      [0, 1, 2, 1, 0, 2, 2, 2, 1, 2, 0],
      [0, 1, 2, 1, 1, 0, 1, 2, 1, 1, 1],
      [0, 1, 2, 1, 1, 1, 2, 0, 2, 2, 2],
      [0, 1, 2, 1, 1, 2, 0, 1, 0, 0, 0],
      [0, 1, 2, 1, 2, 0, 2, 1, 0, 2, 1],
      [0, 1, 2, 1, 2, 1, 0, 2, 1, 0, 2],
      [0, 1, 2, 1, 2, 2, 1, 0, 2, 1, 0],
      [0, 1, 2, 2, 0, 0, 2, 2, 0, 0, 2],
      [0, 1, 2, 2, 0, 1, 0, 0, 1, 1, 0],
      [0, 1, 2, 2, 0, 2, 1, 1, 2, 2, 1],
      [0, 1, 2, 2, 1, 0, 0, 1, 2, 1, 2],
      [0, 1, 2, 2, 1, 1, 1, 2, 0, 2, 0],
      [0, 1, 2, 2, 1, 2, 2, 0, 1, 0, 1],
      [0, 1, 2, 2, 2, 0, 1, 0, 1, 2, 2],
      [0, 1, 2, 2, 2, 1, 2, 1, 2, 0, 0],
      [0, 1, 2, 2, 2, 2, 0, 2, 0, 1, 1],
      [0, 2, 0, 0, 0, 0, 2, 1, 0, 1, 2],
      [0, 2, 0, 0, 0, 1, 0, 2, 1, 2, 0],
      [0, 2, 0, 0, 0, 2, 1, 0, 2, 0, 1],
      [0, 2, 0, 0, 1, 0, 0, 0, 2, 2, 2],
      [0, 2, 0, 0, 1, 1, 1, 1, 0, 0, 0],
      [0, 2, 0, 0, 1, 2, 2, 2, 1, 1, 1],
      [0, 2, 0, 0, 2, 0, 1, 2, 1, 0, 2],
      [0, 2, 0, 0, 2, 1, 2, 0, 2, 1, 0],
      [0, 2, 0, 0, 2, 2, 0, 1, 0, 2, 1],
      [0, 2, 0, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 2, 0, 1, 0, 1, 2, 1, 2, 2, 1],
      [0, 2, 0, 1, 0, 2, 0, 2, 0, 0, 2],
      [0, 2, 0, 1, 1, 0, 2, 2, 0, 2, 0],
      [0, 2, 0, 1, 1, 1, 0, 0, 1, 0, 1],
      [0, 2, 0, 1, 1, 2, 1, 1, 2, 1, 2],
      [0, 2, 0, 1, 2, 0, 0, 1, 2, 0, 0],
      [0, 2, 0, 1, 2, 1, 1, 2, 0, 1, 1],
      [0, 2, 0, 1, 2, 2, 2, 0, 1, 2, 2],
      [0, 2, 0, 2, 0, 0, 0, 2, 2, 1, 1],
      [0, 2, 0, 2, 0, 1, 1, 0, 0, 2, 2],
      [0, 2, 0, 2, 0, 2, 2, 1, 1, 0, 0],
      [0, 2, 0, 2, 1, 0, 1, 1, 1, 2, 1],
      [0, 2, 0, 2, 1, 1, 2, 2, 2, 0, 2],
      [0, 2, 0, 2, 1, 2, 0, 0, 0, 1, 0],
      [0, 2, 0, 2, 2, 0, 2, 0, 0, 0, 1],
      [0, 2, 0, 2, 2, 1, 0, 1, 1, 1, 2],
      [0, 2, 0, 2, 2, 2, 1, 2, 2, 2, 0],
      [0, 2, 1, 0, 0, 0, 2, 2, 2, 0, 0],
      [0, 2, 1, 0, 0, 1, 0, 0, 0, 1, 1],
      [0, 2, 1, 0, 0, 2, 1, 1, 1, 2, 2],
      [0, 2, 1, 0, 1, 0, 0, 1, 1, 1, 0],
      [0, 2, 1, 0, 1, 1, 1, 2, 2, 2, 1],
      [0, 2, 1, 0, 1, 2, 2, 0, 0, 0, 2],
      [0, 2, 1, 0, 2, 0, 1, 0, 0, 2, 0],
      [0, 2, 1, 0, 2, 1, 2, 1, 1, 0, 1],
      [0, 2, 1, 0, 2, 2, 0, 2, 2, 1, 2],
      [0, 2, 1, 1, 0, 0, 1, 1, 0, 0, 1],
      [0, 2, 1, 1, 0, 1, 2, 2, 1, 1, 2],
      [0, 2, 1, 1, 0, 2, 0, 0, 2, 2, 0],
      [0, 2, 1, 1, 1, 0, 2, 0, 2, 1, 1],
      [0, 2, 1, 1, 1, 1, 0, 1, 0, 2, 2],
      [0, 2, 1, 1, 1, 2, 1, 2, 1, 0, 0],
      [0, 2, 1, 1, 2, 0, 0, 2, 1, 2, 1],
      [0, 2, 1, 1, 2, 1, 1, 0, 2, 0, 2],
      [0, 2, 1, 1, 2, 2, 2, 1, 0, 1, 0],
      [0, 2, 1, 2, 0, 0, 0, 0, 1, 0, 2],
      [0, 2, 1, 2, 0, 1, 1, 1, 2, 1, 0],
      [0, 2, 1, 2, 0, 2, 2, 2, 0, 2, 1],
      [0, 2, 1, 2, 1, 0, 1, 2, 0, 1, 2],
      [0, 2, 1, 2, 1, 1, 2, 0, 1, 2, 0],
      [0, 2, 1, 2, 1, 2, 0, 1, 2, 0, 1],
      [0, 2, 1, 2, 2, 0, 2, 1, 2, 2, 2],
      [0, 2, 1, 2, 2, 1, 0, 2, 0, 0, 0],
      [0, 2, 1, 2, 2, 2, 1, 0, 1, 1, 1],
      [0, 2, 2, 0, 0, 0, 2, 0, 1, 2, 1],
      [0, 2, 2, 0, 0, 1, 0, 1, 2, 0, 2],
      [0, 2, 2, 0, 0, 2, 1, 2, 0, 1, 0],
      [0, 2, 2, 0, 1, 0, 0, 2, 0, 0, 1],
      [0, 2, 2, 0, 1, 1, 1, 0, 1, 1, 2],
      [0, 2, 2, 0, 1, 2, 2, 1, 2, 2, 0],
      [0, 2, 2, 0, 2, 0, 1, 1, 2, 1, 1],
      [0, 2, 2, 0, 2, 1, 2, 2, 0, 2, 2],
      [0, 2, 2, 0, 2, 2, 0, 0, 1, 0, 0],
      [0, 2, 2, 1, 0, 0, 1, 2, 2, 2, 2],
      [0, 2, 2, 1, 0, 1, 2, 0, 0, 0, 0],
      [0, 2, 2, 1, 0, 2, 0, 1, 1, 1, 1],
      [0, 2, 2, 1, 1, 0, 2, 1, 1, 0, 2],
      [0, 2, 2, 1, 1, 1, 0, 2, 2, 1, 0],
      [0, 2, 2, 1, 1, 2, 1, 0, 0, 2, 1],
      [0, 2, 2, 1, 2, 0, 0, 0, 0, 1, 2],
      [0, 2, 2, 1, 2, 1, 1, 1, 1, 2, 0],
      [0, 2, 2, 1, 2, 2, 2, 2, 2, 0, 1],
      [0, 2, 2, 2, 0, 0, 0, 1, 0, 2, 0],
      [0, 2, 2, 2, 0, 1, 1, 2, 1, 0, 1],
      [0, 2, 2, 2, 0, 2, 2, 0, 2, 1, 2],
      [0, 2, 2, 2, 1, 0, 1, 0, 2, 0, 0],
      [0, 2, 2, 2, 1, 1, 2, 1, 0, 1, 1],
      [0, 2, 2, 2, 1, 2, 0, 2, 1, 2, 2],
      [0, 2, 2, 2, 2, 0, 2, 2, 1, 1, 0],
      [0, 2, 2, 2, 2, 1, 0, 0, 2, 2, 1],
      [0, 2, 2, 2, 2, 2, 1, 1, 0, 0, 2],
      [1, 0, 0, 0, 0, 0, 2, 0, 2, 1, 1],
      [1, 0, 0, 0, 0, 1, 0, 1, 0, 2, 2],
      [1, 0, 0, 0, 0, 2, 1, 2, 1, 0, 0],
      [1, 0, 0, 0, 1, 0, 0, 2, 1, 2, 1],
      [1, 0, 0, 0, 1, 1, 1, 0, 2, 0, 2],
      [1, 0, 0, 0, 1, 2, 2, 1, 0, 1, 0],
      [1, 0, 0, 0, 2, 0, 1, 1, 0, 0, 1],
      [1, 0, 0, 0, 2, 1, 2, 2, 1, 1, 2],
      [1, 0, 0, 0, 2, 2, 0, 0, 2, 2, 0],
      [1, 0, 0, 1, 0, 0, 1, 2, 0, 1, 2],
      [1, 0, 0, 1, 0, 1, 2, 0, 1, 2, 0],
      [1, 0, 0, 1, 0, 2, 0, 1, 2, 0, 1],
      [1, 0, 0, 1, 1, 0, 2, 1, 2, 2, 2],
      [1, 0, 0, 1, 1, 1, 0, 2, 0, 0, 0],
      [1, 0, 0, 1, 1, 2, 1, 0, 1, 1, 1],
      [1, 0, 0, 1, 2, 0, 0, 0, 1, 0, 2],
      [1, 0, 0, 1, 2, 1, 1, 1, 2, 1, 0],
      [1, 0, 0, 1, 2, 2, 2, 2, 0, 2, 1],
      [1, 0, 0, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 0, 2, 0, 1, 1, 2, 2, 2, 1],
      [1, 0, 0, 2, 0, 2, 2, 0, 0, 0, 2],
      [1, 0, 0, 2, 1, 0, 1, 0, 0, 2, 0],
      [1, 0, 0, 2, 1, 1, 2, 1, 1, 0, 1],
      [1, 0, 0, 2, 1, 2, 0, 2, 2, 1, 2],
      [1, 0, 0, 2, 2, 0, 2, 2, 2, 0, 0],
      [1, 0, 0, 2, 2, 1, 0, 0, 0, 1, 1],
      [1, 0, 0, 2, 2, 2, 1, 1, 1, 2, 2],
      [1, 0, 1, 0, 0, 0, 2, 1, 1, 0, 2],
      [1, 0, 1, 0, 0, 1, 0, 2, 2, 1, 0],
      [1, 0, 1, 0, 0, 2, 1, 0, 0, 2, 1],
      [1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 2],
      [1, 0, 1, 0, 1, 1, 1, 1, 1, 2, 0],
      [1, 0, 1, 0, 1, 2, 2, 2, 2, 0, 1],
      [1, 0, 1, 0, 2, 0, 1, 2, 2, 2, 2],
      [1, 0, 1, 0, 2, 1, 2, 0, 0, 0, 0],
      [1, 0, 1, 0, 2, 2, 0, 1, 1, 1, 1],
      [1, 0, 1, 1, 0, 0, 1, 0, 2, 0, 0],
      [1, 0, 1, 1, 0, 1, 2, 1, 0, 1, 1],
      [1, 0, 1, 1, 0, 2, 0, 2, 1, 2, 2],
      [1, 0, 1, 1, 1, 0, 2, 2, 1, 1, 0],
      [1, 0, 1, 1, 1, 1, 0, 0, 2, 2, 1],
      [1, 0, 1, 1, 1, 2, 1, 1, 0, 0, 2],
      [1, 0, 1, 1, 2, 0, 0, 1, 0, 2, 0],
      [1, 0, 1, 1, 2, 1, 1, 2, 1, 0, 1],
      [1, 0, 1, 1, 2, 2, 2, 0, 2, 1, 2],
      [1, 0, 1, 2, 0, 0, 0, 2, 0, 0, 1],
      [1, 0, 1, 2, 0, 1, 1, 0, 1, 1, 2],
      [1, 0, 1, 2, 0, 2, 2, 1, 2, 2, 0],
      [1, 0, 1, 2, 1, 0, 1, 1, 2, 1, 1],
      [1, 0, 1, 2, 1, 1, 2, 2, 0, 2, 2],
      [1, 0, 1, 2, 1, 2, 0, 0, 1, 0, 0],
      [1, 0, 1, 2, 2, 0, 2, 0, 1, 2, 1],
      [1, 0, 1, 2, 2, 1, 0, 1, 2, 0, 2],
      [1, 0, 1, 2, 2, 2, 1, 2, 0, 1, 0],
      [1, 0, 2, 0, 0, 0, 2, 2, 0, 2, 0],
      [1, 0, 2, 0, 0, 1, 0, 0, 1, 0, 1],
      [1, 0, 2, 0, 0, 2, 1, 1, 2, 1, 2],
      [1, 0, 2, 0, 1, 0, 0, 1, 2, 0, 0],
      [1, 0, 2, 0, 1, 1, 1, 2, 0, 1, 1],
      [1, 0, 2, 0, 1, 2, 2, 0, 1, 2, 2],
      [1, 0, 2, 0, 2, 0, 1, 0, 1, 1, 0],
      [1, 0, 2, 0, 2, 1, 2, 1, 2, 2, 1],
      [1, 0, 2, 0, 2, 2, 0, 2, 0, 0, 2],
      [1, 0, 2, 1, 0, 0, 1, 1, 1, 2, 1],
      [1, 0, 2, 1, 0, 1, 2, 2, 2, 0, 2],
      [1, 0, 2, 1, 0, 2, 0, 0, 0, 1, 0],
      [1, 0, 2, 1, 1, 0, 2, 0, 0, 0, 1],
      [1, 0, 2, 1, 1, 1, 0, 1, 1, 1, 2],
      [1, 0, 2, 1, 1, 2, 1, 2, 2, 2, 0],
      [1, 0, 2, 1, 2, 0, 0, 2, 2, 1, 1],
      [1, 0, 2, 1, 2, 1, 1, 0, 0, 2, 2],
      [1, 0, 2, 1, 2, 2, 2, 1, 1, 0, 0],
      [1, 0, 2, 2, 0, 0, 0, 0, 2, 2, 2],
      [1, 0, 2, 2, 0, 1, 1, 1, 0, 0, 0],
      [1, 0, 2, 2, 0, 2, 2, 2, 1, 1, 1],
      [1, 0, 2, 2, 1, 0, 1, 2, 1, 0, 2],
      [1, 0, 2, 2, 1, 1, 2, 0, 2, 1, 0],
      [1, 0, 2, 2, 1, 2, 0, 1, 0, 2, 1],
      [1, 0, 2, 2, 2, 0, 2, 1, 0, 1, 2],
      [1, 0, 2, 2, 2, 1, 0, 2, 1, 2, 0],
      [1, 0, 2, 2, 2, 2, 1, 0, 2, 0, 1],
      [1, 1, 0, 0, 0, 0, 0, 2, 2, 0, 2],
      [1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0],
      [1, 1, 0, 0, 0, 2, 2, 1, 1, 2, 1],
      [1, 1, 0, 0, 1, 0, 1, 1, 1, 1, 2],
      [1, 1, 0, 0, 1, 1, 2, 2, 2, 2, 0],
      [1, 1, 0, 0, 1, 2, 0, 0, 0, 0, 1],
      [1, 1, 0, 0, 2, 0, 2, 0, 0, 2, 2],
      [1, 1, 0, 0, 2, 1, 0, 1, 1, 0, 0],
      [1, 1, 0, 0, 2, 2, 1, 2, 2, 1, 1],
      [1, 1, 0, 1, 0, 0, 2, 1, 0, 0, 0],
      [1, 1, 0, 1, 0, 1, 0, 2, 1, 1, 1],
      [1, 1, 0, 1, 0, 2, 1, 0, 2, 2, 2],
      [1, 1, 0, 1, 1, 0, 0, 0, 2, 1, 0],
      [1, 1, 0, 1, 1, 1, 1, 1, 0, 2, 1],
      [1, 1, 0, 1, 1, 2, 2, 2, 1, 0, 2],
      [1, 1, 0, 1, 2, 0, 1, 2, 1, 2, 0],
      [1, 1, 0, 1, 2, 1, 2, 0, 2, 0, 1],
      [1, 1, 0, 1, 2, 2, 0, 1, 0, 1, 2],
      [1, 1, 0, 2, 0, 0, 1, 0, 1, 0, 1],
      [1, 1, 0, 2, 0, 1, 2, 1, 2, 1, 2],
      [1, 1, 0, 2, 0, 2, 0, 2, 0, 2, 0],
      [1, 1, 0, 2, 1, 0, 2, 2, 0, 1, 1],
      [1, 1, 0, 2, 1, 1, 0, 0, 1, 2, 2],
      [1, 1, 0, 2, 1, 2, 1, 1, 2, 0, 0],
      [1, 1, 0, 2, 2, 0, 0, 1, 2, 2, 1],
      [1, 1, 0, 2, 2, 1, 1, 2, 0, 0, 2],
      [1, 1, 0, 2, 2, 2, 2, 0, 1, 1, 0],
      [1, 1, 1, 0, 0, 0, 0, 0, 1, 2, 0],
      [1, 1, 1, 0, 0, 1, 1, 1, 2, 0, 1],
      [1, 1, 1, 0, 0, 2, 2, 2, 0, 1, 2],
      [1, 1, 1, 0, 1, 0, 1, 2, 0, 0, 0],
      [1, 1, 1, 0, 1, 1, 2, 0, 1, 1, 1],
      [1, 1, 1, 0, 1, 2, 0, 1, 2, 2, 2],
      [1, 1, 1, 0, 2, 0, 2, 1, 2, 1, 0],
      [1, 1, 1, 0, 2, 1, 0, 2, 0, 2, 1],
      [1, 1, 1, 0, 2, 2, 1, 0, 1, 0, 2],
      [1, 1, 1, 1, 0, 0, 2, 2, 2, 2, 1],
      [1, 1, 1, 1, 0, 1, 0, 0, 0, 0, 2],
      [1, 1, 1, 1, 0, 2, 1, 1, 1, 1, 0],
      [1, 1, 1, 1, 1, 0, 0, 1, 1, 0, 1],
      [1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 2],
      [1, 1, 1, 1, 1, 2, 2, 0, 0, 2, 0],
      [1, 1, 1, 1, 2, 0, 1, 0, 0, 1, 1],
      [1, 1, 1, 1, 2, 1, 2, 1, 1, 2, 2],
      [1, 1, 1, 1, 2, 2, 0, 2, 2, 0, 0],
      [1, 1, 1, 2, 0, 0, 1, 1, 0, 2, 2],
      [1, 1, 1, 2, 0, 1, 2, 2, 1, 0, 0],
      [1, 1, 1, 2, 0, 2, 0, 0, 2, 1, 1],
      [1, 1, 1, 2, 1, 0, 2, 0, 2, 0, 2],
      [1, 1, 1, 2, 1, 1, 0, 1, 0, 1, 0],
      [1, 1, 1, 2, 1, 2, 1, 2, 1, 2, 1],
      [1, 1, 1, 2, 2, 0, 0, 2, 1, 1, 2],
      [1, 1, 1, 2, 2, 1, 1, 0, 2, 2, 0],
      [1, 1, 1, 2, 2, 2, 2, 1, 0, 0, 1],
      [1, 1, 2, 0, 0, 0, 0, 1, 0, 1, 1],
      [1, 1, 2, 0, 0, 1, 1, 2, 1, 2, 2],
      [1, 1, 2, 0, 0, 2, 2, 0, 2, 0, 0],
      [1, 1, 2, 0, 1, 0, 1, 0, 2, 2, 1],
      [1, 1, 2, 0, 1, 1, 2, 1, 0, 0, 2],
      [1, 1, 2, 0, 1, 2, 0, 2, 1, 1, 0],
      [1, 1, 2, 0, 2, 0, 2, 2, 1, 0, 1],
      [1, 1, 2, 0, 2, 1, 0, 0, 2, 1, 2],
      [1, 1, 2, 0, 2, 2, 1, 1, 0, 2, 0],
      [1, 1, 2, 1, 0, 0, 2, 0, 1, 1, 2],
      [1, 1, 2, 1, 0, 1, 0, 1, 2, 2, 0],
      [1, 1, 2, 1, 0, 2, 1, 2, 0, 0, 1],
      [1, 1, 2, 1, 1, 0, 0, 2, 0, 2, 2],
      [1, 1, 2, 1, 1, 1, 1, 0, 1, 0, 0],
      [1, 1, 2, 1, 1, 2, 2, 1, 2, 1, 1],
      [1, 1, 2, 1, 2, 0, 1, 1, 2, 0, 2],
      [1, 1, 2, 1, 2, 1, 2, 2, 0, 1, 0],
      [1, 1, 2, 1, 2, 2, 0, 0, 1, 2, 1],
      [1, 1, 2, 2, 0, 0, 1, 2, 2, 1, 0],
      [1, 1, 2, 2, 0, 1, 2, 0, 0, 2, 1],
      [1, 1, 2, 2, 0, 2, 0, 1, 1, 0, 2],
      [1, 1, 2, 2, 1, 0, 2, 1, 1, 2, 0],
      [1, 1, 2, 2, 1, 1, 0, 2, 2, 0, 1],
      [1, 1, 2, 2, 1, 2, 1, 0, 0, 1, 2],
      [1, 1, 2, 2, 2, 0, 0, 0, 0, 0, 0],
      [1, 1, 2, 2, 2, 1, 1, 1, 1, 1, 1],
      [1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2],
      [1, 2, 0, 0, 0, 0, 1, 1, 2, 2, 0],
      [1, 2, 0, 0, 0, 1, 2, 2, 0, 0, 1],
      [1, 2, 0, 0, 0, 2, 0, 0, 1, 1, 2],
      [1, 2, 0, 0, 1, 0, 2, 0, 1, 0, 0],
      [1, 2, 0, 0, 1, 1, 0, 1, 2, 1, 1],
      [1, 2, 0, 0, 1, 2, 1, 2, 0, 2, 2],
      [1, 2, 0, 0, 2, 0, 0, 2, 0, 1, 0],
      [1, 2, 0, 0, 2, 1, 1, 0, 1, 2, 1],
      [1, 2, 0, 0, 2, 2, 2, 1, 2, 0, 2],
      [1, 2, 0, 1, 0, 0, 0, 0, 0, 2, 1],
      [1, 2, 0, 1, 0, 1, 1, 1, 1, 0, 2],
      [1, 2, 0, 1, 0, 2, 2, 2, 2, 1, 0],
      [1, 2, 0, 1, 1, 0, 1, 2, 2, 0, 1],
      [1, 2, 0, 1, 1, 1, 2, 0, 0, 1, 2],
      [1, 2, 0, 1, 1, 2, 0, 1, 1, 2, 0],
      [1, 2, 0, 1, 2, 0, 2, 1, 1, 1, 1],
      [1, 2, 0, 1, 2, 1, 0, 2, 2, 2, 2],
      [1, 2, 0, 1, 2, 2, 1, 0, 0, 0, 0],
      [1, 2, 0, 2, 0, 0, 2, 2, 1, 2, 2],
      [1, 2, 0, 2, 0, 1, 0, 0, 2, 0, 0],
      [1, 2, 0, 2, 0, 2, 1, 1, 0, 1, 1],
      [1, 2, 0, 2, 1, 0, 0, 1, 0, 0, 2],
      [1, 2, 0, 2, 1, 1, 1, 2, 1, 1, 0],
      [1, 2, 0, 2, 1, 2, 2, 0, 2, 2, 1],
      [1, 2, 0, 2, 2, 0, 1, 0, 2, 1, 2],
      [1, 2, 0, 2, 2, 1, 2, 1, 0, 2, 0],
      [1, 2, 0, 2, 2, 2, 0, 2, 1, 0, 1],
      [1, 2, 1, 0, 0, 0, 1, 2, 1, 1, 1],
      [1, 2, 1, 0, 0, 1, 2, 0, 2, 2, 2],
      [1, 2, 1, 0, 0, 2, 0, 1, 0, 0, 0],
      [1, 2, 1, 0, 1, 0, 2, 1, 0, 2, 1],
      [1, 2, 1, 0, 1, 1, 0, 2, 1, 0, 2],
      [1, 2, 1, 0, 1, 2, 1, 0, 2, 1, 0],
      [1, 2, 1, 0, 2, 0, 0, 0, 2, 0, 1],
      [1, 2, 1, 0, 2, 1, 1, 1, 0, 1, 2],
      [1, 2, 1, 0, 2, 2, 2, 2, 1, 2, 0],
      [1, 2, 1, 1, 0, 0, 0, 1, 2, 1, 2],
      [1, 2, 1, 1, 0, 1, 1, 2, 0, 2, 0],
      [1, 2, 1, 1, 0, 2, 2, 0, 1, 0, 1],
      [1, 2, 1, 1, 1, 0, 1, 0, 1, 2, 2],
      [1, 2, 1, 1, 1, 1, 2, 1, 2, 0, 0],
      [1, 2, 1, 1, 1, 2, 0, 2, 0, 1, 1],
      [1, 2, 1, 1, 2, 0, 2, 2, 0, 0, 2],
      [1, 2, 1, 1, 2, 1, 0, 0, 1, 1, 0],
      [1, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1],
      [1, 2, 1, 2, 0, 0, 2, 0, 0, 1, 0],
      [1, 2, 1, 2, 0, 1, 0, 1, 1, 2, 1],
      [1, 2, 1, 2, 0, 2, 1, 2, 2, 0, 2],
      [1, 2, 1, 2, 1, 0, 0, 2, 2, 2, 0],
      [1, 2, 1, 2, 1, 1, 1, 0, 0, 0, 1],
      [1, 2, 1, 2, 1, 2, 2, 1, 1, 1, 2],
      [1, 2, 1, 2, 2, 0, 1, 1, 1, 0, 0],
      [1, 2, 1, 2, 2, 1, 2, 2, 2, 1, 1],
      [1, 2, 1, 2, 2, 2, 0, 0, 0, 2, 2],
      [1, 2, 2, 0, 0, 0, 1, 0, 0, 0, 2],
      [1, 2, 2, 0, 0, 1, 2, 1, 1, 1, 0],
      [1, 2, 2, 0, 0, 2, 0, 2, 2, 2, 1],
      [1, 2, 2, 0, 1, 0, 2, 2, 2, 1, 2],
      [1, 2, 2, 0, 1, 1, 0, 0, 0, 2, 0],
      [1, 2, 2, 0, 1, 2, 1, 1, 1, 0, 1],
      [1, 2, 2, 0, 2, 0, 0, 1, 1, 2, 2],
      [1, 2, 2, 0, 2, 1, 1, 2, 2, 0, 0],
      [1, 2, 2, 0, 2, 2, 2, 0, 0, 1, 1],
      [1, 2, 2, 1, 0, 0, 0, 2, 1, 0, 0],
      [1, 2, 2, 1, 0, 1, 1, 0, 2, 1, 1],
      [1, 2, 2, 1, 0, 2, 2, 1, 0, 2, 2],
      [1, 2, 2, 1, 1, 0, 1, 1, 0, 1, 0],
      [1, 2, 2, 1, 1, 1, 2, 2, 1, 2, 1],
      [1, 2, 2, 1, 1, 2, 0, 0, 2, 0, 2],
      [1, 2, 2, 1, 2, 0, 2, 0, 2, 2, 0],
      [1, 2, 2, 1, 2, 1, 0, 1, 0, 0, 1],
      [1, 2, 2, 1, 2, 2, 1, 2, 1, 1, 2],
      [1, 2, 2, 2, 0, 0, 2, 1, 2, 0, 1],
      [1, 2, 2, 2, 0, 1, 0, 2, 0, 1, 2],
      [1, 2, 2, 2, 0, 2, 1, 0, 1, 2, 0],
      [1, 2, 2, 2, 1, 0, 0, 0, 1, 1, 1],
      [1, 2, 2, 2, 1, 1, 1, 1, 2, 2, 2],
      [1, 2, 2, 2, 1, 2, 2, 2, 0, 0, 0],
      [1, 2, 2, 2, 2, 0, 1, 2, 0, 2, 1],
      [1, 2, 2, 2, 2, 1, 2, 0, 1, 0, 2],
      [1, 2, 2, 2, 2, 2, 0, 1, 2, 1, 0],
      [2, 0, 0, 0, 0, 0, 1, 0, 1, 2, 2],
      [2, 0, 0, 0, 0, 1, 2, 1, 2, 0, 0],
      [2, 0, 0, 0, 0, 2, 0, 2, 0, 1, 1],
      [2, 0, 0, 0, 1, 0, 2, 2, 0, 0, 2],
      [2, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0],
      [2, 0, 0, 0, 1, 2, 1, 1, 2, 2, 1],
      [2, 0, 0, 0, 2, 0, 0, 1, 2, 1, 2],
      [2, 0, 0, 0, 2, 1, 1, 2, 0, 2, 0],
      [2, 0, 0, 0, 2, 2, 2, 0, 1, 0, 1],
      [2, 0, 0, 1, 0, 0, 0, 2, 2, 2, 0],
      [2, 0, 0, 1, 0, 1, 1, 0, 0, 0, 1],
      [2, 0, 0, 1, 0, 2, 2, 1, 1, 1, 2],
      [2, 0, 0, 1, 1, 0, 1, 1, 1, 0, 0],
      [2, 0, 0, 1, 1, 1, 2, 2, 2, 1, 1],
      [2, 0, 0, 1, 1, 2, 0, 0, 0, 2, 2],
      [2, 0, 0, 1, 2, 0, 2, 0, 0, 1, 0],
      [2, 0, 0, 1, 2, 1, 0, 1, 1, 2, 1],
      [2, 0, 0, 1, 2, 2, 1, 2, 2, 0, 2],
      [2, 0, 0, 2, 0, 0, 2, 1, 0, 2, 1],
      [2, 0, 0, 2, 0, 1, 0, 2, 1, 0, 2],
      [2, 0, 0, 2, 0, 2, 1, 0, 2, 1, 0],
      [2, 0, 0, 2, 1, 0, 0, 0, 2, 0, 1],
      [2, 0, 0, 2, 1, 1, 1, 1, 0, 1, 2],
      [2, 0, 0, 2, 1, 2, 2, 2, 1, 2, 0],
      [2, 0, 0, 2, 2, 0, 1, 2, 1, 1, 1],
      [2, 0, 0, 2, 2, 1, 2, 0, 2, 2, 2],
      [2, 0, 0, 2, 2, 2, 0, 1, 0, 0, 0],
      [2, 0, 1, 0, 0, 0, 1, 1, 0, 1, 0],
      [2, 0, 1, 0, 0, 1, 2, 2, 1, 2, 1],
      [2, 0, 1, 0, 0, 2, 0, 0, 2, 0, 2],
      [2, 0, 1, 0, 1, 0, 2, 0, 2, 2, 0],
      [2, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1],
      [2, 0, 1, 0, 1, 2, 1, 2, 1, 1, 2],
      [2, 0, 1, 0, 2, 0, 0, 2, 1, 0, 0],
      [2, 0, 1, 0, 2, 1, 1, 0, 2, 1, 1],
      [2, 0, 1, 0, 2, 2, 2, 1, 0, 2, 2],
      [2, 0, 1, 1, 0, 0, 0, 0, 1, 1, 1],
      [2, 0, 1, 1, 0, 1, 1, 1, 2, 2, 2],
      [2, 0, 1, 1, 0, 2, 2, 2, 0, 0, 0],
      [2, 0, 1, 1, 1, 0, 1, 2, 0, 2, 1],
      [2, 0, 1, 1, 1, 1, 2, 0, 1, 0, 2],
      [2, 0, 1, 1, 1, 2, 0, 1, 2, 1, 0],
      [2, 0, 1, 1, 2, 0, 2, 1, 2, 0, 1],
      [2, 0, 1, 1, 2, 1, 0, 2, 0, 1, 2],
      [2, 0, 1, 1, 2, 2, 1, 0, 1, 2, 0],
      [2, 0, 1, 2, 0, 0, 2, 2, 2, 1, 2],
      [2, 0, 1, 2, 0, 1, 0, 0, 0, 2, 0],
      [2, 0, 1, 2, 0, 2, 1, 1, 1, 0, 1],
      [2, 0, 1, 2, 1, 0, 0, 1, 1, 2, 2],
      [2, 0, 1, 2, 1, 1, 1, 2, 2, 0, 0],
      [2, 0, 1, 2, 1, 2, 2, 0, 0, 1, 1],
      [2, 0, 1, 2, 2, 0, 1, 0, 0, 0, 2],
      [2, 0, 1, 2, 2, 1, 2, 1, 1, 1, 0],
      [2, 0, 1, 2, 2, 2, 0, 2, 2, 2, 1],
      [2, 0, 2, 0, 0, 0, 1, 2, 2, 0, 1],
      [2, 0, 2, 0, 0, 1, 2, 0, 0, 1, 2],
      [2, 0, 2, 0, 0, 2, 0, 1, 1, 2, 0],
      [2, 0, 2, 0, 1, 0, 2, 1, 1, 1, 1],
      [2, 0, 2, 0, 1, 1, 0, 2, 2, 2, 2],
      [2, 0, 2, 0, 1, 2, 1, 0, 0, 0, 0],
      [2, 0, 2, 0, 2, 0, 0, 0, 0, 2, 1],
      [2, 0, 2, 0, 2, 1, 1, 1, 1, 0, 2],
      [2, 0, 2, 0, 2, 2, 2, 2, 2, 1, 0],
      [2, 0, 2, 1, 0, 0, 0, 1, 0, 0, 2],
      [2, 0, 2, 1, 0, 1, 1, 2, 1, 1, 0],
      [2, 0, 2, 1, 0, 2, 2, 0, 2, 2, 1],
      [2, 0, 2, 1, 1, 0, 1, 0, 2, 1, 2],
      [2, 0, 2, 1, 1, 1, 2, 1, 0, 2, 0],
      [2, 0, 2, 1, 1, 2, 0, 2, 1, 0, 1],
      [2, 0, 2, 1, 2, 0, 2, 2, 1, 2, 2],
      [2, 0, 2, 1, 2, 1, 0, 0, 2, 0, 0],
      [2, 0, 2, 1, 2, 2, 1, 1, 0, 1, 1],
      [2, 0, 2, 2, 0, 0, 2, 0, 1, 0, 0],
      [2, 0, 2, 2, 0, 1, 0, 1, 2, 1, 1],
      [2, 0, 2, 2, 0, 2, 1, 2, 0, 2, 2],
      [2, 0, 2, 2, 1, 0, 0, 2, 0, 1, 0],
      [2, 0, 2, 2, 1, 1, 1, 0, 1, 2, 1],
      [2, 0, 2, 2, 1, 2, 2, 1, 2, 0, 2],
      [2, 0, 2, 2, 2, 0, 1, 1, 2, 2, 0],
      [2, 0, 2, 2, 2, 1, 2, 2, 0, 0, 1],
      [2, 0, 2, 2, 2, 2, 0, 0, 1, 1, 2],
      [2, 1, 0, 0, 0, 0, 2, 2, 1, 1, 0],
      [2, 1, 0, 0, 0, 1, 0, 0, 2, 2, 1],
      [2, 1, 0, 0, 0, 2, 1, 1, 0, 0, 2],
      [2, 1, 0, 0, 1, 0, 0, 1, 0, 2, 0],
      [2, 1, 0, 0, 1, 1, 1, 2, 1, 0, 1],
      [2, 1, 0, 0, 1, 2, 2, 0, 2, 1, 2],
      [2, 1, 0, 0, 2, 0, 1, 0, 2, 0, 0],
      [2, 1, 0, 0, 2, 1, 2, 1, 0, 1, 1],
      [2, 1, 0, 0, 2, 2, 0, 2, 1, 2, 2],
      [2, 1, 0, 1, 0, 0, 1, 1, 2, 1, 1],
      [2, 1, 0, 1, 0, 1, 2, 2, 0, 2, 2],
      [2, 1, 0, 1, 0, 2, 0, 0, 1, 0, 0],
      [2, 1, 0, 1, 1, 0, 2, 0, 1, 2, 1],
      [2, 1, 0, 1, 1, 1, 0, 1, 2, 0, 2],
      [2, 1, 0, 1, 1, 2, 1, 2, 0, 1, 0],
      [2, 1, 0, 1, 2, 0, 0, 2, 0, 0, 1],
      [2, 1, 0, 1, 2, 1, 1, 0, 1, 1, 2],
      [2, 1, 0, 1, 2, 2, 2, 1, 2, 2, 0],
      [2, 1, 0, 2, 0, 0, 0, 0, 0, 1, 2],
      [2, 1, 0, 2, 0, 1, 1, 1, 1, 2, 0],
      [2, 1, 0, 2, 0, 2, 2, 2, 2, 0, 1],
      [2, 1, 0, 2, 1, 0, 1, 2, 2, 2, 2],
      [2, 1, 0, 2, 1, 1, 2, 0, 0, 0, 0],
      [2, 1, 0, 2, 1, 2, 0, 1, 1, 1, 1],
      [2, 1, 0, 2, 2, 0, 2, 1, 1, 0, 2],
      [2, 1, 0, 2, 2, 1, 0, 2, 2, 1, 0],
      [2, 1, 0, 2, 2, 2, 1, 0, 0, 2, 1],
      [2, 1, 1, 0, 0, 0, 2, 0, 0, 0, 1],
      [2, 1, 1, 0, 0, 1, 0, 1, 1, 1, 2],
      [2, 1, 1, 0, 0, 2, 1, 2, 2, 2, 0],
      [2, 1, 1, 0, 1, 0, 0, 2, 2, 1, 1],
      [2, 1, 1, 0, 1, 1, 1, 0, 0, 2, 2],
      [2, 1, 1, 0, 1, 2, 2, 1, 1, 0, 0],
      [2, 1, 1, 0, 2, 0, 1, 1, 1, 2, 1],
      [2, 1, 1, 0, 2, 1, 2, 2, 2, 0, 2],
      [2, 1, 1, 0, 2, 2, 0, 0, 0, 1, 0],
      [2, 1, 1, 1, 0, 0, 1, 2, 1, 0, 2],
      [2, 1, 1, 1, 0, 1, 2, 0, 2, 1, 0],
      [2, 1, 1, 1, 0, 2, 0, 1, 0, 2, 1],
      [2, 1, 1, 1, 1, 0, 2, 1, 0, 1, 2],
      [2, 1, 1, 1, 1, 1, 0, 2, 1, 2, 0],
      [2, 1, 1, 1, 1, 2, 1, 0, 2, 0, 1],
      [2, 1, 1, 1, 2, 0, 0, 0, 2, 2, 2],
      [2, 1, 1, 1, 2, 1, 1, 1, 0, 0, 0],
      [2, 1, 1, 1, 2, 2, 2, 2, 1, 1, 1],
      [2, 1, 1, 2, 0, 0, 0, 1, 2, 0, 0],
      [2, 1, 1, 2, 0, 1, 1, 2, 0, 1, 1],
      [2, 1, 1, 2, 0, 2, 2, 0, 1, 2, 2],
      [2, 1, 1, 2, 1, 0, 1, 0, 1, 1, 0],
      [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1],
      [2, 1, 1, 2, 1, 2, 0, 2, 0, 0, 2],
      [2, 1, 1, 2, 2, 0, 2, 2, 0, 2, 0],
      [2, 1, 1, 2, 2, 1, 0, 0, 1, 0, 1],
      [2, 1, 1, 2, 2, 2, 1, 1, 2, 1, 2],
      [2, 1, 2, 0, 0, 0, 2, 1, 2, 2, 2],
      [2, 1, 2, 0, 0, 1, 0, 2, 0, 0, 0],
      [2, 1, 2, 0, 0, 2, 1, 0, 1, 1, 1],
      [2, 1, 2, 0, 1, 0, 0, 0, 1, 0, 2],
      [2, 1, 2, 0, 1, 1, 1, 1, 2, 1, 0],
      [2, 1, 2, 0, 1, 2, 2, 2, 0, 2, 1],
      [2, 1, 2, 0, 2, 0, 1, 2, 0, 1, 2],
      [2, 1, 2, 0, 2, 1, 2, 0, 1, 2, 0],
      [2, 1, 2, 0, 2, 2, 0, 1, 2, 0, 1],
      [2, 1, 2, 1, 0, 0, 1, 0, 0, 2, 0],
      [2, 1, 2, 1, 0, 1, 2, 1, 1, 0, 1],
      [2, 1, 2, 1, 0, 2, 0, 2, 2, 1, 2],
      [2, 1, 2, 1, 1, 0, 2, 2, 2, 0, 0],
      [2, 1, 2, 1, 1, 1, 0, 0, 0, 1, 1],
      [2, 1, 2, 1, 1, 2, 1, 1, 1, 2, 2],
      [2, 1, 2, 1, 2, 0, 0, 1, 1, 1, 0],
      [2, 1, 2, 1, 2, 1, 1, 2, 2, 2, 1],
      [2, 1, 2, 1, 2, 2, 2, 0, 0, 0, 2],
      [2, 1, 2, 2, 0, 0, 0, 2, 1, 2, 1],
      [2, 1, 2, 2, 0, 1, 1, 0, 2, 0, 2],
      [2, 1, 2, 2, 0, 2, 2, 1, 0, 1, 0],
      [2, 1, 2, 2, 1, 0, 1, 1, 0, 0, 1],
      [2, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2],
      [2, 1, 2, 2, 1, 2, 0, 0, 2, 2, 0],
      [2, 1, 2, 2, 2, 0, 2, 0, 2, 1, 1],
      [2, 1, 2, 2, 2, 1, 0, 1, 0, 2, 2],
      [2, 1, 2, 2, 2, 2, 1, 2, 1, 0, 0],
      [2, 2, 0, 0, 0, 0, 0, 1, 1, 0, 1],
      [2, 2, 0, 0, 0, 1, 1, 2, 2, 1, 2],
      [2, 2, 0, 0, 0, 2, 2, 0, 0, 2, 0],
      [2, 2, 0, 0, 1, 0, 1, 0, 0, 1, 1],
      [2, 2, 0, 0, 1, 1, 2, 1, 1, 2, 2],
      [2, 2, 0, 0, 1, 2, 0, 2, 2, 0, 0],
      [2, 2, 0, 0, 2, 0, 2, 2, 2, 2, 1],
      [2, 2, 0, 0, 2, 1, 0, 0, 0, 0, 2],
      [2, 2, 0, 0, 2, 2, 1, 1, 1, 1, 0],
      [2, 2, 0, 1, 0, 0, 2, 0, 2, 0, 2],
      [2, 2, 0, 1, 0, 1, 0, 1, 0, 1, 0],
      [2, 2, 0, 1, 0, 2, 1, 2, 1, 2, 1],
      [2, 2, 0, 1, 1, 0, 0, 2, 1, 1, 2],
      [2, 2, 0, 1, 1, 1, 1, 0, 2, 2, 0],
      [2, 2, 0, 1, 1, 2, 2, 1, 0, 0, 1],
      [2, 2, 0, 1, 2, 0, 1, 1, 0, 2, 2],
      [2, 2, 0, 1, 2, 1, 2, 2, 1, 0, 0],
      [2, 2, 0, 1, 2, 2, 0, 0, 2, 1, 1],
      [2, 2, 0, 2, 0, 0, 1, 2, 0, 0, 0],
      [2, 2, 0, 2, 0, 1, 2, 0, 1, 1, 1],
      [2, 2, 0, 2, 0, 2, 0, 1, 2, 2, 2],
      [2, 2, 0, 2, 1, 0, 2, 1, 2, 1, 0],
      [2, 2, 0, 2, 1, 1, 0, 2, 0, 2, 1],
      [2, 2, 0, 2, 1, 2, 1, 0, 1, 0, 2],
      [2, 2, 0, 2, 2, 0, 0, 0, 1, 2, 0],
      [2, 2, 0, 2, 2, 1, 1, 1, 2, 0, 1],
      [2, 2, 0, 2, 2, 2, 2, 2, 0, 1, 2],
      [2, 2, 1, 0, 0, 0, 0, 2, 0, 2, 2],
      [2, 2, 1, 0, 0, 1, 1, 0, 1, 0, 0],
      [2, 2, 1, 0, 0, 2, 2, 1, 2, 1, 1],
      [2, 2, 1, 0, 1, 0, 1, 1, 2, 0, 2],
      [2, 2, 1, 0, 1, 1, 2, 2, 0, 1, 0],
      [2, 2, 1, 0, 1, 2, 0, 0, 1, 2, 1],
      [2, 2, 1, 0, 2, 0, 2, 0, 1, 1, 2],
      [2, 2, 1, 0, 2, 1, 0, 1, 2, 2, 0],
      [2, 2, 1, 0, 2, 2, 1, 2, 0, 0, 1],
      [2, 2, 1, 1, 0, 0, 2, 1, 1, 2, 0],
      [2, 2, 1, 1, 0, 1, 0, 2, 2, 0, 1],
      [2, 2, 1, 1, 0, 2, 1, 0, 0, 1, 2],
      [2, 2, 1, 1, 1, 0, 0, 0, 0, 0, 0],
      [2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [2, 2, 1, 1, 1, 2, 2, 2, 2, 2, 2],
      [2, 2, 1, 1, 2, 0, 1, 2, 2, 1, 0],
      [2, 2, 1, 1, 2, 1, 2, 0, 0, 2, 1],
      [2, 2, 1, 1, 2, 2, 0, 1, 1, 0, 2],
      [2, 2, 1, 2, 0, 0, 1, 0, 2, 2, 1],
      [2, 2, 1, 2, 0, 1, 2, 1, 0, 0, 2],
      [2, 2, 1, 2, 0, 2, 0, 2, 1, 1, 0],
      [2, 2, 1, 2, 1, 0, 2, 2, 1, 0, 1],
      [2, 2, 1, 2, 1, 1, 0, 0, 2, 1, 2],
      [2, 2, 1, 2, 1, 2, 1, 1, 0, 2, 0],
      [2, 2, 1, 2, 2, 0, 0, 1, 0, 1, 1],
      [2, 2, 1, 2, 2, 1, 1, 2, 1, 2, 2],
      [2, 2, 1, 2, 2, 2, 2, 0, 2, 0, 0],
      [2, 2, 2, 0, 0, 0, 0, 0, 2, 1, 0],
      [2, 2, 2, 0, 0, 1, 1, 1, 0, 2, 1],
      [2, 2, 2, 0, 0, 2, 2, 2, 1, 0, 2],
      [2, 2, 2, 0, 1, 0, 1, 2, 1, 2, 0],
      [2, 2, 2, 0, 1, 1, 2, 0, 2, 0, 1],
      [2, 2, 2, 0, 1, 2, 0, 1, 0, 1, 2],
      [2, 2, 2, 0, 2, 0, 2, 1, 0, 0, 0],
      [2, 2, 2, 0, 2, 1, 0, 2, 1, 1, 1],
      [2, 2, 2, 0, 2, 2, 1, 0, 2, 2, 2],
      [2, 2, 2, 1, 0, 0, 2, 2, 0, 1, 1],
      [2, 2, 2, 1, 0, 1, 0, 0, 1, 2, 2],
      [2, 2, 2, 1, 0, 2, 1, 1, 2, 0, 0],
      [2, 2, 2, 1, 1, 0, 0, 1, 2, 2, 1],
      [2, 2, 2, 1, 1, 1, 1, 2, 0, 0, 2],
      [2, 2, 2, 1, 1, 2, 2, 0, 1, 1, 0],
      [2, 2, 2, 1, 2, 0, 1, 0, 1, 0, 1],
      [2, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
      [2, 2, 2, 1, 2, 2, 0, 2, 0, 2, 0],
      [2, 2, 2, 2, 0, 0, 1, 1, 1, 1, 2],
      [2, 2, 2, 2, 0, 1, 2, 2, 2, 2, 0],
      [2, 2, 2, 2, 0, 2, 0, 0, 0, 0, 1],
      [2, 2, 2, 2, 1, 0, 2, 0, 0, 2, 2],
      [2, 2, 2, 2, 1, 1, 0, 1, 1, 0, 0],
      [2, 2, 2, 2, 1, 2, 1, 2, 2, 1, 1],
      [2, 2, 2, 2, 2, 0, 0, 2, 2, 0, 2],
      [2, 2, 2, 2, 2, 1, 1, 0, 0, 1, 0],
      [2, 2, 2, 2, 2, 2, 2, 1, 1, 2, 1],
    ] as const,
    systemType: 'R',
    systemNum: 32,
    hasXpert: true,
  } as const,
  'R2-5-12': {
    guaranty: 11,
    numFullHedges: 2,
    numHalfHedges: 5,
    rows: [
      [2, 2, 1, 1, 1, 1, 0],
      [0, 1, 1, 0, 0, 0, 1],
      [0, 1, 1, 0, 1, 1, 0],
      [2, 0, 0, 0, 1, 0, 1],
      [2, 2, 1, 1, 0, 0, 1],
      [1, 2, 0, 0, 1, 0, 0],
      [1, 2, 0, 0, 0, 1, 1],
      [0, 1, 0, 1, 0, 1, 0],
      [2, 0, 0, 0, 0, 1, 0],
      [1, 0, 1, 1, 1, 1, 1],
      [1, 0, 1, 1, 0, 0, 0],
      [0, 1, 0, 1, 1, 0, 1],
    ] as const,
    systemType: 'R',
    systemNum: 35,
    hasXpert: true,
  } as const,
  'R3-3-24': {
    guaranty: 12,
    numFullHedges: 3,
    numHalfHedges: 3,
    rows: [
      [0, 1, 0, 1, 1, 1],
      [0, 2, 2, 0, 0, 1],
      [2, 0, 2, 1, 0, 0],
      [2, 0, 2, 0, 1, 1],
      [2, 1, 1, 1, 1, 0],
      [1, 2, 1, 0, 0, 0],
      [0, 2, 2, 1, 1, 0],
      [1, 1, 2, 0, 1, 0],
      [1, 2, 1, 1, 1, 1],
      [1, 0, 0, 0, 0, 1],
      [2, 0, 2, 1, 1, 1],
      [0, 1, 0, 1, 0, 0],
      [2, 1, 1, 0, 0, 1],
      [0, 0, 1, 0, 1, 0],
      [1, 1, 2, 1, 0, 1],
      [2, 2, 0, 1, 0, 1],
      [2, 0, 2, 0, 0, 0],
      [1, 2, 1, 1, 0, 0],
      [1, 0, 0, 1, 1, 0],
      [0, 1, 0, 0, 0, 0],
      [0, 1, 0, 0, 1, 1],
      [1, 2, 1, 0, 1, 1],
      [0, 0, 1, 1, 0, 1],
      [2, 2, 0, 0, 1, 0],
    ] as const,
    systemType: 'R',
    systemNum: 36,
    hasXpert: true,
  } as const,
  'R4-0-9': {
    guaranty: 12,
    numFullHedges: 4,
    numHalfHedges: 0,
    rows: [
      [0, 0, 1, 0],
      [0, 1, 0, 1],
      [0, 2, 2, 2],
      [1, 2, 0, 0],
      [1, 0, 2, 1],
      [1, 1, 1, 2],
      [2, 1, 2, 0],
      [2, 2, 1, 1],
      [2, 0, 0, 2],
    ] as const,
    systemType: 'R',
    systemNum: 37,
    hasXpert: true,
  } as const,
  'R0-7-16': {
    guaranty: 12,
    numFullHedges: 0,
    numHalfHedges: 7,
    rows: [
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 1],
      [0, 0, 1, 1, 0, 0, 1],
      [0, 0, 1, 1, 1, 1, 0],
      [0, 1, 0, 1, 0, 1, 1],
      [0, 1, 0, 1, 1, 0, 0],
      [0, 1, 1, 0, 0, 1, 0],
      [0, 1, 1, 0, 1, 0, 1],
      [1, 0, 0, 1, 0, 1, 0],
      [1, 0, 0, 1, 1, 0, 1],
      [1, 0, 1, 0, 0, 1, 1],
      [1, 0, 1, 0, 1, 0, 0],
      [1, 1, 0, 0, 0, 0, 1],
      [1, 1, 0, 0, 1, 1, 0],
      [1, 1, 1, 1, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1],
    ] as const,
    systemType: 'R',
    systemNum: 33,
    hasXpert: true,
  } as const,
  'R4-4-144': {
    guaranty: 12,
    numFullHedges: 4,
    numHalfHedges: 4,
    rows: [
      [0, 1, 2, 0, 0, 1, 1, 0],
      [2, 2, 2, 1, 1, 1, 1, 0],
      [1, 1, 1, 1, 1, 1, 0, 1],
      [0, 0, 1, 0, 1, 0, 1, 0],
      [0, 2, 1, 1, 1, 0, 0, 1],
      [0, 2, 1, 2, 0, 1, 0, 0],
      [2, 1, 1, 2, 1, 0, 1, 0],
      [0, 1, 0, 1, 0, 1, 0, 0],
      [1, 2, 2, 2, 1, 0, 0, 0],
      [2, 0, 0, 1, 1, 0, 1, 0],
      [0, 2, 0, 2, 1, 0, 1, 0],
      [1, 1, 2, 0, 1, 1, 0, 0],
      [1, 0, 0, 2, 1, 0, 1, 1],
      [2, 2, 1, 2, 0, 1, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 1],
      [2, 1, 0, 2, 0, 0, 0, 1],
      [0, 2, 0, 1, 0, 1, 1, 0],
      [2, 0, 2, 1, 0, 0, 0, 1],
      [0, 1, 0, 2, 1, 1, 0, 1],
      [0, 2, 1, 0, 1, 1, 0, 1],
      [1, 0, 2, 0, 1, 1, 1, 0],
      [2, 0, 0, 2, 1, 1, 1, 0],
      [1, 2, 0, 0, 0, 1, 0, 1],
      [0, 0, 2, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 1, 1, 1, 1],
      [1, 0, 1, 1, 0, 1, 0, 1],
      [2, 2, 1, 2, 1, 1, 1, 1],
      [1, 0, 0, 0, 1, 0, 0, 0],
      [1, 2, 2, 2, 1, 1, 0, 1],
      [0, 1, 2, 1, 1, 0, 1, 0],
      [1, 0, 1, 1, 1, 1, 1, 1],
      [0, 2, 0, 0, 1, 1, 1, 0],
      [2, 1, 2, 0, 1, 0, 0, 0],
      [0, 1, 1, 0, 0, 1, 0, 1],
      [2, 1, 1, 0, 0, 0, 1, 1],
      [0, 1, 2, 2, 0, 0, 1, 1],
      [0, 0, 2, 0, 1, 0, 1, 1],
      [1, 2, 0, 1, 1, 1, 0, 0],
      [0, 1, 1, 2, 0, 0, 1, 0],
      [2, 0, 2, 0, 0, 1, 0, 1],
      [2, 1, 2, 2, 1, 0, 1, 1],
      [2, 1, 1, 2, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0],
      [2, 2, 0, 0, 0, 1, 0, 0],
      [0, 0, 1, 2, 0, 1, 1, 0],
      [1, 2, 2, 1, 0, 1, 0, 0],
      [1, 1, 2, 2, 1, 1, 1, 1],
      [2, 2, 0, 2, 1, 0, 0, 1],
      [1, 2, 1, 2, 1, 1, 1, 0],
      [1, 0, 2, 0, 0, 0, 1, 1],
      [1, 1, 0, 1, 0, 0, 1, 1],
      [2, 2, 1, 1, 0, 0, 1, 0],
      [0, 1, 1, 1, 0, 0, 0, 1],
      [2, 1, 0, 0, 0, 1, 1, 1],
      [1, 0, 0, 0, 1, 1, 0, 1],
      [2, 1, 1, 0, 1, 1, 1, 0],
      [1, 0, 2, 1, 0, 1, 1, 0],
      [2, 2, 0, 0, 1, 0, 1, 1],
      [2, 0, 1, 1, 0, 1, 0, 0],
      [1, 1, 0, 1, 1, 1, 1, 0],
      [0, 1, 0, 1, 1, 0, 1, 1],
      [1, 0, 0, 1, 1, 0, 0, 1],
      [0, 1, 1, 1, 1, 1, 0, 0],
      [2, 2, 2, 1, 0, 0, 1, 1],
      [2, 0, 1, 1, 1, 0, 1, 1],
      [2, 1, 2, 2, 0, 1, 0, 0],
      [0, 2, 2, 1, 1, 1, 1, 1],
      [2, 1, 2, 1, 1, 0, 0, 1],
      [0, 2, 0, 2, 0, 0, 0, 0],
      [1, 0, 2, 2, 1, 0, 1, 0],
      [0, 2, 2, 1, 0, 1, 0, 1],
      [0, 0, 1, 0, 0, 0, 0, 0],
      [2, 0, 2, 2, 0, 0, 1, 0],
      [1, 0, 1, 2, 1, 1, 0, 0],
      [1, 0, 2, 2, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 1, 1, 0],
      [0, 0, 0, 1, 0, 1, 1, 1],
      [0, 0, 0, 1, 0, 0, 1, 0],
      [0, 0, 1, 1, 1, 1, 1, 0],
      [1, 2, 0, 2, 0, 0, 1, 0],
      [2, 1, 2, 0, 1, 1, 0, 1],
      [2, 2, 0, 1, 1, 1, 0, 1],
      [2, 1, 0, 1, 0, 1, 0, 1],
      [1, 2, 1, 2, 0, 0, 1, 1],
      [2, 1, 0, 0, 0, 0, 1, 0],
      [2, 0, 2, 1, 1, 1, 0, 0],
      [1, 0, 1, 2, 0, 0, 0, 1],
      [1, 0, 1, 0, 0, 1, 1, 1],
      [0, 2, 1, 0, 1, 0, 0, 0],
      [0, 0, 2, 2, 1, 0, 0, 1],
      [2, 1, 0, 1, 1, 1, 1, 1],
      [0, 1, 0, 0, 1, 0, 0, 1],
      [2, 0, 2, 0, 1, 1, 1, 1],
      [0, 1, 1, 0, 1, 1, 1, 1],
      [0, 1, 2, 2, 1, 1, 1, 0],
      [2, 0, 0, 1, 0, 0, 0, 0],
      [0, 1, 0, 2, 1, 0, 0, 0],
      [2, 0, 1, 2, 1, 1, 0, 1],
      [0, 2, 2, 0, 0, 0, 1, 0],
      [0, 2, 2, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 2, 0, 1, 0, 1],
      [2, 0, 1, 0, 1, 0, 0, 1],
      [2, 2, 2, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 0, 0, 0, 0],
      [2, 2, 2, 2, 0, 1, 1, 0],
      [2, 2, 1, 1, 0, 1, 1, 1],
      [0, 2, 0, 0, 0, 0, 1, 1],
      [1, 2, 1, 1, 1, 0, 1, 0],
      [0, 2, 2, 2, 1, 1, 0, 0],
      [1, 1, 2, 0, 0, 0, 0, 1],
      [1, 1, 1, 2, 1, 0, 0, 1],
      [1, 1, 2, 1, 0, 1, 1, 1],
      [1, 1, 0, 2, 0, 1, 1, 0],
      [2, 2, 1, 0, 1, 1, 0, 0],
      [2, 0, 0, 2, 0, 0, 1, 1],
      [2, 0, 2, 2, 0, 1, 1, 1],
      [1, 1, 2, 2, 0, 1, 0, 1],
      [2, 1, 0, 2, 1, 1, 0, 0],
      [0, 0, 1, 1, 0, 0, 1, 1],
      [1, 1, 2, 1, 0, 0, 1, 0],
      [2, 2, 2, 0, 0, 0, 0, 0],
      [2, 1, 1, 1, 0, 1, 1, 0],
      [1, 2, 0, 2, 0, 1, 1, 1],
      [0, 0, 2, 1, 1, 1, 0, 1],
      [0, 2, 2, 2, 0, 0, 0, 1],
      [0, 0, 2, 1, 1, 0, 0, 0],
      [1, 0, 0, 2, 0, 1, 0, 0],
      [1, 2, 2, 0, 1, 0, 0, 1],
      [1, 2, 1, 1, 0, 0, 0, 0],
      [1, 2, 1, 0, 0, 1, 1, 0],
      [1, 0, 1, 0, 0, 0, 1, 0],
      [1, 2, 0, 1, 0, 0, 0, 1],
      [1, 1, 1, 0, 1, 0, 1, 1],
      [2, 0, 1, 2, 1, 0, 0, 0],
      [1, 1, 0, 0, 1, 0, 1, 0],
      [1, 2, 2, 1, 1, 0, 1, 1],
      [1, 1, 1, 1, 1, 0, 0, 0],
      [1, 2, 0, 0, 1, 1, 1, 1],
      [2, 2, 1, 0, 0, 0, 0, 1],
      [0, 1, 1, 2, 0, 1, 1, 1],
      [2, 2, 0, 1, 1, 0, 0, 0],
      [0, 2, 1, 2, 1, 0, 1, 1],
      [1, 1, 1, 0, 0, 1, 0, 0],
    ] as const,
    systemType: 'R',
    systemNum: 39,
    hasXpert: true,
  } as const,
  'R4-4-24': {
    guaranty: 11,
    numFullHedges: 4,
    numHalfHedges: 4,
    rows: [
      [0, 0, 0, 1, 1, 0, 1, 0],
      [0, 2, 1, 0, 0, 1, 1, 0],
      [2, 0, 1, 0, 1, 1, 1, 1],
      [2, 0, 1, 0, 0, 0, 0, 0],
      [2, 1, 0, 2, 1, 0, 0, 1],
      [1, 1, 1, 2, 0, 1, 0, 1],
      [0, 2, 1, 0, 1, 0, 0, 1],
      [2, 2, 1, 1, 0, 0, 1, 1],
      [1, 1, 1, 2, 1, 0, 1, 0],
      [1, 0, 2, 1, 0, 1, 1, 0],
      [2, 2, 2, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 1, 1, 1, 1],
      [2, 1, 0, 2, 0, 1, 1, 0],
      [1, 1, 0, 0, 0, 0, 1, 1],
      [2, 2, 1, 1, 1, 1, 0, 0],
      [0, 0, 2, 2, 1, 1, 0, 0],
      [2, 2, 2, 0, 0, 1, 0, 1],
      [1, 2, 0, 2, 1, 1, 1, 1],
      [1, 0, 2, 1, 1, 0, 0, 1],
      [0, 0, 0, 1, 0, 1, 0, 1],
      [0, 1, 2, 1, 0, 0, 0, 0],
      [1, 2, 0, 2, 0, 0, 0, 0],
      [1, 1, 0, 0, 1, 1, 0, 0],
      [0, 0, 2, 2, 0, 0, 1, 1],
    ] as const,
    systemType: 'R',
    systemNum: 38,
    hasXpert: false,
  } as const,
  'R4-5-48': {
    guaranty: 11,
    numFullHedges: 4,
    numHalfHedges: 5,
    rows: [
      [1, 2, 1, 2, 1, 0, 1, 1, 1],
      [2, 2, 2, 2, 0, 0, 0, 1, 0],
      [2, 1, 0, 2, 1, 1, 1, 0, 1],
      [1, 0, 2, 2, 1, 0, 0, 0, 0],
      [2, 0, 1, 0, 0, 0, 1, 0, 0],
      [0, 1, 2, 1, 1, 1, 0, 1, 0],
      [0, 2, 2, 2, 1, 0, 0, 0, 1],
      [1, 2, 0, 2, 1, 1, 0, 1, 0],
      [2, 2, 0, 1, 0, 0, 1, 0, 1],
      [2, 2, 0, 1, 1, 1, 0, 1, 1],
      [1, 0, 2, 1, 1, 1, 1, 0, 1],
      [2, 0, 2, 0, 0, 1, 0, 0, 1],
      [2, 0, 2, 0, 1, 0, 1, 1, 1],
      [1, 2, 0, 2, 0, 0, 1, 0, 0],
      [0, 1, 1, 2, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 1, 0],
      [2, 0, 1, 0, 1, 1, 0, 1, 0],
      [1, 0, 0, 0, 0, 1, 1, 1, 1],
      [1, 0, 2, 1, 0, 0, 0, 1, 1],
      [1, 1, 1, 1, 0, 0, 0, 1, 0],
      [0, 1, 1, 2, 1, 0, 1, 1, 0],
      [1, 1, 2, 0, 1, 1, 0, 1, 1],
      [0, 0, 1, 2, 1, 1, 0, 1, 1],
      [2, 0, 0, 1, 0, 1, 0, 0, 0],
      [0, 2, 1, 0, 1, 1, 1, 0, 1],
      [0, 0, 0, 0, 1, 1, 1, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 0, 0],
      [0, 2, 2, 2, 0, 1, 1, 1, 1],
      [0, 2, 1, 1, 0, 1, 1, 1, 0],
      [1, 2, 1, 2, 0, 1, 0, 0, 1],
      [0, 0, 1, 2, 0, 0, 1, 0, 1],
      [2, 1, 0, 2, 0, 0, 0, 1, 1],
      [0, 1, 0, 1, 1, 0, 1, 1, 1],
      [1, 2, 2, 0, 1, 0, 1, 1, 0],
      [1, 1, 2, 0, 0, 0, 1, 0, 1],
      [0, 1, 2, 1, 0, 0, 1, 0, 0],
      [0, 2, 1, 0, 0, 0, 0, 1, 1],
      [1, 0, 2, 2, 0, 1, 1, 1, 0],
      [2, 2, 2, 2, 1, 1, 1, 0, 0],
      [0, 2, 1, 1, 1, 0, 0, 0, 0],
      [1, 0, 0, 0, 1, 0, 0, 0, 1],
      [2, 1, 1, 1, 1, 0, 0, 0, 1],
      [2, 1, 0, 0, 0, 1, 1, 1, 0],
      [0, 1, 0, 1, 0, 1, 0, 0, 1],
      [2, 1, 1, 1, 0, 1, 1, 1, 1],
      [2, 1, 0, 0, 1, 0, 0, 0, 0],
      [2, 0, 0, 1, 1, 0, 1, 1, 0],
      [1, 2, 2, 0, 0, 1, 0, 0, 0],
    ] as const,
    systemType: 'R',
    systemNum: 40,
    hasXpert: true,
  } as const,
  'R4-6-24': {
    guaranty: 10,
    numFullHedges: 4,
    numHalfHedges: 6,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 1, 1, 0],
      [2, 0, 1, 1, 0, 1, 0, 1, 0, 1],
      [2, 0, 2, 1, 0, 0, 1, 0, 1, 1],
      [1, 1, 2, 2, 0, 1, 1, 0, 0, 0],
      [1, 1, 1, 2, 0, 0, 0, 1, 1, 0],
      [1, 2, 0, 2, 0, 0, 1, 1, 0, 1],
      [1, 2, 0, 2, 0, 1, 0, 0, 1, 1],
      [2, 2, 1, 1, 0, 1, 1, 0, 0, 0],
      [2, 2, 2, 1, 0, 0, 0, 1, 1, 0],
      [0, 1, 2, 0, 0, 1, 0, 1, 0, 1],
      [0, 1, 1, 0, 0, 0, 1, 0, 1, 1],
      [0, 0, 0, 0, 1, 1, 1, 0, 0, 1],
      [0, 0, 0, 0, 1, 0, 0, 1, 1, 1],
      [0, 0, 1, 1, 1, 0, 1, 1, 0, 0],
      [0, 0, 2, 1, 1, 1, 0, 0, 1, 0],
      [1, 1, 2, 1, 1, 0, 0, 0, 0, 1],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 2, 0, 2, 1, 1, 0, 1, 0, 0],
      [1, 2, 0, 2, 1, 0, 1, 0, 1, 0],
      [2, 2, 1, 2, 1, 0, 0, 0, 0, 1],
      [2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
      [2, 1, 2, 0, 1, 0, 1, 1, 0, 0],
      [2, 1, 1, 0, 1, 1, 0, 0, 1, 0],
    ] as const,
    systemType: 'R',
    systemNum: 41,
    hasXpert: false,
  } as const,
  'R4-6-72': {
    guaranty: 11,
    numFullHedges: 4,
    numHalfHedges: 6,
    rows: [
      [1, 0, 1, 2, 0, 0, 1, 0, 1, 1],
      [0, 1, 2, 0, 1, 0, 0, 1, 1, 0],
      [1, 0, 2, 1, 1, 1, 1, 0, 0, 0],
      [1, 1, 2, 0, 0, 1, 0, 1, 0, 1],
      [2, 1, 1, 1, 0, 1, 1, 0, 0, 1],
      [0, 2, 0, 1, 1, 1, 1, 0, 0, 0],
      [2, 1, 1, 1, 1, 1, 0, 1, 0, 0],
      [1, 0, 1, 2, 0, 1, 1, 1, 1, 0],
      [2, 0, 0, 0, 1, 0, 1, 0, 1, 0],
      [2, 1, 1, 1, 1, 0, 1, 0, 1, 0],
      [2, 2, 2, 2, 1, 1, 0, 1, 0, 0],
      [2, 2, 2, 2, 0, 0, 0, 1, 1, 1],
      [0, 2, 1, 0, 0, 1, 0, 1, 0, 1],
      [0, 2, 1, 0, 0, 0, 1, 0, 1, 1],
      [0, 2, 1, 0, 0, 1, 1, 1, 1, 0],
      [2, 0, 0, 0, 0, 1, 1, 0, 0, 1],
      [2, 2, 2, 2, 1, 0, 1, 0, 1, 0],
      [2, 0, 0, 0, 0, 0, 1, 1, 0, 0],
      [0, 1, 2, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 2, 1, 0, 1, 0, 1, 0, 1],
      [1, 2, 1, 0, 1, 1, 0, 0, 1, 1],
      [1, 1, 0, 2, 1, 0, 1, 1, 0, 1],
      [1, 0, 2, 1, 1, 0, 1, 1, 0, 1],
      [0, 0, 2, 1, 0, 0, 0, 0, 0, 0],
      [2, 1, 1, 1, 0, 1, 0, 0, 1, 0],
      [2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
      [0, 1, 0, 2, 0, 0, 0, 0, 0, 0],
      [2, 2, 2, 2, 1, 0, 0, 0, 0, 1],
      [1, 0, 1, 2, 0, 0, 0, 0, 0, 0],
      [0, 1, 2, 0, 1, 0, 1, 1, 0, 1],
      [2, 0, 0, 0, 0, 0, 0, 1, 1, 1],
      [0, 2, 0, 1, 1, 0, 0, 1, 1, 0],
      [1, 1, 0, 2, 1, 1, 0, 0, 1, 1],
      [0, 0, 1, 2, 1, 0, 1, 1, 0, 1],
      [1, 0, 2, 1, 1, 0, 0, 1, 1, 0],
      [2, 2, 2, 2, 0, 0, 1, 1, 0, 0],
      [2, 0, 0, 0, 1, 1, 0, 1, 0, 0],
      [1, 1, 2, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 2, 0, 1, 0, 1, 0, 1],
      [2, 0, 0, 0, 0, 1, 0, 0, 1, 0],
      [0, 0, 2, 1, 0, 0, 1, 0, 1, 1],
      [0, 1, 2, 0, 1, 1, 0, 0, 1, 1],
      [0, 0, 2, 1, 0, 1, 1, 1, 1, 0],
      [0, 2, 0, 1, 1, 0, 1, 1, 0, 1],
      [0, 0, 1, 2, 1, 1, 1, 0, 0, 0],
      [1, 2, 0, 1, 0, 0, 1, 0, 1, 1],
      [1, 2, 0, 1, 0, 1, 0, 1, 0, 1],
      [0, 2, 1, 0, 0, 0, 0, 0, 0, 0],
      [1, 2, 0, 1, 0, 0, 0, 0, 0, 0],
      [2, 0, 0, 0, 1, 1, 1, 1, 1, 1],
      [0, 2, 0, 1, 1, 1, 0, 0, 1, 1],
      [0, 1, 0, 2, 0, 1, 1, 1, 1, 0],
      [2, 1, 1, 1, 0, 0, 0, 1, 1, 1],
      [1, 1, 0, 2, 1, 0, 0, 1, 1, 0],
      [1, 0, 2, 1, 1, 1, 0, 0, 1, 1],
      [2, 1, 1, 1, 1, 0, 0, 0, 0, 1],
      [2, 2, 2, 2, 0, 1, 0, 0, 1, 0],
      [2, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 1, 2, 1, 0, 0, 1, 1, 0],
      [2, 2, 2, 2, 0, 1, 1, 0, 0, 1],
      [1, 1, 0, 2, 1, 1, 1, 0, 0, 0],
      [2, 1, 1, 1, 0, 0, 1, 1, 0, 0],
      [0, 1, 0, 2, 0, 1, 0, 1, 0, 1],
      [0, 0, 1, 2, 1, 1, 0, 0, 1, 1],
      [0, 1, 0, 2, 0, 0, 1, 0, 1, 1],
      [1, 2, 1, 0, 1, 0, 0, 1, 1, 0],
      [1, 2, 0, 1, 0, 1, 1, 1, 1, 0],
      [1, 2, 1, 0, 1, 1, 1, 0, 0, 0],
      [2, 0, 0, 0, 1, 0, 0, 0, 0, 1],
      [1, 1, 2, 0, 0, 1, 1, 1, 1, 0],
      [1, 1, 2, 0, 0, 0, 1, 0, 1, 1],
      [1, 2, 1, 0, 1, 0, 1, 1, 0, 1],
    ] as const,
    systemType: 'R',
    systemNum: 42,
    hasXpert: true,
  } as const,
  'R4-7-144': {
    guaranty: 11,
    numFullHedges: 4,
    numHalfHedges: 7,
    rows: [
      [0, 0, 0, 0, 1, 1, 1, 1, 0, 1, 1],
      [0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1],
      [0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0],
      [0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1],
      [0, 0, 0, 0, 1, 1, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 1, 0, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 1],
      [0, 0, 0, 0, 1, 0, 1, 0, 1, 1, 0],
      [0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 1, 1, 1, 1],
      [0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 1, 1, 0, 1, 1],
      [1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0],
      [1, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1],
      [1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0],
      [1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1],
      [1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 0],
      [1, 1, 1, 0, 0, 0, 0, 0, 1, 0, 1],
      [1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 0],
      [1, 1, 1, 0, 1, 0, 0, 1, 1, 1, 0],
      [1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1],
      [1, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0],
      [1, 1, 1, 0, 0, 1, 1, 0, 0, 0, 1],
      [1, 1, 1, 0, 1, 0, 1, 0, 1, 1, 1],
      [1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 1, 0, 1, 1, 1, 1],
      [1, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0],
      [2, 2, 2, 0, 0, 1, 0, 1, 0, 1, 1],
      [2, 2, 2, 0, 0, 1, 0, 1, 1, 0, 0],
      [2, 2, 2, 0, 1, 0, 1, 0, 0, 1, 1],
      [2, 2, 2, 0, 1, 0, 1, 0, 1, 0, 0],
      [2, 2, 2, 0, 1, 0, 0, 1, 1, 0, 1],
      [2, 2, 2, 0, 1, 0, 0, 1, 0, 1, 0],
      [2, 2, 2, 0, 0, 1, 1, 0, 1, 0, 1],
      [2, 2, 2, 0, 0, 1, 1, 0, 0, 1, 0],
      [2, 2, 2, 0, 1, 1, 1, 1, 1, 1, 0],
      [2, 2, 2, 0, 1, 1, 1, 1, 0, 0, 1],
      [2, 2, 2, 0, 0, 0, 0, 0, 1, 1, 0],
      [2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 1],
      [2, 2, 2, 0, 1, 1, 0, 0, 1, 1, 1],
      [2, 2, 2, 0, 1, 1, 0, 0, 0, 0, 0],
      [2, 2, 2, 0, 0, 0, 1, 1, 1, 1, 1],
      [2, 2, 2, 0, 0, 0, 1, 1, 0, 0, 0],
      [2, 1, 0, 1, 0, 1, 1, 0, 0, 1, 1],
      [2, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0],
      [2, 1, 0, 1, 1, 0, 0, 1, 0, 1, 1],
      [2, 1, 0, 1, 1, 0, 0, 1, 1, 0, 0],
      [2, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1],
      [2, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0],
      [2, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1],
      [2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
      [2, 1, 0, 1, 1, 1, 0, 0, 1, 1, 0],
      [2, 1, 0, 1, 1, 1, 0, 0, 0, 0, 1],
      [2, 1, 0, 1, 0, 0, 1, 1, 1, 1, 0],
      [2, 1, 0, 1, 0, 0, 1, 1, 0, 0, 1],
      [2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1],
      [2, 1, 0, 1, 1, 1, 1, 1, 0, 0, 0],
      [2, 1, 0, 1, 0, 0, 0, 0, 1, 1, 1],
      [2, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 1, 0, 1, 1, 1, 1, 1, 1],
      [0, 2, 1, 1, 0, 1, 1, 1, 0, 0, 0],
      [0, 2, 1, 1, 1, 0, 0, 0, 1, 1, 1],
      [0, 2, 1, 1, 1, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 1, 1, 0, 1, 1, 0, 0, 1],
      [0, 2, 1, 1, 1, 0, 1, 1, 1, 1, 0],
      [0, 2, 1, 1, 0, 1, 0, 0, 0, 0, 1],
      [0, 2, 1, 1, 0, 1, 0, 0, 1, 1, 0],
      [0, 2, 1, 1, 1, 1, 0, 1, 0, 1, 0],
      [0, 2, 1, 1, 1, 1, 0, 1, 1, 0, 1],
      [0, 2, 1, 1, 0, 0, 1, 0, 0, 1, 0],
      [0, 2, 1, 1, 0, 0, 1, 0, 1, 0, 1],
      [0, 2, 1, 1, 1, 1, 1, 0, 0, 1, 1],
      [0, 2, 1, 1, 1, 1, 1, 0, 1, 0, 0],
      [0, 2, 1, 1, 0, 0, 0, 1, 0, 1, 1],
      [0, 2, 1, 1, 0, 0, 0, 1, 1, 0, 0],
      [1, 0, 2, 1, 0, 1, 1, 1, 0, 0, 1],
      [1, 0, 2, 1, 0, 1, 1, 1, 1, 1, 0],
      [1, 0, 2, 1, 1, 0, 0, 0, 0, 0, 1],
      [1, 0, 2, 1, 1, 0, 0, 0, 1, 1, 0],
      [1, 0, 2, 1, 1, 0, 1, 1, 1, 1, 1],
      [1, 0, 2, 1, 1, 0, 1, 1, 0, 0, 0],
      [1, 0, 2, 1, 0, 1, 0, 0, 1, 1, 1],
      [1, 0, 2, 1, 0, 1, 0, 0, 0, 0, 0],
      [1, 0, 2, 1, 1, 1, 0, 1, 1, 0, 0],
      [1, 0, 2, 1, 1, 1, 0, 1, 0, 1, 1],
      [1, 0, 2, 1, 0, 0, 1, 0, 1, 0, 0],
      [1, 0, 2, 1, 0, 0, 1, 0, 0, 1, 1],
      [1, 0, 2, 1, 1, 1, 1, 0, 1, 0, 1],
      [1, 0, 2, 1, 1, 1, 1, 0, 0, 1, 0],
      [1, 0, 2, 1, 0, 0, 0, 1, 1, 0, 1],
      [1, 0, 2, 1, 0, 0, 0, 1, 0, 1, 0],
      [1, 2, 0, 2, 0, 1, 1, 1, 0, 1, 0],
      [1, 2, 0, 2, 0, 1, 1, 1, 1, 0, 1],
      [1, 2, 0, 2, 1, 0, 0, 0, 0, 1, 0],
      [1, 2, 0, 2, 1, 0, 0, 0, 1, 0, 1],
      [1, 2, 0, 2, 1, 0, 1, 1, 1, 0, 0],
      [1, 2, 0, 2, 1, 0, 1, 1, 0, 1, 1],
      [1, 2, 0, 2, 0, 1, 0, 0, 1, 0, 0],
      [1, 2, 0, 2, 0, 1, 0, 0, 0, 1, 1],
      [1, 2, 0, 2, 1, 1, 0, 1, 1, 1, 1],
      [1, 2, 0, 2, 1, 1, 0, 1, 0, 0, 0],
      [1, 2, 0, 2, 0, 0, 1, 0, 1, 1, 1],
      [1, 2, 0, 2, 0, 0, 1, 0, 0, 0, 0],
      [1, 2, 0, 2, 1, 1, 1, 0, 1, 1, 0],
      [1, 2, 0, 2, 1, 1, 1, 0, 0, 0, 1],
      [1, 2, 0, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 2, 0, 2, 0, 0, 0, 1, 0, 0, 1],
      [2, 0, 1, 2, 0, 1, 1, 1, 0, 0, 0],
      [2, 0, 1, 2, 0, 1, 1, 1, 1, 1, 1],
      [2, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0],
      [2, 0, 1, 2, 1, 0, 0, 0, 1, 1, 1],
      [2, 0, 1, 2, 1, 0, 1, 1, 1, 1, 0],
      [2, 0, 1, 2, 1, 0, 1, 1, 0, 0, 1],
      [2, 0, 1, 2, 0, 1, 0, 0, 1, 1, 0],
      [2, 0, 1, 2, 0, 1, 0, 0, 0, 0, 1],
      [2, 0, 1, 2, 1, 1, 0, 1, 1, 0, 1],
      [2, 0, 1, 2, 1, 1, 0, 1, 0, 1, 0],
      [2, 0, 1, 2, 0, 0, 1, 0, 1, 0, 1],
      [2, 0, 1, 2, 0, 0, 1, 0, 0, 1, 0],
      [2, 0, 1, 2, 1, 1, 1, 0, 1, 0, 0],
      [2, 0, 1, 2, 1, 1, 1, 0, 0, 1, 1],
      [2, 0, 1, 2, 0, 0, 0, 1, 1, 0, 0],
      [2, 0, 1, 2, 0, 0, 0, 1, 0, 1, 1],
      [0, 1, 2, 2, 0, 1, 0, 0, 0, 1, 0],
      [0, 1, 2, 2, 0, 1, 0, 0, 1, 0, 1],
      [0, 1, 2, 2, 1, 0, 1, 1, 0, 1, 0],
      [0, 1, 2, 2, 1, 0, 1, 1, 1, 0, 1],
      [0, 1, 2, 2, 1, 0, 0, 0, 1, 0, 0],
      [0, 1, 2, 2, 1, 0, 0, 0, 0, 1, 1],
      [0, 1, 2, 2, 0, 1, 1, 1, 1, 0, 0],
      [0, 1, 2, 2, 0, 1, 1, 1, 0, 1, 1],
      [0, 1, 2, 2, 1, 1, 1, 0, 1, 1, 1],
      [0, 1, 2, 2, 1, 1, 1, 0, 0, 0, 0],
      [0, 1, 2, 2, 0, 0, 0, 1, 1, 1, 1],
      [0, 1, 2, 2, 0, 0, 0, 1, 0, 0, 0],
      [0, 1, 2, 2, 1, 1, 0, 1, 1, 1, 0],
      [0, 1, 2, 2, 1, 1, 0, 1, 0, 0, 1],
      [0, 1, 2, 2, 0, 0, 1, 0, 1, 1, 0],
      [0, 1, 2, 2, 0, 0, 1, 0, 0, 0, 1],
    ] as const,
    systemType: 'R',
    systemNum: 44,
    hasXpert: false,
  } as const,
  'R4-7-48': {
    guaranty: 10,
    numFullHedges: 4,
    numHalfHedges: 7,
    rows: [
      [2, 2, 0, 1, 0, 0, 1, 0, 1, 0, 1],
      [1, 0, 2, 1, 1, 1, 1, 0, 0, 0, 0],
      [1, 2, 1, 2, 0, 1, 0, 0, 1, 0, 1],
      [1, 0, 2, 1, 0, 0, 0, 1, 1, 0, 0],
      [1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0],
      [2, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1],
      [1, 2, 1, 2, 1, 0, 1, 1, 0, 0, 1],
      [2, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0],
      [1, 1, 2, 0, 0, 0, 1, 0, 0, 1, 1],
      [1, 1, 2, 0, 0, 0, 1, 0, 1, 0, 0],
      [0, 1, 0, 1, 1, 0, 1, 1, 1, 1, 1],
      [2, 2, 0, 1, 1, 1, 0, 1, 0, 0, 1],
      [2, 2, 0, 1, 1, 1, 0, 1, 1, 1, 0],
      [2, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1],
      [0, 2, 2, 2, 0, 1, 1, 1, 0, 0, 0],
      [2, 1, 0, 2, 0, 0, 0, 1, 0, 1, 0],
      [1, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1],
      [2, 0, 2, 0, 0, 1, 0, 0, 1, 0, 0],
      [0, 1, 0, 1, 1, 0, 1, 1, 0, 0, 0],
      [2, 1, 0, 2, 1, 1, 1, 0, 0, 0, 1],
      [0, 2, 2, 2, 0, 1, 1, 1, 1, 1, 1],
      [0, 0, 1, 2, 1, 1, 0, 1, 1, 1, 0],
      [0, 0, 1, 2, 0, 0, 1, 0, 1, 0, 1],
      [0, 2, 2, 2, 1, 0, 0, 0, 0, 1, 1],
      [0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 0],
      [2, 1, 0, 2, 0, 0, 0, 1, 1, 0, 1],
      [2, 1, 0, 2, 1, 1, 1, 0, 1, 1, 0],
      [1, 2, 1, 2, 1, 0, 1, 1, 1, 1, 0],
      [0, 2, 1, 0, 1, 1, 1, 0, 0, 0, 1],
      [2, 2, 0, 1, 0, 0, 1, 0, 0, 1, 0],
      [0, 0, 1, 2, 0, 0, 1, 0, 0, 1, 0],
      [1, 2, 1, 2, 0, 1, 0, 0, 0, 1, 0],
      [1, 1, 2, 0, 1, 1, 0, 1, 1, 1, 1],
      [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1],
      [0, 0, 1, 2, 1, 1, 0, 1, 0, 0, 1],
      [2, 1, 1, 1, 1, 0, 0, 0, 1, 0, 0],
      [0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 1],
      [1, 0, 2, 1, 0, 0, 0, 1, 0, 1, 1],
      [1, 0, 2, 1, 1, 1, 1, 0, 1, 1, 1],
      [0, 2, 1, 0, 1, 1, 1, 0, 1, 1, 0],
      [2, 0, 2, 0, 0, 1, 0, 0, 0, 1, 1],
      [2, 0, 2, 0, 1, 0, 1, 1, 0, 0, 0],
      [0, 2, 1, 0, 0, 0, 0, 1, 0, 1, 0],
      [1, 1, 2, 0, 1, 1, 0, 1, 0, 0, 0],
      [2, 0, 2, 0, 1, 0, 1, 1, 1, 1, 1],
      [0, 2, 1, 0, 0, 0, 0, 1, 1, 0, 1],
      [0, 2, 2, 2, 1, 0, 0, 0, 1, 0, 0],
      [1, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0],
    ] as const,
    systemType: 'R',
    systemNum: 43,
    hasXpert: false,
  } as const,
  'R5-0-18': {
    guaranty: 11,
    numFullHedges: 5,
    numHalfHedges: 0,
    rows: [
      [2, 0, 0, 0, 2],
      [1, 2, 0, 2, 0],
      [0, 1, 1, 0, 1],
      [1, 2, 0, 0, 2],
      [0, 1, 2, 0, 0],
      [0, 1, 0, 1, 1],
      [0, 1, 2, 1, 2],
      [1, 2, 2, 2, 1],
      [2, 0, 2, 0, 0],
      [2, 0, 1, 2, 2],
      [2, 0, 0, 1, 1],
      [2, 0, 2, 2, 1],
      [1, 2, 1, 0, 1],
      [1, 2, 2, 1, 2],
      [0, 1, 1, 2, 2],
      [0, 1, 0, 2, 0],
      [1, 2, 1, 1, 0],
      [2, 0, 1, 1, 0],
    ] as const,
    systemType: 'R',
    systemNum: 45,
    hasXpert: true,
  } as const,
  'R5-3-36': {
    guaranty: 11,
    numFullHedges: 5,
    numHalfHedges: 3,
    rows: [
      [0, 0, 1, 2, 1, 1, 1, 1],
      [1, 0, 0, 2, 2, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 0],
      [1, 2, 1, 0, 0, 1, 0, 1],
      [1, 1, 2, 0, 1, 1, 1, 1],
      [2, 1, 1, 0, 1, 1, 0, 0],
      [2, 0, 2, 1, 2, 0, 1, 0],
      [1, 0, 0, 2, 0, 0, 1, 1],
      [0, 2, 2, 1, 1, 1, 0, 0],
      [2, 2, 2, 2, 1, 0, 0, 1],
      [2, 0, 2, 1, 0, 1, 0, 1],
      [1, 1, 2, 0, 2, 1, 1, 1],
      [1, 1, 1, 1, 0, 1, 1, 0],
      [0, 0, 1, 2, 2, 1, 1, 1],
      [2, 1, 1, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 1, 0, 0, 1],
      [0, 1, 0, 2, 0, 1, 0, 1],
      [1, 0, 0, 2, 1, 1, 0, 0],
      [1, 2, 1, 0, 1, 0, 1, 0],
      [2, 2, 2, 2, 0, 1, 1, 0],
      [0, 1, 0, 2, 2, 0, 1, 0],
      [2, 1, 1, 0, 2, 1, 0, 0],
      [0, 2, 2, 1, 0, 0, 1, 1],
      [2, 2, 0, 1, 0, 0, 0, 0],
      [2, 2, 0, 1, 1, 1, 1, 1],
      [0, 1, 0, 2, 1, 0, 1, 0],
      [2, 2, 2, 2, 2, 0, 0, 1],
      [0, 2, 2, 1, 2, 1, 0, 0],
      [1, 1, 1, 1, 2, 0, 0, 1],
      [1, 1, 1, 1, 1, 0, 0, 1],
      [2, 0, 2, 1, 1, 0, 1, 0],
      [0, 0, 0, 0, 2, 0, 0, 1],
      [2, 2, 0, 1, 2, 1, 1, 1],
      [1, 2, 1, 0, 2, 0, 1, 0],
      [0, 0, 1, 2, 0, 0, 0, 0],
      [1, 1, 2, 0, 0, 0, 0, 0],
    ] as const,
    systemType: 'R',
    systemNum: 46,
    hasXpert: false,
  } as const,
  'R5-5-108': {
    guaranty: 11,
    numFullHedges: 5,
    numHalfHedges: 5,
    rows: [
      [2, 1, 0, 0, 2, 0, 1, 1, 0, 0],
      [0, 2, 1, 0, 2, 0, 1, 1, 0, 0],
      [1, 0, 2, 0, 2, 0, 1, 1, 0, 0],
      [1, 2, 0, 0, 2, 1, 0, 0, 0, 0],
      [2, 0, 1, 0, 2, 1, 0, 0, 0, 0],
      [0, 1, 2, 0, 2, 1, 0, 0, 0, 0],
      [2, 1, 0, 1, 2, 1, 0, 0, 0, 0],
      [0, 2, 1, 1, 2, 1, 0, 0, 0, 0],
      [1, 0, 2, 1, 2, 1, 0, 0, 0, 0],
      [1, 2, 0, 1, 2, 0, 1, 1, 0, 0],
      [2, 0, 1, 1, 2, 0, 1, 1, 0, 0],
      [0, 1, 2, 1, 2, 0, 1, 1, 0, 0],
      [0, 0, 0, 2, 2, 1, 1, 0, 1, 0],
      [1, 1, 1, 2, 2, 1, 1, 0, 1, 0],
      [2, 2, 2, 2, 2, 1, 1, 0, 1, 0],
      [0, 0, 0, 2, 2, 0, 0, 1, 1, 0],
      [1, 1, 1, 2, 2, 0, 0, 1, 1, 0],
      [2, 2, 2, 2, 2, 0, 0, 1, 1, 0],
      [2, 1, 0, 0, 2, 1, 1, 1, 1, 1],
      [0, 2, 1, 0, 2, 1, 1, 1, 1, 1],
      [1, 0, 2, 0, 2, 1, 1, 1, 1, 1],
      [1, 2, 0, 0, 2, 0, 0, 0, 1, 1],
      [2, 0, 1, 0, 2, 0, 0, 0, 1, 1],
      [0, 1, 2, 0, 2, 0, 0, 0, 1, 1],
      [2, 1, 0, 1, 2, 0, 0, 0, 1, 1],
      [0, 2, 1, 1, 2, 0, 0, 0, 1, 1],
      [1, 0, 2, 1, 2, 0, 0, 0, 1, 1],
      [1, 2, 0, 1, 2, 1, 1, 1, 1, 1],
      [2, 0, 1, 1, 2, 1, 1, 1, 1, 1],
      [0, 1, 2, 1, 2, 1, 1, 1, 1, 1],
      [0, 0, 0, 2, 2, 0, 1, 0, 0, 1],
      [1, 1, 1, 2, 2, 0, 1, 0, 0, 1],
      [2, 2, 2, 2, 2, 0, 1, 0, 0, 1],
      [0, 0, 0, 2, 2, 1, 0, 1, 0, 1],
      [1, 1, 1, 2, 2, 1, 0, 1, 0, 1],
      [2, 2, 2, 2, 2, 1, 0, 1, 0, 1],
      [1, 2, 0, 0, 1, 0, 1, 1, 0, 0],
      [2, 0, 1, 0, 1, 0, 1, 1, 0, 0],
      [0, 1, 2, 0, 1, 0, 1, 1, 0, 0],
      [2, 1, 0, 0, 1, 1, 0, 0, 0, 0],
      [0, 2, 1, 0, 1, 1, 0, 0, 0, 0],
      [1, 0, 2, 0, 1, 1, 0, 0, 0, 0],
      [1, 2, 0, 1, 1, 1, 0, 0, 0, 0],
      [2, 0, 1, 1, 1, 1, 0, 0, 0, 0],
      [0, 1, 2, 1, 1, 1, 0, 0, 0, 0],
      [2, 1, 0, 1, 1, 0, 1, 1, 0, 0],
      [0, 2, 1, 1, 1, 0, 1, 1, 0, 0],
      [1, 0, 2, 1, 1, 0, 1, 1, 0, 0],
      [0, 0, 0, 2, 1, 1, 1, 0, 1, 0],
      [1, 1, 1, 2, 1, 1, 1, 0, 1, 0],
      [2, 2, 2, 2, 1, 1, 1, 0, 1, 0],
      [0, 0, 0, 2, 1, 0, 0, 1, 1, 0],
      [1, 1, 1, 2, 1, 0, 0, 1, 1, 0],
      [2, 2, 2, 2, 1, 0, 0, 1, 1, 0],
      [1, 2, 0, 0, 1, 1, 1, 1, 1, 1],
      [2, 0, 1, 0, 1, 1, 1, 1, 1, 1],
      [0, 1, 2, 0, 1, 1, 1, 1, 1, 1],
      [2, 1, 0, 0, 1, 0, 0, 0, 1, 1],
      [0, 2, 1, 0, 1, 0, 0, 0, 1, 1],
      [1, 0, 2, 0, 1, 0, 0, 0, 1, 1],
      [1, 2, 0, 1, 1, 0, 0, 0, 1, 1],
      [2, 0, 1, 1, 1, 0, 0, 0, 1, 1],
      [0, 1, 2, 1, 1, 0, 0, 0, 1, 1],
      [2, 1, 0, 1, 1, 1, 1, 1, 1, 1],
      [0, 2, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 0, 2, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 2, 1, 0, 1, 0, 0, 1],
      [1, 1, 1, 2, 1, 0, 1, 0, 0, 1],
      [2, 2, 2, 2, 1, 0, 1, 0, 0, 1],
      [0, 0, 0, 2, 1, 1, 0, 1, 0, 1],
      [1, 1, 1, 2, 1, 1, 0, 1, 0, 1],
      [2, 2, 2, 2, 1, 1, 0, 1, 0, 1],
      [1, 2, 0, 0, 0, 1, 0, 1, 1, 0],
      [2, 0, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 1, 2, 0, 0, 1, 0, 1, 1, 0],
      [2, 1, 0, 0, 0, 0, 1, 0, 1, 0],
      [0, 2, 1, 0, 0, 0, 1, 0, 1, 0],
      [1, 0, 2, 0, 0, 0, 1, 0, 1, 0],
      [1, 2, 0, 1, 0, 0, 1, 0, 1, 0],
      [2, 0, 1, 1, 0, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 0, 0, 1, 0, 1, 0],
      [2, 1, 0, 1, 0, 1, 0, 1, 1, 0],
      [0, 2, 1, 1, 0, 1, 0, 1, 1, 0],
      [1, 0, 2, 1, 0, 1, 0, 1, 1, 0],
      [0, 0, 0, 2, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 2, 0, 0, 0, 0, 0, 0],
      [2, 2, 2, 2, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 1, 1, 1, 0, 0],
      [1, 1, 1, 2, 0, 1, 1, 1, 0, 0],
      [2, 2, 2, 2, 0, 1, 1, 1, 0, 0],
      [1, 2, 0, 0, 0, 0, 0, 1, 0, 1],
      [2, 0, 1, 0, 0, 0, 0, 1, 0, 1],
      [0, 1, 2, 0, 0, 0, 0, 1, 0, 1],
      [2, 1, 0, 0, 0, 1, 1, 0, 0, 1],
      [0, 2, 1, 0, 0, 1, 1, 0, 0, 1],
      [1, 0, 2, 0, 0, 1, 1, 0, 0, 1],
      [1, 2, 0, 1, 0, 1, 1, 0, 0, 1],
      [2, 0, 1, 1, 0, 1, 1, 0, 0, 1],
      [0, 1, 2, 1, 0, 1, 1, 0, 0, 1],
      [2, 1, 0, 1, 0, 0, 0, 1, 0, 1],
      [0, 2, 1, 1, 0, 0, 0, 1, 0, 1],
      [1, 0, 2, 1, 0, 0, 0, 1, 0, 1],
      [0, 0, 0, 2, 0, 1, 0, 0, 1, 1],
      [1, 1, 1, 2, 0, 1, 0, 0, 1, 1],
      [2, 2, 2, 2, 0, 1, 0, 0, 1, 1],
      [0, 0, 0, 2, 0, 0, 1, 1, 1, 1],
      [1, 1, 1, 2, 0, 0, 1, 1, 1, 1],
      [2, 2, 2, 2, 0, 0, 1, 1, 1, 1],
    ] as const,
    systemType: 'R',
    systemNum: 47,
    hasXpert: true,
  } as const,
  'R6-3-24': {
    guaranty: 10,
    numFullHedges: 6,
    numHalfHedges: 3,
    rows: [
      [2, 2, 2, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 0, 0, 0],
      [1, 1, 1, 2, 2, 2, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 1, 1, 1],
      [2, 2, 2, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 2, 2, 2, 1, 1, 1],
      [2, 2, 0, 2, 0, 0, 0, 1, 1],
      [0, 0, 1, 0, 1, 1, 0, 1, 1],
      [1, 1, 2, 1, 2, 2, 0, 1, 1],
      [1, 1, 0, 1, 0, 0, 1, 0, 0],
      [2, 2, 1, 2, 1, 1, 1, 0, 0],
      [0, 0, 2, 0, 2, 2, 1, 0, 0],
      [2, 2, 0, 0, 2, 0, 1, 0, 1],
      [0, 0, 1, 1, 0, 1, 1, 0, 1],
      [1, 1, 2, 2, 1, 2, 1, 0, 1],
      [1, 1, 0, 0, 1, 0, 0, 1, 0],
      [2, 2, 1, 1, 2, 1, 0, 1, 0],
      [0, 0, 2, 2, 0, 2, 0, 1, 0],
      [2, 2, 0, 0, 0, 2, 1, 1, 0],
      [0, 0, 1, 1, 1, 0, 1, 1, 0],
      [1, 1, 2, 2, 2, 1, 1, 1, 0],
      [1, 1, 0, 0, 0, 1, 0, 0, 1],
      [2, 2, 1, 1, 1, 2, 0, 0, 1],
      [0, 0, 2, 2, 2, 0, 0, 0, 1],
    ] as const,
    systemType: 'R',
    systemNum: 48,
    hasXpert: false,
  } as const,
  'R6-3-72': {
    guaranty: 11,
    numFullHedges: 6,
    numHalfHedges: 3,
    rows: [
      [1, 1, 0, 0, 2, 2, 0, 0, 0],
      [0, 0, 2, 1, 0, 0, 0, 0, 0],
      [0, 0, 2, 2, 1, 1, 1, 0, 1],
      [0, 2, 0, 2, 1, 1, 0, 0, 0],
      [0, 1, 1, 0, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 0, 1, 1, 0, 0],
      [0, 1, 1, 1, 2, 1, 1, 1, 0],
      [2, 0, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 1, 0, 2, 2, 1, 0, 1],
      [2, 0, 0, 2, 2, 0, 1, 1, 0],
      [0, 0, 2, 0, 2, 2, 1, 1, 1],
      [0, 2, 0, 0, 2, 2, 0, 1, 0],
      [2, 2, 1, 2, 1, 1, 0, 1, 0],
      [2, 2, 1, 1, 0, 0, 1, 1, 1],
      [1, 1, 0, 1, 0, 0, 0, 0, 0],
      [1, 2, 2, 0, 1, 0, 0, 0, 1],
      [2, 1, 2, 2, 1, 1, 1, 1, 1],
      [0, 1, 1, 2, 0, 2, 1, 1, 0],
      [1, 2, 2, 1, 1, 2, 1, 0, 0],
      [1, 2, 2, 2, 2, 0, 1, 0, 0],
      [2, 2, 1, 1, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 1, 0, 0, 0, 1],
      [2, 0, 0, 0, 1, 0, 1, 0, 0],
      [2, 1, 2, 0, 2, 2, 1, 0, 1],
      [2, 0, 0, 2, 0, 2, 1, 0, 0],
      [0, 1, 1, 1, 1, 2, 0, 1, 1],
      [0, 0, 2, 1, 0, 0, 1, 1, 1],
      [0, 1, 1, 0, 0, 1, 0, 1, 1],
      [1, 2, 2, 2, 0, 2, 0, 0, 1],
      [0, 0, 2, 2, 1, 1, 0, 1, 0],
      [2, 2, 1, 0, 2, 2, 1, 1, 1],
      [2, 0, 0, 1, 1, 2, 1, 1, 0],
      [1, 2, 2, 1, 2, 1, 1, 1, 0],
      [1, 2, 2, 0, 0, 1, 0, 1, 1],
      [1, 1, 0, 1, 0, 0, 1, 1, 1],
      [1, 2, 2, 1, 2, 1, 0, 0, 1],
      [1, 1, 0, 0, 2, 2, 1, 1, 1],
      [2, 0, 0, 2, 2, 0, 0, 0, 1],
      [1, 0, 1, 2, 1, 1, 1, 1, 1],
      [1, 2, 2, 0, 0, 1, 1, 0, 0],
      [1, 2, 2, 0, 1, 0, 1, 1, 0],
      [0, 2, 0, 1, 0, 0, 0, 1, 0],
      [1, 2, 2, 2, 2, 0, 0, 1, 1],
      [1, 0, 1, 0, 2, 2, 0, 1, 0],
      [0, 1, 1, 2, 2, 0, 1, 0, 0],
      [2, 0, 0, 2, 0, 2, 0, 1, 1],
      [2, 0, 0, 1, 2, 1, 0, 1, 1],
      [1, 1, 0, 2, 1, 1, 1, 0, 1],
      [0, 2, 0, 1, 0, 0, 1, 0, 1],
      [2, 1, 2, 1, 0, 0, 1, 0, 1],
      [2, 1, 2, 0, 2, 2, 0, 1, 0],
      [0, 1, 1, 2, 0, 2, 0, 0, 1],
      [1, 2, 2, 2, 0, 2, 1, 1, 0],
      [2, 0, 0, 1, 1, 2, 0, 0, 1],
      [2, 0, 0, 0, 1, 0, 0, 1, 1],
      [2, 0, 0, 0, 0, 1, 0, 0, 1],
      [1, 0, 1, 1, 0, 0, 1, 0, 1],
      [0, 1, 1, 1, 2, 1, 0, 0, 1],
      [1, 2, 2, 1, 1, 2, 0, 1, 1],
      [1, 0, 1, 2, 1, 1, 0, 0, 0],
      [0, 1, 1, 2, 2, 0, 0, 1, 1],
      [0, 2, 0, 2, 1, 1, 1, 1, 1],
      [0, 1, 1, 1, 1, 2, 1, 0, 0],
      [2, 2, 1, 0, 2, 2, 0, 0, 0],
      [2, 2, 1, 2, 1, 1, 1, 0, 1],
      [1, 0, 1, 1, 0, 0, 0, 1, 0],
      [0, 0, 2, 0, 2, 2, 0, 0, 0],
      [1, 1, 0, 2, 1, 1, 0, 1, 0],
      [2, 0, 0, 1, 2, 1, 1, 0, 0],
      [2, 1, 2, 1, 0, 0, 0, 1, 0],
      [0, 2, 0, 0, 2, 2, 1, 0, 1],
      [2, 1, 2, 2, 1, 1, 0, 0, 0],
    ] as const,
    systemType: 'R',
    systemNum: 49,
    hasXpert: false,
  } as const,
  'R6-4-44': {
    guaranty: 10,
    numFullHedges: 6,
    numHalfHedges: 4,
    rows: [
      [1, 2, 2, 2, 2, 2, 1, 0, 0, 0],
      [1, 2, 2, 2, 2, 2, 0, 1, 1, 1],
      [1, 2, 0, 1, 1, 1, 0, 0, 1, 0],
      [1, 2, 0, 1, 1, 1, 1, 1, 0, 1],
      [0, 0, 0, 0, 2, 2, 1, 1, 0, 0],
      [0, 0, 0, 0, 2, 2, 0, 0, 1, 1],
      [0, 0, 0, 2, 0, 2, 1, 0, 1, 0],
      [0, 0, 0, 2, 0, 2, 0, 1, 0, 1],
      [0, 0, 0, 2, 2, 0, 0, 1, 1, 0],
      [0, 0, 0, 2, 2, 0, 1, 0, 0, 1],
      [0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
      [0, 1, 2, 1, 1, 2, 0, 1, 1, 0],
      [0, 1, 2, 1, 1, 2, 1, 0, 0, 1],
      [0, 1, 2, 1, 2, 1, 1, 0, 1, 0],
      [0, 1, 2, 1, 2, 1, 0, 1, 0, 1],
      [0, 1, 2, 2, 1, 1, 0, 0, 1, 1],
      [0, 1, 2, 2, 1, 1, 1, 1, 0, 0],
      [0, 1, 2, 0, 0, 0, 1, 1, 1, 1],
      [0, 1, 2, 0, 0, 0, 0, 0, 0, 0],
      [1, 2, 1, 1, 0, 0, 0, 0, 1, 1],
      [1, 2, 1, 1, 0, 0, 1, 1, 0, 0],
      [1, 2, 1, 0, 1, 0, 1, 0, 1, 0],
      [1, 2, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 2, 1, 0, 0, 1, 0, 1, 1, 0],
      [1, 2, 1, 0, 0, 1, 1, 0, 0, 1],
      [1, 2, 1, 2, 2, 2, 1, 1, 1, 1],
      [1, 2, 1, 2, 2, 2, 0, 0, 0, 0],
      [2, 1, 0, 2, 2, 0, 1, 0, 0, 1],
      [2, 1, 0, 2, 2, 0, 0, 1, 1, 0],
      [2, 1, 0, 2, 0, 2, 0, 1, 0, 1],
      [2, 1, 0, 2, 0, 2, 1, 0, 1, 0],
      [2, 1, 0, 0, 2, 2, 1, 1, 0, 0],
      [2, 1, 0, 0, 2, 2, 0, 0, 1, 1],
      [2, 1, 0, 1, 1, 1, 0, 0, 0, 0],
      [2, 1, 0, 1, 1, 1, 1, 1, 1, 1],
      [2, 0, 2, 1, 1, 2, 0, 1, 1, 0],
      [2, 0, 2, 1, 1, 2, 1, 0, 0, 1],
      [2, 0, 2, 1, 2, 1, 1, 0, 1, 0],
      [2, 0, 2, 1, 2, 1, 0, 1, 0, 1],
      [2, 0, 2, 2, 1, 1, 0, 0, 1, 1],
      [2, 0, 2, 2, 1, 1, 1, 1, 0, 0],
      [2, 0, 2, 0, 0, 0, 1, 1, 1, 1],
      [2, 0, 2, 0, 0, 0, 0, 0, 0, 0],
    ] as const,
    systemType: 'R',
    systemNum: 50,
    hasXpert: true,
  } as const,
  'R7-0-36': {
    guaranty: 11,
    numFullHedges: 7,
    numHalfHedges: 0,
    rows: [
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 2, 2, 2],
      [0, 1, 2, 1, 0, 1, 2],
      [0, 1, 2, 1, 1, 2, 0],
      [0, 1, 2, 1, 2, 0, 1],
      [0, 2, 1, 2, 0, 0, 0],
      [0, 2, 1, 2, 1, 1, 1],
      [0, 2, 1, 2, 2, 2, 2],
      [0, 2, 1, 0, 0, 2, 1],
      [0, 2, 1, 0, 1, 0, 2],
      [0, 2, 1, 0, 2, 1, 0],
      [1, 0, 2, 2, 0, 2, 1],
      [1, 0, 2, 2, 1, 0, 2],
      [1, 0, 2, 2, 2, 1, 0],
      [1, 1, 1, 0, 0, 1, 2],
      [1, 1, 1, 0, 1, 2, 0],
      [1, 1, 1, 0, 2, 0, 1],
      [1, 1, 0, 1, 0, 0, 0],
      [1, 1, 0, 1, 1, 1, 1],
      [1, 1, 0, 1, 2, 2, 2],
      [1, 2, 0, 1, 0, 1, 2],
      [1, 2, 0, 1, 1, 2, 0],
      [1, 2, 0, 1, 2, 0, 1],
      [2, 0, 1, 1, 0, 2, 1],
      [2, 0, 1, 1, 1, 0, 2],
      [2, 0, 1, 1, 2, 1, 0],
      [2, 0, 2, 2, 0, 1, 2],
      [2, 0, 2, 2, 1, 2, 0],
      [2, 0, 2, 2, 2, 0, 1],
      [2, 1, 0, 2, 0, 2, 1],
      [2, 1, 0, 2, 1, 0, 2],
      [2, 1, 0, 2, 2, 1, 0],
      [2, 2, 2, 0, 0, 0, 0],
      [2, 2, 2, 0, 1, 1, 1],
      [2, 2, 2, 0, 2, 2, 2],
    ] as const,
    systemType: 'R',
    systemNum: 28,
    hasXpert: true,
  } as const,
  'R7-2-108': {
    guaranty: 11,
    numFullHedges: 7,
    numHalfHedges: 2,
    rows: [
      [1, 1, 0, 1, 2, 2, 2, 0, 0],
      [1, 0, 1, 1, 2, 1, 0, 0, 1],
      [2, 0, 1, 2, 0, 0, 1, 0, 1],
      [2, 2, 2, 1, 0, 0, 0, 0, 0],
      [2, 0, 0, 1, 0, 0, 2, 1, 0],
      [2, 2, 1, 2, 2, 0, 0, 1, 0],
      [1, 0, 0, 0, 0, 2, 2, 0, 1],
      [1, 0, 2, 2, 1, 1, 0, 0, 1],
      [1, 0, 1, 2, 1, 2, 2, 1, 1],
      [0, 1, 0, 2, 2, 1, 2, 0, 1],
      [0, 2, 2, 1, 2, 1, 2, 1, 0],
      [2, 2, 0, 1, 1, 1, 1, 0, 1],
      [0, 1, 1, 0, 0, 2, 2, 1, 0],
      [2, 1, 1, 0, 2, 0, 1, 0, 0],
      [0, 2, 1, 1, 2, 1, 1, 1, 1],
      [0, 0, 2, 2, 0, 2, 2, 1, 1],
      [0, 1, 0, 0, 0, 0, 1, 0, 0],
      [0, 1, 2, 1, 0, 2, 1, 0, 1],
      [1, 1, 1, 2, 1, 0, 0, 1, 1],
      [2, 0, 0, 2, 2, 1, 0, 1, 1],
      [1, 1, 2, 0, 1, 2, 2, 0, 0],
      [0, 0, 1, 1, 2, 2, 2, 1, 1],
      [0, 0, 0, 2, 1, 1, 1, 1, 0],
      [2, 0, 1, 2, 2, 1, 1, 1, 0],
      [0, 2, 0, 2, 1, 0, 0, 1, 0],
      [1, 0, 0, 1, 2, 1, 1, 0, 0],
      [1, 1, 1, 1, 2, 2, 1, 0, 1],
      [2, 1, 0, 2, 2, 2, 1, 1, 1],
      [2, 1, 1, 2, 2, 2, 2, 1, 0],
      [0, 1, 2, 2, 2, 1, 0, 0, 0],
      [2, 2, 2, 1, 1, 2, 0, 1, 1],
      [2, 2, 2, 0, 1, 2, 1, 1, 0],
      [0, 0, 2, 1, 2, 2, 0, 1, 0],
      [0, 2, 1, 0, 1, 2, 0, 0, 1],
      [2, 0, 0, 1, 1, 2, 2, 0, 1],
      [2, 1, 0, 1, 1, 0, 0, 0, 1],
      [0, 0, 2, 2, 2, 0, 2, 0, 0],
      [2, 0, 2, 1, 0, 1, 1, 0, 0],
      [2, 1, 0, 2, 1, 0, 1, 0, 0],
      [2, 0, 2, 1, 1, 0, 1, 1, 1],
      [1, 2, 2, 2, 1, 0, 2, 0, 1],
      [1, 0, 0, 0, 2, 0, 2, 1, 0],
      [0, 0, 2, 1, 0, 1, 0, 0, 1],
      [1, 2, 0, 0, 2, 2, 1, 1, 0],
      [2, 0, 2, 0, 1, 0, 2, 1, 0],
      [1, 1, 1, 1, 1, 0, 1, 1, 0],
      [0, 1, 0, 0, 1, 2, 1, 1, 1],
      [1, 1, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 1, 1, 0, 1, 1],
      [1, 1, 0, 1, 0, 1, 2, 1, 1],
      [2, 1, 1, 0, 0, 2, 1, 1, 1],
      [0, 0, 1, 0, 1, 0, 1, 0, 1],
      [1, 0, 0, 1, 0, 0, 1, 1, 1],
      [1, 2, 2, 0, 1, 0, 0, 0, 0],
      [1, 1, 2, 0, 2, 1, 2, 1, 1],
      [0, 0, 0, 0, 0, 2, 0, 0, 0],
      [2, 1, 2, 0, 1, 1, 0, 1, 0],
      [1, 0, 2, 0, 2, 0, 1, 1, 1],
      [2, 0, 1, 0, 2, 2, 0, 0, 0],
      [0, 2, 0, 0, 0, 1, 2, 0, 0],
      [0, 1, 2, 2, 0, 0, 0, 1, 1],
      [2, 2, 0, 2, 1, 1, 2, 0, 0],
      [1, 2, 0, 1, 0, 2, 0, 1, 1],
      [0, 2, 0, 0, 1, 0, 2, 1, 1],
      [0, 2, 2, 2, 0, 1, 1, 1, 1],
      [1, 0, 2, 2, 0, 2, 0, 1, 0],
      [1, 1, 1, 2, 0, 1, 0, 0, 0],
      [1, 2, 0, 1, 2, 0, 0, 0, 0],
      [2, 0, 0, 2, 1, 2, 0, 0, 0],
      [1, 0, 1, 1, 1, 2, 0, 1, 0],
      [1, 1, 2, 2, 1, 2, 1, 0, 1],
      [2, 1, 2, 1, 1, 1, 2, 1, 1],
      [2, 0, 2, 0, 2, 2, 2, 0, 1],
      [1, 2, 2, 2, 0, 1, 2, 1, 0],
      [1, 1, 2, 2, 0, 0, 1, 1, 0],
      [2, 1, 2, 1, 0, 2, 2, 0, 0],
      [2, 0, 1, 0, 0, 1, 0, 1, 1],
      [1, 2, 1, 2, 0, 2, 1, 0, 0],
      [0, 1, 1, 1, 2, 0, 0, 1, 1],
      [2, 2, 1, 0, 2, 1, 2, 0, 0],
      [1, 1, 0, 0, 2, 1, 0, 1, 0],
      [1, 2, 1, 1, 1, 1, 2, 1, 0],
      [0, 0, 0, 2, 2, 0, 1, 0, 1],
      [0, 1, 2, 1, 2, 0, 1, 1, 0],
      [0, 1, 1, 1, 1, 1, 0, 0, 0],
      [2, 2, 0, 2, 2, 0, 2, 1, 1],
      [0, 2, 1, 1, 1, 2, 1, 0, 0],
      [1, 2, 1, 2, 1, 1, 1, 1, 1],
      [0, 1, 1, 0, 1, 1, 2, 0, 1],
      [2, 2, 2, 0, 2, 1, 1, 0, 1],
      [1, 2, 1, 1, 2, 0, 2, 0, 1],
      [2, 2, 0, 1, 0, 2, 1, 1, 0],
      [0, 1, 0, 2, 1, 2, 2, 1, 0],
      [0, 2, 0, 2, 2, 2, 0, 0, 1],
      [0, 0, 1, 1, 1, 0, 2, 0, 0],
      [0, 2, 2, 2, 2, 2, 1, 0, 0],
      [2, 2, 1, 2, 0, 2, 0, 0, 1],
      [0, 2, 1, 0, 0, 0, 0, 1, 0],
      [0, 0, 1, 0, 0, 1, 1, 1, 0],
      [2, 1, 1, 2, 0, 1, 2, 0, 1],
      [2, 1, 2, 0, 2, 0, 0, 0, 1],
      [1, 2, 2, 0, 2, 2, 0, 1, 1],
      [1, 0, 1, 2, 0, 0, 2, 0, 0],
      [2, 2, 1, 0, 0, 0, 2, 1, 1],
      [2, 1, 0, 1, 0, 1, 0, 1, 0],
      [0, 2, 2, 1, 0, 0, 2, 0, 1],
      [1, 2, 0, 0, 0, 1, 1, 0, 1],
      [1, 0, 2, 0, 1, 1, 1, 0, 0],
    ] as const,
    systemType: 'R',
    systemNum: 52,
    hasXpert: false,
  } as const,
  'R7-2-34': {
    guaranty: 10,
    numFullHedges: 7,
    numHalfHedges: 2,
    rows: [
      [0, 0, 0, 0, 1, 0, 0, 0, 1],
      [2, 2, 2, 0, 0, 0, 0, 0, 0],
      [0, 1, 2, 2, 2, 2, 0, 0, 0],
      [1, 2, 0, 2, 2, 2, 0, 0, 0],
      [2, 0, 1, 2, 2, 2, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 0, 1, 0],
      [1, 1, 1, 0, 0, 0, 0, 1, 1],
      [1, 0, 2, 1, 1, 1, 0, 1, 1],
      [2, 1, 0, 1, 1, 1, 0, 1, 1],
      [0, 2, 1, 1, 1, 1, 0, 1, 1],
      [0, 1, 2, 1, 2, 0, 1, 0, 0],
      [1, 2, 0, 1, 2, 0, 1, 0, 0],
      [2, 0, 1, 1, 2, 0, 1, 0, 0],
      [0, 1, 2, 2, 0, 1, 1, 0, 0],
      [1, 2, 0, 2, 0, 1, 1, 0, 0],
      [2, 0, 1, 2, 0, 1, 1, 0, 0],
      [1, 0, 2, 0, 1, 2, 1, 1, 1],
      [2, 1, 0, 0, 1, 2, 1, 1, 1],
      [0, 2, 1, 0, 1, 2, 1, 1, 1],
      [2, 2, 2, 2, 2, 1, 1, 1, 1],
      [0, 0, 0, 2, 0, 2, 1, 1, 1],
      [1, 1, 1, 2, 2, 1, 1, 1, 1],
      [2, 2, 2, 1, 1, 2, 2, 0, 0],
      [0, 0, 0, 1, 0, 1, 2, 0, 0],
      [1, 1, 1, 1, 1, 2, 2, 0, 0],
      [0, 1, 2, 0, 2, 1, 2, 0, 0],
      [1, 2, 0, 0, 2, 1, 2, 0, 0],
      [2, 0, 1, 0, 2, 1, 2, 0, 0],
      [1, 0, 2, 2, 1, 0, 2, 1, 1],
      [2, 1, 0, 2, 1, 0, 2, 1, 1],
      [0, 2, 1, 2, 1, 0, 2, 1, 1],
      [1, 0, 2, 1, 0, 2, 2, 1, 1],
      [2, 1, 0, 1, 0, 2, 2, 1, 1],
      [0, 2, 1, 1, 0, 2, 2, 1, 1],
    ] as const,
    systemType: 'R',
    systemNum: 51,
    hasXpert: true,
  } as const,
  'R8-0-27': {
    guaranty: 10,
    numFullHedges: 8,
    numHalfHedges: 0,
    rows: [
      [1, 2, 1, 1, 1, 2, 0, 1],
      [1, 1, 1, 0, 0, 0, 0, 2],
      [1, 0, 2, 0, 1, 1, 2, 1],
      [0, 1, 1, 2, 0, 2, 2, 0],
      [0, 2, 2, 1, 0, 1, 1, 0],
      [1, 0, 0, 1, 0, 1, 1, 2],
      [2, 0, 1, 0, 2, 2, 1, 2],
      [0, 2, 0, 2, 2, 1, 0, 1],
      [1, 1, 0, 2, 1, 0, 1, 1],
      [2, 2, 2, 0, 0, 0, 0, 1],
      [0, 0, 2, 2, 1, 0, 1, 2],
      [1, 2, 0, 0, 2, 2, 1, 0],
      [0, 0, 1, 1, 2, 0, 2, 1],
      [2, 1, 1, 1, 0, 1, 1, 1],
      [1, 0, 1, 2, 2, 1, 0, 0],
      [2, 2, 1, 2, 1, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 0, 1, 1, 2, 2],
      [2, 1, 2, 2, 2, 1, 0, 2],
      [1, 2, 2, 2, 0, 2, 2, 2],
      [2, 0, 0, 2, 0, 2, 2, 1],
      [1, 1, 2, 1, 2, 0, 2, 0],
      [0, 1, 0, 1, 1, 2, 0, 2],
      [0, 1, 2, 0, 2, 2, 1, 1],
      [2, 0, 2, 1, 1, 2, 0, 0],
      [2, 1, 0, 0, 1, 1, 2, 0],
      [2, 2, 0, 1, 2, 0, 2, 2],
    ] as const,
    systemType: 'R',
    systemNum: 53,
    hasXpert: true,
  } as const,
  'R8-0-81': {
    guaranty: 11,
    numFullHedges: 8,
    numHalfHedges: 0,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 1, 1],
      [0, 0, 0, 2, 2, 2, 2, 2],
      [0, 0, 1, 0, 2, 2, 1, 1],
      [0, 0, 1, 1, 0, 0, 2, 2],
      [0, 0, 1, 2, 1, 1, 0, 0],
      [0, 0, 2, 0, 1, 1, 2, 2],
      [0, 0, 2, 1, 2, 2, 0, 0],
      [0, 0, 2, 2, 0, 0, 1, 1],
      [0, 1, 0, 0, 1, 2, 1, 2],
      [0, 1, 0, 1, 2, 0, 2, 0],
      [0, 1, 0, 2, 0, 1, 0, 1],
      [0, 1, 1, 0, 0, 1, 2, 0],
      [0, 1, 1, 1, 1, 2, 0, 1],
      [0, 1, 1, 2, 2, 0, 1, 2],
      [0, 1, 2, 0, 2, 0, 0, 1],
      [0, 1, 2, 1, 0, 1, 1, 2],
      [0, 1, 2, 2, 1, 2, 2, 0],
      [0, 2, 0, 0, 2, 1, 2, 1],
      [0, 2, 0, 1, 0, 2, 0, 2],
      [0, 2, 0, 2, 1, 0, 1, 0],
      [0, 2, 1, 0, 1, 0, 0, 2],
      [0, 2, 1, 1, 2, 1, 1, 0],
      [0, 2, 1, 2, 0, 2, 2, 1],
      [0, 2, 2, 0, 0, 2, 1, 0],
      [0, 2, 2, 1, 1, 0, 2, 1],
      [0, 2, 2, 2, 2, 1, 0, 2],
      [1, 0, 0, 0, 1, 2, 2, 1],
      [1, 0, 0, 1, 2, 0, 0, 2],
      [1, 0, 0, 2, 0, 1, 1, 0],
      [1, 0, 1, 0, 0, 1, 0, 2],
      [1, 0, 1, 1, 1, 2, 1, 0],
      [1, 0, 1, 2, 2, 0, 2, 1],
      [1, 0, 2, 0, 2, 0, 1, 0],
      [1, 0, 2, 1, 0, 1, 2, 1],
      [1, 0, 2, 2, 1, 2, 0, 2],
      [1, 1, 0, 0, 2, 1, 0, 0],
      [1, 1, 0, 1, 0, 2, 1, 1],
      [1, 1, 0, 2, 1, 0, 2, 2],
      [1, 1, 1, 0, 1, 0, 1, 1],
      [1, 1, 1, 1, 2, 1, 2, 2],
      [1, 1, 1, 2, 0, 2, 0, 0],
      [1, 1, 2, 0, 0, 2, 2, 2],
      [1, 1, 2, 1, 1, 0, 0, 0],
      [1, 1, 2, 2, 2, 1, 1, 1],
      [1, 2, 0, 0, 0, 0, 1, 2],
      [1, 2, 0, 1, 1, 1, 2, 0],
      [1, 2, 0, 2, 2, 2, 0, 1],
      [1, 2, 1, 0, 2, 2, 2, 0],
      [1, 2, 1, 1, 0, 0, 0, 1],
      [1, 2, 1, 2, 1, 1, 1, 2],
      [1, 2, 2, 0, 1, 1, 0, 1],
      [1, 2, 2, 1, 2, 2, 1, 2],
      [1, 2, 2, 2, 0, 0, 2, 0],
      [2, 0, 0, 0, 2, 1, 1, 2],
      [2, 0, 0, 1, 0, 2, 2, 0],
      [2, 0, 0, 2, 1, 0, 0, 1],
      [2, 0, 1, 0, 1, 0, 2, 0],
      [2, 0, 1, 1, 2, 1, 0, 1],
      [2, 0, 1, 2, 0, 2, 1, 2],
      [2, 0, 2, 0, 0, 2, 0, 1],
      [2, 0, 2, 1, 1, 0, 1, 2],
      [2, 0, 2, 2, 2, 1, 2, 0],
      [2, 1, 0, 0, 0, 0, 2, 1],
      [2, 1, 0, 1, 1, 1, 0, 2],
      [2, 1, 0, 2, 2, 2, 1, 0],
      [2, 1, 1, 0, 2, 2, 0, 2],
      [2, 1, 1, 1, 0, 0, 1, 0],
      [2, 1, 1, 2, 1, 1, 2, 1],
      [2, 1, 2, 0, 1, 1, 1, 0],
      [2, 1, 2, 1, 2, 2, 2, 1],
      [2, 1, 2, 2, 0, 0, 0, 2],
      [2, 2, 0, 0, 1, 2, 0, 0],
      [2, 2, 0, 1, 2, 0, 1, 1],
      [2, 2, 0, 2, 0, 1, 2, 2],
      [2, 2, 1, 0, 0, 1, 1, 1],
      [2, 2, 1, 1, 1, 2, 2, 2],
      [2, 2, 1, 2, 2, 0, 0, 0],
      [2, 2, 2, 0, 2, 0, 2, 2],
      [2, 2, 2, 1, 0, 1, 0, 0],
      [2, 2, 2, 2, 1, 2, 1, 1],
    ] as const,
    systemType: 'R',
    systemNum: 29,
    hasXpert: true,
  } as const,
  'R8-2-324': {
    guaranty: 11,
    numFullHedges: 8,
    numHalfHedges: 2,
    rows: [
      [1, 1, 0, 0, 2, 0, 1, 2, 0, 1],
      [2, 0, 1, 2, 1, 1, 0, 0, 0, 0],
      [0, 2, 0, 2, 1, 1, 1, 1, 1, 1],
      [0, 1, 1, 0, 0, 1, 1, 0, 0, 0],
      [0, 1, 0, 0, 2, 1, 2, 0, 1, 0],
      [1, 0, 2, 2, 1, 0, 2, 2, 0, 1],
      [0, 1, 1, 0, 1, 0, 2, 2, 0, 1],
      [2, 2, 0, 1, 0, 1, 1, 0, 1, 1],
      [2, 0, 0, 1, 2, 2, 0, 0, 1, 0],
      [1, 0, 1, 2, 2, 1, 2, 0, 1, 0],
      [2, 2, 1, 0, 1, 0, 0, 1, 1, 1],
      [0, 2, 2, 2, 2, 0, 1, 0, 1, 1],
      [2, 0, 2, 1, 2, 0, 2, 1, 1, 1],
      [2, 1, 0, 1, 2, 1, 0, 1, 1, 1],
      [2, 2, 1, 0, 1, 0, 0, 1, 0, 0],
      [0, 2, 0, 2, 2, 2, 2, 2, 1, 0],
      [2, 0, 1, 0, 2, 0, 1, 0, 1, 1],
      [1, 2, 2, 0, 0, 0, 1, 1, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 0, 1, 2, 0, 1, 0, 1, 1],
      [0, 0, 0, 2, 2, 1, 2, 0, 0, 0],
      [0, 0, 2, 0, 1, 2, 0, 2, 1, 1],
      [1, 0, 2, 1, 2, 2, 0, 0, 0, 0],
      [2, 1, 0, 2, 1, 2, 2, 0, 0, 1],
      [2, 0, 2, 0, 1, 1, 1, 1, 1, 1],
      [2, 1, 2, 2, 2, 0, 2, 1, 1, 0],
      [1, 0, 1, 0, 0, 0, 0, 0, 1, 0],
      [1, 1, 1, 0, 1, 1, 1, 0, 0, 1],
      [1, 1, 0, 1, 0, 1, 2, 1, 1, 0],
      [1, 2, 2, 2, 0, 0, 1, 0, 0, 1],
      [2, 2, 1, 1, 0, 0, 2, 2, 1, 0],
      [2, 1, 2, 1, 1, 2, 1, 2, 0, 1],
      [1, 2, 1, 2, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 2, 0, 0, 2, 2, 0, 0],
      [2, 0, 0, 0, 0, 2, 1, 2, 0, 0],
      [2, 2, 2, 1, 2, 1, 2, 0, 1, 0],
      [0, 2, 2, 0, 0, 2, 2, 0, 1, 1],
      [0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
      [2, 1, 0, 0, 1, 2, 2, 1, 1, 1],
      [2, 1, 1, 2, 0, 2, 2, 0, 1, 0],
      [1, 1, 2, 0, 0, 1, 1, 0, 1, 0],
      [0, 0, 0, 1, 2, 1, 2, 2, 0, 1],
      [2, 1, 1, 2, 0, 0, 2, 1, 0, 1],
      [0, 0, 0, 2, 0, 0, 0, 2, 0, 1],
      [2, 2, 1, 1, 0, 1, 2, 0, 0, 1],
      [0, 2, 0, 0, 0, 2, 0, 0, 0, 1],
      [0, 0, 2, 0, 2, 0, 1, 0, 1, 0],
      [1, 1, 2, 0, 2, 0, 0, 2, 1, 1],
      [2, 0, 2, 0, 2, 0, 2, 0, 0, 1],
      [1, 2, 1, 0, 1, 2, 1, 0, 0, 0],
      [2, 1, 2, 1, 0, 0, 0, 0, 0, 0],
      [2, 0, 0, 0, 1, 1, 2, 1, 0, 1],
      [0, 2, 0, 0, 2, 0, 2, 1, 1, 1],
      [2, 2, 2, 0, 0, 1, 0, 2, 0, 0],
      [1, 2, 1, 0, 1, 2, 1, 0, 1, 1],
      [1, 0, 1, 1, 1, 2, 1, 0, 1, 0],
      [2, 2, 1, 2, 1, 2, 0, 2, 1, 0],
      [1, 1, 0, 2, 0, 2, 2, 0, 1, 1],
      [2, 0, 2, 1, 0, 1, 0, 2, 1, 0],
      [1, 2, 0, 2, 1, 2, 0, 2, 0, 0],
      [0, 2, 2, 1, 2, 0, 1, 2, 0, 1],
      [1, 2, 2, 2, 2, 1, 0, 1, 0, 0],
      [1, 1, 1, 2, 0, 1, 0, 2, 1, 0],
      [0, 0, 1, 2, 1, 2, 2, 1, 0, 0],
      [0, 1, 1, 2, 0, 1, 1, 2, 0, 1],
      [0, 2, 1, 1, 0, 1, 1, 0, 1, 0],
      [2, 1, 2, 1, 0, 0, 0, 0, 1, 1],
      [2, 1, 0, 0, 2, 1, 0, 0, 0, 1],
      [2, 0, 2, 0, 1, 1, 1, 1, 0, 0],
      [2, 0, 1, 0, 0, 2, 2, 2, 0, 1],
      [1, 1, 1, 2, 2, 0, 2, 1, 1, 1],
      [0, 2, 2, 0, 1, 0, 0, 1, 1, 0],
      [1, 0, 0, 1, 2, 1, 1, 2, 1, 0],
      [2, 1, 1, 2, 2, 1, 1, 2, 1, 1],
      [1, 0, 2, 0, 1, 0, 2, 0, 1, 1],
      [1, 1, 0, 2, 0, 2, 2, 0, 0, 0],
      [0, 1, 2, 0, 2, 2, 1, 1, 0, 0],
      [1, 0, 2, 0, 2, 2, 0, 2, 0, 1],
      [1, 1, 0, 1, 0, 2, 2, 2, 0, 1],
      [1, 2, 0, 0, 2, 1, 1, 2, 0, 0],
      [2, 2, 0, 2, 2, 1, 0, 1, 1, 0],
      [0, 1, 0, 2, 0, 1, 0, 2, 1, 1],
      [1, 0, 0, 0, 1, 2, 0, 2, 1, 0],
      [1, 0, 0, 2, 0, 0, 2, 2, 1, 0],
      [2, 2, 0, 1, 1, 0, 2, 2, 0, 1],
      [0, 1, 2, 1, 1, 2, 0, 2, 1, 0],
      [1, 0, 2, 2, 1, 2, 2, 1, 1, 0],
      [1, 0, 0, 1, 1, 0, 0, 1, 0, 0],
      [2, 0, 2, 2, 1, 1, 1, 0, 0, 1],
      [0, 1, 1, 0, 0, 1, 1, 0, 1, 1],
      [0, 2, 1, 1, 2, 0, 0, 2, 1, 1],
      [2, 2, 1, 2, 1, 0, 0, 0, 0, 1],
      [1, 0, 2, 1, 2, 2, 0, 0, 1, 1],
      [1, 0, 2, 0, 2, 1, 0, 1, 1, 0],
      [2, 1, 1, 1, 2, 0, 1, 0, 1, 0],
      [0, 1, 1, 2, 2, 2, 0, 0, 0, 0],
      [0, 1, 2, 0, 2, 2, 1, 1, 1, 1],
      [2, 1, 1, 2, 2, 1, 1, 2, 0, 0],
      [1, 0, 1, 2, 1, 0, 1, 2, 0, 0],
      [0, 0, 0, 0, 1, 2, 1, 2, 0, 1],
      [0, 0, 0, 0, 1, 1, 1, 1, 1, 0],
      [1, 0, 0, 1, 1, 0, 0, 1, 1, 1],
      [1, 2, 0, 1, 1, 2, 0, 1, 0, 1],
      [0, 2, 0, 2, 1, 1, 1, 1, 0, 0],
      [0, 0, 1, 0, 2, 1, 0, 1, 0, 0],
      [1, 2, 0, 2, 1, 2, 0, 2, 1, 1],
      [0, 2, 1, 2, 1, 0, 2, 0, 1, 0],
      [1, 2, 0, 0, 0, 0, 2, 1, 0, 1],
      [2, 2, 2, 0, 1, 2, 1, 0, 1, 0],
      [2, 0, 0, 2, 0, 1, 1, 0, 1, 0],
      [2, 0, 2, 2, 0, 2, 0, 1, 1, 1],
      [0, 2, 0, 1, 1, 0, 1, 2, 1, 0],
      [2, 2, 2, 1, 1, 0, 1, 2, 1, 1],
      [1, 1, 1, 0, 0, 2, 0, 1, 1, 1],
      [2, 1, 2, 1, 1, 1, 1, 1, 1, 0],
      [0, 2, 0, 1, 0, 2, 0, 1, 0, 0],
      [0, 1, 0, 0, 1, 0, 1, 2, 0, 0],
      [0, 2, 0, 0, 0, 1, 0, 2, 1, 0],
      [0, 1, 1, 1, 1, 0, 2, 0, 0, 0],
      [1, 0, 0, 0, 1, 0, 0, 0, 0, 1],
      [2, 1, 2, 0, 2, 1, 2, 0, 1, 1],
      [2, 2, 1, 2, 0, 1, 2, 1, 1, 1],
      [2, 1, 2, 0, 0, 0, 0, 2, 0, 1],
      [1, 0, 1, 2, 1, 0, 1, 2, 1, 1],
      [1, 0, 0, 2, 2, 2, 1, 1, 0, 0],
      [1, 0, 0, 0, 0, 1, 2, 1, 1, 1],
      [0, 0, 1, 1, 1, 2, 2, 0, 0, 1],
      [2, 0, 2, 1, 2, 0, 2, 1, 0, 0],
      [2, 0, 1, 2, 2, 0, 1, 2, 0, 1],
      [2, 2, 2, 1, 2, 2, 2, 1, 0, 1],
      [2, 1, 1, 1, 1, 2, 0, 2, 0, 0],
      [2, 1, 1, 1, 2, 1, 1, 1, 0, 1],
      [0, 2, 0, 0, 2, 0, 2, 1, 0, 0],
      [1, 1, 1, 1, 2, 2, 2, 2, 1, 0],
      [0, 1, 1, 1, 2, 1, 0, 1, 1, 0],
      [1, 1, 2, 0, 2, 0, 0, 2, 0, 0],
      [1, 2, 1, 1, 2, 1, 2, 0, 0, 0],
      [1, 1, 0, 0, 1, 1, 0, 0, 1, 1],
      [0, 0, 1, 0, 2, 1, 0, 1, 1, 1],
      [2, 0, 1, 0, 2, 0, 1, 0, 0, 0],
      [2, 2, 0, 0, 2, 2, 0, 0, 0, 0],
      [2, 0, 0, 0, 1, 0, 2, 0, 1, 0],
      [0, 2, 1, 1, 0, 2, 1, 1, 0, 1],
      [2, 2, 0, 2, 1, 0, 2, 0, 1, 1],
      [1, 0, 0, 0, 0, 1, 2, 1, 0, 0],
      [2, 1, 0, 2, 0, 0, 1, 1, 0, 0],
      [1, 0, 1, 1, 0, 1, 0, 2, 0, 0],
      [0, 1, 0, 2, 0, 1, 0, 2, 0, 0],
      [1, 1, 2, 1, 1, 1, 2, 1, 0, 1],
      [0, 0, 2, 2, 1, 1, 0, 0, 1, 0],
      [0, 0, 1, 2, 2, 1, 0, 0, 0, 1],
      [0, 1, 0, 0, 1, 0, 1, 2, 1, 1],
      [1, 2, 1, 0, 2, 1, 2, 2, 0, 1],
      [0, 0, 1, 2, 1, 2, 2, 1, 1, 1],
      [2, 2, 0, 1, 0, 1, 1, 0, 0, 0],
      [1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
      [1, 0, 2, 1, 0, 1, 1, 2, 0, 1],
      [0, 1, 0, 1, 2, 2, 2, 2, 1, 1],
      [0, 2, 2, 2, 0, 1, 2, 1, 1, 0],
      [0, 1, 2, 1, 0, 1, 2, 1, 0, 0],
      [0, 1, 0, 0, 2, 2, 2, 1, 0, 1],
      [0, 2, 1, 2, 0, 2, 1, 2, 1, 1],
      [2, 2, 2, 0, 0, 1, 0, 2, 1, 1],
      [0, 1, 2, 1, 0, 1, 2, 1, 1, 1],
      [1, 2, 2, 2, 2, 1, 0, 1, 1, 1],
      [2, 1, 2, 0, 0, 2, 0, 1, 1, 0],
      [1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
      [0, 0, 0, 1, 1, 2, 1, 0, 0, 0],
      [0, 2, 2, 1, 1, 1, 0, 0, 0, 0],
      [0, 2, 2, 2, 0, 2, 2, 2, 0, 1],
      [1, 2, 2, 1, 2, 1, 0, 0, 0, 1],
      [2, 0, 1, 1, 1, 1, 0, 2, 0, 1],
      [0, 1, 1, 0, 1, 2, 2, 1, 1, 0],
      [2, 0, 2, 2, 0, 2, 0, 1, 0, 0],
      [0, 2, 2, 2, 2, 0, 1, 0, 0, 0],
      [1, 2, 1, 1, 0, 0, 0, 2, 0, 1],
      [1, 1, 0, 0, 1, 1, 0, 0, 0, 0],
      [1, 2, 0, 1, 0, 0, 2, 2, 0, 0],
      [0, 1, 1, 2, 2, 2, 0, 0, 1, 1],
      [1, 1, 1, 1, 2, 0, 2, 0, 0, 1],
      [0, 1, 2, 0, 0, 1, 2, 0, 0, 1],
      [2, 2, 2, 2, 2, 2, 2, 2, 1, 1],
      [1, 1, 2, 0, 0, 2, 1, 1, 0, 1],
      [2, 0, 0, 1, 1, 1, 2, 2, 0, 0],
      [1, 2, 0, 1, 1, 1, 0, 0, 1, 0],
      [0, 0, 1, 1, 0, 0, 1, 1, 1, 1],
      [1, 1, 2, 2, 2, 0, 0, 1, 0, 1],
      [2, 0, 1, 0, 0, 1, 2, 1, 1, 0],
      [1, 2, 1, 2, 0, 0, 0, 0, 1, 1],
      [1, 1, 1, 0, 0, 2, 0, 1, 0, 0],
      [0, 2, 1, 0, 2, 0, 0, 1, 0, 1],
      [2, 2, 0, 1, 1, 2, 2, 1, 1, 0],
      [1, 2, 2, 0, 1, 2, 2, 0, 0, 1],
      [1, 0, 1, 0, 2, 2, 2, 2, 1, 1],
      [1, 1, 2, 1, 0, 2, 1, 2, 0, 0],
      [2, 2, 0, 2, 2, 2, 0, 2, 0, 1],
      [1, 0, 0, 2, 2, 2, 1, 1, 1, 1],
      [0, 0, 2, 2, 1, 2, 0, 1, 0, 1],
      [1, 0, 1, 1, 1, 0, 1, 1, 0, 1],
      [0, 1, 1, 2, 0, 0, 1, 1, 1, 0],
      [0, 0, 2, 1, 2, 1, 1, 2, 1, 1],
      [0, 2, 1, 1, 2, 0, 0, 2, 0, 0],
      [0, 2, 1, 2, 0, 2, 1, 2, 0, 0],
      [0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
      [2, 0, 0, 0, 0, 2, 1, 2, 1, 1],
      [0, 0, 2, 1, 0, 0, 2, 1, 0, 1],
      [1, 0, 2, 1, 0, 0, 1, 1, 1, 0],
      [1, 2, 0, 0, 0, 2, 2, 0, 1, 0],
      [1, 1, 0, 2, 1, 1, 0, 2, 0, 1],
      [2, 1, 0, 0, 1, 2, 2, 1, 0, 0],
      [2, 0, 2, 1, 0, 2, 0, 0, 0, 1],
      [0, 2, 2, 1, 2, 2, 1, 1, 1, 0],
      [2, 0, 2, 0, 2, 2, 2, 2, 1, 0],
      [0, 1, 2, 2, 1, 0, 0, 1, 0, 0],
      [0, 0, 2, 1, 2, 1, 1, 2, 0, 0],
      [2, 2, 1, 2, 0, 1, 2, 1, 0, 0],
      [2, 1, 0, 2, 0, 0, 1, 1, 1, 1],
      [2, 0, 2, 2, 1, 0, 1, 2, 1, 0],
      [0, 1, 2, 0, 0, 0, 2, 2, 1, 0],
      [2, 2, 2, 2, 2, 2, 2, 2, 0, 0],
      [2, 0, 1, 1, 0, 2, 2, 0, 1, 1],
      [0, 2, 2, 0, 1, 1, 0, 2, 0, 1],
      [0, 2, 1, 2, 1, 1, 2, 1, 0, 1],
      [2, 2, 2, 0, 1, 0, 1, 1, 0, 1],
      [2, 1, 0, 1, 2, 1, 0, 1, 0, 0],
      [1, 1, 2, 1, 0, 2, 1, 2, 1, 1],
      [1, 2, 1, 2, 1, 2, 1, 2, 0, 1],
      [1, 0, 2, 0, 1, 0, 2, 0, 0, 0],
      [2, 1, 0, 1, 0, 0, 1, 0, 0, 1],
      [2, 2, 1, 0, 2, 1, 1, 2, 1, 0],
      [1, 1, 1, 2, 0, 2, 0, 0, 0, 1],
      [0, 1, 0, 2, 1, 2, 1, 0, 1, 0],
      [1, 0, 2, 2, 0, 1, 1, 0, 0, 0],
      [2, 1, 0, 0, 2, 0, 0, 2, 1, 0],
      [2, 0, 0, 2, 2, 0, 0, 2, 1, 1],
      [2, 1, 2, 2, 1, 2, 1, 0, 0, 0],
      [2, 1, 2, 0, 2, 1, 2, 0, 0, 0],
      [1, 1, 2, 2, 1, 1, 2, 2, 1, 1],
      [1, 2, 2, 1, 1, 2, 2, 1, 1, 1],
      [0, 1, 2, 1, 1, 0, 0, 0, 0, 1],
      [1, 0, 1, 2, 2, 2, 2, 1, 0, 1],
      [1, 2, 0, 0, 2, 1, 1, 2, 1, 1],
      [0, 2, 0, 1, 1, 1, 1, 0, 0, 1],
      [1, 2, 1, 1, 2, 1, 2, 0, 1, 1],
      [1, 1, 2, 2, 1, 1, 2, 2, 0, 0],
      [0, 1, 2, 2, 1, 0, 0, 1, 1, 1],
      [1, 2, 2, 1, 2, 0, 0, 2, 1, 0],
      [1, 2, 2, 0, 0, 0, 1, 1, 1, 1],
      [2, 0, 0, 2, 0, 2, 1, 1, 0, 1],
      [1, 0, 0, 1, 2, 2, 1, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 1, 2, 0, 2, 1, 1, 0],
      [0, 1, 0, 2, 1, 0, 1, 1, 0, 1],
      [2, 2, 1, 1, 2, 2, 1, 1, 1, 1],
      [1, 0, 1, 1, 0, 1, 0, 2, 1, 1],
      [0, 0, 2, 0, 2, 1, 1, 1, 0, 1],
      [1, 1, 0, 0, 2, 2, 1, 1, 1, 0],
      [0, 0, 2, 0, 1, 2, 0, 2, 0, 0],
      [2, 2, 0, 0, 0, 1, 1, 2, 0, 1],
      [2, 2, 2, 1, 1, 0, 1, 2, 0, 0],
      [1, 2, 0, 2, 2, 1, 1, 1, 0, 1],
      [0, 1, 1, 1, 1, 0, 2, 0, 1, 1],
      [2, 1, 0, 2, 1, 1, 2, 2, 1, 0],
      [1, 2, 2, 0, 1, 1, 2, 2, 1, 0],
      [1, 1, 0, 2, 1, 0, 0, 1, 1, 0],
      [0, 2, 1, 0, 1, 1, 2, 2, 1, 1],
      [2, 1, 0, 1, 0, 2, 1, 2, 1, 0],
      [0, 2, 1, 0, 2, 2, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 2, 0, 2, 2, 0, 1, 0, 1, 0],
      [0, 1, 1, 1, 2, 2, 0, 2, 0, 1],
      [2, 0, 0, 1, 1, 1, 2, 2, 1, 1],
      [0, 1, 0, 1, 0, 0, 0, 0, 1, 0],
      [1, 1, 2, 1, 1, 0, 2, 0, 1, 0],
      [0, 0, 1, 1, 1, 1, 2, 2, 1, 0],
      [0, 0, 2, 1, 0, 2, 2, 0, 1, 0],
      [0, 2, 0, 2, 2, 0, 2, 0, 0, 1],
      [2, 2, 2, 2, 0, 1, 0, 1, 0, 1],
      [1, 0, 2, 2, 0, 1, 1, 0, 1, 1],
      [2, 0, 1, 1, 1, 0, 0, 1, 1, 0],
      [1, 2, 1, 2, 1, 1, 1, 1, 1, 0],
      [2, 0, 0, 1, 2, 0, 0, 1, 0, 1],
      [0, 0, 1, 0, 0, 2, 1, 2, 1, 0],
      [0, 2, 0, 1, 0, 2, 0, 1, 1, 1],
      [2, 1, 1, 0, 0, 0, 2, 2, 0, 0],
      [2, 1, 2, 2, 2, 1, 2, 2, 0, 1],
      [2, 2, 1, 1, 2, 2, 1, 1, 0, 0],
      [1, 1, 2, 2, 2, 2, 0, 0, 1, 0],
      [2, 1, 1, 0, 1, 1, 0, 0, 1, 0],
      [2, 1, 1, 1, 1, 2, 0, 2, 1, 1],
      [2, 2, 0, 0, 0, 0, 1, 1, 1, 0],
      [2, 2, 0, 2, 1, 0, 2, 0, 0, 0],
      [2, 2, 1, 0, 2, 2, 1, 0, 0, 1],
      [0, 2, 2, 1, 1, 1, 0, 0, 1, 1],
      [0, 0, 0, 2, 0, 2, 0, 1, 1, 0],
      [0, 0, 0, 1, 1, 2, 1, 0, 1, 1],
      [0, 0, 0, 2, 2, 1, 2, 0, 1, 1],
      [0, 1, 0, 1, 2, 2, 2, 2, 0, 0],
      [0, 1, 2, 2, 2, 2, 1, 0, 0, 1],
      [1, 2, 2, 1, 1, 2, 2, 1, 0, 0],
      [1, 0, 0, 2, 0, 1, 2, 0, 0, 1],
      [2, 0, 1, 2, 2, 2, 1, 1, 1, 0],
      [2, 1, 1, 0, 1, 2, 0, 1, 0, 1],
      [2, 0, 1, 1, 0, 2, 2, 0, 0, 0],
      [1, 2, 1, 1, 0, 2, 0, 1, 1, 0],
      [2, 2, 2, 2, 0, 0, 0, 0, 1, 0],
      [2, 0, 1, 2, 1, 1, 0, 0, 1, 1],
      [1, 1, 1, 2, 2, 0, 2, 1, 0, 0],
      [0, 2, 1, 0, 1, 1, 2, 2, 0, 0],
      [1, 2, 0, 1, 0, 0, 2, 2, 1, 1],
      [2, 2, 0, 0, 2, 2, 0, 0, 1, 1],
      [0, 0, 1, 0, 0, 0, 1, 0, 0, 1],
      [1, 0, 1, 0, 2, 2, 2, 2, 0, 0],
      [1, 1, 0, 1, 2, 0, 1, 0, 0, 0],
      [0, 1, 2, 2, 2, 1, 1, 2, 1, 0],
      [0, 2, 2, 0, 0, 2, 2, 0, 0, 0],
      [2, 0, 0, 2, 2, 0, 0, 2, 0, 0],
      [1, 1, 1, 0, 1, 0, 1, 2, 1, 0],
      [2, 1, 1, 0, 0, 0, 2, 2, 1, 1],
      [0, 0, 2, 2, 0, 0, 2, 2, 1, 1],
      [2, 1, 2, 2, 1, 2, 1, 0, 1, 1],
      [1, 2, 2, 2, 0, 2, 1, 2, 1, 0],
      [0, 0, 1, 2, 2, 0, 0, 2, 1, 0],
      [1, 2, 1, 0, 2, 0, 2, 1, 1, 0],
    ] as const,
    systemType: 'R',
    systemNum: 54,
    hasXpert: true,
  } as const,
  'R8-3-504': {
    guaranty: 11,
    numFullHedges: 8,
    numHalfHedges: 3,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
      [1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1],
      [2, 2, 2, 0, 0, 0, 0, 0, 1, 1, 1],
      [2, 1, 0, 0, 2, 0, 0, 0, 1, 1, 1],
      [0, 2, 1, 0, 2, 0, 0, 0, 1, 1, 1],
      [1, 0, 2, 0, 2, 0, 0, 0, 1, 1, 1],
      [1, 2, 0, 2, 1, 1, 0, 0, 1, 1, 1],
      [2, 0, 1, 2, 1, 1, 0, 0, 1, 1, 1],
      [0, 1, 2, 2, 1, 1, 0, 0, 1, 1, 1],
      [1, 2, 0, 1, 1, 2, 0, 0, 1, 1, 1],
      [2, 0, 1, 1, 1, 2, 0, 0, 1, 1, 1],
      [0, 1, 2, 1, 1, 2, 0, 0, 1, 1, 1],
      [0, 0, 0, 2, 0, 0, 1, 0, 1, 1, 1],
      [1, 1, 1, 2, 0, 0, 1, 0, 1, 1, 1],
      [2, 2, 2, 2, 0, 0, 1, 0, 1, 1, 1],
      [2, 1, 0, 2, 0, 2, 1, 0, 1, 1, 1],
      [0, 2, 1, 2, 0, 2, 1, 0, 1, 1, 1],
      [1, 0, 2, 2, 0, 2, 1, 0, 1, 1, 1],
      [2, 1, 0, 0, 2, 2, 1, 0, 1, 1, 1],
      [0, 2, 1, 0, 2, 2, 1, 0, 1, 1, 1],
      [1, 0, 2, 0, 2, 2, 1, 0, 1, 1, 1],
      [0, 0, 0, 1, 2, 1, 2, 0, 1, 1, 1],
      [1, 1, 1, 1, 2, 1, 2, 0, 1, 1, 1],
      [2, 2, 2, 1, 2, 1, 2, 0, 1, 1, 1],
      [1, 2, 0, 2, 2, 1, 2, 0, 1, 1, 1],
      [2, 0, 1, 2, 2, 1, 2, 0, 1, 1, 1],
      [0, 1, 2, 2, 2, 1, 2, 0, 1, 1, 1],
      [0, 0, 0, 1, 1, 2, 2, 0, 1, 1, 1],
      [1, 1, 1, 1, 1, 2, 2, 0, 1, 1, 1],
      [2, 2, 2, 1, 1, 2, 2, 0, 1, 1, 1],
      [2, 1, 0, 2, 2, 0, 0, 1, 1, 1, 1],
      [0, 2, 1, 2, 2, 0, 0, 1, 1, 1, 1],
      [1, 0, 2, 2, 2, 0, 0, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 2, 0, 1, 1, 1, 1],
      [1, 1, 1, 0, 0, 2, 0, 1, 1, 1, 1],
      [2, 2, 2, 0, 0, 2, 0, 1, 1, 1, 1],
      [2, 1, 0, 2, 0, 2, 0, 1, 1, 1, 1],
      [0, 2, 1, 2, 0, 2, 0, 1, 1, 1, 1],
      [1, 0, 2, 2, 0, 2, 0, 1, 1, 1, 1],
      [0, 0, 0, 2, 2, 0, 1, 1, 1, 1, 1],
      [1, 1, 1, 2, 2, 0, 1, 1, 1, 1, 1],
      [2, 2, 2, 2, 2, 0, 1, 1, 1, 1, 1],
      [1, 2, 0, 1, 0, 1, 1, 1, 1, 1, 1],
      [2, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1],
      [0, 1, 2, 1, 0, 1, 1, 1, 1, 1, 1],
      [2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1],
      [0, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 0, 2, 1, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 2, 2, 1, 1, 1, 1, 1],
      [1, 1, 1, 0, 2, 2, 1, 1, 1, 1, 1],
      [2, 2, 2, 0, 2, 2, 1, 1, 1, 1, 1],
      [1, 2, 0, 1, 0, 0, 2, 1, 1, 1, 1],
      [2, 0, 1, 1, 0, 0, 2, 1, 1, 1, 1],
      [0, 1, 2, 1, 0, 0, 2, 1, 1, 1, 1],
      [1, 2, 0, 0, 1, 0, 2, 1, 1, 1, 1],
      [2, 0, 1, 0, 1, 0, 2, 1, 1, 1, 1],
      [0, 1, 2, 0, 1, 0, 2, 1, 1, 1, 1],
      [2, 1, 0, 0, 1, 1, 2, 1, 1, 1, 1],
      [0, 2, 1, 0, 1, 1, 2, 1, 1, 1, 1],
      [1, 0, 2, 0, 1, 1, 2, 1, 1, 1, 1],
      [0, 0, 0, 2, 1, 1, 0, 2, 1, 1, 1],
      [1, 1, 1, 2, 1, 1, 0, 2, 1, 1, 1],
      [2, 2, 2, 2, 1, 1, 0, 2, 1, 1, 1],
      [0, 0, 0, 1, 2, 1, 0, 2, 1, 1, 1],
      [1, 1, 1, 1, 2, 1, 0, 2, 1, 1, 1],
      [2, 2, 2, 1, 2, 1, 0, 2, 1, 1, 1],
      [1, 2, 0, 1, 2, 2, 0, 2, 1, 1, 1],
      [2, 0, 1, 1, 2, 2, 0, 2, 1, 1, 1],
      [0, 1, 2, 1, 2, 2, 0, 2, 1, 1, 1],
      [1, 2, 0, 0, 1, 0, 1, 2, 1, 1, 1],
      [2, 0, 1, 0, 1, 0, 1, 2, 1, 1, 1],
      [0, 1, 2, 0, 1, 0, 1, 2, 1, 1, 1],
      [2, 1, 0, 1, 1, 0, 1, 2, 1, 1, 1],
      [0, 2, 1, 1, 1, 0, 1, 2, 1, 1, 1],
      [1, 0, 2, 1, 1, 0, 1, 2, 1, 1, 1],
      [1, 2, 0, 0, 0, 1, 1, 2, 1, 1, 1],
      [2, 0, 1, 0, 0, 1, 1, 2, 1, 1, 1],
      [0, 1, 2, 0, 0, 1, 1, 2, 1, 1, 1],
      [2, 1, 0, 1, 0, 0, 2, 2, 1, 1, 1],
      [0, 2, 1, 1, 0, 0, 2, 2, 1, 1, 1],
      [1, 0, 2, 1, 0, 0, 2, 2, 1, 1, 1],
      [2, 1, 0, 0, 0, 1, 2, 2, 1, 1, 1],
      [0, 2, 1, 0, 0, 1, 2, 2, 1, 1, 1],
      [1, 0, 2, 0, 0, 1, 2, 2, 1, 1, 1],
      [0, 0, 0, 2, 1, 2, 2, 2, 1, 1, 1],
      [1, 1, 1, 2, 1, 2, 2, 2, 1, 1, 1],
      [2, 2, 2, 2, 1, 2, 2, 2, 1, 1, 1],
      [1, 2, 0, 2, 2, 2, 2, 2, 1, 1, 1],
      [2, 0, 1, 2, 2, 2, 2, 2, 1, 1, 1],
      [0, 1, 2, 2, 2, 2, 2, 2, 1, 1, 1],
      [2, 1, 0, 1, 0, 1, 0, 0, 0, 1, 1],
      [0, 2, 1, 1, 0, 1, 0, 0, 0, 1, 1],
      [1, 0, 2, 1, 0, 1, 0, 0, 0, 1, 1],
      [0, 0, 0, 2, 2, 2, 0, 0, 0, 1, 1],
      [1, 1, 1, 2, 2, 2, 0, 0, 0, 1, 1],
      [2, 2, 2, 2, 2, 2, 0, 0, 0, 1, 1],
      [1, 2, 0, 1, 2, 0, 1, 0, 0, 1, 1],
      [2, 0, 1, 1, 2, 0, 1, 0, 0, 1, 1],
      [0, 1, 2, 1, 2, 0, 1, 0, 0, 1, 1],
      [0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 1],
      [1, 1, 1, 0, 1, 1, 1, 0, 0, 1, 1],
      [2, 2, 2, 0, 1, 1, 1, 0, 0, 1, 1],
      [2, 1, 0, 2, 1, 0, 2, 0, 0, 1, 1],
      [0, 2, 1, 2, 1, 0, 2, 0, 0, 1, 1],
      [1, 0, 2, 2, 1, 0, 2, 0, 0, 1, 1],
      [1, 2, 0, 0, 0, 2, 2, 0, 0, 1, 1],
      [2, 0, 1, 0, 0, 2, 2, 0, 0, 1, 1],
      [0, 1, 2, 0, 0, 2, 2, 0, 0, 1, 1],
      [0, 0, 0, 1, 1, 0, 0, 1, 0, 1, 1],
      [1, 1, 1, 1, 1, 0, 0, 1, 0, 1, 1],
      [2, 2, 2, 1, 1, 0, 0, 1, 0, 1, 1],
      [1, 2, 0, 0, 2, 1, 0, 1, 0, 1, 1],
      [2, 0, 1, 0, 2, 1, 0, 1, 0, 1, 1],
      [0, 1, 2, 0, 2, 1, 0, 1, 0, 1, 1],
      [2, 1, 0, 0, 0, 0, 1, 1, 0, 1, 1],
      [0, 2, 1, 0, 0, 0, 1, 1, 0, 1, 1],
      [1, 0, 2, 0, 0, 0, 1, 1, 0, 1, 1],
      [1, 2, 0, 2, 1, 2, 1, 1, 0, 1, 1],
      [2, 0, 1, 2, 1, 2, 1, 1, 0, 1, 1],
      [0, 1, 2, 2, 1, 2, 1, 1, 0, 1, 1],
      [0, 0, 0, 2, 0, 1, 2, 1, 0, 1, 1],
      [1, 1, 1, 2, 0, 1, 2, 1, 0, 1, 1],
      [2, 2, 2, 2, 0, 1, 2, 1, 0, 1, 1],
      [2, 1, 0, 1, 2, 2, 2, 1, 0, 1, 1],
      [0, 2, 1, 1, 2, 2, 2, 1, 0, 1, 1],
      [1, 0, 2, 1, 2, 2, 2, 1, 0, 1, 1],
      [1, 2, 0, 2, 0, 0, 0, 2, 0, 1, 1],
      [2, 0, 1, 2, 0, 0, 0, 2, 0, 1, 1],
      [0, 1, 2, 2, 0, 0, 0, 2, 0, 1, 1],
      [2, 1, 0, 0, 1, 2, 0, 2, 0, 1, 1],
      [0, 2, 1, 0, 1, 2, 0, 2, 0, 1, 1],
      [1, 0, 2, 0, 1, 2, 0, 2, 0, 1, 1],
      [2, 1, 0, 2, 2, 1, 1, 2, 0, 1, 1],
      [0, 2, 1, 2, 2, 1, 1, 2, 0, 1, 1],
      [1, 0, 2, 2, 2, 1, 1, 2, 0, 1, 1],
      [0, 0, 0, 1, 0, 2, 1, 2, 0, 1, 1],
      [1, 1, 1, 1, 0, 2, 1, 2, 0, 1, 1],
      [2, 2, 2, 1, 0, 2, 1, 2, 0, 1, 1],
      [0, 0, 0, 0, 2, 0, 2, 2, 0, 1, 1],
      [1, 1, 1, 0, 2, 0, 2, 2, 0, 1, 1],
      [2, 2, 2, 0, 2, 0, 2, 2, 0, 1, 1],
      [1, 2, 0, 1, 1, 1, 2, 2, 0, 1, 1],
      [2, 0, 1, 1, 1, 1, 2, 2, 0, 1, 1],
      [0, 1, 2, 1, 1, 1, 2, 2, 0, 1, 1],
      [2, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
      [0, 2, 1, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 0, 2, 1, 0, 1, 0, 0, 1, 0, 1],
      [0, 0, 0, 2, 2, 2, 0, 0, 1, 0, 1],
      [1, 1, 1, 2, 2, 2, 0, 0, 1, 0, 1],
      [2, 2, 2, 2, 2, 2, 0, 0, 1, 0, 1],
      [1, 2, 0, 1, 2, 0, 1, 0, 1, 0, 1],
      [2, 0, 1, 1, 2, 0, 1, 0, 1, 0, 1],
      [0, 1, 2, 1, 2, 0, 1, 0, 1, 0, 1],
      [0, 0, 0, 0, 1, 1, 1, 0, 1, 0, 1],
      [1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1],
      [2, 2, 2, 0, 1, 1, 1, 0, 1, 0, 1],
      [2, 1, 0, 2, 1, 0, 2, 0, 1, 0, 1],
      [0, 2, 1, 2, 1, 0, 2, 0, 1, 0, 1],
      [1, 0, 2, 2, 1, 0, 2, 0, 1, 0, 1],
      [1, 2, 0, 0, 0, 2, 2, 0, 1, 0, 1],
      [2, 0, 1, 0, 0, 2, 2, 0, 1, 0, 1],
      [0, 1, 2, 0, 0, 2, 2, 0, 1, 0, 1],
      [0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 1],
      [1, 1, 1, 1, 1, 0, 0, 1, 1, 0, 1],
      [2, 2, 2, 1, 1, 0, 0, 1, 1, 0, 1],
      [1, 2, 0, 0, 2, 1, 0, 1, 1, 0, 1],
      [2, 0, 1, 0, 2, 1, 0, 1, 1, 0, 1],
      [0, 1, 2, 0, 2, 1, 0, 1, 1, 0, 1],
      [2, 1, 0, 0, 0, 0, 1, 1, 1, 0, 1],
      [0, 2, 1, 0, 0, 0, 1, 1, 1, 0, 1],
      [1, 0, 2, 0, 0, 0, 1, 1, 1, 0, 1],
      [1, 2, 0, 2, 1, 2, 1, 1, 1, 0, 1],
      [2, 0, 1, 2, 1, 2, 1, 1, 1, 0, 1],
      [0, 1, 2, 2, 1, 2, 1, 1, 1, 0, 1],
      [0, 0, 0, 2, 0, 1, 2, 1, 1, 0, 1],
      [1, 1, 1, 2, 0, 1, 2, 1, 1, 0, 1],
      [2, 2, 2, 2, 0, 1, 2, 1, 1, 0, 1],
      [2, 1, 0, 1, 2, 2, 2, 1, 1, 0, 1],
      [0, 2, 1, 1, 2, 2, 2, 1, 1, 0, 1],
      [1, 0, 2, 1, 2, 2, 2, 1, 1, 0, 1],
      [1, 2, 0, 2, 0, 0, 0, 2, 1, 0, 1],
      [2, 0, 1, 2, 0, 0, 0, 2, 1, 0, 1],
      [0, 1, 2, 2, 0, 0, 0, 2, 1, 0, 1],
      [2, 1, 0, 0, 1, 2, 0, 2, 1, 0, 1],
      [0, 2, 1, 0, 1, 2, 0, 2, 1, 0, 1],
      [1, 0, 2, 0, 1, 2, 0, 2, 1, 0, 1],
      [2, 1, 0, 2, 2, 1, 1, 2, 1, 0, 1],
      [0, 2, 1, 2, 2, 1, 1, 2, 1, 0, 1],
      [1, 0, 2, 2, 2, 1, 1, 2, 1, 0, 1],
      [0, 0, 0, 1, 0, 2, 1, 2, 1, 0, 1],
      [1, 1, 1, 1, 0, 2, 1, 2, 1, 0, 1],
      [2, 2, 2, 1, 0, 2, 1, 2, 1, 0, 1],
      [0, 0, 0, 0, 2, 0, 2, 2, 1, 0, 1],
      [1, 1, 1, 0, 2, 0, 2, 2, 1, 0, 1],
      [2, 2, 2, 0, 2, 0, 2, 2, 1, 0, 1],
      [1, 2, 0, 1, 1, 1, 2, 2, 1, 0, 1],
      [2, 0, 1, 1, 1, 1, 2, 2, 1, 0, 1],
      [0, 1, 2, 1, 1, 1, 2, 2, 1, 0, 1],
      [1, 2, 0, 0, 1, 0, 0, 0, 0, 0, 1],
      [2, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1],
      [0, 1, 2, 0, 1, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 1],
      [1, 1, 1, 2, 2, 2, 0, 0, 0, 0, 1],
      [2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 1],
      [1, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1],
      [2, 0, 1, 2, 0, 1, 1, 0, 0, 0, 1],
      [0, 1, 2, 2, 0, 1, 1, 0, 0, 0, 1],
      [2, 1, 0, 1, 1, 2, 1, 0, 0, 0, 1],
      [0, 2, 1, 1, 1, 2, 1, 0, 0, 0, 1],
      [1, 0, 2, 1, 1, 2, 1, 0, 0, 0, 1],
      [0, 0, 0, 1, 0, 0, 2, 0, 0, 0, 1],
      [1, 1, 1, 1, 0, 0, 2, 0, 0, 0, 1],
      [2, 2, 2, 1, 0, 0, 2, 0, 0, 0, 1],
      [2, 1, 0, 0, 2, 1, 2, 0, 0, 0, 1],
      [0, 2, 1, 0, 2, 1, 2, 0, 0, 0, 1],
      [1, 0, 2, 0, 2, 1, 2, 0, 0, 0, 1],
      [2, 1, 0, 2, 1, 1, 0, 1, 0, 0, 1],
      [0, 2, 1, 2, 1, 1, 0, 1, 0, 0, 1],
      [1, 0, 2, 2, 1, 1, 0, 1, 0, 0, 1],
      [1, 2, 0, 1, 0, 2, 0, 1, 0, 0, 1],
      [2, 0, 1, 1, 0, 2, 0, 1, 0, 0, 1],
      [0, 1, 2, 1, 0, 2, 0, 1, 0, 0, 1],
      [2, 1, 0, 0, 0, 0, 1, 1, 0, 0, 1],
      [0, 2, 1, 0, 0, 0, 1, 1, 0, 0, 1],
      [1, 0, 2, 0, 0, 0, 1, 1, 0, 0, 1],
      [0, 0, 0, 1, 2, 1, 1, 1, 0, 0, 1],
      [1, 1, 1, 1, 2, 1, 1, 1, 0, 0, 1],
      [2, 2, 2, 1, 2, 1, 1, 1, 0, 0, 1],
      [1, 2, 0, 2, 2, 0, 2, 1, 0, 0, 1],
      [2, 0, 1, 2, 2, 0, 2, 1, 0, 0, 1],
      [0, 1, 2, 2, 2, 0, 2, 1, 0, 0, 1],
      [0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 1],
      [1, 1, 1, 0, 1, 2, 2, 1, 0, 0, 1],
      [2, 2, 2, 0, 1, 2, 2, 1, 0, 0, 1],
      [2, 1, 0, 1, 2, 0, 0, 2, 0, 0, 1],
      [0, 2, 1, 1, 2, 0, 0, 2, 0, 0, 1],
      [1, 0, 2, 1, 2, 0, 0, 2, 0, 0, 1],
      [0, 0, 0, 0, 0, 1, 0, 2, 0, 0, 1],
      [1, 1, 1, 0, 0, 1, 0, 2, 0, 0, 1],
      [2, 2, 2, 0, 0, 1, 0, 2, 0, 0, 1],
      [0, 0, 0, 2, 1, 0, 1, 2, 0, 0, 1],
      [1, 1, 1, 2, 1, 0, 1, 2, 0, 0, 1],
      [2, 2, 2, 2, 1, 0, 1, 2, 0, 0, 1],
      [1, 2, 0, 0, 2, 2, 1, 2, 0, 0, 1],
      [2, 0, 1, 0, 2, 2, 1, 2, 0, 0, 1],
      [0, 1, 2, 0, 2, 2, 1, 2, 0, 0, 1],
      [1, 2, 0, 1, 1, 1, 2, 2, 0, 0, 1],
      [2, 0, 1, 1, 1, 1, 2, 2, 0, 0, 1],
      [0, 1, 2, 1, 1, 1, 2, 2, 0, 0, 1],
      [2, 1, 0, 2, 0, 2, 2, 2, 0, 0, 1],
      [0, 2, 1, 2, 0, 2, 2, 2, 0, 0, 1],
      [1, 0, 2, 2, 0, 2, 2, 2, 0, 0, 1],
      [2, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0],
      [0, 2, 1, 1, 0, 1, 0, 0, 1, 1, 0],
      [1, 0, 2, 1, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 0, 2, 2, 2, 0, 0, 1, 1, 0],
      [1, 1, 1, 2, 2, 2, 0, 0, 1, 1, 0],
      [2, 2, 2, 2, 2, 2, 0, 0, 1, 1, 0],
      [1, 2, 0, 1, 2, 0, 1, 0, 1, 1, 0],
      [2, 0, 1, 1, 2, 0, 1, 0, 1, 1, 0],
      [0, 1, 2, 1, 2, 0, 1, 0, 1, 1, 0],
      [0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 0],
      [1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 0],
      [2, 2, 2, 0, 1, 1, 1, 0, 1, 1, 0],
      [2, 1, 0, 2, 1, 0, 2, 0, 1, 1, 0],
      [0, 2, 1, 2, 1, 0, 2, 0, 1, 1, 0],
      [1, 0, 2, 2, 1, 0, 2, 0, 1, 1, 0],
      [1, 2, 0, 0, 0, 2, 2, 0, 1, 1, 0],
      [2, 0, 1, 0, 0, 2, 2, 0, 1, 1, 0],
      [0, 1, 2, 0, 0, 2, 2, 0, 1, 1, 0],
      [0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 0],
      [1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 0],
      [2, 2, 2, 1, 1, 0, 0, 1, 1, 1, 0],
      [1, 2, 0, 0, 2, 1, 0, 1, 1, 1, 0],
      [2, 0, 1, 0, 2, 1, 0, 1, 1, 1, 0],
      [0, 1, 2, 0, 2, 1, 0, 1, 1, 1, 0],
      [2, 1, 0, 0, 0, 0, 1, 1, 1, 1, 0],
      [0, 2, 1, 0, 0, 0, 1, 1, 1, 1, 0],
      [1, 0, 2, 0, 0, 0, 1, 1, 1, 1, 0],
      [1, 2, 0, 2, 1, 2, 1, 1, 1, 1, 0],
      [2, 0, 1, 2, 1, 2, 1, 1, 1, 1, 0],
      [0, 1, 2, 2, 1, 2, 1, 1, 1, 1, 0],
      [0, 0, 0, 2, 0, 1, 2, 1, 1, 1, 0],
      [1, 1, 1, 2, 0, 1, 2, 1, 1, 1, 0],
      [2, 2, 2, 2, 0, 1, 2, 1, 1, 1, 0],
      [2, 1, 0, 1, 2, 2, 2, 1, 1, 1, 0],
      [0, 2, 1, 1, 2, 2, 2, 1, 1, 1, 0],
      [1, 0, 2, 1, 2, 2, 2, 1, 1, 1, 0],
      [1, 2, 0, 2, 0, 0, 0, 2, 1, 1, 0],
      [2, 0, 1, 2, 0, 0, 0, 2, 1, 1, 0],
      [0, 1, 2, 2, 0, 0, 0, 2, 1, 1, 0],
      [2, 1, 0, 0, 1, 2, 0, 2, 1, 1, 0],
      [0, 2, 1, 0, 1, 2, 0, 2, 1, 1, 0],
      [1, 0, 2, 0, 1, 2, 0, 2, 1, 1, 0],
      [2, 1, 0, 2, 2, 1, 1, 2, 1, 1, 0],
      [0, 2, 1, 2, 2, 1, 1, 2, 1, 1, 0],
      [1, 0, 2, 2, 2, 1, 1, 2, 1, 1, 0],
      [0, 0, 0, 1, 0, 2, 1, 2, 1, 1, 0],
      [1, 1, 1, 1, 0, 2, 1, 2, 1, 1, 0],
      [2, 2, 2, 1, 0, 2, 1, 2, 1, 1, 0],
      [0, 0, 0, 0, 2, 0, 2, 2, 1, 1, 0],
      [1, 1, 1, 0, 2, 0, 2, 2, 1, 1, 0],
      [2, 2, 2, 0, 2, 0, 2, 2, 1, 1, 0],
      [1, 2, 0, 1, 1, 1, 2, 2, 1, 1, 0],
      [2, 0, 1, 1, 1, 1, 2, 2, 1, 1, 0],
      [0, 1, 2, 1, 1, 1, 2, 2, 1, 1, 0],
      [1, 2, 0, 0, 1, 0, 0, 0, 0, 1, 0],
      [2, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0],
      [0, 1, 2, 0, 1, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 2, 2, 2, 0, 0, 0, 1, 0],
      [1, 1, 1, 2, 2, 2, 0, 0, 0, 1, 0],
      [2, 2, 2, 2, 2, 2, 0, 0, 0, 1, 0],
      [1, 2, 0, 2, 0, 1, 1, 0, 0, 1, 0],
      [2, 0, 1, 2, 0, 1, 1, 0, 0, 1, 0],
      [0, 1, 2, 2, 0, 1, 1, 0, 0, 1, 0],
      [2, 1, 0, 1, 1, 2, 1, 0, 0, 1, 0],
      [0, 2, 1, 1, 1, 2, 1, 0, 0, 1, 0],
      [1, 0, 2, 1, 1, 2, 1, 0, 0, 1, 0],
      [0, 0, 0, 1, 0, 0, 2, 0, 0, 1, 0],
      [1, 1, 1, 1, 0, 0, 2, 0, 0, 1, 0],
      [2, 2, 2, 1, 0, 0, 2, 0, 0, 1, 0],
      [2, 1, 0, 0, 2, 1, 2, 0, 0, 1, 0],
      [0, 2, 1, 0, 2, 1, 2, 0, 0, 1, 0],
      [1, 0, 2, 0, 2, 1, 2, 0, 0, 1, 0],
      [2, 1, 0, 2, 1, 1, 0, 1, 0, 1, 0],
      [0, 2, 1, 2, 1, 1, 0, 1, 0, 1, 0],
      [1, 0, 2, 2, 1, 1, 0, 1, 0, 1, 0],
      [1, 2, 0, 1, 0, 2, 0, 1, 0, 1, 0],
      [2, 0, 1, 1, 0, 2, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 0, 2, 0, 1, 0, 1, 0],
      [2, 1, 0, 0, 0, 0, 1, 1, 0, 1, 0],
      [0, 2, 1, 0, 0, 0, 1, 1, 0, 1, 0],
      [1, 0, 2, 0, 0, 0, 1, 1, 0, 1, 0],
      [0, 0, 0, 1, 2, 1, 1, 1, 0, 1, 0],
      [1, 1, 1, 1, 2, 1, 1, 1, 0, 1, 0],
      [2, 2, 2, 1, 2, 1, 1, 1, 0, 1, 0],
      [1, 2, 0, 2, 2, 0, 2, 1, 0, 1, 0],
      [2, 0, 1, 2, 2, 0, 2, 1, 0, 1, 0],
      [0, 1, 2, 2, 2, 0, 2, 1, 0, 1, 0],
      [0, 0, 0, 0, 1, 2, 2, 1, 0, 1, 0],
      [1, 1, 1, 0, 1, 2, 2, 1, 0, 1, 0],
      [2, 2, 2, 0, 1, 2, 2, 1, 0, 1, 0],
      [2, 1, 0, 1, 2, 0, 0, 2, 0, 1, 0],
      [0, 2, 1, 1, 2, 0, 0, 2, 0, 1, 0],
      [1, 0, 2, 1, 2, 0, 0, 2, 0, 1, 0],
      [0, 0, 0, 0, 0, 1, 0, 2, 0, 1, 0],
      [1, 1, 1, 0, 0, 1, 0, 2, 0, 1, 0],
      [2, 2, 2, 0, 0, 1, 0, 2, 0, 1, 0],
      [0, 0, 0, 2, 1, 0, 1, 2, 0, 1, 0],
      [1, 1, 1, 2, 1, 0, 1, 2, 0, 1, 0],
      [2, 2, 2, 2, 1, 0, 1, 2, 0, 1, 0],
      [1, 2, 0, 0, 2, 2, 1, 2, 0, 1, 0],
      [2, 0, 1, 0, 2, 2, 1, 2, 0, 1, 0],
      [0, 1, 2, 0, 2, 2, 1, 2, 0, 1, 0],
      [1, 2, 0, 1, 1, 1, 2, 2, 0, 1, 0],
      [2, 0, 1, 1, 1, 1, 2, 2, 0, 1, 0],
      [0, 1, 2, 1, 1, 1, 2, 2, 0, 1, 0],
      [2, 1, 0, 2, 0, 2, 2, 2, 0, 1, 0],
      [0, 2, 1, 2, 0, 2, 2, 2, 0, 1, 0],
      [1, 0, 2, 2, 0, 2, 2, 2, 0, 1, 0],
      [1, 2, 0, 0, 1, 0, 0, 0, 1, 0, 0],
      [2, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0],
      [0, 1, 2, 0, 1, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 2, 2, 0, 0, 1, 0, 0],
      [1, 1, 1, 2, 2, 2, 0, 0, 1, 0, 0],
      [2, 2, 2, 2, 2, 2, 0, 0, 1, 0, 0],
      [1, 2, 0, 2, 0, 1, 1, 0, 1, 0, 0],
      [2, 0, 1, 2, 0, 1, 1, 0, 1, 0, 0],
      [0, 1, 2, 2, 0, 1, 1, 0, 1, 0, 0],
      [2, 1, 0, 1, 1, 2, 1, 0, 1, 0, 0],
      [0, 2, 1, 1, 1, 2, 1, 0, 1, 0, 0],
      [1, 0, 2, 1, 1, 2, 1, 0, 1, 0, 0],
      [0, 0, 0, 1, 0, 0, 2, 0, 1, 0, 0],
      [1, 1, 1, 1, 0, 0, 2, 0, 1, 0, 0],
      [2, 2, 2, 1, 0, 0, 2, 0, 1, 0, 0],
      [2, 1, 0, 0, 2, 1, 2, 0, 1, 0, 0],
      [0, 2, 1, 0, 2, 1, 2, 0, 1, 0, 0],
      [1, 0, 2, 0, 2, 1, 2, 0, 1, 0, 0],
      [2, 1, 0, 2, 1, 1, 0, 1, 1, 0, 0],
      [0, 2, 1, 2, 1, 1, 0, 1, 1, 0, 0],
      [1, 0, 2, 2, 1, 1, 0, 1, 1, 0, 0],
      [1, 2, 0, 1, 0, 2, 0, 1, 1, 0, 0],
      [2, 0, 1, 1, 0, 2, 0, 1, 1, 0, 0],
      [0, 1, 2, 1, 0, 2, 0, 1, 1, 0, 0],
      [2, 1, 0, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 2, 1, 0, 0, 0, 1, 1, 1, 0, 0],
      [1, 0, 2, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 0, 0, 1, 2, 1, 1, 1, 1, 0, 0],
      [1, 1, 1, 1, 2, 1, 1, 1, 1, 0, 0],
      [2, 2, 2, 1, 2, 1, 1, 1, 1, 0, 0],
      [1, 2, 0, 2, 2, 0, 2, 1, 1, 0, 0],
      [2, 0, 1, 2, 2, 0, 2, 1, 1, 0, 0],
      [0, 1, 2, 2, 2, 0, 2, 1, 1, 0, 0],
      [0, 0, 0, 0, 1, 2, 2, 1, 1, 0, 0],
      [1, 1, 1, 0, 1, 2, 2, 1, 1, 0, 0],
      [2, 2, 2, 0, 1, 2, 2, 1, 1, 0, 0],
      [2, 1, 0, 1, 2, 0, 0, 2, 1, 0, 0],
      [0, 2, 1, 1, 2, 0, 0, 2, 1, 0, 0],
      [1, 0, 2, 1, 2, 0, 0, 2, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 2, 1, 0, 0],
      [1, 1, 1, 0, 0, 1, 0, 2, 1, 0, 0],
      [2, 2, 2, 0, 0, 1, 0, 2, 1, 0, 0],
      [0, 0, 0, 2, 1, 0, 1, 2, 1, 0, 0],
      [1, 1, 1, 2, 1, 0, 1, 2, 1, 0, 0],
      [2, 2, 2, 2, 1, 0, 1, 2, 1, 0, 0],
      [1, 2, 0, 0, 2, 2, 1, 2, 1, 0, 0],
      [2, 0, 1, 0, 2, 2, 1, 2, 1, 0, 0],
      [0, 1, 2, 0, 2, 2, 1, 2, 1, 0, 0],
      [1, 2, 0, 1, 1, 1, 2, 2, 1, 0, 0],
      [2, 0, 1, 1, 1, 1, 2, 2, 1, 0, 0],
      [0, 1, 2, 1, 1, 1, 2, 2, 1, 0, 0],
      [2, 1, 0, 2, 0, 2, 2, 2, 1, 0, 0],
      [0, 2, 1, 2, 0, 2, 2, 2, 1, 0, 0],
      [1, 0, 2, 2, 0, 2, 2, 2, 1, 0, 0],
      [2, 1, 0, 2, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 2, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
      [2, 2, 2, 1, 1, 1, 0, 0, 0, 0, 0],
      [1, 2, 0, 1, 2, 1, 0, 0, 0, 0, 0],
      [2, 0, 1, 1, 2, 1, 0, 0, 0, 0, 0],
      [0, 1, 2, 1, 2, 1, 0, 0, 0, 0, 0],
      [2, 1, 0, 0, 0, 2, 0, 0, 0, 0, 0],
      [0, 2, 1, 0, 0, 2, 0, 0, 0, 0, 0],
      [1, 0, 2, 0, 0, 2, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 1, 0, 0, 0, 0],
      [1, 1, 1, 0, 2, 0, 1, 0, 0, 0, 0],
      [2, 2, 2, 0, 2, 0, 1, 0, 0, 0, 0],
      [2, 1, 0, 2, 2, 0, 1, 0, 0, 0, 0],
      [0, 2, 1, 2, 2, 0, 1, 0, 0, 0, 0],
      [1, 0, 2, 2, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 2, 1, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 2, 1, 0, 0, 0, 0],
      [2, 2, 2, 0, 0, 2, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 1, 1, 2, 0, 0, 0, 0],
      [1, 1, 1, 2, 1, 1, 2, 0, 0, 0, 0],
      [2, 2, 2, 2, 1, 1, 2, 0, 0, 0, 0],
      [1, 2, 0, 2, 1, 2, 2, 0, 0, 0, 0],
      [2, 0, 1, 2, 1, 2, 2, 0, 0, 0, 0],
      [0, 1, 2, 2, 1, 2, 2, 0, 0, 0, 0],
      [1, 2, 0, 1, 2, 2, 2, 0, 0, 0, 0],
      [2, 0, 1, 1, 2, 2, 2, 0, 0, 0, 0],
      [0, 1, 2, 1, 2, 2, 2, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0],
      [1, 1, 1, 2, 0, 0, 0, 1, 0, 0, 0],
      [2, 2, 2, 2, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 0, 1, 0, 0, 0],
      [1, 1, 1, 0, 2, 0, 0, 1, 0, 0, 0],
      [2, 2, 2, 0, 2, 0, 0, 1, 0, 0, 0],
      [2, 1, 0, 0, 2, 2, 0, 1, 0, 0, 0],
      [0, 2, 1, 0, 2, 2, 0, 1, 0, 0, 0],
      [1, 0, 2, 0, 2, 2, 0, 1, 0, 0, 0],
      [1, 2, 0, 1, 1, 0, 1, 1, 0, 0, 0],
      [2, 0, 1, 1, 1, 0, 1, 1, 0, 0, 0],
      [0, 1, 2, 1, 1, 0, 1, 1, 0, 0, 0],
      [1, 2, 0, 0, 1, 1, 1, 1, 0, 0, 0],
      [2, 0, 1, 0, 1, 1, 1, 1, 0, 0, 0],
      [0, 1, 2, 0, 1, 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 2, 0, 2, 1, 1, 0, 0, 0],
      [1, 1, 1, 2, 0, 2, 1, 1, 0, 0, 0],
      [2, 2, 2, 2, 0, 2, 1, 1, 0, 0, 0],
      [2, 1, 0, 2, 2, 2, 1, 1, 0, 0, 0],
      [0, 2, 1, 2, 2, 2, 1, 1, 0, 0, 0],
      [1, 0, 2, 2, 2, 2, 1, 1, 0, 0, 0],
      [2, 1, 0, 1, 1, 0, 2, 1, 0, 0, 0],
      [0, 2, 1, 1, 1, 0, 2, 1, 0, 0, 0],
      [1, 0, 2, 1, 1, 0, 2, 1, 0, 0, 0],
      [1, 2, 0, 0, 0, 1, 2, 1, 0, 0, 0],
      [2, 0, 1, 0, 0, 1, 2, 1, 0, 0, 0],
      [0, 1, 2, 0, 0, 1, 2, 1, 0, 0, 0],
      [2, 1, 0, 1, 0, 1, 2, 1, 0, 0, 0],
      [0, 2, 1, 1, 0, 1, 2, 1, 0, 0, 0],
      [1, 0, 2, 1, 0, 1, 2, 1, 0, 0, 0],
      [1, 2, 0, 2, 2, 1, 0, 2, 0, 0, 0],
      [2, 0, 1, 2, 2, 1, 0, 2, 0, 0, 0],
      [0, 1, 2, 2, 2, 1, 0, 2, 0, 0, 0],
      [0, 0, 0, 1, 1, 2, 0, 2, 0, 0, 0],
      [1, 1, 1, 1, 1, 2, 0, 2, 0, 0, 0],
      [2, 2, 2, 1, 1, 2, 0, 2, 0, 0, 0],
      [1, 2, 0, 2, 1, 2, 0, 2, 0, 0, 0],
      [2, 0, 1, 2, 1, 2, 0, 2, 0, 0, 0],
      [0, 1, 2, 2, 1, 2, 0, 2, 0, 0, 0],
      [1, 2, 0, 1, 0, 0, 1, 2, 0, 0, 0],
      [2, 0, 1, 1, 0, 0, 1, 2, 0, 0, 0],
      [0, 1, 2, 1, 0, 0, 1, 2, 0, 0, 0],
      [2, 1, 0, 1, 0, 1, 1, 2, 0, 0, 0],
      [0, 2, 1, 1, 0, 1, 1, 2, 0, 0, 0],
      [1, 0, 2, 1, 0, 1, 1, 2, 0, 0, 0],
      [2, 1, 0, 0, 1, 1, 1, 2, 0, 0, 0],
      [0, 2, 1, 0, 1, 1, 1, 2, 0, 0, 0],
      [1, 0, 2, 0, 1, 1, 1, 2, 0, 0, 0],
      [1, 2, 0, 0, 0, 0, 2, 2, 0, 0, 0],
      [2, 0, 1, 0, 0, 0, 2, 2, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 2, 2, 0, 0, 0],
      [2, 1, 0, 0, 1, 0, 2, 2, 0, 0, 0],
      [0, 2, 1, 0, 1, 0, 2, 2, 0, 0, 0],
      [1, 0, 2, 0, 1, 0, 2, 2, 0, 0, 0],
      [0, 0, 0, 2, 2, 1, 2, 2, 0, 0, 0],
      [1, 1, 1, 2, 2, 1, 2, 2, 0, 0, 0],
      [2, 2, 2, 2, 2, 1, 2, 2, 0, 0, 0],
      [0, 0, 0, 1, 2, 2, 2, 2, 0, 0, 0],
      [1, 1, 1, 1, 2, 2, 2, 2, 0, 0, 0],
      [2, 2, 2, 1, 2, 2, 2, 2, 0, 0, 0],
    ] as const,
    systemType: 'R',
    systemNum: 55,
    hasXpert: false,
  } as const,
  'R9-0-1356': {
    guaranty: 12,
    numFullHedges: 9,
    numHalfHedges: 0,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 2, 2, 0, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 1, 0, 0, 0],
      [2, 0, 0, 0, 0, 1, 0, 0, 0],
      [1, 1, 2, 0, 0, 2, 0, 0, 0],
      [1, 2, 1, 0, 0, 2, 0, 0, 0],
      [0, 2, 0, 0, 1, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 0, 0, 0, 0],
      [0, 2, 2, 0, 1, 1, 0, 0, 0],
      [2, 0, 2, 0, 1, 1, 0, 0, 0],
      [2, 1, 0, 0, 1, 2, 0, 0, 0],
      [1, 1, 2, 0, 2, 0, 0, 0, 0],
      [2, 1, 1, 0, 2, 0, 0, 0, 0],
      [1, 2, 0, 0, 2, 1, 0, 0, 0],
      [0, 0, 2, 0, 2, 2, 0, 0, 0],
      [2, 2, 1, 0, 2, 2, 0, 0, 0],
      [0, 0, 2, 1, 0, 0, 0, 0, 0],
      [1, 1, 0, 1, 0, 0, 0, 0, 0],
      [0, 2, 2, 1, 0, 1, 0, 0, 0],
      [2, 2, 0, 1, 0, 1, 0, 0, 0],
      [2, 0, 1, 1, 0, 2, 0, 0, 0],
      [2, 0, 2, 1, 1, 0, 0, 0, 0],
      [2, 2, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 0, 0, 0],
      [0, 1, 1, 1, 1, 2, 0, 0, 0],
      [1, 2, 2, 1, 1, 2, 0, 0, 0],
      [0, 2, 1, 1, 2, 0, 0, 0, 0],
      [1, 0, 1, 1, 2, 1, 0, 0, 0],
      [2, 1, 2, 1, 2, 1, 0, 0, 0],
      [0, 1, 0, 1, 2, 2, 0, 0, 0],
      [1, 0, 0, 1, 2, 2, 0, 0, 0],
      [1, 2, 1, 2, 0, 0, 0, 0, 0],
      [2, 1, 1, 2, 0, 0, 0, 0, 0],
      [1, 0, 2, 2, 0, 1, 0, 0, 0],
      [0, 2, 0, 2, 0, 2, 0, 0, 0],
      [2, 1, 2, 2, 0, 2, 0, 0, 0],
      [0, 1, 2, 2, 1, 0, 0, 0, 0],
      [1, 1, 0, 2, 1, 1, 0, 0, 0],
      [2, 2, 1, 2, 1, 1, 0, 0, 0],
      [0, 0, 1, 2, 1, 2, 0, 0, 0],
      [1, 0, 0, 2, 1, 2, 0, 0, 0],
      [1, 2, 2, 2, 2, 0, 0, 0, 0],
      [2, 0, 0, 2, 2, 0, 0, 0, 0],
      [0, 0, 1, 2, 2, 1, 0, 0, 0],
      [0, 1, 0, 2, 2, 1, 0, 0, 0],
      [1, 1, 1, 2, 2, 2, 0, 0, 0],
      [2, 2, 2, 2, 2, 2, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 0, 1],
      [2, 2, 2, 0, 0, 0, 0, 0, 1],
      [0, 2, 0, 0, 0, 1, 0, 0, 1],
      [1, 0, 1, 0, 0, 1, 0, 0, 1],
      [0, 1, 0, 0, 0, 2, 0, 0, 1],
      [2, 0, 2, 0, 0, 2, 0, 0, 1],
      [0, 0, 2, 0, 1, 0, 0, 0, 1],
      [1, 1, 0, 0, 1, 0, 0, 0, 1],
      [1, 0, 0, 0, 1, 1, 0, 0, 1],
      [2, 1, 1, 0, 1, 1, 0, 0, 1],
      [0, 2, 1, 0, 1, 2, 0, 0, 1],
      [0, 0, 1, 0, 2, 0, 0, 0, 1],
      [2, 2, 0, 0, 2, 0, 0, 0, 1],
      [0, 1, 2, 0, 2, 1, 0, 0, 1],
      [1, 2, 2, 0, 2, 2, 0, 0, 1],
      [2, 0, 0, 0, 2, 2, 0, 0, 1],
      [0, 1, 1, 1, 0, 0, 0, 0, 1],
      [2, 0, 0, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 1, 0, 1, 0, 0, 1],
      [1, 1, 2, 1, 0, 1, 0, 0, 1],
      [1, 2, 0, 1, 0, 2, 0, 0, 1],
      [0, 1, 0, 1, 1, 0, 0, 0, 1],
      [1, 2, 1, 1, 1, 0, 0, 0, 1],
      [0, 0, 0, 1, 1, 1, 0, 0, 1],
      [2, 2, 2, 1, 1, 1, 0, 0, 1],
      [1, 0, 1, 1, 1, 2, 0, 0, 1],
      [2, 1, 2, 1, 1, 2, 0, 0, 1],
      [1, 0, 2, 1, 2, 0, 0, 0, 1],
      [1, 1, 0, 1, 2, 1, 0, 0, 1],
      [2, 2, 1, 1, 2, 1, 0, 0, 1],
      [0, 2, 2, 1, 2, 2, 0, 0, 1],
      [2, 1, 1, 1, 2, 2, 0, 0, 1],
      [0, 2, 2, 2, 0, 0, 0, 0, 1],
      [1, 0, 0, 2, 0, 0, 0, 0, 1],
      [2, 1, 0, 2, 0, 1, 0, 0, 1],
      [0, 0, 2, 2, 0, 2, 0, 0, 1],
      [2, 2, 1, 2, 0, 2, 0, 0, 1],
      [2, 0, 1, 2, 1, 0, 0, 0, 1],
      [0, 1, 1, 2, 1, 1, 0, 0, 1],
      [1, 2, 2, 2, 1, 1, 0, 0, 1],
      [1, 1, 2, 2, 1, 2, 0, 0, 1],
      [2, 2, 0, 2, 1, 2, 0, 0, 1],
      [0, 2, 0, 2, 2, 0, 0, 0, 1],
      [2, 1, 2, 2, 2, 0, 0, 0, 1],
      [1, 2, 1, 2, 2, 1, 0, 0, 1],
      [2, 0, 2, 2, 2, 1, 0, 0, 1],
      [0, 0, 0, 2, 2, 2, 0, 0, 1],
      [1, 1, 1, 2, 2, 2, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 0, 2],
      [1, 1, 1, 0, 0, 0, 0, 0, 2],
      [1, 2, 2, 0, 0, 1, 0, 0, 2],
      [2, 1, 2, 0, 0, 1, 0, 0, 2],
      [0, 0, 1, 0, 0, 2, 0, 0, 2],
      [2, 2, 0, 0, 0, 2, 0, 0, 2],
      [2, 1, 2, 0, 1, 0, 0, 0, 2],
      [2, 2, 1, 0, 1, 0, 0, 0, 2],
      [0, 1, 0, 0, 1, 1, 0, 0, 2],
      [1, 2, 1, 0, 1, 1, 0, 0, 2],
      [1, 0, 2, 0, 1, 2, 0, 0, 2],
      [0, 2, 2, 0, 2, 0, 0, 0, 2],
      [1, 0, 0, 0, 2, 0, 0, 0, 2],
      [2, 0, 1, 0, 2, 1, 0, 0, 2],
      [0, 1, 1, 0, 2, 2, 0, 0, 2],
      [1, 1, 0, 0, 2, 2, 0, 0, 2],
      [1, 2, 2, 1, 0, 0, 0, 0, 2],
      [2, 2, 1, 1, 0, 0, 0, 0, 2],
      [1, 0, 0, 1, 0, 1, 0, 0, 2],
      [2, 1, 1, 1, 0, 1, 0, 0, 2],
      [0, 1, 2, 1, 0, 2, 0, 0, 2],
      [0, 0, 1, 1, 1, 0, 0, 0, 2],
      [1, 1, 2, 1, 1, 0, 0, 0, 2],
      [1, 1, 1, 1, 1, 1, 0, 0, 2],
      [2, 2, 2, 1, 1, 1, 0, 0, 2],
      [0, 2, 0, 1, 1, 2, 0, 0, 2],
      [2, 0, 0, 1, 1, 2, 0, 0, 2],
      [2, 1, 0, 1, 2, 0, 0, 0, 2],
      [0, 0, 2, 1, 2, 1, 0, 0, 2],
      [0, 2, 0, 1, 2, 1, 0, 0, 2],
      [1, 2, 1, 1, 2, 2, 0, 0, 2],
      [2, 0, 2, 1, 2, 2, 0, 0, 2],
      [0, 1, 0, 2, 0, 0, 0, 0, 2],
      [2, 0, 2, 2, 0, 0, 0, 0, 2],
      [0, 2, 1, 2, 0, 1, 0, 0, 2],
      [1, 0, 1, 2, 0, 2, 0, 0, 2],
      [1, 1, 0, 2, 0, 2, 0, 0, 2],
      [1, 2, 0, 2, 1, 0, 0, 0, 2],
      [0, 0, 2, 2, 1, 1, 0, 0, 2],
      [2, 0, 0, 2, 1, 1, 0, 0, 2],
      [0, 2, 2, 2, 1, 2, 0, 0, 2],
      [2, 1, 1, 2, 1, 2, 0, 0, 2],
      [0, 1, 1, 2, 2, 0, 0, 0, 2],
      [1, 0, 1, 2, 2, 0, 0, 0, 2],
      [1, 1, 2, 2, 2, 1, 0, 0, 2],
      [2, 2, 0, 2, 2, 1, 0, 0, 2],
      [0, 0, 0, 2, 2, 2, 0, 0, 2],
      [2, 2, 2, 2, 2, 2, 0, 0, 2],
      [0, 1, 2, 0, 0, 0, 0, 1, 0],
      [1, 2, 0, 0, 0, 0, 0, 1, 0],
      [2, 0, 1, 0, 0, 0, 0, 1, 0],
      [0, 2, 2, 0, 0, 2, 0, 1, 0],
      [1, 0, 0, 0, 0, 2, 0, 1, 0],
      [2, 1, 1, 0, 0, 2, 0, 1, 0],
      [0, 0, 1, 0, 1, 1, 0, 1, 0],
      [1, 1, 2, 0, 1, 1, 0, 1, 0],
      [2, 2, 0, 0, 1, 1, 0, 1, 0],
      [0, 0, 0, 0, 1, 2, 0, 1, 0],
      [1, 1, 1, 0, 1, 2, 0, 1, 0],
      [2, 2, 2, 0, 1, 2, 0, 1, 0],
      [0, 1, 0, 0, 2, 0, 0, 1, 0],
      [1, 2, 1, 0, 2, 0, 0, 1, 0],
      [2, 0, 2, 0, 2, 0, 0, 1, 0],
      [0, 2, 1, 0, 2, 1, 0, 1, 0],
      [1, 0, 2, 0, 2, 1, 0, 1, 0],
      [2, 1, 0, 0, 2, 1, 0, 1, 0],
      [0, 1, 0, 1, 0, 1, 0, 1, 0],
      [1, 2, 1, 1, 0, 1, 0, 1, 0],
      [2, 0, 2, 1, 0, 1, 0, 1, 0],
      [0, 2, 1, 1, 0, 2, 0, 1, 0],
      [1, 0, 2, 1, 0, 2, 0, 1, 0],
      [2, 1, 0, 1, 0, 2, 0, 1, 0],
      [0, 2, 2, 1, 1, 0, 0, 1, 0],
      [1, 0, 0, 1, 1, 0, 0, 1, 0],
      [2, 1, 1, 1, 1, 0, 0, 1, 0],
      [0, 1, 2, 1, 1, 1, 0, 1, 0],
      [1, 2, 0, 1, 1, 1, 0, 1, 0],
      [2, 0, 1, 1, 1, 1, 0, 1, 0],
      [0, 0, 0, 1, 2, 0, 0, 1, 0],
      [1, 1, 1, 1, 2, 0, 0, 1, 0],
      [2, 2, 2, 1, 2, 0, 0, 1, 0],
      [0, 0, 1, 1, 2, 2, 0, 1, 0],
      [1, 1, 2, 1, 2, 2, 0, 1, 0],
      [2, 2, 0, 1, 2, 2, 0, 1, 0],
      [0, 0, 1, 2, 0, 0, 0, 1, 0],
      [1, 1, 2, 2, 0, 0, 0, 1, 0],
      [2, 2, 0, 2, 0, 0, 0, 1, 0],
      [0, 0, 0, 2, 0, 1, 0, 1, 0],
      [1, 1, 1, 2, 0, 1, 0, 1, 0],
      [2, 2, 2, 2, 0, 1, 0, 1, 0],
      [0, 2, 1, 2, 1, 0, 0, 1, 0],
      [1, 0, 2, 2, 1, 0, 0, 1, 0],
      [2, 1, 0, 2, 1, 0, 0, 1, 0],
      [0, 1, 0, 2, 1, 2, 0, 1, 0],
      [1, 2, 1, 2, 1, 2, 0, 1, 0],
      [2, 0, 2, 2, 1, 2, 0, 1, 0],
      [0, 2, 2, 2, 2, 1, 0, 1, 0],
      [1, 0, 0, 2, 2, 1, 0, 1, 0],
      [2, 1, 1, 2, 2, 1, 0, 1, 0],
      [0, 1, 2, 2, 2, 2, 0, 1, 0],
      [1, 2, 0, 2, 2, 2, 0, 1, 0],
      [2, 0, 1, 2, 2, 2, 0, 1, 0],
      [1, 1, 1, 0, 0, 0, 0, 1, 1],
      [2, 2, 2, 0, 0, 0, 0, 1, 1],
      [0, 2, 0, 0, 0, 1, 0, 1, 1],
      [1, 0, 1, 0, 0, 1, 0, 1, 1],
      [0, 1, 0, 0, 0, 2, 0, 1, 1],
      [2, 0, 2, 0, 0, 2, 0, 1, 1],
      [0, 0, 2, 0, 1, 0, 0, 1, 1],
      [1, 1, 0, 0, 1, 0, 0, 1, 1],
      [1, 0, 0, 0, 1, 1, 0, 1, 1],
      [2, 1, 1, 0, 1, 1, 0, 1, 1],
      [0, 2, 1, 0, 1, 2, 0, 1, 1],
      [0, 0, 1, 0, 2, 0, 0, 1, 1],
      [2, 2, 0, 0, 2, 0, 0, 1, 1],
      [0, 1, 2, 0, 2, 1, 0, 1, 1],
      [1, 2, 2, 0, 2, 2, 0, 1, 1],
      [2, 0, 0, 0, 2, 2, 0, 1, 1],
      [0, 1, 1, 1, 0, 0, 0, 1, 1],
      [2, 0, 0, 1, 0, 0, 0, 1, 1],
      [0, 0, 1, 1, 0, 1, 0, 1, 1],
      [1, 1, 2, 1, 0, 1, 0, 1, 1],
      [1, 2, 0, 1, 0, 2, 0, 1, 1],
      [0, 1, 0, 1, 1, 0, 0, 1, 1],
      [1, 2, 1, 1, 1, 0, 0, 1, 1],
      [0, 0, 0, 1, 1, 1, 0, 1, 1],
      [2, 2, 2, 1, 1, 1, 0, 1, 1],
      [1, 0, 1, 1, 1, 2, 0, 1, 1],
      [2, 1, 2, 1, 1, 2, 0, 1, 1],
      [1, 0, 2, 1, 2, 0, 0, 1, 1],
      [1, 1, 0, 1, 2, 1, 0, 1, 1],
      [2, 2, 1, 1, 2, 1, 0, 1, 1],
      [0, 2, 2, 1, 2, 2, 0, 1, 1],
      [2, 1, 1, 1, 2, 2, 0, 1, 1],
      [0, 2, 2, 2, 0, 0, 0, 1, 1],
      [1, 0, 0, 2, 0, 0, 0, 1, 1],
      [2, 1, 0, 2, 0, 1, 0, 1, 1],
      [0, 0, 2, 2, 0, 2, 0, 1, 1],
      [2, 2, 1, 2, 0, 2, 0, 1, 1],
      [2, 0, 1, 2, 1, 0, 0, 1, 1],
      [0, 1, 1, 2, 1, 1, 0, 1, 1],
      [1, 2, 2, 2, 1, 1, 0, 1, 1],
      [1, 1, 2, 2, 1, 2, 0, 1, 1],
      [2, 2, 0, 2, 1, 2, 0, 1, 1],
      [0, 2, 0, 2, 2, 0, 0, 1, 1],
      [2, 1, 2, 2, 2, 0, 0, 1, 1],
      [1, 2, 1, 2, 2, 1, 0, 1, 1],
      [2, 0, 2, 2, 2, 1, 0, 1, 1],
      [0, 0, 0, 2, 2, 2, 0, 1, 1],
      [1, 1, 1, 2, 2, 2, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 1, 2],
      [2, 2, 2, 0, 0, 0, 0, 1, 2],
      [0, 1, 1, 0, 0, 1, 0, 1, 2],
      [2, 0, 0, 0, 0, 1, 0, 1, 2],
      [1, 1, 2, 0, 0, 2, 0, 1, 2],
      [1, 2, 1, 0, 0, 2, 0, 1, 2],
      [0, 2, 0, 0, 1, 0, 0, 1, 2],
      [1, 0, 1, 0, 1, 0, 0, 1, 2],
      [0, 2, 2, 0, 1, 1, 0, 1, 2],
      [2, 0, 2, 0, 1, 1, 0, 1, 2],
      [2, 1, 0, 0, 1, 2, 0, 1, 2],
      [1, 1, 2, 0, 2, 0, 0, 1, 2],
      [2, 1, 1, 0, 2, 0, 0, 1, 2],
      [1, 2, 0, 0, 2, 1, 0, 1, 2],
      [0, 0, 2, 0, 2, 2, 0, 1, 2],
      [2, 2, 1, 0, 2, 2, 0, 1, 2],
      [0, 0, 2, 1, 0, 0, 0, 1, 2],
      [1, 1, 0, 1, 0, 0, 0, 1, 2],
      [0, 2, 2, 1, 0, 1, 0, 1, 2],
      [2, 2, 0, 1, 0, 1, 0, 1, 2],
      [2, 0, 1, 1, 0, 2, 0, 1, 2],
      [2, 0, 2, 1, 1, 0, 0, 1, 2],
      [2, 2, 0, 1, 1, 0, 0, 1, 2],
      [0, 0, 0, 1, 1, 1, 0, 1, 2],
      [1, 1, 1, 1, 1, 1, 0, 1, 2],
      [0, 1, 1, 1, 1, 2, 0, 1, 2],
      [1, 2, 2, 1, 1, 2, 0, 1, 2],
      [0, 2, 1, 1, 2, 0, 0, 1, 2],
      [1, 0, 1, 1, 2, 1, 0, 1, 2],
      [2, 1, 2, 1, 2, 1, 0, 1, 2],
      [0, 1, 0, 1, 2, 2, 0, 1, 2],
      [1, 0, 0, 1, 2, 2, 0, 1, 2],
      [1, 2, 1, 2, 0, 0, 0, 1, 2],
      [2, 1, 1, 2, 0, 0, 0, 1, 2],
      [1, 0, 2, 2, 0, 1, 0, 1, 2],
      [0, 2, 0, 2, 0, 2, 0, 1, 2],
      [2, 1, 2, 2, 0, 2, 0, 1, 2],
      [0, 1, 2, 2, 1, 0, 0, 1, 2],
      [1, 1, 0, 2, 1, 1, 0, 1, 2],
      [2, 2, 1, 2, 1, 1, 0, 1, 2],
      [0, 0, 1, 2, 1, 2, 0, 1, 2],
      [1, 0, 0, 2, 1, 2, 0, 1, 2],
      [1, 2, 2, 2, 2, 0, 0, 1, 2],
      [2, 0, 0, 2, 2, 0, 0, 1, 2],
      [0, 0, 1, 2, 2, 1, 0, 1, 2],
      [0, 1, 0, 2, 2, 1, 0, 1, 2],
      [1, 1, 1, 2, 2, 2, 0, 1, 2],
      [2, 2, 2, 2, 2, 2, 0, 1, 2],
      [0, 0, 0, 0, 0, 0, 0, 2, 0],
      [1, 1, 1, 0, 0, 0, 0, 2, 0],
      [1, 2, 2, 0, 0, 1, 0, 2, 0],
      [2, 1, 2, 0, 0, 1, 0, 2, 0],
      [0, 0, 1, 0, 0, 2, 0, 2, 0],
      [2, 2, 0, 0, 0, 2, 0, 2, 0],
      [2, 1, 2, 0, 1, 0, 0, 2, 0],
      [2, 2, 1, 0, 1, 0, 0, 2, 0],
      [0, 1, 0, 0, 1, 1, 0, 2, 0],
      [1, 2, 1, 0, 1, 1, 0, 2, 0],
      [1, 0, 2, 0, 1, 2, 0, 2, 0],
      [0, 2, 2, 0, 2, 0, 0, 2, 0],
      [1, 0, 0, 0, 2, 0, 0, 2, 0],
      [2, 0, 1, 0, 2, 1, 0, 2, 0],
      [0, 1, 1, 0, 2, 2, 0, 2, 0],
      [1, 1, 0, 0, 2, 2, 0, 2, 0],
      [1, 2, 2, 1, 0, 0, 0, 2, 0],
      [2, 2, 1, 1, 0, 0, 0, 2, 0],
      [1, 0, 0, 1, 0, 1, 0, 2, 0],
      [2, 1, 1, 1, 0, 1, 0, 2, 0],
      [0, 1, 2, 1, 0, 2, 0, 2, 0],
      [0, 0, 1, 1, 1, 0, 0, 2, 0],
      [1, 1, 2, 1, 1, 0, 0, 2, 0],
      [1, 1, 1, 1, 1, 1, 0, 2, 0],
      [2, 2, 2, 1, 1, 1, 0, 2, 0],
      [0, 2, 0, 1, 1, 2, 0, 2, 0],
      [2, 0, 0, 1, 1, 2, 0, 2, 0],
      [2, 1, 0, 1, 2, 0, 0, 2, 0],
      [0, 0, 2, 1, 2, 1, 0, 2, 0],
      [0, 2, 0, 1, 2, 1, 0, 2, 0],
      [1, 2, 1, 1, 2, 2, 0, 2, 0],
      [2, 0, 2, 1, 2, 2, 0, 2, 0],
      [0, 1, 0, 2, 0, 0, 0, 2, 0],
      [2, 0, 2, 2, 0, 0, 0, 2, 0],
      [0, 2, 1, 2, 0, 1, 0, 2, 0],
      [1, 0, 1, 2, 0, 2, 0, 2, 0],
      [1, 1, 0, 2, 0, 2, 0, 2, 0],
      [1, 2, 0, 2, 1, 0, 0, 2, 0],
      [0, 0, 2, 2, 1, 1, 0, 2, 0],
      [2, 0, 0, 2, 1, 1, 0, 2, 0],
      [0, 2, 2, 2, 1, 2, 0, 2, 0],
      [2, 1, 1, 2, 1, 2, 0, 2, 0],
      [0, 1, 1, 2, 2, 0, 0, 2, 0],
      [1, 0, 1, 2, 2, 0, 0, 2, 0],
      [1, 1, 2, 2, 2, 1, 0, 2, 0],
      [2, 2, 0, 2, 2, 1, 0, 2, 0],
      [0, 0, 0, 2, 2, 2, 0, 2, 0],
      [2, 2, 2, 2, 2, 2, 0, 2, 0],
      [0, 2, 1, 0, 0, 0, 0, 2, 1],
      [1, 0, 2, 0, 0, 0, 0, 2, 1],
      [2, 1, 0, 0, 0, 0, 0, 2, 1],
      [0, 0, 2, 0, 0, 1, 0, 2, 1],
      [1, 1, 0, 0, 0, 1, 0, 2, 1],
      [2, 2, 1, 0, 0, 1, 0, 2, 1],
      [0, 1, 1, 0, 1, 0, 0, 2, 1],
      [1, 2, 2, 0, 1, 0, 0, 2, 1],
      [2, 0, 0, 0, 1, 0, 0, 2, 1],
      [0, 1, 2, 0, 1, 2, 0, 2, 1],
      [1, 2, 0, 0, 1, 2, 0, 2, 1],
      [2, 0, 1, 0, 1, 2, 0, 2, 1],
      [0, 0, 0, 0, 2, 1, 0, 2, 1],
      [1, 1, 1, 0, 2, 1, 0, 2, 1],
      [2, 2, 2, 0, 2, 1, 0, 2, 1],
      [0, 2, 0, 0, 2, 2, 0, 2, 1],
      [1, 0, 1, 0, 2, 2, 0, 2, 1],
      [2, 1, 2, 0, 2, 2, 0, 2, 1],
      [0, 2, 0, 1, 0, 0, 0, 2, 1],
      [1, 0, 1, 1, 0, 0, 0, 2, 1],
      [2, 1, 2, 1, 0, 0, 0, 2, 1],
      [0, 0, 0, 1, 0, 2, 0, 2, 1],
      [1, 1, 1, 1, 0, 2, 0, 2, 1],
      [2, 2, 2, 1, 0, 2, 0, 2, 1],
      [0, 2, 1, 1, 1, 1, 0, 2, 1],
      [1, 0, 2, 1, 1, 1, 0, 2, 1],
      [2, 1, 0, 1, 1, 1, 0, 2, 1],
      [0, 0, 2, 1, 1, 2, 0, 2, 1],
      [1, 1, 0, 1, 1, 2, 0, 2, 1],
      [2, 2, 1, 1, 1, 2, 0, 2, 1],
      [0, 1, 2, 1, 2, 0, 0, 2, 1],
      [1, 2, 0, 1, 2, 0, 0, 2, 1],
      [2, 0, 1, 1, 2, 0, 0, 2, 1],
      [0, 1, 1, 1, 2, 1, 0, 2, 1],
      [1, 2, 2, 1, 2, 1, 0, 2, 1],
      [2, 0, 0, 1, 2, 1, 0, 2, 1],
      [0, 1, 2, 2, 0, 1, 0, 2, 1],
      [1, 2, 0, 2, 0, 1, 0, 2, 1],
      [2, 0, 1, 2, 0, 1, 0, 2, 1],
      [0, 1, 1, 2, 0, 2, 0, 2, 1],
      [1, 2, 2, 2, 0, 2, 0, 2, 1],
      [2, 0, 0, 2, 0, 2, 0, 2, 1],
      [0, 0, 0, 2, 1, 0, 0, 2, 1],
      [1, 1, 1, 2, 1, 0, 0, 2, 1],
      [2, 2, 2, 2, 1, 0, 0, 2, 1],
      [0, 2, 0, 2, 1, 1, 0, 2, 1],
      [1, 0, 1, 2, 1, 1, 0, 2, 1],
      [2, 1, 2, 2, 1, 1, 0, 2, 1],
      [0, 0, 2, 2, 2, 0, 0, 2, 1],
      [1, 1, 0, 2, 2, 0, 0, 2, 1],
      [2, 2, 1, 2, 2, 0, 0, 2, 1],
      [0, 2, 1, 2, 2, 2, 0, 2, 1],
      [1, 0, 2, 2, 2, 2, 0, 2, 1],
      [2, 1, 0, 2, 2, 2, 0, 2, 1],
      [0, 1, 2, 0, 0, 0, 0, 2, 2],
      [1, 2, 0, 0, 0, 0, 0, 2, 2],
      [2, 0, 1, 0, 0, 0, 0, 2, 2],
      [0, 2, 2, 0, 0, 2, 0, 2, 2],
      [1, 0, 0, 0, 0, 2, 0, 2, 2],
      [2, 1, 1, 0, 0, 2, 0, 2, 2],
      [0, 0, 1, 0, 1, 1, 0, 2, 2],
      [1, 1, 2, 0, 1, 1, 0, 2, 2],
      [2, 2, 0, 0, 1, 1, 0, 2, 2],
      [0, 0, 0, 0, 1, 2, 0, 2, 2],
      [1, 1, 1, 0, 1, 2, 0, 2, 2],
      [2, 2, 2, 0, 1, 2, 0, 2, 2],
      [0, 1, 0, 0, 2, 0, 0, 2, 2],
      [1, 2, 1, 0, 2, 0, 0, 2, 2],
      [2, 0, 2, 0, 2, 0, 0, 2, 2],
      [0, 2, 1, 0, 2, 1, 0, 2, 2],
      [1, 0, 2, 0, 2, 1, 0, 2, 2],
      [2, 1, 0, 0, 2, 1, 0, 2, 2],
      [0, 1, 0, 1, 0, 1, 0, 2, 2],
      [1, 2, 1, 1, 0, 1, 0, 2, 2],
      [2, 0, 2, 1, 0, 1, 0, 2, 2],
      [0, 2, 1, 1, 0, 2, 0, 2, 2],
      [1, 0, 2, 1, 0, 2, 0, 2, 2],
      [2, 1, 0, 1, 0, 2, 0, 2, 2],
      [0, 2, 2, 1, 1, 0, 0, 2, 2],
      [1, 0, 0, 1, 1, 0, 0, 2, 2],
      [2, 1, 1, 1, 1, 0, 0, 2, 2],
      [0, 1, 2, 1, 1, 1, 0, 2, 2],
      [1, 2, 0, 1, 1, 1, 0, 2, 2],
      [2, 0, 1, 1, 1, 1, 0, 2, 2],
      [0, 0, 0, 1, 2, 0, 0, 2, 2],
      [1, 1, 1, 1, 2, 0, 0, 2, 2],
      [2, 2, 2, 1, 2, 0, 0, 2, 2],
      [0, 0, 1, 1, 2, 2, 0, 2, 2],
      [1, 1, 2, 1, 2, 2, 0, 2, 2],
      [2, 2, 0, 1, 2, 2, 0, 2, 2],
      [0, 0, 1, 2, 0, 0, 0, 2, 2],
      [1, 1, 2, 2, 0, 0, 0, 2, 2],
      [2, 2, 0, 2, 0, 0, 0, 2, 2],
      [0, 0, 0, 2, 0, 1, 0, 2, 2],
      [1, 1, 1, 2, 0, 1, 0, 2, 2],
      [2, 2, 2, 2, 0, 1, 0, 2, 2],
      [0, 2, 1, 2, 1, 0, 0, 2, 2],
      [1, 0, 2, 2, 1, 0, 0, 2, 2],
      [2, 1, 0, 2, 1, 0, 0, 2, 2],
      [0, 1, 0, 2, 1, 2, 0, 2, 2],
      [1, 2, 1, 2, 1, 2, 0, 2, 2],
      [2, 0, 2, 2, 1, 2, 0, 2, 2],
      [0, 2, 2, 2, 2, 1, 0, 2, 2],
      [1, 0, 0, 2, 2, 1, 0, 2, 2],
      [2, 1, 1, 2, 2, 1, 0, 2, 2],
      [0, 1, 2, 2, 2, 2, 0, 2, 2],
      [1, 2, 0, 2, 2, 2, 0, 2, 2],
      [2, 0, 1, 2, 2, 2, 0, 2, 2],
      [0, 2, 1, 0, 0, 0, 1, 0, 0],
      [1, 0, 2, 0, 0, 0, 1, 0, 0],
      [2, 1, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 2, 0, 0, 1, 1, 0, 0],
      [1, 1, 0, 0, 0, 1, 1, 0, 0],
      [2, 2, 1, 0, 0, 1, 1, 0, 0],
      [0, 1, 1, 0, 1, 0, 1, 0, 0],
      [1, 2, 2, 0, 1, 0, 1, 0, 0],
      [2, 0, 0, 0, 1, 0, 1, 0, 0],
      [0, 1, 2, 0, 1, 2, 1, 0, 0],
      [1, 2, 0, 0, 1, 2, 1, 0, 0],
      [2, 0, 1, 0, 1, 2, 1, 0, 0],
      [0, 0, 0, 0, 2, 1, 1, 0, 0],
      [1, 1, 1, 0, 2, 1, 1, 0, 0],
      [2, 2, 2, 0, 2, 1, 1, 0, 0],
      [0, 2, 0, 0, 2, 2, 1, 0, 0],
      [1, 0, 1, 0, 2, 2, 1, 0, 0],
      [2, 1, 2, 0, 2, 2, 1, 0, 0],
      [0, 2, 0, 1, 0, 0, 1, 0, 0],
      [1, 0, 1, 1, 0, 0, 1, 0, 0],
      [2, 1, 2, 1, 0, 0, 1, 0, 0],
      [0, 0, 0, 1, 0, 2, 1, 0, 0],
      [1, 1, 1, 1, 0, 2, 1, 0, 0],
      [2, 2, 2, 1, 0, 2, 1, 0, 0],
      [0, 2, 1, 1, 1, 1, 1, 0, 0],
      [1, 0, 2, 1, 1, 1, 1, 0, 0],
      [2, 1, 0, 1, 1, 1, 1, 0, 0],
      [0, 0, 2, 1, 1, 2, 1, 0, 0],
      [1, 1, 0, 1, 1, 2, 1, 0, 0],
      [2, 2, 1, 1, 1, 2, 1, 0, 0],
      [0, 1, 2, 1, 2, 0, 1, 0, 0],
      [1, 2, 0, 1, 2, 0, 1, 0, 0],
      [2, 0, 1, 1, 2, 0, 1, 0, 0],
      [0, 1, 1, 1, 2, 1, 1, 0, 0],
      [1, 2, 2, 1, 2, 1, 1, 0, 0],
      [2, 0, 0, 1, 2, 1, 1, 0, 0],
      [0, 1, 2, 2, 0, 1, 1, 0, 0],
      [1, 2, 0, 2, 0, 1, 1, 0, 0],
      [2, 0, 1, 2, 0, 1, 1, 0, 0],
      [0, 1, 1, 2, 0, 2, 1, 0, 0],
      [1, 2, 2, 2, 0, 2, 1, 0, 0],
      [2, 0, 0, 2, 0, 2, 1, 0, 0],
      [0, 0, 0, 2, 1, 0, 1, 0, 0],
      [1, 1, 1, 2, 1, 0, 1, 0, 0],
      [2, 2, 2, 2, 1, 0, 1, 0, 0],
      [0, 2, 0, 2, 1, 1, 1, 0, 0],
      [1, 0, 1, 2, 1, 1, 1, 0, 0],
      [2, 1, 2, 2, 1, 1, 1, 0, 0],
      [0, 0, 2, 2, 2, 0, 1, 0, 0],
      [1, 1, 0, 2, 2, 0, 1, 0, 0],
      [2, 2, 1, 2, 2, 0, 1, 0, 0],
      [0, 2, 1, 2, 2, 2, 1, 0, 0],
      [1, 0, 2, 2, 2, 2, 1, 0, 0],
      [2, 1, 0, 2, 2, 2, 1, 0, 0],
      [0, 1, 2, 0, 0, 0, 1, 0, 1],
      [1, 2, 0, 0, 0, 0, 1, 0, 1],
      [2, 0, 1, 0, 0, 0, 1, 0, 1],
      [0, 2, 2, 0, 0, 2, 1, 0, 1],
      [1, 0, 0, 0, 0, 2, 1, 0, 1],
      [2, 1, 1, 0, 0, 2, 1, 0, 1],
      [0, 0, 1, 0, 1, 1, 1, 0, 1],
      [1, 1, 2, 0, 1, 1, 1, 0, 1],
      [2, 2, 0, 0, 1, 1, 1, 0, 1],
      [0, 0, 0, 0, 1, 2, 1, 0, 1],
      [1, 1, 1, 0, 1, 2, 1, 0, 1],
      [2, 2, 2, 0, 1, 2, 1, 0, 1],
      [0, 1, 0, 0, 2, 0, 1, 0, 1],
      [1, 2, 1, 0, 2, 0, 1, 0, 1],
      [2, 0, 2, 0, 2, 0, 1, 0, 1],
      [0, 2, 1, 0, 2, 1, 1, 0, 1],
      [1, 0, 2, 0, 2, 1, 1, 0, 1],
      [2, 1, 0, 0, 2, 1, 1, 0, 1],
      [0, 1, 0, 1, 0, 1, 1, 0, 1],
      [1, 2, 1, 1, 0, 1, 1, 0, 1],
      [2, 0, 2, 1, 0, 1, 1, 0, 1],
      [0, 2, 1, 1, 0, 2, 1, 0, 1],
      [1, 0, 2, 1, 0, 2, 1, 0, 1],
      [2, 1, 0, 1, 0, 2, 1, 0, 1],
      [0, 2, 2, 1, 1, 0, 1, 0, 1],
      [1, 0, 0, 1, 1, 0, 1, 0, 1],
      [2, 1, 1, 1, 1, 0, 1, 0, 1],
      [0, 1, 2, 1, 1, 1, 1, 0, 1],
      [1, 2, 0, 1, 1, 1, 1, 0, 1],
      [2, 0, 1, 1, 1, 1, 1, 0, 1],
      [0, 0, 0, 1, 2, 0, 1, 0, 1],
      [1, 1, 1, 1, 2, 0, 1, 0, 1],
      [2, 2, 2, 1, 2, 0, 1, 0, 1],
      [0, 0, 1, 1, 2, 2, 1, 0, 1],
      [1, 1, 2, 1, 2, 2, 1, 0, 1],
      [2, 2, 0, 1, 2, 2, 1, 0, 1],
      [0, 0, 1, 2, 0, 0, 1, 0, 1],
      [1, 1, 2, 2, 0, 0, 1, 0, 1],
      [2, 2, 0, 2, 0, 0, 1, 0, 1],
      [0, 0, 0, 2, 0, 1, 1, 0, 1],
      [1, 1, 1, 2, 0, 1, 1, 0, 1],
      [2, 2, 2, 2, 0, 1, 1, 0, 1],
      [0, 2, 1, 2, 1, 0, 1, 0, 1],
      [1, 0, 2, 2, 1, 0, 1, 0, 1],
      [2, 1, 0, 2, 1, 0, 1, 0, 1],
      [0, 1, 0, 2, 1, 2, 1, 0, 1],
      [1, 2, 1, 2, 1, 2, 1, 0, 1],
      [2, 0, 2, 2, 1, 2, 1, 0, 1],
      [0, 2, 2, 2, 2, 1, 1, 0, 1],
      [1, 0, 0, 2, 2, 1, 1, 0, 1],
      [2, 1, 1, 2, 2, 1, 1, 0, 1],
      [0, 1, 2, 2, 2, 2, 1, 0, 1],
      [1, 2, 0, 2, 2, 2, 1, 0, 1],
      [2, 0, 1, 2, 2, 2, 1, 0, 1],
      [0, 0, 0, 0, 0, 0, 1, 0, 2],
      [2, 2, 2, 0, 0, 0, 1, 0, 2],
      [0, 1, 1, 0, 0, 1, 1, 0, 2],
      [2, 0, 0, 0, 0, 1, 1, 0, 2],
      [1, 1, 2, 0, 0, 2, 1, 0, 2],
      [1, 2, 1, 0, 0, 2, 1, 0, 2],
      [0, 2, 0, 0, 1, 0, 1, 0, 2],
      [1, 0, 1, 0, 1, 0, 1, 0, 2],
      [0, 2, 2, 0, 1, 1, 1, 0, 2],
      [2, 0, 2, 0, 1, 1, 1, 0, 2],
      [2, 1, 0, 0, 1, 2, 1, 0, 2],
      [1, 1, 2, 0, 2, 0, 1, 0, 2],
      [2, 1, 1, 0, 2, 0, 1, 0, 2],
      [1, 2, 0, 0, 2, 1, 1, 0, 2],
      [0, 0, 2, 0, 2, 2, 1, 0, 2],
      [2, 2, 1, 0, 2, 2, 1, 0, 2],
      [0, 0, 2, 1, 0, 0, 1, 0, 2],
      [1, 1, 0, 1, 0, 0, 1, 0, 2],
      [0, 2, 2, 1, 0, 1, 1, 0, 2],
      [2, 2, 0, 1, 0, 1, 1, 0, 2],
      [2, 0, 1, 1, 0, 2, 1, 0, 2],
      [2, 0, 2, 1, 1, 0, 1, 0, 2],
      [2, 2, 0, 1, 1, 0, 1, 0, 2],
      [0, 0, 0, 1, 1, 1, 1, 0, 2],
      [1, 1, 1, 1, 1, 1, 1, 0, 2],
      [0, 1, 1, 1, 1, 2, 1, 0, 2],
      [1, 2, 2, 1, 1, 2, 1, 0, 2],
      [0, 2, 1, 1, 2, 0, 1, 0, 2],
      [1, 0, 1, 1, 2, 1, 1, 0, 2],
      [2, 1, 2, 1, 2, 1, 1, 0, 2],
      [0, 1, 0, 1, 2, 2, 1, 0, 2],
      [1, 0, 0, 1, 2, 2, 1, 0, 2],
      [1, 2, 1, 2, 0, 0, 1, 0, 2],
      [2, 1, 1, 2, 0, 0, 1, 0, 2],
      [1, 0, 2, 2, 0, 1, 1, 0, 2],
      [0, 2, 0, 2, 0, 2, 1, 0, 2],
      [2, 1, 2, 2, 0, 2, 1, 0, 2],
      [0, 1, 2, 2, 1, 0, 1, 0, 2],
      [1, 1, 0, 2, 1, 1, 1, 0, 2],
      [2, 2, 1, 2, 1, 1, 1, 0, 2],
      [0, 0, 1, 2, 1, 2, 1, 0, 2],
      [1, 0, 0, 2, 1, 2, 1, 0, 2],
      [1, 2, 2, 2, 2, 0, 1, 0, 2],
      [2, 0, 0, 2, 2, 0, 1, 0, 2],
      [0, 0, 1, 2, 2, 1, 1, 0, 2],
      [0, 1, 0, 2, 2, 1, 1, 0, 2],
      [1, 1, 1, 2, 2, 2, 1, 0, 2],
      [2, 2, 2, 2, 2, 2, 1, 0, 2],
      [0, 0, 0, 0, 0, 0, 1, 1, 0],
      [2, 2, 2, 0, 0, 0, 1, 1, 0],
      [0, 1, 1, 0, 0, 1, 1, 1, 0],
      [2, 0, 0, 0, 0, 1, 1, 1, 0],
      [1, 1, 2, 0, 0, 2, 1, 1, 0],
      [1, 2, 1, 0, 0, 2, 1, 1, 0],
      [0, 2, 0, 0, 1, 0, 1, 1, 0],
      [1, 0, 1, 0, 1, 0, 1, 1, 0],
      [0, 2, 2, 0, 1, 1, 1, 1, 0],
      [2, 0, 2, 0, 1, 1, 1, 1, 0],
      [2, 1, 0, 0, 1, 2, 1, 1, 0],
      [1, 1, 2, 0, 2, 0, 1, 1, 0],
      [2, 1, 1, 0, 2, 0, 1, 1, 0],
      [1, 2, 0, 0, 2, 1, 1, 1, 0],
      [0, 0, 2, 0, 2, 2, 1, 1, 0],
      [2, 2, 1, 0, 2, 2, 1, 1, 0],
      [0, 0, 2, 1, 0, 0, 1, 1, 0],
      [1, 1, 0, 1, 0, 0, 1, 1, 0],
      [0, 2, 2, 1, 0, 1, 1, 1, 0],
      [2, 2, 0, 1, 0, 1, 1, 1, 0],
      [2, 0, 1, 1, 0, 2, 1, 1, 0],
      [2, 0, 2, 1, 1, 0, 1, 1, 0],
      [2, 2, 0, 1, 1, 0, 1, 1, 0],
      [0, 0, 0, 1, 1, 1, 1, 1, 0],
      [1, 1, 1, 1, 1, 1, 1, 1, 0],
      [0, 1, 1, 1, 1, 2, 1, 1, 0],
      [1, 2, 2, 1, 1, 2, 1, 1, 0],
      [0, 2, 1, 1, 2, 0, 1, 1, 0],
      [1, 0, 1, 1, 2, 1, 1, 1, 0],
      [2, 1, 2, 1, 2, 1, 1, 1, 0],
      [0, 1, 0, 1, 2, 2, 1, 1, 0],
      [1, 0, 0, 1, 2, 2, 1, 1, 0],
      [1, 2, 1, 2, 0, 0, 1, 1, 0],
      [2, 1, 1, 2, 0, 0, 1, 1, 0],
      [1, 0, 2, 2, 0, 1, 1, 1, 0],
      [0, 2, 0, 2, 0, 2, 1, 1, 0],
      [2, 1, 2, 2, 0, 2, 1, 1, 0],
      [0, 1, 2, 2, 1, 0, 1, 1, 0],
      [1, 1, 0, 2, 1, 1, 1, 1, 0],
      [2, 2, 1, 2, 1, 1, 1, 1, 0],
      [0, 0, 1, 2, 1, 2, 1, 1, 0],
      [1, 0, 0, 2, 1, 2, 1, 1, 0],
      [1, 2, 2, 2, 2, 0, 1, 1, 0],
      [2, 0, 0, 2, 2, 0, 1, 1, 0],
      [0, 0, 1, 2, 2, 1, 1, 1, 0],
      [0, 1, 0, 2, 2, 1, 1, 1, 0],
      [1, 1, 1, 2, 2, 2, 1, 1, 0],
      [2, 2, 2, 2, 2, 2, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 1, 1, 1],
      [1, 1, 1, 0, 0, 0, 1, 1, 1],
      [1, 2, 2, 0, 0, 1, 1, 1, 1],
      [2, 1, 2, 0, 0, 1, 1, 1, 1],
      [0, 0, 1, 0, 0, 2, 1, 1, 1],
      [2, 2, 0, 0, 0, 2, 1, 1, 1],
      [2, 1, 2, 0, 1, 0, 1, 1, 1],
      [2, 2, 1, 0, 1, 0, 1, 1, 1],
      [0, 1, 0, 0, 1, 1, 1, 1, 1],
      [1, 2, 1, 0, 1, 1, 1, 1, 1],
      [1, 0, 2, 0, 1, 2, 1, 1, 1],
      [0, 2, 2, 0, 2, 0, 1, 1, 1],
      [1, 0, 0, 0, 2, 0, 1, 1, 1],
      [2, 0, 1, 0, 2, 1, 1, 1, 1],
      [0, 1, 1, 0, 2, 2, 1, 1, 1],
      [1, 1, 0, 0, 2, 2, 1, 1, 1],
      [1, 2, 2, 1, 0, 0, 1, 1, 1],
      [2, 2, 1, 1, 0, 0, 1, 1, 1],
      [1, 0, 0, 1, 0, 1, 1, 1, 1],
      [2, 1, 1, 1, 0, 1, 1, 1, 1],
      [0, 1, 2, 1, 0, 2, 1, 1, 1],
      [0, 0, 1, 1, 1, 0, 1, 1, 1],
      [1, 1, 2, 1, 1, 0, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1, 1],
      [2, 2, 2, 1, 1, 1, 1, 1, 1],
      [0, 2, 0, 1, 1, 2, 1, 1, 1],
      [2, 0, 0, 1, 1, 2, 1, 1, 1],
      [2, 1, 0, 1, 2, 0, 1, 1, 1],
      [0, 0, 2, 1, 2, 1, 1, 1, 1],
      [0, 2, 0, 1, 2, 1, 1, 1, 1],
      [1, 2, 1, 1, 2, 2, 1, 1, 1],
      [2, 0, 2, 1, 2, 2, 1, 1, 1],
      [0, 1, 0, 2, 0, 0, 1, 1, 1],
      [2, 0, 2, 2, 0, 0, 1, 1, 1],
      [0, 2, 1, 2, 0, 1, 1, 1, 1],
      [1, 0, 1, 2, 0, 2, 1, 1, 1],
      [1, 1, 0, 2, 0, 2, 1, 1, 1],
      [1, 2, 0, 2, 1, 0, 1, 1, 1],
      [0, 0, 2, 2, 1, 1, 1, 1, 1],
      [2, 0, 0, 2, 1, 1, 1, 1, 1],
      [0, 2, 2, 2, 1, 2, 1, 1, 1],
      [2, 1, 1, 2, 1, 2, 1, 1, 1],
      [0, 1, 1, 2, 2, 0, 1, 1, 1],
      [1, 0, 1, 2, 2, 0, 1, 1, 1],
      [1, 1, 2, 2, 2, 1, 1, 1, 1],
      [2, 2, 0, 2, 2, 1, 1, 1, 1],
      [0, 0, 0, 2, 2, 2, 1, 1, 1],
      [2, 2, 2, 2, 2, 2, 1, 1, 1],
      [0, 2, 1, 0, 0, 0, 1, 1, 2],
      [1, 0, 2, 0, 0, 0, 1, 1, 2],
      [2, 1, 0, 0, 0, 0, 1, 1, 2],
      [0, 0, 2, 0, 0, 1, 1, 1, 2],
      [1, 1, 0, 0, 0, 1, 1, 1, 2],
      [2, 2, 1, 0, 0, 1, 1, 1, 2],
      [0, 1, 1, 0, 1, 0, 1, 1, 2],
      [1, 2, 2, 0, 1, 0, 1, 1, 2],
      [2, 0, 0, 0, 1, 0, 1, 1, 2],
      [0, 1, 2, 0, 1, 2, 1, 1, 2],
      [1, 2, 0, 0, 1, 2, 1, 1, 2],
      [2, 0, 1, 0, 1, 2, 1, 1, 2],
      [0, 0, 0, 0, 2, 1, 1, 1, 2],
      [1, 1, 1, 0, 2, 1, 1, 1, 2],
      [2, 2, 2, 0, 2, 1, 1, 1, 2],
      [0, 2, 0, 0, 2, 2, 1, 1, 2],
      [1, 0, 1, 0, 2, 2, 1, 1, 2],
      [2, 1, 2, 0, 2, 2, 1, 1, 2],
      [0, 2, 0, 1, 0, 0, 1, 1, 2],
      [1, 0, 1, 1, 0, 0, 1, 1, 2],
      [2, 1, 2, 1, 0, 0, 1, 1, 2],
      [0, 0, 0, 1, 0, 2, 1, 1, 2],
      [1, 1, 1, 1, 0, 2, 1, 1, 2],
      [2, 2, 2, 1, 0, 2, 1, 1, 2],
      [0, 2, 1, 1, 1, 1, 1, 1, 2],
      [1, 0, 2, 1, 1, 1, 1, 1, 2],
      [2, 1, 0, 1, 1, 1, 1, 1, 2],
      [0, 0, 2, 1, 1, 2, 1, 1, 2],
      [1, 1, 0, 1, 1, 2, 1, 1, 2],
      [2, 2, 1, 1, 1, 2, 1, 1, 2],
      [0, 1, 2, 1, 2, 0, 1, 1, 2],
      [1, 2, 0, 1, 2, 0, 1, 1, 2],
      [2, 0, 1, 1, 2, 0, 1, 1, 2],
      [0, 1, 1, 1, 2, 1, 1, 1, 2],
      [1, 2, 2, 1, 2, 1, 1, 1, 2],
      [2, 0, 0, 1, 2, 1, 1, 1, 2],
      [0, 1, 2, 2, 0, 1, 1, 1, 2],
      [1, 2, 0, 2, 0, 1, 1, 1, 2],
      [2, 0, 1, 2, 0, 1, 1, 1, 2],
      [0, 1, 1, 2, 0, 2, 1, 1, 2],
      [1, 2, 2, 2, 0, 2, 1, 1, 2],
      [2, 0, 0, 2, 0, 2, 1, 1, 2],
      [0, 0, 0, 2, 1, 0, 1, 1, 2],
      [1, 1, 1, 2, 1, 0, 1, 1, 2],
      [2, 2, 2, 2, 1, 0, 1, 1, 2],
      [0, 2, 0, 2, 1, 1, 1, 1, 2],
      [1, 0, 1, 2, 1, 1, 1, 1, 2],
      [2, 1, 2, 2, 1, 1, 1, 1, 2],
      [0, 0, 2, 2, 2, 0, 1, 1, 2],
      [1, 1, 0, 2, 2, 0, 1, 1, 2],
      [2, 2, 1, 2, 2, 0, 1, 1, 2],
      [0, 2, 1, 2, 2, 2, 1, 1, 2],
      [1, 0, 2, 2, 2, 2, 1, 1, 2],
      [2, 1, 0, 2, 2, 2, 1, 1, 2],
      [1, 1, 1, 0, 0, 0, 1, 2, 0],
      [2, 2, 2, 0, 0, 0, 1, 2, 0],
      [0, 2, 0, 0, 0, 1, 1, 2, 0],
      [1, 0, 1, 0, 0, 1, 1, 2, 0],
      [0, 1, 0, 0, 0, 2, 1, 2, 0],
      [2, 0, 2, 0, 0, 2, 1, 2, 0],
      [0, 0, 2, 0, 1, 0, 1, 2, 0],
      [1, 1, 0, 0, 1, 0, 1, 2, 0],
      [1, 0, 0, 0, 1, 1, 1, 2, 0],
      [2, 1, 1, 0, 1, 1, 1, 2, 0],
      [0, 2, 1, 0, 1, 2, 1, 2, 0],
      [0, 0, 1, 0, 2, 0, 1, 2, 0],
      [2, 2, 0, 0, 2, 0, 1, 2, 0],
      [0, 1, 2, 0, 2, 1, 1, 2, 0],
      [1, 2, 2, 0, 2, 2, 1, 2, 0],
      [2, 0, 0, 0, 2, 2, 1, 2, 0],
      [0, 1, 1, 1, 0, 0, 1, 2, 0],
      [2, 0, 0, 1, 0, 0, 1, 2, 0],
      [0, 0, 1, 1, 0, 1, 1, 2, 0],
      [1, 1, 2, 1, 0, 1, 1, 2, 0],
      [1, 2, 0, 1, 0, 2, 1, 2, 0],
      [0, 1, 0, 1, 1, 0, 1, 2, 0],
      [1, 2, 1, 1, 1, 0, 1, 2, 0],
      [0, 0, 0, 1, 1, 1, 1, 2, 0],
      [2, 2, 2, 1, 1, 1, 1, 2, 0],
      [1, 0, 1, 1, 1, 2, 1, 2, 0],
      [2, 1, 2, 1, 1, 2, 1, 2, 0],
      [1, 0, 2, 1, 2, 0, 1, 2, 0],
      [1, 1, 0, 1, 2, 1, 1, 2, 0],
      [2, 2, 1, 1, 2, 1, 1, 2, 0],
      [0, 2, 2, 1, 2, 2, 1, 2, 0],
      [2, 1, 1, 1, 2, 2, 1, 2, 0],
      [0, 2, 2, 2, 0, 0, 1, 2, 0],
      [1, 0, 0, 2, 0, 0, 1, 2, 0],
      [2, 1, 0, 2, 0, 1, 1, 2, 0],
      [0, 0, 2, 2, 0, 2, 1, 2, 0],
      [2, 2, 1, 2, 0, 2, 1, 2, 0],
      [2, 0, 1, 2, 1, 0, 1, 2, 0],
      [0, 1, 1, 2, 1, 1, 1, 2, 0],
      [1, 2, 2, 2, 1, 1, 1, 2, 0],
      [1, 1, 2, 2, 1, 2, 1, 2, 0],
      [2, 2, 0, 2, 1, 2, 1, 2, 0],
      [0, 2, 0, 2, 2, 0, 1, 2, 0],
      [2, 1, 2, 2, 2, 0, 1, 2, 0],
      [1, 2, 1, 2, 2, 1, 1, 2, 0],
      [2, 0, 2, 2, 2, 1, 1, 2, 0],
      [0, 0, 0, 2, 2, 2, 1, 2, 0],
      [1, 1, 1, 2, 2, 2, 1, 2, 0],
      [1, 1, 1, 0, 0, 0, 1, 2, 1],
      [2, 2, 2, 0, 0, 0, 1, 2, 1],
      [0, 2, 0, 0, 0, 1, 1, 2, 1],
      [1, 0, 1, 0, 0, 1, 1, 2, 1],
      [0, 1, 0, 0, 0, 2, 1, 2, 1],
      [2, 0, 2, 0, 0, 2, 1, 2, 1],
      [0, 0, 2, 0, 1, 0, 1, 2, 1],
      [1, 1, 0, 0, 1, 0, 1, 2, 1],
      [1, 0, 0, 0, 1, 1, 1, 2, 1],
      [2, 1, 1, 0, 1, 1, 1, 2, 1],
      [0, 2, 1, 0, 1, 2, 1, 2, 1],
      [0, 0, 1, 0, 2, 0, 1, 2, 1],
      [2, 2, 0, 0, 2, 0, 1, 2, 1],
      [0, 1, 2, 0, 2, 1, 1, 2, 1],
      [1, 2, 2, 0, 2, 2, 1, 2, 1],
      [2, 0, 0, 0, 2, 2, 1, 2, 1],
      [0, 1, 1, 1, 0, 0, 1, 2, 1],
      [2, 0, 0, 1, 0, 0, 1, 2, 1],
      [0, 0, 1, 1, 0, 1, 1, 2, 1],
      [1, 1, 2, 1, 0, 1, 1, 2, 1],
      [1, 2, 0, 1, 0, 2, 1, 2, 1],
      [0, 1, 0, 1, 1, 0, 1, 2, 1],
      [1, 2, 1, 1, 1, 0, 1, 2, 1],
      [0, 0, 0, 1, 1, 1, 1, 2, 1],
      [2, 2, 2, 1, 1, 1, 1, 2, 1],
      [1, 0, 1, 1, 1, 2, 1, 2, 1],
      [2, 1, 2, 1, 1, 2, 1, 2, 1],
      [1, 0, 2, 1, 2, 0, 1, 2, 1],
      [1, 1, 0, 1, 2, 1, 1, 2, 1],
      [2, 2, 1, 1, 2, 1, 1, 2, 1],
      [0, 2, 2, 1, 2, 2, 1, 2, 1],
      [2, 1, 1, 1, 2, 2, 1, 2, 1],
      [0, 2, 2, 2, 0, 0, 1, 2, 1],
      [1, 0, 0, 2, 0, 0, 1, 2, 1],
      [2, 1, 0, 2, 0, 1, 1, 2, 1],
      [0, 0, 2, 2, 0, 2, 1, 2, 1],
      [2, 2, 1, 2, 0, 2, 1, 2, 1],
      [2, 0, 1, 2, 1, 0, 1, 2, 1],
      [0, 1, 1, 2, 1, 1, 1, 2, 1],
      [1, 2, 2, 2, 1, 1, 1, 2, 1],
      [1, 1, 2, 2, 1, 2, 1, 2, 1],
      [2, 2, 0, 2, 1, 2, 1, 2, 1],
      [0, 2, 0, 2, 2, 0, 1, 2, 1],
      [2, 1, 2, 2, 2, 0, 1, 2, 1],
      [1, 2, 1, 2, 2, 1, 1, 2, 1],
      [2, 0, 2, 2, 2, 1, 1, 2, 1],
      [0, 0, 0, 2, 2, 2, 1, 2, 1],
      [1, 1, 1, 2, 2, 2, 1, 2, 1],
      [1, 1, 1, 0, 0, 0, 1, 2, 2],
      [2, 2, 2, 0, 0, 0, 1, 2, 2],
      [0, 2, 0, 0, 0, 1, 1, 2, 2],
      [1, 0, 1, 0, 0, 1, 1, 2, 2],
      [0, 1, 0, 0, 0, 2, 1, 2, 2],
      [2, 0, 2, 0, 0, 2, 1, 2, 2],
      [0, 0, 2, 0, 1, 0, 1, 2, 2],
      [1, 1, 0, 0, 1, 0, 1, 2, 2],
      [1, 0, 0, 0, 1, 1, 1, 2, 2],
      [2, 1, 1, 0, 1, 1, 1, 2, 2],
      [0, 2, 1, 0, 1, 2, 1, 2, 2],
      [0, 0, 1, 0, 2, 0, 1, 2, 2],
      [2, 2, 0, 0, 2, 0, 1, 2, 2],
      [0, 1, 2, 0, 2, 1, 1, 2, 2],
      [1, 2, 2, 0, 2, 2, 1, 2, 2],
      [2, 0, 0, 0, 2, 2, 1, 2, 2],
      [0, 1, 1, 1, 0, 0, 1, 2, 2],
      [2, 0, 0, 1, 0, 0, 1, 2, 2],
      [0, 0, 1, 1, 0, 1, 1, 2, 2],
      [1, 1, 2, 1, 0, 1, 1, 2, 2],
      [1, 2, 0, 1, 0, 2, 1, 2, 2],
      [0, 1, 0, 1, 1, 0, 1, 2, 2],
      [1, 2, 1, 1, 1, 0, 1, 2, 2],
      [0, 0, 0, 1, 1, 1, 1, 2, 2],
      [2, 2, 2, 1, 1, 1, 1, 2, 2],
      [1, 0, 1, 1, 1, 2, 1, 2, 2],
      [2, 1, 2, 1, 1, 2, 1, 2, 2],
      [1, 0, 2, 1, 2, 0, 1, 2, 2],
      [1, 1, 0, 1, 2, 1, 1, 2, 2],
      [2, 2, 1, 1, 2, 1, 1, 2, 2],
      [0, 2, 2, 1, 2, 2, 1, 2, 2],
      [2, 1, 1, 1, 2, 2, 1, 2, 2],
      [0, 2, 2, 2, 0, 0, 1, 2, 2],
      [1, 0, 0, 2, 0, 0, 1, 2, 2],
      [2, 1, 0, 2, 0, 1, 1, 2, 2],
      [0, 0, 2, 2, 0, 2, 1, 2, 2],
      [2, 2, 1, 2, 0, 2, 1, 2, 2],
      [2, 0, 1, 2, 1, 0, 1, 2, 2],
      [0, 1, 1, 2, 1, 1, 1, 2, 2],
      [1, 2, 2, 2, 1, 1, 1, 2, 2],
      [1, 1, 2, 2, 1, 2, 1, 2, 2],
      [2, 2, 0, 2, 1, 2, 1, 2, 2],
      [0, 2, 0, 2, 2, 0, 1, 2, 2],
      [2, 1, 2, 2, 2, 0, 1, 2, 2],
      [1, 2, 1, 2, 2, 1, 1, 2, 2],
      [2, 0, 2, 2, 2, 1, 1, 2, 2],
      [0, 0, 0, 2, 2, 2, 1, 2, 2],
      [1, 1, 1, 2, 2, 2, 1, 2, 2],
      [0, 0, 0, 0, 0, 0, 2, 0, 0],
      [1, 1, 1, 0, 0, 0, 2, 0, 0],
      [1, 2, 2, 0, 0, 1, 2, 0, 0],
      [2, 1, 2, 0, 0, 1, 2, 0, 0],
      [0, 0, 1, 0, 0, 2, 2, 0, 0],
      [2, 2, 0, 0, 0, 2, 2, 0, 0],
      [2, 1, 2, 0, 1, 0, 2, 0, 0],
      [2, 2, 1, 0, 1, 0, 2, 0, 0],
      [0, 1, 0, 0, 1, 1, 2, 0, 0],
      [1, 2, 1, 0, 1, 1, 2, 0, 0],
      [1, 0, 2, 0, 1, 2, 2, 0, 0],
      [0, 2, 2, 0, 2, 0, 2, 0, 0],
      [1, 0, 0, 0, 2, 0, 2, 0, 0],
      [2, 0, 1, 0, 2, 1, 2, 0, 0],
      [0, 1, 1, 0, 2, 2, 2, 0, 0],
      [1, 1, 0, 0, 2, 2, 2, 0, 0],
      [1, 2, 2, 1, 0, 0, 2, 0, 0],
      [2, 2, 1, 1, 0, 0, 2, 0, 0],
      [1, 0, 0, 1, 0, 1, 2, 0, 0],
      [2, 1, 1, 1, 0, 1, 2, 0, 0],
      [0, 1, 2, 1, 0, 2, 2, 0, 0],
      [0, 0, 1, 1, 1, 0, 2, 0, 0],
      [1, 1, 2, 1, 1, 0, 2, 0, 0],
      [1, 1, 1, 1, 1, 1, 2, 0, 0],
      [2, 2, 2, 1, 1, 1, 2, 0, 0],
      [0, 2, 0, 1, 1, 2, 2, 0, 0],
      [2, 0, 0, 1, 1, 2, 2, 0, 0],
      [2, 1, 0, 1, 2, 0, 2, 0, 0],
      [0, 0, 2, 1, 2, 1, 2, 0, 0],
      [0, 2, 0, 1, 2, 1, 2, 0, 0],
      [1, 2, 1, 1, 2, 2, 2, 0, 0],
      [2, 0, 2, 1, 2, 2, 2, 0, 0],
      [0, 1, 0, 2, 0, 0, 2, 0, 0],
      [2, 0, 2, 2, 0, 0, 2, 0, 0],
      [0, 2, 1, 2, 0, 1, 2, 0, 0],
      [1, 0, 1, 2, 0, 2, 2, 0, 0],
      [1, 1, 0, 2, 0, 2, 2, 0, 0],
      [1, 2, 0, 2, 1, 0, 2, 0, 0],
      [0, 0, 2, 2, 1, 1, 2, 0, 0],
      [2, 0, 0, 2, 1, 1, 2, 0, 0],
      [0, 2, 2, 2, 1, 2, 2, 0, 0],
      [2, 1, 1, 2, 1, 2, 2, 0, 0],
      [0, 1, 1, 2, 2, 0, 2, 0, 0],
      [1, 0, 1, 2, 2, 0, 2, 0, 0],
      [1, 1, 2, 2, 2, 1, 2, 0, 0],
      [2, 2, 0, 2, 2, 1, 2, 0, 0],
      [0, 0, 0, 2, 2, 2, 2, 0, 0],
      [2, 2, 2, 2, 2, 2, 2, 0, 0],
      [1, 1, 1, 0, 0, 0, 2, 0, 1],
      [2, 2, 2, 0, 0, 0, 2, 0, 1],
      [0, 2, 0, 0, 0, 1, 2, 0, 1],
      [1, 0, 1, 0, 0, 1, 2, 0, 1],
      [0, 1, 0, 0, 0, 2, 2, 0, 1],
      [2, 0, 2, 0, 0, 2, 2, 0, 1],
      [0, 0, 2, 0, 1, 0, 2, 0, 1],
      [1, 1, 0, 0, 1, 0, 2, 0, 1],
      [1, 0, 0, 0, 1, 1, 2, 0, 1],
      [2, 1, 1, 0, 1, 1, 2, 0, 1],
      [0, 2, 1, 0, 1, 2, 2, 0, 1],
      [0, 0, 1, 0, 2, 0, 2, 0, 1],
      [2, 2, 0, 0, 2, 0, 2, 0, 1],
      [0, 1, 2, 0, 2, 1, 2, 0, 1],
      [1, 2, 2, 0, 2, 2, 2, 0, 1],
      [2, 0, 0, 0, 2, 2, 2, 0, 1],
      [0, 1, 1, 1, 0, 0, 2, 0, 1],
      [2, 0, 0, 1, 0, 0, 2, 0, 1],
      [0, 0, 1, 1, 0, 1, 2, 0, 1],
      [1, 1, 2, 1, 0, 1, 2, 0, 1],
      [1, 2, 0, 1, 0, 2, 2, 0, 1],
      [0, 1, 0, 1, 1, 0, 2, 0, 1],
      [1, 2, 1, 1, 1, 0, 2, 0, 1],
      [0, 0, 0, 1, 1, 1, 2, 0, 1],
      [2, 2, 2, 1, 1, 1, 2, 0, 1],
      [1, 0, 1, 1, 1, 2, 2, 0, 1],
      [2, 1, 2, 1, 1, 2, 2, 0, 1],
      [1, 0, 2, 1, 2, 0, 2, 0, 1],
      [1, 1, 0, 1, 2, 1, 2, 0, 1],
      [2, 2, 1, 1, 2, 1, 2, 0, 1],
      [0, 2, 2, 1, 2, 2, 2, 0, 1],
      [2, 1, 1, 1, 2, 2, 2, 0, 1],
      [0, 2, 2, 2, 0, 0, 2, 0, 1],
      [1, 0, 0, 2, 0, 0, 2, 0, 1],
      [2, 1, 0, 2, 0, 1, 2, 0, 1],
      [0, 0, 2, 2, 0, 2, 2, 0, 1],
      [2, 2, 1, 2, 0, 2, 2, 0, 1],
      [2, 0, 1, 2, 1, 0, 2, 0, 1],
      [0, 1, 1, 2, 1, 1, 2, 0, 1],
      [1, 2, 2, 2, 1, 1, 2, 0, 1],
      [1, 1, 2, 2, 1, 2, 2, 0, 1],
      [2, 2, 0, 2, 1, 2, 2, 0, 1],
      [0, 2, 0, 2, 2, 0, 2, 0, 1],
      [2, 1, 2, 2, 2, 0, 2, 0, 1],
      [1, 2, 1, 2, 2, 1, 2, 0, 1],
      [2, 0, 2, 2, 2, 1, 2, 0, 1],
      [0, 0, 0, 2, 2, 2, 2, 0, 1],
      [1, 1, 1, 2, 2, 2, 2, 0, 1],
      [0, 2, 1, 0, 0, 0, 2, 0, 2],
      [1, 0, 2, 0, 0, 0, 2, 0, 2],
      [2, 1, 0, 0, 0, 0, 2, 0, 2],
      [0, 0, 2, 0, 0, 1, 2, 0, 2],
      [1, 1, 0, 0, 0, 1, 2, 0, 2],
      [2, 2, 1, 0, 0, 1, 2, 0, 2],
      [0, 1, 1, 0, 1, 0, 2, 0, 2],
      [1, 2, 2, 0, 1, 0, 2, 0, 2],
      [2, 0, 0, 0, 1, 0, 2, 0, 2],
      [0, 1, 2, 0, 1, 2, 2, 0, 2],
      [1, 2, 0, 0, 1, 2, 2, 0, 2],
      [2, 0, 1, 0, 1, 2, 2, 0, 2],
      [0, 0, 0, 0, 2, 1, 2, 0, 2],
      [1, 1, 1, 0, 2, 1, 2, 0, 2],
      [2, 2, 2, 0, 2, 1, 2, 0, 2],
      [0, 2, 0, 0, 2, 2, 2, 0, 2],
      [1, 0, 1, 0, 2, 2, 2, 0, 2],
      [2, 1, 2, 0, 2, 2, 2, 0, 2],
      [0, 2, 0, 1, 0, 0, 2, 0, 2],
      [1, 0, 1, 1, 0, 0, 2, 0, 2],
      [2, 1, 2, 1, 0, 0, 2, 0, 2],
      [0, 0, 0, 1, 0, 2, 2, 0, 2],
      [1, 1, 1, 1, 0, 2, 2, 0, 2],
      [2, 2, 2, 1, 0, 2, 2, 0, 2],
      [0, 2, 1, 1, 1, 1, 2, 0, 2],
      [1, 0, 2, 1, 1, 1, 2, 0, 2],
      [2, 1, 0, 1, 1, 1, 2, 0, 2],
      [0, 0, 2, 1, 1, 2, 2, 0, 2],
      [1, 1, 0, 1, 1, 2, 2, 0, 2],
      [2, 2, 1, 1, 1, 2, 2, 0, 2],
      [0, 1, 2, 1, 2, 0, 2, 0, 2],
      [1, 2, 0, 1, 2, 0, 2, 0, 2],
      [2, 0, 1, 1, 2, 0, 2, 0, 2],
      [0, 1, 1, 1, 2, 1, 2, 0, 2],
      [1, 2, 2, 1, 2, 1, 2, 0, 2],
      [2, 0, 0, 1, 2, 1, 2, 0, 2],
      [0, 1, 2, 2, 0, 1, 2, 0, 2],
      [1, 2, 0, 2, 0, 1, 2, 0, 2],
      [2, 0, 1, 2, 0, 1, 2, 0, 2],
      [0, 1, 1, 2, 0, 2, 2, 0, 2],
      [1, 2, 2, 2, 0, 2, 2, 0, 2],
      [2, 0, 0, 2, 0, 2, 2, 0, 2],
      [0, 0, 0, 2, 1, 0, 2, 0, 2],
      [1, 1, 1, 2, 1, 0, 2, 0, 2],
      [2, 2, 2, 2, 1, 0, 2, 0, 2],
      [0, 2, 0, 2, 1, 1, 2, 0, 2],
      [1, 0, 1, 2, 1, 1, 2, 0, 2],
      [2, 1, 2, 2, 1, 1, 2, 0, 2],
      [0, 0, 2, 2, 2, 0, 2, 0, 2],
      [1, 1, 0, 2, 2, 0, 2, 0, 2],
      [2, 2, 1, 2, 2, 0, 2, 0, 2],
      [0, 2, 1, 2, 2, 2, 2, 0, 2],
      [1, 0, 2, 2, 2, 2, 2, 0, 2],
      [2, 1, 0, 2, 2, 2, 2, 0, 2],
      [0, 2, 1, 0, 0, 0, 2, 1, 0],
      [1, 0, 2, 0, 0, 0, 2, 1, 0],
      [2, 1, 0, 0, 0, 0, 2, 1, 0],
      [0, 0, 2, 0, 0, 1, 2, 1, 0],
      [1, 1, 0, 0, 0, 1, 2, 1, 0],
      [2, 2, 1, 0, 0, 1, 2, 1, 0],
      [0, 1, 1, 0, 1, 0, 2, 1, 0],
      [1, 2, 2, 0, 1, 0, 2, 1, 0],
      [2, 0, 0, 0, 1, 0, 2, 1, 0],
      [0, 1, 2, 0, 1, 2, 2, 1, 0],
      [1, 2, 0, 0, 1, 2, 2, 1, 0],
      [2, 0, 1, 0, 1, 2, 2, 1, 0],
      [0, 0, 0, 0, 2, 1, 2, 1, 0],
      [1, 1, 1, 0, 2, 1, 2, 1, 0],
      [2, 2, 2, 0, 2, 1, 2, 1, 0],
      [0, 2, 0, 0, 2, 2, 2, 1, 0],
      [1, 0, 1, 0, 2, 2, 2, 1, 0],
      [2, 1, 2, 0, 2, 2, 2, 1, 0],
      [0, 2, 0, 1, 0, 0, 2, 1, 0],
      [1, 0, 1, 1, 0, 0, 2, 1, 0],
      [2, 1, 2, 1, 0, 0, 2, 1, 0],
      [0, 0, 0, 1, 0, 2, 2, 1, 0],
      [1, 1, 1, 1, 0, 2, 2, 1, 0],
      [2, 2, 2, 1, 0, 2, 2, 1, 0],
      [0, 2, 1, 1, 1, 1, 2, 1, 0],
      [1, 0, 2, 1, 1, 1, 2, 1, 0],
      [2, 1, 0, 1, 1, 1, 2, 1, 0],
      [0, 0, 2, 1, 1, 2, 2, 1, 0],
      [1, 1, 0, 1, 1, 2, 2, 1, 0],
      [2, 2, 1, 1, 1, 2, 2, 1, 0],
      [0, 1, 2, 1, 2, 0, 2, 1, 0],
      [1, 2, 0, 1, 2, 0, 2, 1, 0],
      [2, 0, 1, 1, 2, 0, 2, 1, 0],
      [0, 1, 1, 1, 2, 1, 2, 1, 0],
      [1, 2, 2, 1, 2, 1, 2, 1, 0],
      [2, 0, 0, 1, 2, 1, 2, 1, 0],
      [0, 1, 2, 2, 0, 1, 2, 1, 0],
      [1, 2, 0, 2, 0, 1, 2, 1, 0],
      [2, 0, 1, 2, 0, 1, 2, 1, 0],
      [0, 1, 1, 2, 0, 2, 2, 1, 0],
      [1, 2, 2, 2, 0, 2, 2, 1, 0],
      [2, 0, 0, 2, 0, 2, 2, 1, 0],
      [0, 0, 0, 2, 1, 0, 2, 1, 0],
      [1, 1, 1, 2, 1, 0, 2, 1, 0],
      [2, 2, 2, 2, 1, 0, 2, 1, 0],
      [0, 2, 0, 2, 1, 1, 2, 1, 0],
      [1, 0, 1, 2, 1, 1, 2, 1, 0],
      [2, 1, 2, 2, 1, 1, 2, 1, 0],
      [0, 0, 2, 2, 2, 0, 2, 1, 0],
      [1, 1, 0, 2, 2, 0, 2, 1, 0],
      [2, 2, 1, 2, 2, 0, 2, 1, 0],
      [0, 2, 1, 2, 2, 2, 2, 1, 0],
      [1, 0, 2, 2, 2, 2, 2, 1, 0],
      [2, 1, 0, 2, 2, 2, 2, 1, 0],
      [1, 1, 1, 0, 0, 0, 2, 1, 1],
      [2, 2, 2, 0, 0, 0, 2, 1, 1],
      [0, 2, 0, 0, 0, 1, 2, 1, 1],
      [1, 0, 1, 0, 0, 1, 2, 1, 1],
      [0, 1, 0, 0, 0, 2, 2, 1, 1],
      [2, 0, 2, 0, 0, 2, 2, 1, 1],
      [0, 0, 2, 0, 1, 0, 2, 1, 1],
      [1, 1, 0, 0, 1, 0, 2, 1, 1],
      [1, 0, 0, 0, 1, 1, 2, 1, 1],
      [2, 1, 1, 0, 1, 1, 2, 1, 1],
      [0, 2, 1, 0, 1, 2, 2, 1, 1],
      [0, 0, 1, 0, 2, 0, 2, 1, 1],
      [2, 2, 0, 0, 2, 0, 2, 1, 1],
      [0, 1, 2, 0, 2, 1, 2, 1, 1],
      [1, 2, 2, 0, 2, 2, 2, 1, 1],
      [2, 0, 0, 0, 2, 2, 2, 1, 1],
      [0, 1, 1, 1, 0, 0, 2, 1, 1],
      [2, 0, 0, 1, 0, 0, 2, 1, 1],
      [0, 0, 1, 1, 0, 1, 2, 1, 1],
      [1, 1, 2, 1, 0, 1, 2, 1, 1],
      [1, 2, 0, 1, 0, 2, 2, 1, 1],
      [0, 1, 0, 1, 1, 0, 2, 1, 1],
      [1, 2, 1, 1, 1, 0, 2, 1, 1],
      [0, 0, 0, 1, 1, 1, 2, 1, 1],
      [2, 2, 2, 1, 1, 1, 2, 1, 1],
      [1, 0, 1, 1, 1, 2, 2, 1, 1],
      [2, 1, 2, 1, 1, 2, 2, 1, 1],
      [1, 0, 2, 1, 2, 0, 2, 1, 1],
      [1, 1, 0, 1, 2, 1, 2, 1, 1],
      [2, 2, 1, 1, 2, 1, 2, 1, 1],
      [0, 2, 2, 1, 2, 2, 2, 1, 1],
      [2, 1, 1, 1, 2, 2, 2, 1, 1],
      [0, 2, 2, 2, 0, 0, 2, 1, 1],
      [1, 0, 0, 2, 0, 0, 2, 1, 1],
      [2, 1, 0, 2, 0, 1, 2, 1, 1],
      [0, 0, 2, 2, 0, 2, 2, 1, 1],
      [2, 2, 1, 2, 0, 2, 2, 1, 1],
      [2, 0, 1, 2, 1, 0, 2, 1, 1],
      [0, 1, 1, 2, 1, 1, 2, 1, 1],
      [1, 2, 2, 2, 1, 1, 2, 1, 1],
      [1, 1, 2, 2, 1, 2, 2, 1, 1],
      [2, 2, 0, 2, 1, 2, 2, 1, 1],
      [0, 2, 0, 2, 2, 0, 2, 1, 1],
      [2, 1, 2, 2, 2, 0, 2, 1, 1],
      [1, 2, 1, 2, 2, 1, 2, 1, 1],
      [2, 0, 2, 2, 2, 1, 2, 1, 1],
      [0, 0, 0, 2, 2, 2, 2, 1, 1],
      [1, 1, 1, 2, 2, 2, 2, 1, 1],
      [0, 1, 2, 0, 0, 0, 2, 1, 2],
      [1, 2, 0, 0, 0, 0, 2, 1, 2],
      [2, 0, 1, 0, 0, 0, 2, 1, 2],
      [0, 2, 2, 0, 0, 2, 2, 1, 2],
      [1, 0, 0, 0, 0, 2, 2, 1, 2],
      [2, 1, 1, 0, 0, 2, 2, 1, 2],
      [0, 0, 1, 0, 1, 1, 2, 1, 2],
      [1, 1, 2, 0, 1, 1, 2, 1, 2],
      [2, 2, 0, 0, 1, 1, 2, 1, 2],
      [0, 0, 0, 0, 1, 2, 2, 1, 2],
      [1, 1, 1, 0, 1, 2, 2, 1, 2],
      [2, 2, 2, 0, 1, 2, 2, 1, 2],
      [0, 1, 0, 0, 2, 0, 2, 1, 2],
      [1, 2, 1, 0, 2, 0, 2, 1, 2],
      [2, 0, 2, 0, 2, 0, 2, 1, 2],
      [0, 2, 1, 0, 2, 1, 2, 1, 2],
      [1, 0, 2, 0, 2, 1, 2, 1, 2],
      [2, 1, 0, 0, 2, 1, 2, 1, 2],
      [0, 1, 0, 1, 0, 1, 2, 1, 2],
      [1, 2, 1, 1, 0, 1, 2, 1, 2],
      [2, 0, 2, 1, 0, 1, 2, 1, 2],
      [0, 2, 1, 1, 0, 2, 2, 1, 2],
      [1, 0, 2, 1, 0, 2, 2, 1, 2],
      [2, 1, 0, 1, 0, 2, 2, 1, 2],
      [0, 2, 2, 1, 1, 0, 2, 1, 2],
      [1, 0, 0, 1, 1, 0, 2, 1, 2],
      [2, 1, 1, 1, 1, 0, 2, 1, 2],
      [0, 1, 2, 1, 1, 1, 2, 1, 2],
      [1, 2, 0, 1, 1, 1, 2, 1, 2],
      [2, 0, 1, 1, 1, 1, 2, 1, 2],
      [0, 0, 0, 1, 2, 0, 2, 1, 2],
      [1, 1, 1, 1, 2, 0, 2, 1, 2],
      [2, 2, 2, 1, 2, 0, 2, 1, 2],
      [0, 0, 1, 1, 2, 2, 2, 1, 2],
      [1, 1, 2, 1, 2, 2, 2, 1, 2],
      [2, 2, 0, 1, 2, 2, 2, 1, 2],
      [0, 0, 1, 2, 0, 0, 2, 1, 2],
      [1, 1, 2, 2, 0, 0, 2, 1, 2],
      [2, 2, 0, 2, 0, 0, 2, 1, 2],
      [0, 0, 0, 2, 0, 1, 2, 1, 2],
      [1, 1, 1, 2, 0, 1, 2, 1, 2],
      [2, 2, 2, 2, 0, 1, 2, 1, 2],
      [0, 2, 1, 2, 1, 0, 2, 1, 2],
      [1, 0, 2, 2, 1, 0, 2, 1, 2],
      [2, 1, 0, 2, 1, 0, 2, 1, 2],
      [0, 1, 0, 2, 1, 2, 2, 1, 2],
      [1, 2, 1, 2, 1, 2, 2, 1, 2],
      [2, 0, 2, 2, 1, 2, 2, 1, 2],
      [0, 2, 2, 2, 2, 1, 2, 1, 2],
      [1, 0, 0, 2, 2, 1, 2, 1, 2],
      [2, 1, 1, 2, 2, 1, 2, 1, 2],
      [0, 1, 2, 2, 2, 2, 2, 1, 2],
      [1, 2, 0, 2, 2, 2, 2, 1, 2],
      [2, 0, 1, 2, 2, 2, 2, 1, 2],
      [0, 1, 2, 0, 0, 0, 2, 2, 0],
      [1, 2, 0, 0, 0, 0, 2, 2, 0],
      [2, 0, 1, 0, 0, 0, 2, 2, 0],
      [0, 2, 2, 0, 0, 2, 2, 2, 0],
      [1, 0, 0, 0, 0, 2, 2, 2, 0],
      [2, 1, 1, 0, 0, 2, 2, 2, 0],
      [0, 0, 1, 0, 1, 1, 2, 2, 0],
      [1, 1, 2, 0, 1, 1, 2, 2, 0],
      [2, 2, 0, 0, 1, 1, 2, 2, 0],
      [0, 0, 0, 0, 1, 2, 2, 2, 0],
      [1, 1, 1, 0, 1, 2, 2, 2, 0],
      [2, 2, 2, 0, 1, 2, 2, 2, 0],
      [0, 1, 0, 0, 2, 0, 2, 2, 0],
      [1, 2, 1, 0, 2, 0, 2, 2, 0],
      [2, 0, 2, 0, 2, 0, 2, 2, 0],
      [0, 2, 1, 0, 2, 1, 2, 2, 0],
      [1, 0, 2, 0, 2, 1, 2, 2, 0],
      [2, 1, 0, 0, 2, 1, 2, 2, 0],
      [0, 1, 0, 1, 0, 1, 2, 2, 0],
      [1, 2, 1, 1, 0, 1, 2, 2, 0],
      [2, 0, 2, 1, 0, 1, 2, 2, 0],
      [0, 2, 1, 1, 0, 2, 2, 2, 0],
      [1, 0, 2, 1, 0, 2, 2, 2, 0],
      [2, 1, 0, 1, 0, 2, 2, 2, 0],
      [0, 2, 2, 1, 1, 0, 2, 2, 0],
      [1, 0, 0, 1, 1, 0, 2, 2, 0],
      [2, 1, 1, 1, 1, 0, 2, 2, 0],
      [0, 1, 2, 1, 1, 1, 2, 2, 0],
      [1, 2, 0, 1, 1, 1, 2, 2, 0],
      [2, 0, 1, 1, 1, 1, 2, 2, 0],
      [0, 0, 0, 1, 2, 0, 2, 2, 0],
      [1, 1, 1, 1, 2, 0, 2, 2, 0],
      [2, 2, 2, 1, 2, 0, 2, 2, 0],
      [0, 0, 1, 1, 2, 2, 2, 2, 0],
      [1, 1, 2, 1, 2, 2, 2, 2, 0],
      [2, 2, 0, 1, 2, 2, 2, 2, 0],
      [0, 0, 1, 2, 0, 0, 2, 2, 0],
      [1, 1, 2, 2, 0, 0, 2, 2, 0],
      [2, 2, 0, 2, 0, 0, 2, 2, 0],
      [0, 0, 0, 2, 0, 1, 2, 2, 0],
      [1, 1, 1, 2, 0, 1, 2, 2, 0],
      [2, 2, 2, 2, 0, 1, 2, 2, 0],
      [0, 2, 1, 2, 1, 0, 2, 2, 0],
      [1, 0, 2, 2, 1, 0, 2, 2, 0],
      [2, 1, 0, 2, 1, 0, 2, 2, 0],
      [0, 1, 0, 2, 1, 2, 2, 2, 0],
      [1, 2, 1, 2, 1, 2, 2, 2, 0],
      [2, 0, 2, 2, 1, 2, 2, 2, 0],
      [0, 2, 2, 2, 2, 1, 2, 2, 0],
      [1, 0, 0, 2, 2, 1, 2, 2, 0],
      [2, 1, 1, 2, 2, 1, 2, 2, 0],
      [0, 1, 2, 2, 2, 2, 2, 2, 0],
      [1, 2, 0, 2, 2, 2, 2, 2, 0],
      [2, 0, 1, 2, 2, 2, 2, 2, 0],
      [0, 0, 0, 0, 0, 0, 2, 2, 1],
      [2, 2, 2, 0, 0, 0, 2, 2, 1],
      [0, 1, 1, 0, 0, 1, 2, 2, 1],
      [2, 0, 0, 0, 0, 1, 2, 2, 1],
      [1, 1, 2, 0, 0, 2, 2, 2, 1],
      [1, 2, 1, 0, 0, 2, 2, 2, 1],
      [0, 2, 0, 0, 1, 0, 2, 2, 1],
      [1, 0, 1, 0, 1, 0, 2, 2, 1],
      [0, 2, 2, 0, 1, 1, 2, 2, 1],
      [2, 0, 2, 0, 1, 1, 2, 2, 1],
      [2, 1, 0, 0, 1, 2, 2, 2, 1],
      [1, 1, 2, 0, 2, 0, 2, 2, 1],
      [2, 1, 1, 0, 2, 0, 2, 2, 1],
      [1, 2, 0, 0, 2, 1, 2, 2, 1],
      [0, 0, 2, 0, 2, 2, 2, 2, 1],
      [2, 2, 1, 0, 2, 2, 2, 2, 1],
      [0, 0, 2, 1, 0, 0, 2, 2, 1],
      [1, 1, 0, 1, 0, 0, 2, 2, 1],
      [0, 2, 2, 1, 0, 1, 2, 2, 1],
      [2, 2, 0, 1, 0, 1, 2, 2, 1],
      [2, 0, 1, 1, 0, 2, 2, 2, 1],
      [2, 0, 2, 1, 1, 0, 2, 2, 1],
      [2, 2, 0, 1, 1, 0, 2, 2, 1],
      [0, 0, 0, 1, 1, 1, 2, 2, 1],
      [1, 1, 1, 1, 1, 1, 2, 2, 1],
      [0, 1, 1, 1, 1, 2, 2, 2, 1],
      [1, 2, 2, 1, 1, 2, 2, 2, 1],
      [0, 2, 1, 1, 2, 0, 2, 2, 1],
      [1, 0, 1, 1, 2, 1, 2, 2, 1],
      [2, 1, 2, 1, 2, 1, 2, 2, 1],
      [0, 1, 0, 1, 2, 2, 2, 2, 1],
      [1, 0, 0, 1, 2, 2, 2, 2, 1],
      [1, 2, 1, 2, 0, 0, 2, 2, 1],
      [2, 1, 1, 2, 0, 0, 2, 2, 1],
      [1, 0, 2, 2, 0, 1, 2, 2, 1],
      [0, 2, 0, 2, 0, 2, 2, 2, 1],
      [2, 1, 2, 2, 0, 2, 2, 2, 1],
      [0, 1, 2, 2, 1, 0, 2, 2, 1],
      [1, 1, 0, 2, 1, 1, 2, 2, 1],
      [2, 2, 1, 2, 1, 1, 2, 2, 1],
      [0, 0, 1, 2, 1, 2, 2, 2, 1],
      [1, 0, 0, 2, 1, 2, 2, 2, 1],
      [1, 2, 2, 2, 2, 0, 2, 2, 1],
      [2, 0, 0, 2, 2, 0, 2, 2, 1],
      [0, 0, 1, 2, 2, 1, 2, 2, 1],
      [0, 1, 0, 2, 2, 1, 2, 2, 1],
      [1, 1, 1, 2, 2, 2, 2, 2, 1],
      [2, 2, 2, 2, 2, 2, 2, 2, 1],
      [0, 0, 0, 0, 0, 0, 2, 2, 2],
      [1, 1, 1, 0, 0, 0, 2, 2, 2],
      [1, 2, 2, 0, 0, 1, 2, 2, 2],
      [2, 1, 2, 0, 0, 1, 2, 2, 2],
      [0, 0, 1, 0, 0, 2, 2, 2, 2],
      [2, 2, 0, 0, 0, 2, 2, 2, 2],
      [2, 1, 2, 0, 1, 0, 2, 2, 2],
      [2, 2, 1, 0, 1, 0, 2, 2, 2],
      [0, 1, 0, 0, 1, 1, 2, 2, 2],
      [1, 2, 1, 0, 1, 1, 2, 2, 2],
      [1, 0, 2, 0, 1, 2, 2, 2, 2],
      [0, 2, 2, 0, 2, 0, 2, 2, 2],
      [1, 0, 0, 0, 2, 0, 2, 2, 2],
      [2, 0, 1, 0, 2, 1, 2, 2, 2],
      [0, 1, 1, 0, 2, 2, 2, 2, 2],
      [1, 1, 0, 0, 2, 2, 2, 2, 2],
      [1, 2, 2, 1, 0, 0, 2, 2, 2],
      [2, 2, 1, 1, 0, 0, 2, 2, 2],
      [1, 0, 0, 1, 0, 1, 2, 2, 2],
      [2, 1, 1, 1, 0, 1, 2, 2, 2],
      [0, 1, 2, 1, 0, 2, 2, 2, 2],
      [0, 0, 1, 1, 1, 0, 2, 2, 2],
      [1, 1, 2, 1, 1, 0, 2, 2, 2],
      [1, 1, 1, 1, 1, 1, 2, 2, 2],
      [2, 2, 2, 1, 1, 1, 2, 2, 2],
      [0, 2, 0, 1, 1, 2, 2, 2, 2],
      [2, 0, 0, 1, 1, 2, 2, 2, 2],
      [2, 1, 0, 1, 2, 0, 2, 2, 2],
      [0, 0, 2, 1, 2, 1, 2, 2, 2],
      [0, 2, 0, 1, 2, 1, 2, 2, 2],
      [1, 2, 1, 1, 2, 2, 2, 2, 2],
      [2, 0, 2, 1, 2, 2, 2, 2, 2],
      [0, 1, 0, 2, 0, 0, 2, 2, 2],
      [2, 0, 2, 2, 0, 0, 2, 2, 2],
      [0, 2, 1, 2, 0, 1, 2, 2, 2],
      [1, 0, 1, 2, 0, 2, 2, 2, 2],
      [1, 1, 0, 2, 0, 2, 2, 2, 2],
      [1, 2, 0, 2, 1, 0, 2, 2, 2],
      [0, 0, 2, 2, 1, 1, 2, 2, 2],
      [2, 0, 0, 2, 1, 1, 2, 2, 2],
      [0, 2, 2, 2, 1, 2, 2, 2, 2],
      [2, 1, 1, 2, 1, 2, 2, 2, 2],
      [0, 1, 1, 2, 2, 0, 2, 2, 2],
      [1, 0, 1, 2, 2, 0, 2, 2, 2],
      [1, 1, 2, 2, 2, 1, 2, 2, 2],
      [2, 2, 0, 2, 2, 1, 2, 2, 2],
      [0, 0, 0, 2, 2, 2, 2, 2, 2],
      [2, 2, 2, 2, 2, 2, 2, 2, 2],
    ] as const,
    systemType: 'R',
    systemNum: 57,
    hasXpert: false,
  } as const,
  'R9-0-222': {
    guaranty: 11,
    numFullHedges: 9,
    numHalfHedges: 0,
    rows: [
      [0, 0, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 2, 2, 2],
      [0, 0, 0, 0, 1, 1, 0, 0, 1],
      [0, 0, 0, 0, 2, 2, 0, 0, 2],
      [0, 0, 0, 1, 0, 1, 0, 1, 0],
      [0, 0, 0, 1, 1, 0, 1, 0, 0],
      [0, 0, 0, 1, 1, 1, 2, 2, 2],
      [0, 0, 0, 2, 0, 2, 0, 2, 0],
      [0, 0, 0, 2, 2, 0, 2, 0, 0],
      [0, 0, 0, 2, 2, 2, 1, 1, 1],
      [0, 0, 1, 0, 0, 1, 1, 0, 0],
      [0, 0, 1, 0, 1, 0, 0, 1, 0],
      [0, 0, 1, 0, 2, 1, 1, 2, 2],
      [0, 0, 1, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 1, 0, 2, 2, 1, 2],
      [0, 0, 1, 1, 2, 2, 0, 2, 1],
      [0, 0, 1, 2, 1, 0, 2, 2, 1],
      [0, 0, 1, 2, 1, 2, 1, 0, 2],
      [0, 0, 1, 2, 2, 1, 2, 1, 0],
      [0, 0, 2, 0, 0, 2, 2, 0, 0],
      [0, 0, 2, 0, 1, 2, 2, 1, 1],
      [0, 0, 2, 0, 2, 0, 0, 2, 0],
      [0, 0, 2, 1, 1, 2, 1, 2, 0],
      [0, 0, 2, 1, 2, 0, 1, 1, 2],
      [0, 0, 2, 1, 2, 1, 2, 0, 1],
      [0, 0, 2, 2, 0, 0, 0, 0, 2],
      [0, 0, 2, 2, 0, 1, 1, 2, 1],
      [0, 0, 2, 2, 1, 1, 0, 1, 2],
      [0, 1, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 0, 0, 2, 1, 2, 1, 2],
      [0, 1, 0, 1, 0, 2, 2, 2, 1],
      [0, 1, 0, 1, 2, 2, 1, 0, 2],
      [0, 1, 0, 2, 1, 0, 1, 2, 2],
      [0, 1, 0, 2, 1, 2, 2, 1, 0],
      [0, 1, 0, 2, 2, 1, 0, 2, 1],
      [0, 1, 1, 0, 1, 2, 0, 2, 2],
      [0, 1, 1, 0, 2, 2, 2, 0, 1],
      [0, 1, 1, 1, 1, 1, 1, 1, 1],
      [0, 1, 1, 1, 2, 0, 2, 2, 0],
      [0, 1, 1, 2, 0, 1, 2, 0, 2],
      [0, 1, 1, 2, 0, 2, 1, 2, 0],
      [0, 1, 1, 2, 2, 0, 0, 1, 2],
      [0, 1, 2, 0, 0, 2, 1, 1, 2],
      [0, 1, 2, 0, 1, 1, 2, 2, 0],
      [0, 1, 2, 0, 2, 0, 1, 2, 1],
      [0, 1, 2, 1, 0, 1, 0, 2, 2],
      [0, 1, 2, 1, 1, 0, 2, 0, 2],
      [0, 1, 2, 1, 2, 2, 0, 1, 0],
      [0, 1, 2, 2, 0, 0, 2, 1, 1],
      [0, 1, 2, 2, 1, 2, 0, 0, 1],
      [0, 1, 2, 2, 2, 1, 1, 0, 0],
      [0, 2, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 0, 0, 1, 2, 1, 2, 1],
      [0, 2, 0, 1, 1, 2, 0, 1, 2],
      [0, 2, 0, 1, 2, 0, 2, 1, 1],
      [0, 2, 0, 1, 2, 1, 1, 2, 0],
      [0, 2, 0, 2, 0, 1, 1, 1, 2],
      [0, 2, 0, 2, 1, 1, 2, 0, 1],
      [0, 2, 1, 0, 0, 1, 2, 2, 1],
      [0, 2, 1, 0, 1, 0, 2, 1, 2],
      [0, 2, 1, 0, 2, 2, 1, 1, 0],
      [0, 2, 1, 1, 0, 0, 1, 2, 2],
      [0, 2, 1, 1, 1, 2, 2, 0, 0],
      [0, 2, 1, 1, 2, 1, 0, 0, 2],
      [0, 2, 1, 2, 0, 2, 0, 1, 1],
      [0, 2, 1, 2, 1, 1, 0, 2, 0],
      [0, 2, 1, 2, 2, 0, 1, 0, 1],
      [0, 2, 2, 0, 1, 1, 1, 0, 2],
      [0, 2, 2, 0, 2, 1, 0, 1, 1],
      [0, 2, 2, 1, 0, 1, 2, 1, 0],
      [0, 2, 2, 1, 0, 2, 1, 0, 1],
      [0, 2, 2, 1, 1, 0, 0, 2, 1],
      [0, 2, 2, 2, 1, 0, 1, 1, 0],
      [0, 2, 2, 2, 2, 2, 2, 2, 2],
      [1, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 2, 1, 2, 2, 1],
      [1, 0, 0, 1, 0, 2, 1, 2, 2],
      [1, 0, 0, 1, 2, 2, 2, 1, 0],
      [1, 0, 0, 2, 1, 0, 2, 1, 2],
      [1, 0, 0, 2, 1, 2, 0, 2, 1],
      [1, 0, 0, 2, 2, 1, 1, 0, 2],
      [1, 0, 1, 0, 1, 2, 2, 2, 0],
      [1, 0, 1, 0, 2, 2, 0, 1, 2],
      [1, 0, 1, 1, 1, 1, 1, 1, 1],
      [1, 0, 1, 1, 2, 0, 2, 0, 2],
      [1, 0, 1, 2, 0, 1, 0, 2, 2],
      [1, 0, 1, 2, 0, 2, 2, 0, 1],
      [1, 0, 1, 2, 2, 0, 1, 2, 0],
      [1, 0, 2, 0, 0, 1, 2, 1, 2],
      [1, 0, 2, 0, 1, 0, 1, 2, 2],
      [1, 0, 2, 0, 2, 2, 1, 0, 1],
      [1, 0, 2, 1, 0, 0, 2, 2, 1],
      [1, 0, 2, 1, 1, 2, 0, 0, 2],
      [1, 0, 2, 1, 2, 1, 0, 2, 0],
      [1, 0, 2, 2, 0, 2, 1, 1, 0],
      [1, 0, 2, 2, 1, 1, 2, 0, 0],
      [1, 0, 2, 2, 2, 0, 0, 1, 1],
      [1, 1, 0, 0, 1, 1, 1, 1, 0],
      [1, 1, 0, 0, 1, 2, 2, 0, 2],
      [1, 1, 0, 0, 2, 2, 1, 2, 0],
      [1, 1, 0, 1, 0, 1, 1, 0, 1],
      [1, 1, 0, 1, 1, 0, 0, 1, 1],
      [1, 1, 0, 1, 2, 0, 0, 2, 2],
      [1, 1, 0, 2, 0, 1, 2, 2, 0],
      [1, 1, 0, 2, 0, 2, 0, 1, 2],
      [1, 1, 0, 2, 2, 0, 2, 0, 1],
      [1, 1, 1, 0, 0, 0, 2, 2, 2],
      [1, 1, 1, 0, 0, 1, 0, 1, 1],
      [1, 1, 1, 0, 1, 0, 1, 0, 1],
      [1, 1, 1, 1, 0, 0, 1, 1, 0],
      [1, 1, 1, 1, 1, 1, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 2, 2, 2],
      [1, 1, 1, 1, 2, 2, 1, 1, 2],
      [1, 1, 1, 2, 1, 2, 1, 2, 1],
      [1, 1, 1, 2, 2, 1, 2, 1, 1],
      [1, 1, 1, 2, 2, 2, 0, 0, 0],
      [1, 1, 2, 0, 0, 2, 0, 2, 1],
      [1, 1, 2, 0, 2, 0, 2, 1, 0],
      [1, 1, 2, 0, 2, 1, 0, 0, 2],
      [1, 1, 2, 1, 0, 2, 2, 0, 0],
      [1, 1, 2, 1, 1, 2, 2, 1, 1],
      [1, 1, 2, 1, 2, 1, 1, 2, 1],
      [1, 1, 2, 2, 0, 0, 1, 0, 2],
      [1, 1, 2, 2, 1, 0, 0, 2, 0],
      [1, 1, 2, 2, 1, 1, 1, 1, 2],
      [1, 2, 0, 0, 0, 2, 2, 1, 1],
      [1, 2, 0, 0, 1, 1, 0, 2, 2],
      [1, 2, 0, 0, 2, 0, 1, 1, 2],
      [1, 2, 0, 1, 0, 1, 2, 0, 2],
      [1, 2, 0, 1, 1, 0, 2, 2, 0],
      [1, 2, 0, 1, 2, 2, 0, 0, 1],
      [1, 2, 0, 2, 0, 0, 1, 2, 1],
      [1, 2, 0, 2, 1, 2, 1, 0, 0],
      [1, 2, 0, 2, 2, 1, 0, 1, 0],
      [1, 2, 1, 0, 0, 2, 1, 0, 2],
      [1, 2, 1, 0, 2, 0, 0, 2, 1],
      [1, 2, 1, 0, 2, 1, 2, 0, 0],
      [1, 2, 1, 1, 0, 2, 0, 2, 0],
      [1, 2, 1, 1, 1, 1, 1, 1, 1],
      [1, 2, 1, 2, 0, 0, 2, 1, 0],
      [1, 2, 1, 2, 1, 0, 0, 0, 2],
      [1, 2, 2, 0, 0, 1, 1, 2, 0],
      [1, 2, 2, 0, 1, 0, 2, 0, 1],
      [1, 2, 2, 0, 1, 2, 0, 1, 0],
      [1, 2, 2, 1, 0, 0, 0, 1, 2],
      [1, 2, 2, 1, 2, 0, 1, 0, 0],
      [1, 2, 2, 2, 0, 1, 0, 0, 1],
      [1, 2, 2, 2, 2, 2, 2, 2, 2],
      [2, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 0, 0, 0, 1, 2, 1, 1, 2],
      [2, 0, 0, 1, 1, 2, 2, 0, 1],
      [2, 0, 0, 1, 2, 0, 1, 2, 1],
      [2, 0, 0, 1, 2, 1, 0, 1, 2],
      [2, 0, 0, 2, 0, 1, 2, 1, 1],
      [2, 0, 0, 2, 1, 1, 1, 2, 0],
      [2, 0, 1, 0, 0, 2, 1, 2, 1],
      [2, 0, 1, 0, 1, 1, 2, 0, 2],
      [2, 0, 1, 0, 2, 0, 2, 1, 1],
      [2, 0, 1, 1, 0, 1, 2, 2, 0],
      [2, 0, 1, 1, 1, 0, 0, 2, 2],
      [2, 0, 1, 1, 2, 2, 1, 0, 0],
      [2, 0, 1, 2, 0, 0, 1, 1, 2],
      [2, 0, 1, 2, 1, 2, 0, 1, 0],
      [2, 0, 1, 2, 2, 1, 0, 0, 1],
      [2, 0, 2, 0, 1, 1, 0, 2, 1],
      [2, 0, 2, 0, 2, 1, 1, 1, 0],
      [2, 0, 2, 1, 0, 1, 1, 0, 2],
      [2, 0, 2, 1, 0, 2, 0, 1, 1],
      [2, 0, 2, 1, 1, 0, 2, 1, 0],
      [2, 0, 2, 2, 1, 0, 1, 0, 1],
      [2, 0, 2, 2, 2, 2, 2, 2, 2],
      [2, 1, 0, 0, 0, 1, 1, 2, 2],
      [2, 1, 0, 0, 1, 0, 2, 2, 1],
      [2, 1, 0, 0, 2, 2, 0, 1, 1],
      [2, 1, 0, 1, 0, 0, 2, 1, 2],
      [2, 1, 0, 1, 1, 2, 0, 2, 0],
      [2, 1, 0, 1, 2, 1, 2, 0, 0],
      [2, 1, 0, 2, 0, 2, 1, 0, 1],
      [2, 1, 0, 2, 1, 1, 0, 0, 2],
      [2, 1, 0, 2, 2, 0, 1, 1, 0],
      [2, 1, 1, 0, 0, 2, 2, 1, 0],
      [2, 1, 1, 0, 2, 0, 1, 0, 2],
      [2, 1, 1, 0, 2, 1, 0, 2, 0],
      [2, 1, 1, 1, 0, 2, 0, 0, 2],
      [2, 1, 1, 1, 1, 1, 1, 1, 1],
      [2, 1, 1, 2, 0, 0, 0, 2, 1],
      [2, 1, 1, 2, 1, 0, 2, 0, 0],
      [2, 1, 2, 0, 0, 1, 2, 0, 1],
      [2, 1, 2, 0, 1, 0, 0, 1, 2],
      [2, 1, 2, 0, 1, 2, 1, 0, 0],
      [2, 1, 2, 1, 0, 0, 1, 2, 0],
      [2, 1, 2, 1, 2, 0, 0, 0, 1],
      [2, 1, 2, 2, 0, 1, 0, 1, 0],
      [2, 1, 2, 2, 2, 2, 2, 2, 2],
      [2, 2, 0, 0, 1, 1, 2, 1, 0],
      [2, 2, 0, 0, 2, 1, 1, 0, 1],
      [2, 2, 0, 0, 2, 2, 2, 2, 0],
      [2, 2, 0, 1, 0, 1, 0, 2, 1],
      [2, 2, 0, 1, 0, 2, 1, 1, 0],
      [2, 2, 0, 1, 1, 0, 1, 0, 2],
      [2, 2, 0, 2, 0, 2, 2, 0, 2],
      [2, 2, 0, 2, 1, 0, 0, 1, 1],
      [2, 2, 0, 2, 2, 0, 0, 2, 2],
      [2, 2, 1, 0, 0, 1, 0, 1, 2],
      [2, 2, 1, 0, 1, 0, 1, 2, 0],
      [2, 2, 1, 0, 1, 2, 0, 0, 1],
      [2, 2, 1, 1, 0, 0, 2, 0, 1],
      [2, 2, 1, 1, 2, 0, 0, 1, 0],
      [2, 2, 1, 1, 2, 2, 2, 2, 1],
      [2, 2, 1, 2, 0, 1, 1, 0, 0],
      [2, 2, 1, 2, 1, 2, 2, 1, 2],
      [2, 2, 1, 2, 2, 1, 1, 2, 2],
      [2, 2, 2, 0, 0, 0, 1, 1, 1],
      [2, 2, 2, 0, 0, 2, 0, 2, 2],
      [2, 2, 2, 0, 2, 0, 2, 0, 2],
      [2, 2, 2, 1, 1, 1, 0, 0, 0],
      [2, 2, 2, 1, 1, 2, 1, 2, 2],
      [2, 2, 2, 1, 2, 1, 2, 1, 2],
      [2, 2, 2, 2, 0, 0, 2, 2, 0],
      [2, 2, 2, 2, 1, 1, 2, 2, 1],
      [2, 2, 2, 2, 2, 2, 0, 0, 0],
      [2, 2, 2, 2, 2, 2, 1, 1, 1],
    ] as const,
    systemType: 'R',
    systemNum: 30,
    hasXpert: true,
  } as const,
  'R9-0-243': {
    guaranty: 11,
    numFullHedges: 9,
    numHalfHedges: 0,
    rows: [
      [1, 1, 0, 0, 0, 1, 1, 0, 0],
      [1, 1, 1, 2, 2, 1, 2, 1, 0],
      [2, 1, 1, 2, 1, 0, 2, 2, 0],
      [2, 1, 0, 1, 1, 0, 2, 1, 2],
      [0, 0, 2, 1, 0, 2, 1, 1, 2],
      [0, 1, 1, 0, 1, 1, 2, 2, 1],
      [0, 1, 2, 1, 2, 2, 0, 1, 0],
      [2, 2, 0, 1, 0, 0, 1, 1, 0],
      [1, 2, 0, 0, 0, 2, 1, 1, 2],
      [1, 2, 0, 0, 2, 1, 0, 0, 1],
      [1, 2, 1, 0, 2, 0, 1, 0, 2],
      [2, 1, 2, 2, 2, 0, 1, 0, 2],
      [2, 1, 1, 1, 1, 2, 0, 1, 0],
      [2, 1, 1, 2, 0, 2, 1, 1, 2],
      [1, 0, 2, 2, 1, 1, 2, 2, 1],
      [1, 1, 2, 2, 0, 1, 1, 2, 2],
      [1, 1, 1, 1, 0, 1, 1, 1, 1],
      [1, 1, 0, 0, 2, 0, 0, 2, 2],
      [1, 0, 0, 1, 2, 0, 2, 2, 0],
      [1, 2, 2, 2, 2, 1, 0, 2, 0],
      [1, 1, 1, 1, 1, 2, 2, 2, 2],
      [1, 1, 2, 0, 2, 1, 2, 2, 1],
      [1, 1, 1, 0, 2, 2, 1, 2, 0],
      [0, 0, 0, 0, 1, 1, 1, 1, 1],
      [2, 0, 0, 1, 2, 0, 0, 1, 1],
      [2, 2, 1, 1, 2, 1, 1, 0, 0],
      [1, 2, 1, 2, 0, 0, 0, 0, 0],
      [2, 0, 2, 1, 1, 0, 1, 0, 2],
      [1, 2, 1, 0, 0, 1, 2, 1, 0],
      [2, 2, 2, 0, 1, 1, 2, 1, 0],
      [0, 2, 2, 0, 1, 1, 0, 0, 1],
      [2, 0, 1, 0, 0, 2, 0, 1, 0],
      [0, 0, 2, 1, 2, 1, 0, 0, 1],
      [2, 0, 0, 0, 0, 0, 2, 1, 2],
      [1, 1, 2, 0, 1, 0, 1, 1, 0],
      [2, 1, 0, 0, 0, 1, 2, 2, 1],
      [2, 0, 2, 1, 0, 2, 0, 2, 1],
      [2, 1, 0, 2, 0, 0, 0, 1, 1],
      [2, 0, 1, 1, 2, 2, 1, 1, 2],
      [2, 0, 1, 2, 2, 0, 0, 2, 2],
      [2, 0, 0, 1, 1, 2, 2, 0, 0],
      [2, 1, 2, 1, 1, 1, 1, 1, 1],
      [2, 0, 2, 2, 0, 0, 2, 0, 1],
      [1, 2, 2, 0, 2, 2, 2, 0, 0],
      [1, 0, 0, 1, 1, 2, 1, 1, 2],
      [1, 2, 0, 1, 1, 1, 1, 0, 0],
      [2, 0, 0, 0, 1, 1, 0, 2, 0],
      [0, 1, 1, 0, 2, 2, 0, 0, 2],
      [0, 2, 1, 2, 2, 2, 1, 0, 1],
      [0, 1, 0, 1, 0, 2, 2, 2, 2],
      [2, 2, 1, 0, 2, 0, 2, 2, 0],
      [0, 1, 2, 2, 2, 0, 2, 2, 0],
      [0, 1, 0, 1, 2, 1, 1, 1, 1],
      [0, 1, 1, 2, 2, 1, 1, 2, 2],
      [0, 1, 1, 1, 1, 2, 1, 0, 1],
      [1, 0, 0, 2, 0, 2, 2, 1, 1],
      [1, 0, 1, 0, 1, 0, 0, 0, 0],
      [0, 1, 2, 2, 0, 1, 0, 0, 1],
      [0, 0, 1, 2, 0, 1, 2, 2, 1],
      [0, 0, 2, 1, 1, 0, 2, 2, 0],
      [1, 1, 0, 1, 1, 0, 1, 2, 1],
      [2, 2, 1, 1, 1, 0, 0, 2, 2],
      [2, 2, 0, 1, 1, 1, 2, 2, 1],
      [0, 0, 1, 1, 2, 2, 2, 0, 0],
      [2, 2, 1, 2, 1, 1, 2, 0, 2],
      [2, 1, 1, 2, 2, 1, 0, 0, 1],
      [0, 2, 2, 1, 1, 2, 2, 1, 1],
      [1, 0, 1, 0, 0, 2, 2, 2, 2],
      [1, 2, 0, 2, 2, 0, 1, 2, 1],
      [1, 2, 2, 0, 0, 0, 0, 1, 1],
      [1, 2, 0, 1, 2, 2, 2, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 2, 0, 1, 0, 2],
      [2, 1, 2, 2, 1, 2, 0, 2, 1],
      [2, 2, 0, 1, 2, 2, 0, 0, 2],
      [1, 0, 2, 0, 0, 1, 0, 2, 0],
      [0, 2, 2, 2, 1, 0, 1, 2, 1],
      [2, 0, 1, 2, 0, 1, 1, 0, 0],
      [1, 1, 2, 1, 2, 2, 1, 0, 1],
      [1, 0, 1, 0, 2, 1, 1, 1, 1],
      [0, 2, 2, 0, 2, 2, 1, 1, 2],
      [2, 1, 2, 0, 2, 1, 0, 1, 2],
      [2, 2, 0, 2, 1, 2, 1, 0, 1],
      [1, 2, 1, 1, 0, 2, 1, 2, 0],
      [0, 2, 1, 0, 1, 2, 2, 0, 0],
      [0, 1, 1, 2, 0, 2, 2, 0, 0],
      [1, 2, 0, 2, 0, 1, 2, 0, 2],
      [1, 2, 1, 1, 2, 1, 0, 1, 2],
      [0, 0, 0, 2, 0, 2, 1, 2, 0],
      [2, 1, 2, 0, 1, 0, 2, 0, 1],
      [0, 2, 1, 0, 0, 1, 1, 2, 2],
      [2, 2, 2, 2, 1, 0, 0, 0, 0],
      [1, 2, 2, 2, 0, 2, 1, 0, 1],
      [1, 1, 1, 0, 0, 0, 2, 0, 1],
      [2, 1, 2, 2, 0, 1, 2, 1, 0],
      [0, 2, 0, 0, 0, 2, 0, 2, 1],
      [0, 1, 2, 0, 0, 2, 2, 1, 1],
      [1, 0, 0, 0, 0, 0, 1, 2, 1],
      [2, 0, 0, 2, 1, 0, 1, 1, 0],
      [0, 1, 2, 1, 0, 0, 1, 2, 1],
      [1, 0, 1, 1, 2, 2, 0, 2, 1],
      [0, 2, 1, 1, 1, 0, 1, 1, 0],
      [0, 0, 1, 1, 1, 1, 1, 2, 2],
      [1, 1, 2, 1, 1, 1, 0, 2, 0],
      [0, 1, 1, 0, 0, 0, 1, 1, 0],
      [1, 2, 1, 2, 2, 2, 2, 2, 2],
      [2, 1, 0, 2, 2, 2, 2, 0, 0],
      [1, 1, 0, 1, 0, 2, 0, 1, 0],
      [2, 0, 1, 0, 2, 1, 2, 0, 2],
      [1, 0, 2, 1, 0, 2, 2, 0, 0],
      [1, 2, 0, 2, 1, 2, 0, 1, 0],
      [2, 2, 0, 0, 1, 0, 0, 1, 1],
      [0, 0, 1, 2, 1, 2, 0, 0, 2],
      [0, 1, 1, 1, 2, 0, 2, 1, 2],
      [2, 0, 2, 0, 1, 2, 2, 2, 2],
      [2, 0, 2, 1, 2, 1, 2, 1, 0],
      [0, 2, 0, 2, 0, 1, 1, 1, 1],
      [2, 2, 2, 1, 0, 1, 0, 1, 2],
      [0, 2, 0, 2, 1, 2, 2, 2, 2],
      [0, 1, 0, 0, 0, 1, 0, 1, 2],
      [2, 0, 2, 0, 2, 0, 0, 0, 0],
      [1, 1, 2, 0, 0, 2, 0, 0, 2],
      [2, 0, 0, 1, 0, 1, 1, 2, 2],
      [0, 0, 0, 2, 1, 0, 2, 0, 1],
      [0, 2, 0, 0, 1, 0, 1, 0, 2],
      [0, 0, 1, 1, 0, 0, 0, 1, 1],
      [1, 0, 2, 0, 1, 2, 1, 0, 1],
      [0, 2, 2, 0, 0, 0, 2, 2, 0],
      [2, 1, 0, 1, 0, 2, 1, 0, 1],
      [0, 1, 0, 2, 0, 0, 1, 0, 2],
      [2, 1, 1, 1, 0, 1, 2, 0, 2],
      [1, 0, 0, 2, 2, 1, 1, 0, 0],
      [2, 2, 0, 0, 2, 1, 1, 2, 2],
      [0, 2, 0, 1, 2, 2, 1, 2, 0],
      [2, 1, 0, 0, 1, 2, 0, 0, 2],
      [0, 2, 2, 1, 2, 0, 0, 2, 2],
      [0, 2, 0, 2, 2, 0, 0, 0, 0],
      [2, 1, 2, 1, 0, 0, 0, 0, 0],
      [0, 0, 2, 2, 1, 1, 1, 0, 0],
      [1, 2, 0, 0, 1, 0, 2, 2, 0],
      [1, 0, 1, 1, 0, 0, 1, 0, 2],
      [0, 2, 1, 2, 1, 1, 0, 2, 0],
      [0, 0, 2, 2, 0, 0, 0, 2, 2],
      [2, 0, 1, 1, 1, 1, 0, 0, 1],
      [0, 2, 1, 1, 0, 2, 0, 0, 2],
      [1, 2, 1, 0, 1, 2, 0, 2, 1],
      [2, 0, 2, 2, 1, 1, 0, 1, 2],
      [0, 1, 2, 1, 1, 1, 2, 0, 2],
      [0, 0, 1, 0, 0, 2, 1, 0, 1],
      [0, 1, 0, 0, 2, 0, 2, 0, 1],
      [0, 1, 0, 0, 1, 2, 1, 2, 0],
      [1, 1, 1, 2, 0, 2, 0, 2, 1],
      [0, 0, 0, 1, 1, 2, 0, 2, 1],
      [1, 1, 2, 1, 0, 0, 2, 1, 2],
      [0, 0, 0, 1, 0, 1, 2, 1, 0],
      [2, 1, 2, 1, 2, 2, 2, 2, 2],
      [2, 0, 1, 0, 1, 0, 1, 2, 1],
      [1, 0, 1, 2, 1, 2, 1, 2, 0],
      [1, 1, 1, 2, 1, 0, 1, 0, 2],
      [2, 2, 2, 0, 0, 0, 1, 0, 2],
      [1, 0, 2, 0, 2, 0, 2, 1, 2],
      [0, 2, 1, 1, 2, 1, 2, 2, 1],
      [0, 2, 0, 0, 2, 1, 2, 1, 0],
      [0, 1, 1, 2, 1, 0, 0, 1, 1],
      [2, 0, 0, 0, 2, 2, 1, 0, 1],
      [2, 0, 1, 2, 1, 2, 2, 1, 1],
      [0, 2, 0, 1, 1, 1, 0, 1, 2],
      [0, 2, 0, 1, 0, 0, 2, 0, 1],
      [1, 1, 1, 1, 2, 0, 0, 0, 0],
      [1, 0, 2, 2, 2, 2, 0, 0, 2],
      [0, 1, 0, 2, 1, 1, 2, 1, 0],
      [1, 2, 0, 1, 0, 0, 0, 2, 2],
      [2, 1, 1, 1, 2, 0, 1, 2, 1],
      [0, 1, 0, 1, 1, 0, 0, 0, 0],
      [2, 2, 2, 1, 1, 2, 1, 2, 0],
      [0, 0, 2, 0, 0, 1, 2, 0, 2],
      [2, 2, 1, 2, 0, 0, 1, 2, 1],
      [0, 0, 2, 0, 1, 2, 0, 1, 0],
      [2, 0, 0, 2, 0, 2, 0, 0, 2],
      [0, 0, 0, 2, 2, 1, 0, 1, 2],
      [1, 0, 2, 1, 2, 1, 1, 2, 2],
      [2, 1, 1, 0, 0, 0, 0, 2, 2],
      [1, 0, 2, 1, 1, 0, 0, 1, 1],
      [2, 0, 0, 2, 2, 1, 2, 2, 1],
      [1, 2, 2, 2, 1, 0, 2, 1, 2],
      [1, 1, 0, 1, 2, 1, 2, 0, 2],
      [2, 1, 1, 0, 2, 2, 2, 1, 1],
      [0, 1, 1, 1, 0, 1, 0, 2, 0],
      [1, 0, 1, 2, 2, 0, 2, 0, 1],
      [0, 2, 1, 2, 0, 0, 2, 1, 2],
      [2, 0, 1, 1, 0, 0, 2, 2, 0],
      [1, 0, 1, 1, 1, 1, 2, 1, 0],
      [0, 0, 2, 2, 2, 2, 2, 1, 1],
      [1, 0, 0, 0, 2, 2, 0, 1, 0],
      [2, 2, 1, 0, 1, 2, 1, 1, 2],
      [1, 0, 2, 2, 0, 0, 1, 1, 0],
      [0, 2, 2, 1, 0, 1, 1, 0, 0],
      [0, 0, 2, 0, 2, 0, 1, 2, 1],
      [0, 0, 1, 0, 1, 0, 2, 1, 2],
      [0, 2, 2, 2, 0, 2, 0, 1, 0],
      [0, 0, 1, 2, 2, 0, 1, 1, 0],
      [1, 1, 0, 0, 1, 2, 2, 1, 1],
      [0, 1, 2, 0, 2, 1, 1, 0, 0],
      [1, 1, 2, 2, 1, 2, 2, 0, 0],
      [2, 0, 2, 2, 2, 2, 1, 2, 0],
      [1, 0, 0, 2, 1, 0, 0, 2, 2],
      [2, 2, 1, 1, 0, 2, 2, 1, 1],
      [2, 1, 1, 0, 1, 1, 1, 0, 0],
      [0, 0, 1, 0, 2, 1, 0, 2, 0],
      [1, 2, 2, 1, 1, 2, 0, 0, 2],
      [0, 1, 2, 0, 1, 0, 0, 2, 2],
      [1, 0, 0, 0, 1, 1, 2, 0, 2],
      [2, 1, 0, 0, 2, 0, 1, 1, 0],
      [2, 2, 2, 2, 2, 1, 1, 1, 1],
      [0, 2, 1, 0, 2, 0, 0, 1, 1],
      [2, 2, 1, 0, 0, 1, 0, 0, 1],
      [1, 2, 2, 1, 2, 0, 1, 1, 0],
      [2, 2, 0, 2, 2, 0, 2, 1, 2],
      [1, 2, 2, 1, 0, 1, 2, 2, 1],
      [1, 1, 1, 0, 1, 1, 0, 1, 2],
      [1, 1, 2, 2, 2, 0, 0, 1, 1],
      [2, 2, 2, 1, 2, 0, 2, 0, 1],
      [2, 2, 0, 0, 0, 2, 2, 0, 0],
      [2, 2, 0, 2, 0, 1, 0, 2, 0],
      [1, 1, 0, 2, 2, 2, 1, 1, 2],
      [2, 2, 2, 0, 2, 2, 0, 2, 1],
      [2, 0, 2, 0, 0, 1, 1, 1, 1],
      [2, 1, 0, 1, 2, 1, 0, 2, 0],
      [1, 0, 1, 2, 0, 1, 0, 1, 2],
      [1, 2, 2, 0, 1, 1, 1, 2, 2],
      [1, 0, 0, 1, 0, 1, 0, 0, 1],
      [2, 2, 2, 2, 0, 2, 2, 2, 2],
      [0, 1, 2, 2, 1, 2, 1, 1, 2],
      [2, 2, 1, 2, 2, 2, 0, 1, 0],
      [1, 2, 1, 1, 1, 0, 2, 0, 1],
      [0, 2, 2, 2, 2, 1, 2, 0, 2],
      [2, 1, 0, 2, 1, 1, 1, 2, 2],
      [1, 1, 0, 2, 0, 0, 2, 2, 0],
      [1, 2, 1, 2, 1, 1, 1, 1, 1],
      [1, 1, 0, 2, 1, 1, 0, 0, 1],
      [0, 1, 0, 2, 2, 2, 0, 2, 1],
      [2, 1, 2, 0, 0, 2, 1, 2, 0],
      [0, 0, 0, 0, 2, 2, 2, 2, 2],
    ] as const,
    systemType: 'R',
    systemNum: 56,
    hasXpert: true,
  } as const,
  'U0-10-38': {
    guaranty: undefined,
    numFullHedges: 0,
    numHalfHedges: 10,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 0, 1, 0, 1, 1, 0, 1, 0],
      [0, 0, 1, 1, 1, 0, 0, 1, 0, 1],
      [1, 0, 1, 0, 1, 1, 0, 0, 1, 0],
      [0, 1, 1, 0, 0, 1, 1, 1, 0, 1],
      [0, 1, 0, 0, 1, 0, 1, 0, 1, 1],
      [0, 1, 1, 1, 0, 0, 1, 1, 1, 0],
      [1, 1, 0, 1, 0, 0, 0, 1, 1, 1],
      [1, 0, 0, 1, 1, 0, 1, 1, 1, 0],
      [1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
      [1, 0, 0, 1, 1, 1, 1, 0, 0, 1],
      [1, 0, 1, 1, 0, 1, 1, 1, 0, 0],
      [1, 0, 1, 0, 0, 0, 1, 1, 1, 1],
      [0, 0, 1, 1, 0, 1, 0, 0, 1, 1],
      [0, 1, 0, 0, 1, 1, 0, 1, 1, 0],
      [1, 0, 0, 0, 0, 1, 1, 1, 1, 0],
      [0, 1, 0, 1, 0, 1, 1, 1, 0, 0],
      [0, 1, 1, 0, 1, 1, 1, 0, 1, 0],
      [1, 1, 0, 0, 1, 0, 1, 1, 0, 0],
      [1, 1, 0, 1, 1, 1, 0, 1, 0, 0],
      [0, 0, 0, 1, 1, 1, 0, 1, 1, 1],
      [0, 1, 1, 0, 1, 1, 0, 0, 0, 1],
      [1, 1, 1, 0, 1, 0, 1, 0, 0, 1],
      [0, 1, 1, 1, 0, 0, 1, 0, 0, 1],
      [0, 0, 0, 1, 0, 0, 1, 1, 1, 1],
      [1, 0, 1, 1, 1, 0, 0, 0, 1, 1],
      [1, 1, 0, 0, 0, 1, 1, 0, 0, 1],
      [1, 1, 1, 0, 0, 0, 1, 0, 1, 0],
      [0, 1, 1, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 1, 0, 1, 1, 1, 1, 0, 0],
      [1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
      [1, 1, 1, 1, 0, 1, 0, 0, 0, 1],
      [1, 1, 0, 0, 1, 1, 0, 0, 1, 1],
      [0, 0, 1, 1, 1, 0, 1, 0, 1, 0],
      [1, 1, 1, 0, 1, 0, 0, 1, 1, 0],
      [1, 0, 1, 1, 0, 0, 0, 1, 1, 0],
      [1, 0, 0, 0, 1, 0, 0, 1, 1, 1],
      [0, 1, 0, 1, 1, 0, 1, 1, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 60,
    hasXpert: true,
  } as const,
  'U0-11-65': {
    guaranty: undefined,
    numFullHedges: 0,
    numHalfHedges: 11,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 1],
      [0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0],
      [1, 1, 1, 1, 0, 1, 0, 0, 0, 1, 0],
      [0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0],
      [1, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1],
      [1, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1],
      [0, 1, 1, 1, 1, 0, 0, 0, 1, 0, 1],
      [1, 0, 0, 0, 1, 0, 1, 0, 1, 1, 0],
      [0, 0, 0, 1, 0, 1, 1, 1, 1, 0, 0],
      [0, 1, 1, 0, 0, 0, 0, 1, 0, 1, 1],
      [1, 0, 1, 1, 1, 0, 0, 1, 0, 0, 0],
      [0, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 1],
      [1, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1],
      [1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1],
      [0, 0, 1, 0, 1, 0, 1, 1, 0, 0, 1],
      [1, 1, 0, 0, 0, 1, 0, 1, 1, 1, 0],
      [0, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1],
      [1, 0, 1, 0, 0, 0, 1, 1, 0, 1, 0],
      [0, 0, 1, 1, 0, 0, 1, 0, 1, 1, 1],
      [0, 1, 0, 0, 1, 0, 0, 0, 1, 1, 1],
      [1, 1, 0, 0, 0, 0, 1, 1, 1, 0, 1],
      [1, 1, 0, 1, 1, 0, 1, 0, 0, 0, 0],
      [1, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0],
      [1, 0, 1, 1, 0, 0, 1, 1, 1, 0, 0],
      [1, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0],
      [1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 1, 0, 1, 0, 1],
      [1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1],
      [0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 1],
      [1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1],
      [0, 0, 1, 1, 1, 1, 0, 0, 0, 1, 0],
      [1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 0],
      [1, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1],
      [0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 1],
      [0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 0],
      [1, 1, 1, 0, 1, 0, 0, 0, 1, 1, 0],
      [0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0],
      [0, 1, 0, 0, 1, 1, 1, 0, 1, 0, 1],
      [0, 0, 0, 1, 1, 1, 0, 1, 1, 0, 1],
      [0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 1],
      [1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 0],
      [0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1],
      [1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 0],
      [1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 1],
      [1, 1, 0, 1, 1, 0, 0, 1, 1, 0, 0],
      [0, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0],
      [1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 1],
      [1, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0],
      [0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1],
      [1, 0, 1, 0, 1, 1, 1, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 0, 0, 0, 0, 1, 1],
      [1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0],
      [0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 0],
      [0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 1],
      [1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1],
      [0, 1, 1, 0, 0, 1, 0, 1, 1, 0, 1],
      [1, 0, 0, 0, 1, 1, 0, 1, 0, 1, 0],
      [1, 0, 0, 1, 0, 1, 0, 0, 1, 1, 0],
      [1, 1, 1, 1, 0, 0, 0, 1, 0, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 61,
    hasXpert: true,
  } as const,
  'U0-7-10': {
    guaranty: undefined,
    numFullHedges: 0,
    numHalfHedges: 7,
    rows: [
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 0, 1, 0, 1],
      [1, 1, 0, 1, 0, 0, 0],
      [1, 0, 1, 0, 0, 1, 0],
      [0, 0, 0, 1, 0, 1, 1],
      [0, 1, 0, 0, 1, 1, 0],
      [1, 1, 0, 0, 0, 1, 1],
      [1, 0, 0, 1, 1, 1, 0],
      [0, 1, 1, 1, 0, 0, 1],
      [1, 1, 1, 0, 1, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 59,
    hasXpert: true,
  } as const,
  'U11-0-133': {
    guaranty: undefined,
    numFullHedges: 11,
    numHalfHedges: 0,
    rows: [
      [1, 2, 1, 1, 0, 0, 0, 0, 0, 1, 0],
      [2, 1, 2, 2, 0, 0, 0, 0, 0, 2, 0],
      [0, 1, 2, 1, 1, 0, 0, 0, 0, 0, 1],
      [0, 2, 1, 2, 2, 0, 0, 0, 0, 0, 2],
      [1, 0, 1, 2, 1, 1, 0, 0, 0, 0, 0],
      [2, 0, 2, 1, 2, 2, 0, 0, 0, 0, 0],
      [0, 1, 0, 1, 2, 1, 1, 0, 0, 0, 0],
      [0, 2, 0, 2, 1, 2, 2, 0, 0, 0, 0],
      [0, 0, 1, 0, 1, 2, 1, 1, 0, 0, 0],
      [0, 0, 2, 0, 2, 1, 2, 2, 0, 0, 0],
      [0, 0, 0, 1, 0, 1, 2, 1, 1, 0, 0],
      [0, 0, 0, 2, 0, 2, 1, 2, 2, 0, 0],
      [0, 0, 0, 0, 1, 0, 1, 2, 1, 1, 0],
      [0, 0, 0, 0, 2, 0, 2, 1, 2, 2, 0],
      [0, 0, 0, 0, 0, 1, 0, 1, 2, 1, 1],
      [0, 0, 0, 0, 0, 2, 0, 2, 1, 2, 2],
      [1, 0, 0, 0, 0, 0, 1, 0, 1, 2, 1],
      [2, 0, 0, 0, 0, 0, 2, 0, 2, 1, 2],
      [1, 1, 0, 0, 0, 0, 0, 1, 0, 1, 2],
      [2, 2, 0, 0, 0, 0, 0, 2, 0, 2, 1],
      [2, 1, 1, 0, 0, 0, 0, 0, 1, 0, 1],
      [1, 2, 2, 0, 0, 0, 0, 0, 2, 0, 2],
      [2, 2, 2, 0, 1, 0, 0, 1, 0, 0, 0],
      [1, 1, 1, 0, 2, 0, 0, 2, 0, 0, 0],
      [0, 2, 2, 2, 0, 1, 0, 0, 1, 0, 0],
      [0, 1, 1, 1, 0, 2, 0, 0, 2, 0, 0],
      [0, 0, 2, 2, 2, 0, 1, 0, 0, 1, 0],
      [0, 0, 1, 1, 1, 0, 2, 0, 0, 2, 0],
      [0, 0, 0, 2, 2, 2, 0, 1, 0, 0, 1],
      [0, 0, 0, 1, 1, 1, 0, 2, 0, 0, 2],
      [1, 0, 0, 0, 2, 2, 2, 0, 1, 0, 0],
      [2, 0, 0, 0, 1, 1, 1, 0, 2, 0, 0],
      [0, 1, 0, 0, 0, 2, 2, 2, 0, 1, 0],
      [0, 2, 0, 0, 0, 1, 1, 1, 0, 2, 0],
      [0, 0, 1, 0, 0, 0, 2, 2, 2, 0, 1],
      [0, 0, 2, 0, 0, 0, 1, 1, 1, 0, 2],
      [1, 0, 0, 1, 0, 0, 0, 2, 2, 2, 0],
      [2, 0, 0, 2, 0, 0, 0, 1, 1, 1, 0],
      [0, 1, 0, 0, 1, 0, 0, 0, 2, 2, 2],
      [0, 2, 0, 0, 2, 0, 0, 0, 1, 1, 1],
      [2, 0, 1, 0, 0, 1, 0, 0, 0, 2, 2],
      [1, 0, 2, 0, 0, 2, 0, 0, 0, 1, 1],
      [2, 2, 0, 1, 0, 0, 1, 0, 0, 0, 2],
      [1, 1, 0, 2, 0, 0, 2, 0, 0, 0, 1],
      [1, 1, 2, 0, 0, 1, 2, 0, 0, 0, 0],
      [2, 2, 1, 0, 0, 2, 1, 0, 0, 0, 0],
      [0, 1, 1, 2, 0, 0, 1, 2, 0, 0, 0],
      [0, 2, 2, 1, 0, 0, 2, 1, 0, 0, 0],
      [0, 0, 1, 1, 2, 0, 0, 1, 2, 0, 0],
      [0, 0, 2, 2, 1, 0, 0, 2, 1, 0, 0],
      [0, 0, 0, 1, 1, 2, 0, 0, 1, 2, 0],
      [0, 0, 0, 2, 2, 1, 0, 0, 2, 1, 0],
      [0, 0, 0, 0, 1, 1, 2, 0, 0, 1, 2],
      [0, 0, 0, 0, 2, 2, 1, 0, 0, 2, 1],
      [2, 0, 0, 0, 0, 1, 1, 2, 0, 0, 1],
      [1, 0, 0, 0, 0, 2, 2, 1, 0, 0, 2],
      [1, 2, 0, 0, 0, 0, 1, 1, 2, 0, 0],
      [2, 1, 0, 0, 0, 0, 2, 2, 1, 0, 0],
      [0, 1, 2, 0, 0, 0, 0, 1, 1, 2, 0],
      [0, 2, 1, 0, 0, 0, 0, 2, 2, 1, 0],
      [0, 0, 1, 2, 0, 0, 0, 0, 1, 1, 2],
      [0, 0, 2, 1, 0, 0, 0, 0, 2, 2, 1],
      [2, 0, 0, 1, 2, 0, 0, 0, 0, 1, 1],
      [1, 0, 0, 2, 1, 0, 0, 0, 0, 2, 2],
      [1, 2, 0, 0, 1, 2, 0, 0, 0, 0, 1],
      [2, 1, 0, 0, 2, 1, 0, 0, 0, 0, 2],
      [2, 1, 0, 2, 2, 0, 0, 0, 2, 0, 0],
      [1, 2, 0, 1, 1, 0, 0, 0, 1, 0, 0],
      [0, 2, 1, 0, 2, 2, 0, 0, 0, 2, 0],
      [0, 1, 2, 0, 1, 1, 0, 0, 0, 1, 0],
      [0, 0, 2, 1, 0, 2, 2, 0, 0, 0, 2],
      [0, 0, 1, 2, 0, 1, 1, 0, 0, 0, 1],
      [2, 0, 0, 2, 1, 0, 2, 2, 0, 0, 0],
      [1, 0, 0, 1, 2, 0, 1, 1, 0, 0, 0],
      [0, 2, 0, 0, 2, 1, 0, 2, 2, 0, 0],
      [0, 1, 0, 0, 1, 2, 0, 1, 1, 0, 0],
      [0, 0, 2, 0, 0, 2, 1, 0, 2, 2, 0],
      [0, 0, 1, 0, 0, 1, 2, 0, 1, 1, 0],
      [0, 0, 0, 2, 0, 0, 2, 1, 0, 2, 2],
      [0, 0, 0, 1, 0, 0, 1, 2, 0, 1, 1],
      [2, 0, 0, 0, 2, 0, 0, 2, 1, 0, 2],
      [1, 0, 0, 0, 1, 0, 0, 1, 2, 0, 1],
      [2, 2, 0, 0, 0, 2, 0, 0, 2, 1, 0],
      [1, 1, 0, 0, 0, 1, 0, 0, 1, 2, 0],
      [0, 2, 2, 0, 0, 0, 2, 0, 0, 2, 1],
      [0, 1, 1, 0, 0, 0, 1, 0, 0, 1, 2],
      [1, 0, 2, 2, 0, 0, 0, 2, 0, 0, 2],
      [2, 0, 1, 1, 0, 0, 0, 1, 0, 0, 1],
      [2, 1, 0, 1, 0, 2, 0, 2, 0, 0, 0],
      [1, 2, 0, 2, 0, 1, 0, 1, 0, 0, 0],
      [0, 2, 1, 0, 1, 0, 2, 0, 2, 0, 0],
      [0, 1, 2, 0, 2, 0, 1, 0, 1, 0, 0],
      [0, 0, 2, 1, 0, 1, 0, 2, 0, 2, 0],
      [0, 0, 1, 2, 0, 2, 0, 1, 0, 1, 0],
      [0, 0, 0, 2, 1, 0, 1, 0, 2, 0, 2],
      [0, 0, 0, 1, 2, 0, 2, 0, 1, 0, 1],
      [2, 0, 0, 0, 2, 1, 0, 1, 0, 2, 0],
      [1, 0, 0, 0, 1, 2, 0, 2, 0, 1, 0],
      [0, 2, 0, 0, 0, 2, 1, 0, 1, 0, 2],
      [0, 1, 0, 0, 0, 1, 2, 0, 2, 0, 1],
      [2, 0, 2, 0, 0, 0, 2, 1, 0, 1, 0],
      [1, 0, 1, 0, 0, 0, 1, 2, 0, 2, 0],
      [0, 2, 0, 2, 0, 0, 0, 2, 1, 0, 1],
      [0, 1, 0, 1, 0, 0, 0, 1, 2, 0, 2],
      [1, 0, 2, 0, 2, 0, 0, 0, 2, 1, 0],
      [2, 0, 1, 0, 1, 0, 0, 0, 1, 2, 0],
      [0, 1, 0, 2, 0, 2, 0, 0, 0, 2, 1],
      [0, 2, 0, 1, 0, 1, 0, 0, 0, 1, 2],
      [1, 0, 1, 0, 2, 0, 2, 0, 0, 0, 2],
      [2, 0, 2, 0, 1, 0, 1, 0, 0, 0, 1],
      [1, 1, 0, 0, 1, 0, 1, 0, 0, 2, 0],
      [2, 2, 0, 0, 2, 0, 2, 0, 0, 1, 0],
      [0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 2],
      [0, 2, 2, 0, 0, 2, 0, 2, 0, 0, 1],
      [2, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0],
      [1, 0, 2, 2, 0, 0, 2, 0, 2, 0, 0],
      [0, 2, 0, 1, 1, 0, 0, 1, 0, 1, 0],
      [0, 1, 0, 2, 2, 0, 0, 2, 0, 2, 0],
      [0, 0, 2, 0, 1, 1, 0, 0, 1, 0, 1],
      [0, 0, 1, 0, 2, 2, 0, 0, 2, 0, 2],
      [1, 0, 0, 2, 0, 1, 1, 0, 0, 1, 0],
      [2, 0, 0, 1, 0, 2, 2, 0, 0, 2, 0],
      [0, 1, 0, 0, 2, 0, 1, 1, 0, 0, 1],
      [0, 2, 0, 0, 1, 0, 2, 2, 0, 0, 2],
      [1, 0, 1, 0, 0, 2, 0, 1, 1, 0, 0],
      [2, 0, 2, 0, 0, 1, 0, 2, 2, 0, 0],
      [0, 1, 0, 1, 0, 0, 2, 0, 1, 1, 0],
      [0, 2, 0, 2, 0, 0, 1, 0, 2, 2, 0],
      [0, 0, 1, 0, 1, 0, 0, 2, 0, 1, 1],
      [0, 0, 2, 0, 2, 0, 0, 1, 0, 2, 2],
      [1, 0, 0, 1, 0, 1, 0, 0, 2, 0, 1],
      [2, 0, 0, 2, 0, 2, 0, 0, 1, 0, 2],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 83,
    hasXpert: true,
  } as const,
  'U13-0-105': {
    guaranty: undefined,
    numFullHedges: 13,
    numHalfHedges: 0,
    rows: [
      [0, 0, 0, 0, 0, 1, 2, 0, 0, 0, 0, 0, 2],
      [0, 1, 0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0],
      [0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0],
      [0, 0, 0, 0, 1, 0, 2, 0, 0, 1, 0, 0, 0],
      [0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
      [0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 0, 0, 0, 0, 1, 0, 2, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 2, 0, 0, 0, 0, 2, 0],
      [2, 0, 2, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0],
      [0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0],
      [0, 1, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 2, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 2, 0],
      [0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 2, 0, 0],
      [0, 0, 0, 0, 2, 1, 0, 0, 2, 0, 0, 0, 0],
      [2, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 2, 0, 0, 0, 0, 0, 1, 0, 0, 0, 2, 0],
      [0, 0, 0, 0, 1, 0, 0, 2, 0, 0, 0, 2, 0],
      [1, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0],
      [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 2, 0, 0],
      [0, 2, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 2, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0],
      [1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
      [0, 2, 0, 0, 2, 0, 0, 2, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 2, 0, 0],
      [0, 0, 0, 0, 0, 2, 0, 1, 0, 0, 0, 0, 2],
      [1, 0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 0],
      [1, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2, 0],
      [0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 1, 0, 0],
      [2, 0, 0, 2, 0, 0, 2, 0, 0, 0, 0, 0, 0],
      [1, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2],
      [2, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0],
      [0, 1, 0, 0, 2, 0, 0, 0, 0, 0, 0, 2, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 1],
      [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 2],
      [0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 1, 0],
      [0, 0, 0, 0, 0, 2, 1, 0, 0, 0, 0, 0, 1],
      [0, 2, 2, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0],
      [1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 0, 0, 1, 2, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 2],
      [0, 0, 0, 0, 0, 0, 2, 1, 0, 0, 0, 0, 1],
      [2, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0],
      [2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      [2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2],
      [0, 0, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0],
      [0, 2, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0],
      [0, 1, 0, 2, 0, 0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 2, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0],
      [0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 0, 1, 0, 0, 0, 1, 0],
      [0, 2, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 0, 0, 2, 0, 0, 0, 0, 0, 2, 0],
      [1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 2, 0, 0, 0, 1, 0, 0, 0],
      [0, 2, 1, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 0, 0, 1, 0, 0, 0, 0, 1, 0],
      [0, 0, 2, 0, 0, 0, 1, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 0, 0, 2],
      [0, 0, 0, 0, 1, 2, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 1, 0, 0],
      [0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 1],
      [0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 2, 0, 0],
      [0, 0, 2, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2],
      [0, 0, 0, 0, 0, 0, 0, 0, 2, 1, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 1, 2, 0, 0, 0, 0, 2],
      [0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 2, 1, 0],
      [0, 0, 1, 0, 0, 0, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 1, 0, 0, 0, 2, 0, 0, 0],
      [2, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
      [2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 0],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1],
      [0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 2, 0, 0],
      [2, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0],
      [0, 0, 1, 2, 0, 0, 0, 0, 0, 0, 0, 0, 2],
      [0, 0, 1, 0, 0, 0, 0, 2, 0, 1, 0, 0, 0],
      [1, 0, 2, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 2, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 2, 2],
      [0, 0, 0, 2, 1, 0, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 1, 0, 0, 2, 0, 0, 0],
      [0, 1, 0, 0, 0, 0, 0, 2, 0, 0, 0, 1, 0],
      [0, 2, 0, 1, 0, 0, 0, 0, 0, 2, 0, 0, 0],
      [0, 0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 1, 0, 0],
      [0, 0, 1, 0, 2, 0, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 1, 0, 0, 0, 2, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 2, 0, 0, 0, 0, 1],
      [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 0, 1, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0],
      [0, 0, 0, 1, 2, 0, 0, 0, 0, 0, 0, 0, 2],
    ] as const,
    systemType: 'U',
    systemNum: 84,
    hasXpert: true,
  } as const,
  'U3-6-20': {
    guaranty: undefined,
    numFullHedges: 3,
    numHalfHedges: 6,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 0, 0, 1, 1],
      [0, 1, 1, 1, 0, 1, 1, 0, 0],
      [2, 2, 0, 0, 1, 0, 1, 0, 0],
      [2, 0, 0, 1, 0, 1, 0, 0, 1],
      [2, 2, 1, 1, 0, 0, 0, 1, 0],
      [0, 1, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 2, 1, 1, 0, 1, 0, 1],
      [1, 1, 2, 0, 1, 1, 0, 0, 0],
      [2, 0, 2, 0, 0, 1, 1, 0, 0],
      [0, 2, 0, 0, 1, 1, 0, 1, 1],
      [1, 0, 0, 1, 1, 1, 0, 1, 0],
      [1, 0, 0, 0, 1, 1, 1, 0, 1],
      [1, 2, 0, 1, 0, 0, 1, 0, 1],
      [1, 2, 2, 0, 0, 0, 1, 1, 0],
      [0, 0, 1, 0, 1, 1, 1, 1, 0],
      [2, 1, 2, 0, 0, 0, 0, 0, 1],
      [1, 2, 1, 0, 0, 1, 0, 0, 1],
      [2, 1, 0, 0, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 1, 0, 0, 1, 0],
    ] as const,
    systemType: 'U',
    systemNum: 62,
    hasXpert: true,
  } as const,
  'U3-6-50': {
    guaranty: undefined,
    numFullHedges: 3,
    numHalfHedges: 6,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 1, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 1, 1, 0],
      [2, 2, 2, 0, 0, 0, 0, 1, 1],
      [0, 0, 2, 0, 1, 1, 1, 0, 1],
      [1, 0, 0, 1, 1, 0, 0, 1, 1],
      [0, 1, 1, 1, 0, 1, 0, 0, 1],
      [1, 2, 1, 0, 1, 0, 1, 0, 0],
      [1, 1, 2, 0, 0, 1, 0, 1, 0],
      [2, 2, 0, 0, 0, 1, 1, 0, 1],
      [1, 0, 1, 1, 1, 1, 0, 0, 0],
      [0, 2, 0, 1, 1, 0, 1, 0, 1],
      [2, 1, 2, 0, 0, 0, 1, 0, 0],
      [0, 2, 1, 0, 1, 1, 0, 1, 0],
      [2, 1, 0, 1, 0, 0, 0, 1, 0],
      [0, 1, 2, 1, 1, 0, 0, 0, 0],
      [0, 1, 0, 0, 0, 0, 1, 1, 1],
      [1, 0, 2, 1, 0, 0, 1, 0, 1],
      [2, 2, 2, 1, 0, 1, 0, 0, 0],
      [2, 0, 1, 0, 1, 0, 0, 0, 1],
      [2, 0, 0, 0, 1, 0, 1, 1, 0],
      [1, 1, 0, 1, 0, 1, 1, 0, 0],
      [0, 0, 2, 1, 0, 1, 0, 1, 1],
      [1, 2, 2, 0, 1, 0, 0, 0, 1],
      [0, 0, 0, 0, 1, 1, 0, 1, 1],
      [0, 2, 2, 0, 0, 0, 1, 1, 0],
      [2, 0, 1, 0, 0, 0, 1, 1, 1],
      [2, 0, 1, 0, 0, 1, 0, 1, 0],
      [1, 0, 2, 1, 0, 0, 0, 1, 0],
      [2, 0, 2, 1, 1, 0, 1, 0, 0],
      [0, 1, 0, 0, 1, 1, 1, 1, 0],
      [1, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 1, 0, 1, 0, 0, 1, 0],
      [1, 1, 1, 0, 0, 0, 1, 0, 1],
      [1, 2, 0, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 0, 1, 0, 0, 1, 1],
      [2, 2, 0, 1, 0, 0, 0, 0, 1],
      [0, 2, 1, 1, 0, 0, 0, 1, 1],
      [2, 1, 0, 0, 1, 0, 1, 0, 1],
      [1, 1, 1, 1, 0, 0, 0, 0, 0],
      [2, 0, 0, 1, 1, 1, 0, 0, 1],
      [0, 2, 2, 0, 0, 1, 0, 0, 1],
      [1, 1, 0, 0, 0, 1, 0, 0, 1],
      [0, 0, 2, 1, 0, 1, 1, 0, 0],
      [0, 2, 0, 1, 0, 1, 0, 1, 0],
      [1, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 2, 1, 0, 0, 1, 1, 0, 0],
      [2, 1, 2, 0, 1, 0, 0, 1, 0],
      [2, 0, 0, 1, 0, 1, 1, 1, 0],
      [2, 2, 1, 1, 0, 0, 1, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 63,
    hasXpert: true,
  } as const,
  'U3-7-98': {
    guaranty: undefined,
    numFullHedges: 3,
    numHalfHedges: 7,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 2, 0, 0, 0, 0, 1, 1, 1],
      [2, 0, 1, 1, 1, 0, 1, 0, 0, 0],
      [0, 2, 0, 0, 1, 1, 0, 0, 1, 0],
      [2, 0, 0, 1, 0, 1, 0, 1, 0, 1],
      [1, 2, 1, 0, 0, 1, 1, 1, 0, 0],
      [0, 0, 2, 0, 1, 0, 1, 1, 0, 1],
      [0, 1, 0, 1, 1, 1, 1, 0, 0, 1],
      [2, 1, 0, 1, 0, 0, 1, 1, 1, 0],
      [1, 1, 1, 1, 0, 1, 0, 0, 1, 0],
      [1, 0, 1, 0, 1, 1, 0, 0, 0, 1],
      [0, 2, 2, 1, 0, 0, 1, 0, 1, 1],
      [2, 1, 2, 0, 1, 1, 0, 1, 0, 0],
      [0, 2, 2, 0, 0, 1, 0, 1, 0, 1],
      [2, 0, 2, 1, 0, 0, 0, 0, 1, 0],
      [2, 2, 0, 0, 1, 0, 1, 0, 0, 1],
      [1, 2, 0, 1, 1, 0, 1, 0, 1, 0],
      [2, 1, 1, 0, 0, 0, 0, 0, 0, 1],
      [0, 2, 1, 1, 0, 0, 0, 1, 1, 0],
      [0, 0, 1, 0, 0, 1, 1, 0, 1, 1],
      [1, 0, 0, 1, 1, 0, 0, 1, 1, 1],
      [2, 2, 2, 0, 0, 1, 1, 0, 1, 0],
      [1, 0, 0, 0, 0, 1, 0, 1, 1, 0],
      [1, 1, 1, 1, 1, 0, 0, 1, 0, 0],
      [1, 0, 0, 1, 0, 0, 1, 0, 0, 1],
      [1, 2, 2, 1, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 1, 1, 1, 0],
      [1, 0, 1, 0, 1, 0, 1, 1, 1, 0],
      [0, 0, 2, 1, 1, 1, 0, 0, 1, 1],
      [0, 1, 2, 1, 0, 1, 1, 1, 0, 0],
      [1, 1, 2, 0, 0, 1, 1, 0, 0, 1],
      [0, 1, 2, 0, 1, 0, 1, 0, 1, 0],
      [2, 0, 1, 1, 0, 0, 1, 1, 0, 1],
      [2, 0, 0, 0, 1, 0, 0, 1, 0, 1],
      [2, 1, 0, 0, 0, 1, 0, 1, 1, 1],
      [2, 0, 1, 1, 1, 1, 0, 0, 1, 0],
      [0, 0, 1, 0, 1, 1, 0, 1, 1, 1],
      [1, 1, 2, 0, 1, 0, 0, 0, 0, 0],
      [0, 2, 0, 1, 0, 0, 1, 1, 0, 1],
      [2, 0, 2, 1, 0, 1, 1, 0, 0, 1],
      [0, 1, 0, 0, 1, 0, 0, 0, 1, 1],
      [0, 1, 1, 1, 1, 0, 0, 0, 0, 1],
      [2, 0, 2, 1, 1, 0, 0, 0, 0, 1],
      [2, 0, 2, 0, 1, 0, 0, 1, 1, 0],
      [0, 1, 0, 0, 1, 1, 1, 1, 0, 0],
      [1, 0, 2, 0, 0, 0, 1, 0, 1, 1],
      [2, 2, 1, 0, 1, 0, 0, 0, 1, 1],
      [0, 0, 2, 0, 1, 1, 1, 0, 0, 0],
      [1, 2, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 1, 1, 0, 1, 0, 1, 0, 0],
      [2, 1, 0, 0, 0, 1, 1, 0, 0, 0],
      [2, 2, 0, 1, 1, 0, 0, 1, 0, 0],
      [1, 1, 0, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 2, 1, 0, 0, 1, 1, 1, 0],
      [0, 2, 1, 0, 0, 0, 1, 0, 0, 1],
      [2, 0, 0, 0, 1, 1, 1, 0, 1, 1],
      [1, 2, 1, 0, 0, 0, 0, 1, 0, 1],
      [1, 2, 0, 0, 1, 1, 0, 1, 0, 0],
      [1, 1, 0, 1, 0, 0, 0, 1, 0, 1],
      [2, 2, 1, 1, 0, 0, 1, 0, 1, 0],
      [2, 2, 0, 1, 0, 1, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 0, 0, 0, 1, 1],
      [0, 2, 1, 1, 1, 1, 1, 0, 0, 0],
      [1, 2, 0, 1, 0, 1, 1, 0, 0, 0],
      [2, 2, 0, 1, 0, 0, 0, 1, 1, 1],
      [0, 0, 2, 1, 1, 0, 0, 1, 0, 0],
      [1, 2, 1, 0, 1, 0, 1, 0, 0, 0],
      [1, 0, 0, 1, 1, 0, 1, 1, 0, 0],
      [0, 2, 0, 0, 0, 1, 1, 1, 1, 0],
      [1, 2, 1, 0, 0, 1, 0, 0, 1, 1],
      [1, 1, 2, 1, 0, 0, 1, 0, 0, 0],
      [2, 2, 2, 0, 0, 0, 0, 1, 0, 0],
      [2, 1, 0, 0, 0, 0, 1, 1, 0, 1],
      [1, 0, 2, 0, 1, 1, 0, 0, 1, 0],
      [0, 0, 1, 1, 0, 1, 0, 0, 0, 1],
      [1, 2, 0, 1, 1, 0, 0, 0, 0, 1],
      [2, 0, 2, 0, 0, 1, 0, 0, 1, 1],
      [2, 1, 2, 1, 0, 1, 0, 0, 0, 0],
      [2, 0, 1, 0, 1, 1, 1, 1, 0, 0],
      [2, 0, 1, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 0, 1, 1, 0, 1, 0, 1, 1],
      [0, 1, 0, 1, 0, 1, 0, 1, 1, 0],
      [1, 1, 1, 0, 0, 0, 1, 0, 1, 0],
      [0, 1, 1, 0, 0, 1, 0, 1, 0, 0],
      [2, 2, 1, 0, 0, 1, 0, 0, 0, 0],
      [0, 2, 2, 0, 1, 0, 0, 1, 1, 1],
      [1, 0, 2, 1, 0, 1, 1, 0, 1, 0],
      [1, 0, 0, 0, 0, 1, 1, 1, 0, 1],
      [2, 1, 0, 0, 1, 1, 0, 0, 0, 1],
      [1, 2, 1, 1, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
      [1, 1, 0, 0, 1, 1, 1, 0, 1, 0],
      [0, 1, 2, 0, 0, 1, 0, 0, 1, 0],
      [0, 2, 0, 1, 1, 1, 0, 1, 0, 1],
      [0, 2, 2, 1, 1, 0, 0, 0, 1, 0],
      [0, 2, 1, 0, 1, 0, 0, 1, 0, 0],
      [2, 1, 0, 1, 1, 0, 0, 0, 1, 0],
      [2, 2, 0, 0, 1, 0, 1, 1, 1, 0],
    ] as const,
    systemType: 'U',
    systemNum: 64,
    hasXpert: true,
  } as const,
  'U4-3-66': {
    guaranty: undefined,
    numFullHedges: 4,
    numHalfHedges: 3,
    rows: [
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 1],
      [1, 0, 0, 1, 1, 0, 0],
      [1, 0, 0, 2, 1, 0, 0],
      [2, 0, 0, 1, 1, 0, 0],
      [2, 0, 0, 2, 1, 0, 0],
      [1, 0, 1, 0, 0, 1, 0],
      [1, 0, 2, 0, 0, 1, 0],
      [2, 0, 1, 0, 0, 1, 0],
      [2, 0, 2, 0, 0, 1, 0],
      [1, 1, 0, 0, 0, 0, 1],
      [1, 2, 0, 0, 0, 0, 1],
      [2, 1, 0, 0, 0, 0, 1],
      [2, 2, 0, 0, 0, 0, 1],
      [0, 0, 1, 1, 1, 1, 0],
      [0, 0, 1, 2, 1, 1, 0],
      [0, 0, 2, 1, 1, 1, 0],
      [0, 0, 2, 2, 1, 1, 0],
      [0, 1, 0, 1, 1, 0, 1],
      [0, 1, 0, 2, 1, 0, 1],
      [0, 2, 0, 1, 1, 0, 1],
      [0, 2, 0, 2, 1, 0, 1],
      [0, 1, 1, 0, 0, 1, 1],
      [0, 1, 2, 0, 0, 1, 1],
      [0, 2, 1, 0, 0, 1, 1],
      [0, 2, 2, 0, 0, 1, 1],
      [1, 0, 0, 1, 0, 1, 1],
      [1, 0, 0, 2, 0, 1, 1],
      [2, 0, 0, 1, 0, 1, 1],
      [2, 0, 0, 2, 0, 1, 1],
      [1, 0, 1, 0, 1, 0, 1],
      [1, 0, 2, 0, 1, 0, 1],
      [2, 0, 1, 0, 1, 0, 1],
      [2, 0, 2, 0, 1, 0, 1],
      [1, 1, 0, 0, 1, 1, 0],
      [1, 2, 0, 0, 1, 1, 0],
      [2, 1, 0, 0, 1, 1, 0],
      [2, 2, 0, 0, 1, 1, 0],
      [1, 1, 1, 1, 0, 0, 0],
      [1, 1, 1, 2, 0, 0, 0],
      [1, 1, 2, 1, 0, 0, 0],
      [1, 1, 2, 2, 0, 0, 0],
      [1, 2, 1, 1, 0, 0, 0],
      [1, 2, 1, 2, 0, 0, 0],
      [1, 2, 2, 1, 0, 0, 0],
      [1, 2, 2, 2, 0, 0, 0],
      [2, 1, 1, 1, 0, 0, 0],
      [2, 1, 1, 2, 0, 0, 0],
      [2, 1, 2, 1, 0, 0, 0],
      [2, 1, 2, 2, 0, 0, 0],
      [2, 2, 1, 1, 0, 0, 0],
      [2, 2, 1, 2, 0, 0, 0],
      [2, 2, 2, 1, 0, 0, 0],
      [2, 2, 2, 2, 0, 0, 0],
      [0, 2, 1, 0, 1, 0, 0],
      [0, 2, 2, 0, 1, 0, 0],
      [0, 0, 1, 1, 0, 0, 1],
      [0, 0, 1, 2, 0, 0, 1],
      [0, 0, 2, 1, 0, 0, 1],
      [0, 0, 2, 2, 0, 0, 1],
      [0, 1, 0, 1, 0, 1, 0],
      [0, 1, 0, 2, 0, 1, 0],
      [0, 2, 0, 1, 0, 1, 0],
      [0, 2, 0, 2, 0, 1, 0],
      [0, 1, 1, 0, 1, 0, 0],
      [0, 1, 2, 0, 1, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 65,
    hasXpert: true,
  } as const,
  'U4-4-16': {
    guaranty: undefined,
    numFullHedges: 4,
    numHalfHedges: 4,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 2, 0, 0, 0, 1],
      [0, 1, 2, 1, 1, 1, 1, 0],
      [1, 1, 1, 0, 0, 0, 1, 0],
      [2, 0, 0, 0, 1, 0, 0, 1],
      [2, 0, 2, 2, 0, 1, 0, 0],
      [1, 2, 0, 1, 0, 1, 1, 1],
      [1, 2, 2, 2, 1, 0, 1, 0],
      [1, 2, 1, 0, 1, 1, 0, 1],
      [2, 0, 1, 1, 1, 0, 1, 0],
      [0, 0, 2, 0, 0, 1, 1, 1],
      [1, 1, 2, 1, 0, 0, 0, 1],
      [2, 2, 0, 1, 1, 1, 0, 0],
      [0, 1, 0, 2, 1, 1, 0, 1],
      [1, 0, 0, 0, 1, 1, 1, 0],
      [2, 1, 0, 2, 0, 0, 1, 1],
    ] as const,
    systemType: 'U',
    systemNum: 66,
    hasXpert: true,
  } as const,
  'U4-4-44': {
    guaranty: undefined,
    numFullHedges: 4,
    numHalfHedges: 4,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [2, 0, 0, 2, 0, 1, 1, 0],
      [2, 1, 2, 0, 1, 0, 0, 1],
      [0, 2, 1, 1, 0, 1, 0, 1],
      [0, 0, 1, 1, 1, 0, 1, 0],
      [1, 1, 0, 1, 0, 0, 1, 1],
      [1, 2, 2, 2, 0, 0, 0, 1],
      [1, 2, 0, 0, 1, 1, 0, 1],
      [0, 1, 2, 1, 0, 1, 1, 0],
      [2, 1, 0, 1, 1, 1, 0, 0],
      [2, 1, 1, 0, 0, 0, 1, 0],
      [1, 0, 2, 0, 0, 1, 1, 1],
      [0, 0, 2, 2, 1, 1, 0, 1],
      [1, 2, 2, 0, 1, 0, 1, 0],
      [2, 2, 2, 0, 0, 1, 0, 0],
      [0, 2, 0, 2, 1, 0, 1, 1],
      [1, 1, 1, 2, 1, 0, 0, 0],
      [2, 2, 0, 2, 0, 1, 0, 1],
      [2, 0, 1, 1, 1, 0, 0, 1],
      [2, 2, 0, 1, 0, 0, 0, 0],
      [1, 1, 0, 2, 0, 1, 0, 0],
      [0, 0, 0, 1, 1, 1, 1, 1],
      [0, 0, 1, 2, 0, 1, 1, 1],
      [0, 0, 2, 0, 1, 0, 1, 1],
      [2, 2, 0, 0, 0, 0, 1, 1],
      [1, 0, 1, 0, 0, 1, 0, 0],
      [0, 1, 0, 1, 1, 0, 0, 1],
      [1, 0, 0, 0, 1, 1, 1, 0],
      [1, 2, 1, 1, 0, 0, 1, 0],
      [0, 2, 0, 0, 0, 1, 1, 0],
      [2, 0, 2, 1, 0, 1, 0, 1],
      [1, 1, 2, 0, 1, 1, 0, 0],
      [2, 1, 2, 2, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 1],
      [0, 2, 1, 0, 1, 0, 0, 0],
      [2, 0, 2, 2, 1, 0, 1, 0],
      [0, 1, 1, 0, 1, 1, 1, 0],
      [1, 0, 2, 1, 0, 0, 0, 0],
      [2, 0, 1, 2, 1, 1, 0, 0],
      [0, 1, 2, 2, 0, 0, 1, 1],
      [0, 2, 2, 1, 1, 1, 0, 0],
      [0, 1, 1, 1, 0, 0, 0, 0],
      [1, 0, 0, 2, 1, 0, 0, 1],
      [0, 1, 2, 0, 0, 1, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 67,
    hasXpert: true,
  } as const,
  'U4-5-30': {
    guaranty: undefined,
    numFullHedges: 4,
    numHalfHedges: 5,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 1, 1, 1],
      [0, 1, 0, 1, 1, 0, 1, 1, 1],
      [0, 2, 0, 2, 1, 0, 1, 1, 1],
      [0, 1, 1, 2, 1, 1, 0, 0, 1],
      [0, 2, 2, 1, 1, 1, 0, 0, 1],
      [0, 1, 2, 0, 0, 1, 1, 1, 1],
      [0, 2, 1, 0, 0, 1, 1, 1, 1],
      [0, 0, 1, 2, 1, 1, 1, 1, 0],
      [0, 0, 2, 1, 1, 1, 1, 1, 0],
      [1, 1, 2, 2, 0, 0, 0, 1, 1],
      [1, 2, 2, 1, 0, 0, 0, 1, 1],
      [2, 1, 1, 2, 0, 0, 0, 1, 1],
      [2, 2, 1, 1, 0, 0, 0, 1, 1],
      [1, 1, 2, 0, 1, 0, 1, 1, 0],
      [2, 2, 1, 0, 1, 0, 1, 1, 0],
      [1, 0, 1, 1, 1, 0, 1, 0, 1],
      [2, 0, 2, 2, 1, 0, 1, 0, 1],
      [1, 2, 0, 2, 1, 1, 0, 1, 0],
      [2, 1, 0, 1, 1, 1, 0, 1, 0],
      [1, 0, 1, 0, 1, 1, 0, 1, 1],
      [2, 0, 2, 0, 1, 1, 0, 1, 1],
      [1, 0, 0, 1, 0, 1, 1, 1, 1],
      [2, 0, 0, 2, 0, 1, 1, 1, 1],
      [1, 2, 0, 0, 1, 1, 1, 0, 1],
      [2, 1, 0, 0, 1, 1, 1, 0, 1],
      [1, 1, 1, 2, 0, 1, 1, 0, 0],
      [2, 2, 1, 2, 0, 1, 1, 0, 0],
      [1, 1, 2, 1, 0, 1, 1, 0, 0],
      [2, 2, 2, 1, 0, 1, 1, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 68,
    hasXpert: true,
  } as const,
  'U4-5-68': {
    guaranty: undefined,
    numFullHedges: 4,
    numHalfHedges: 5,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 0, 1],
      [1, 1, 0, 0, 0, 0, 1, 1, 1],
      [2, 2, 1, 2, 0, 0, 0, 1, 0],
      [2, 1, 2, 0, 1, 0, 0, 0, 1],
      [2, 0, 0, 1, 1, 0, 1, 0, 0],
      [0, 1, 1, 2, 0, 1, 1, 0, 0],
      [1, 2, 0, 0, 1, 1, 0, 1, 0],
      [0, 1, 1, 0, 0, 1, 0, 1, 1],
      [1, 0, 0, 2, 0, 1, 0, 1, 1],
      [0, 0, 2, 2, 0, 0, 1, 0, 1],
      [0, 0, 2, 0, 0, 1, 1, 1, 0],
      [1, 0, 2, 2, 1, 0, 0, 0, 0],
      [1, 2, 2, 1, 0, 0, 1, 0, 0],
      [0, 0, 1, 0, 1, 0, 1, 1, 1],
      [2, 0, 1, 0, 0, 1, 1, 0, 1],
      [1, 2, 0, 1, 1, 0, 0, 0, 1],
      [0, 1, 0, 1, 1, 0, 0, 1, 0],
      [2, 0, 2, 1, 0, 0, 0, 1, 1],
      [2, 1, 0, 1, 0, 1, 0, 0, 1],
      [1, 1, 2, 0, 0, 1, 0, 0, 0],
      [1, 1, 1, 0, 1, 0, 1, 0, 0],
      [0, 0, 1, 0, 1, 1, 0, 1, 0],
      [0, 2, 2, 1, 1, 1, 0, 0, 0],
      [0, 1, 2, 2, 0, 0, 1, 1, 0],
      [1, 2, 1, 0, 0, 1, 1, 0, 0],
      [0, 2, 0, 0, 1, 1, 0, 0, 1],
      [1, 1, 0, 2, 1, 1, 0, 0, 0],
      [2, 2, 0, 2, 0, 1, 0, 0, 0],
      [1, 2, 1, 0, 0, 0, 0, 1, 1],
      [2, 2, 2, 0, 0, 0, 1, 1, 0],
      [2, 0, 1, 2, 0, 0, 1, 0, 0],
      [2, 1, 1, 2, 1, 0, 0, 0, 0],
      [0, 1, 2, 0, 0, 1, 1, 0, 1],
      [1, 1, 1, 1, 0, 0, 0, 1, 0],
      [0, 1, 0, 2, 1, 0, 1, 0, 0],
      [1, 1, 1, 2, 0, 0, 0, 0, 1],
      [1, 0, 0, 1, 0, 1, 1, 0, 0],
      [2, 0, 0, 2, 1, 1, 0, 1, 0],
      [2, 2, 0, 0, 0, 0, 1, 0, 1],
      [1, 1, 2, 0, 1, 0, 0, 1, 0],
      [0, 1, 0, 1, 0, 1, 1, 1, 0],
      [0, 0, 1, 2, 0, 0, 0, 1, 1],
      [2, 2, 1, 1, 0, 0, 0, 0, 1],
      [1, 2, 0, 2, 0, 0, 1, 1, 0],
      [1, 0, 0, 0, 1, 0, 1, 1, 0],
      [2, 2, 1, 0, 1, 1, 0, 0, 0],
      [0, 2, 1, 2, 1, 0, 0, 0, 1],
      [0, 2, 0, 2, 0, 1, 1, 0, 1],
      [2, 2, 0, 0, 0, 1, 0, 1, 1],
      [1, 0, 1, 2, 0, 1, 0, 0, 0],
      [0, 0, 2, 2, 1, 1, 1, 0, 0],
      [2, 0, 0, 2, 1, 0, 0, 0, 1],
      [0, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 0, 1, 1, 0, 0, 1, 0, 1],
      [2, 0, 0, 2, 0, 0, 1, 1, 1],
      [0, 2, 1, 1, 0, 0, 1, 1, 0],
      [0, 2, 2, 2, 0, 1, 0, 1, 0],
      [2, 1, 0, 0, 1, 1, 1, 0, 0],
      [0, 2, 2, 0, 1, 0, 1, 0, 0],
      [0, 2, 2, 0, 1, 0, 0, 1, 1],
      [2, 0, 1, 1, 1, 0, 0, 1, 0],
      [1, 0, 2, 1, 0, 1, 0, 0, 1],
      [1, 0, 1, 0, 1, 0, 0, 0, 1],
      [0, 0, 2, 1, 1, 0, 1, 1, 0],
      [0, 2, 0, 1, 0, 0, 0, 1, 1],
      [2, 1, 2, 1, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 1, 1, 1, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 69,
    hasXpert: true,
  } as const,
  'U4-7-200': {
    guaranty: undefined,
    numFullHedges: 4,
    numHalfHedges: 7,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 0, 1, 1, 0, 0, 0, 1, 1, 1, 0],
      [0, 2, 0, 0, 1, 1, 1, 0, 0, 1, 0],
      [1, 1, 2, 2, 0, 0, 1, 0, 0, 0, 1],
      [0, 2, 2, 1, 1, 0, 0, 1, 0, 0, 0],
      [1, 2, 1, 0, 1, 0, 0, 0, 1, 0, 1],
      [2, 1, 0, 2, 0, 1, 0, 0, 1, 0, 0],
      [2, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1],
      [0, 0, 2, 0, 1, 0, 0, 1, 1, 1, 1],
      [0, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1],
      [1, 1, 1, 0, 1, 0, 1, 1, 0, 0, 0],
      [1, 0, 2, 0, 1, 1, 1, 0, 1, 0, 0],
      [2, 2, 0, 1, 1, 0, 1, 0, 1, 0, 0],
      [1, 1, 1, 0, 0, 1, 0, 0, 0, 1, 0],
      [2, 1, 0, 2, 1, 0, 0, 1, 0, 0, 1],
      [2, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1],
      [0, 2, 1, 2, 0, 0, 0, 0, 0, 1, 1],
      [2, 0, 2, 2, 0, 1, 1, 0, 0, 1, 0],
      [0, 2, 2, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 0, 0, 2, 1, 0, 0, 0, 1, 1, 0],
      [2, 0, 2, 1, 1, 0, 1, 0, 0, 0, 1],
      [0, 0, 0, 2, 1, 1, 1, 1, 1, 0, 0],
      [0, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0],
      [1, 2, 2, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 1, 0, 2, 0, 1, 0, 1, 0, 1, 1],
      [2, 0, 1, 0, 0, 1, 0, 0, 1, 1, 1],
      [1, 1, 0, 0, 1, 1, 1, 0, 0, 0, 1],
      [2, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1],
      [1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1],
      [2, 0, 2, 2, 0, 0, 0, 1, 0, 1, 1],
      [2, 1, 2, 0, 0, 0, 0, 0, 1, 1, 0],
      [0, 1, 2, 2, 0, 0, 0, 1, 1, 0, 0],
      [0, 2, 1, 0, 0, 0, 1, 1, 0, 1, 0],
      [2, 2, 0, 1, 0, 1, 0, 1, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 1],
      [1, 1, 0, 1, 1, 0, 0, 1, 1, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 1, 0, 1, 0],
      [2, 0, 2, 0, 0, 1, 0, 1, 1, 0, 0],
      [1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 0],
      [0, 1, 0, 1, 0, 0, 1, 1, 0, 0, 1],
      [0, 0, 1, 2, 0, 1, 0, 1, 1, 0, 1],
      [1, 2, 1, 2, 0, 0, 0, 1, 0, 0, 0],
      [0, 2, 1, 2, 0, 1, 1, 0, 1, 0, 0],
      [0, 1, 2, 0, 1, 0, 1, 0, 1, 0, 1],
      [1, 2, 2, 1, 0, 0, 0, 0, 0, 1, 0],
      [0, 1, 2, 0, 0, 1, 1, 0, 0, 1, 1],
      [2, 0, 0, 0, 1, 0, 1, 1, 1, 1, 0],
      [1, 1, 2, 0, 0, 1, 0, 1, 0, 0, 1],
      [0, 0, 2, 2, 1, 0, 1, 1, 0, 1, 0],
      [2, 1, 1, 1, 0, 1, 0, 0, 0, 0, 1],
      [2, 0, 1, 1, 1, 1, 0, 0, 1, 0, 0],
      [0, 1, 2, 1, 1, 0, 0, 0, 0, 1, 1],
      [1, 2, 0, 0, 1, 0, 0, 1, 0, 1, 0],
      [0, 1, 0, 0, 1, 1, 0, 1, 1, 1, 0],
      [1, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1],
      [2, 0, 1, 2, 0, 0, 1, 0, 1, 0, 1],
      [0, 2, 0, 0, 1, 1, 0, 1, 0, 0, 1],
      [0, 0, 1, 2, 1, 1, 1, 0, 0, 0, 1],
      [2, 1, 1, 2, 1, 0, 0, 0, 0, 1, 0],
      [1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0],
      [1, 1, 1, 0, 0, 0, 1, 0, 1, 1, 0],
      [0, 0, 2, 1, 0, 1, 1, 1, 0, 0, 1],
      [2, 2, 0, 0, 0, 1, 0, 1, 1, 1, 0],
      [2, 1, 2, 0, 1, 1, 0, 0, 0, 1, 0],
      [0, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0],
      [2, 2, 0, 0, 0, 1, 0, 0, 0, 1, 1],
      [1, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0],
      [0, 1, 0, 2, 0, 0, 1, 0, 0, 1, 1],
      [0, 2, 0, 2, 1, 1, 0, 0, 1, 1, 0],
      [0, 1, 1, 1, 0, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 2, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 1, 2, 1, 0, 0, 1, 1, 1, 0],
      [1, 0, 2, 0, 0, 0, 0, 1, 1, 1, 0],
      [1, 2, 0, 2, 0, 0, 1, 0, 1, 0, 0],
      [0, 2, 1, 0, 1, 1, 0, 0, 1, 0, 0],
      [1, 0, 2, 1, 0, 0, 1, 0, 1, 1, 0],
      [1, 0, 2, 1, 0, 1, 0, 0, 0, 0, 1],
      [0, 2, 1, 1, 0, 0, 0, 1, 1, 0, 1],
      [0, 1, 2, 0, 1, 1, 1, 1, 0, 0, 0],
      [1, 0, 0, 2, 0, 0, 1, 1, 0, 0, 1],
      [0, 0, 0, 2, 0, 0, 1, 1, 1, 1, 0],
      [2, 2, 0, 0, 0, 0, 1, 0, 1, 1, 1],
      [1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 0],
      [0, 1, 1, 1, 1, 0, 0, 0, 1, 0, 1],
      [1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0],
      [2, 2, 2, 1, 1, 1, 0, 0, 0, 0, 0],
      [1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0],
      [2, 2, 2, 0, 0, 1, 1, 0, 0, 0, 0],
      [2, 0, 2, 2, 1, 0, 0, 1, 1, 0, 0],
      [0, 2, 1, 2, 1, 0, 1, 0, 0, 1, 0],
      [1, 1, 0, 2, 0, 1, 0, 1, 0, 0, 0],
      [2, 0, 2, 0, 0, 1, 1, 0, 1, 0, 1],
      [0, 2, 1, 2, 1, 1, 0, 1, 0, 0, 0],
      [2, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0],
      [2, 0, 1, 1, 0, 0, 0, 0, 0, 1, 1],
      [1, 1, 2, 0, 0, 0, 0, 0, 1, 0, 1],
      [2, 0, 2, 2, 1, 1, 0, 0, 0, 0, 1],
      [2, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0],
      [2, 1, 0, 1, 0, 0, 0, 0, 1, 1, 1],
      [2, 2, 0, 1, 1, 0, 0, 0, 0, 0, 1],
      [1, 1, 0, 1, 0, 1, 0, 0, 0, 1, 1],
      [0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 1, 0, 0, 1, 1, 1, 0, 0],
      [0, 1, 0, 2, 1, 0, 0, 0, 1, 1, 1],
      [0, 2, 0, 0, 1, 1, 1, 0, 1, 0, 1],
      [0, 0, 2, 1, 1, 1, 1, 0, 0, 1, 0],
      [2, 0, 0, 1, 1, 0, 0, 1, 1, 0, 1],
      [0, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0],
      [1, 0, 2, 2, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 1, 2, 1, 0, 1, 0, 1, 0, 0],
      [0, 2, 2, 2, 1, 0, 0, 0, 1, 0, 1],
      [2, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0],
      [0, 1, 2, 0, 1, 0, 0, 1, 0, 0, 1],
      [0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1],
      [1, 0, 1, 2, 0, 0, 1, 1, 0, 1, 0],
      [1, 2, 1, 1, 0, 0, 0, 0, 1, 0, 0],
      [2, 2, 1, 0, 1, 0, 0, 1, 0, 0, 1],
      [0, 2, 1, 1, 0, 0, 1, 0, 0, 0, 1],
      [1, 2, 1, 2, 0, 1, 0, 0, 0, 0, 1],
      [1, 0, 0, 2, 1, 1, 0, 0, 1, 0, 1],
      [1, 2, 2, 0, 0, 0, 1, 0, 0, 1, 1],
      [2, 2, 2, 0, 1, 0, 1, 1, 0, 0, 0],
      [2, 0, 2, 1, 1, 0, 0, 0, 0, 1, 0],
      [2, 1, 1, 0, 0, 0, 0, 1, 1, 0, 1],
      [2, 0, 2, 1, 0, 0, 0, 0, 1, 0, 1],
      [1, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1],
      [1, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0],
      [0, 2, 0, 0, 0, 1, 1, 1, 1, 0, 0],
      [1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
      [0, 2, 2, 2, 0, 0, 1, 0, 1, 1, 0],
      [0, 2, 0, 2, 1, 0, 0, 1, 0, 1, 1],
      [0, 0, 2, 0, 0, 1, 0, 1, 0, 1, 1],
      [0, 2, 2, 1, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 2, 0, 1, 1, 0, 0, 0, 1, 1],
      [0, 1, 2, 1, 1, 0, 1, 0, 0, 0, 0],
      [0, 1, 1, 2, 0, 0, 0, 1, 0, 0, 1],
      [1, 1, 0, 0, 1, 0, 0, 0, 0, 1, 1],
      [2, 1, 2, 1, 0, 0, 1, 0, 0, 1, 0],
      [0, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1],
      [2, 2, 2, 1, 0, 0, 0, 1, 0, 0, 1],
      [0, 0, 2, 0, 1, 1, 0, 0, 1, 0, 1],
      [1, 0, 0, 2, 1, 1, 1, 0, 0, 1, 0],
      [2, 0, 0, 2, 1, 1, 0, 1, 0, 0, 0],
      [0, 1, 2, 0, 0, 1, 1, 0, 1, 0, 0],
      [0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0],
      [1, 2, 0, 1, 1, 1, 1, 0, 0, 0, 0],
      [1, 0, 1, 2, 1, 1, 0, 0, 0, 0, 0],
      [1, 2, 1, 0, 0, 0, 1, 1, 0, 0, 1],
      [1, 2, 2, 0, 1, 0, 0, 0, 1, 1, 0],
      [2, 1, 0, 2, 0, 0, 1, 1, 0, 1, 0],
      [1, 2, 2, 2, 1, 0, 0, 0, 0, 0, 0],
      [1, 0, 0, 1, 1, 0, 1, 0, 1, 0, 1],
      [0, 2, 0, 1, 1, 0, 1, 0, 0, 1, 1],
      [0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0],
      [0, 0, 0, 0, 1, 1, 1, 1, 0, 1, 1],
      [2, 1, 2, 1, 1, 0, 0, 0, 1, 0, 0],
      [0, 2, 2, 0, 1, 1, 0, 1, 0, 1, 0],
      [0, 2, 0, 2, 1, 0, 0, 1, 1, 0, 0],
      [0, 0, 1, 0, 0, 1, 1, 1, 1, 1, 0],
      [2, 1, 1, 1, 0, 0, 1, 1, 0, 0, 0],
      [1, 1, 2, 0, 0, 0, 1, 1, 0, 1, 0],
      [1, 2, 0, 1, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 2, 2, 0, 0, 0, 0, 1, 1, 1],
      [1, 0, 2, 2, 0, 0, 0, 1, 1, 0, 1],
      [0, 0, 2, 0, 1, 0, 1, 0, 1, 1, 0],
      [1, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1],
      [2, 1, 2, 0, 0, 0, 1, 1, 0, 0, 1],
      [2, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1],
      [1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 1],
      [2, 0, 0, 2, 1, 0, 1, 0, 0, 1, 1],
      [2, 0, 1, 2, 1, 0, 1, 1, 0, 0, 0],
      [0, 1, 1, 0, 1, 0, 0, 1, 1, 0, 0],
      [2, 2, 1, 1, 0, 1, 0, 0, 0, 1, 0],
      [2, 2, 1, 2, 0, 0, 1, 0, 0, 0, 0],
      [1, 2, 0, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 2, 2, 0, 1, 0, 0, 1, 0, 0],
      [2, 2, 2, 2, 0, 0, 0, 0, 1, 0, 0],
      [1, 0, 2, 1, 1, 0, 1, 1, 0, 0, 0],
      [2, 0, 0, 0, 1, 0, 0, 1, 0, 1, 1],
      [2, 2, 0, 2, 0, 0, 0, 1, 1, 0, 1],
      [0, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1],
      [2, 1, 1, 0, 0, 0, 1, 0, 0, 1, 1],
      [0, 2, 2, 2, 0, 1, 0, 0, 0, 1, 0],
      [0, 2, 0, 2, 0, 1, 1, 1, 0, 1, 0],
      [2, 1, 1, 0, 0, 0, 0, 1, 0, 1, 0],
      [0, 2, 2, 2, 0, 0, 1, 1, 0, 0, 1],
      [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1],
      [0, 0, 2, 1, 1, 1, 0, 1, 1, 0, 0],
      [2, 0, 1, 0, 1, 1, 1, 0, 0, 1, 0],
      [0, 1, 0, 2, 0, 1, 1, 0, 1, 0, 1],
      [1, 2, 0, 2, 1, 0, 1, 1, 0, 0, 0],
      [2, 1, 0, 2, 1, 0, 1, 0, 0, 0, 0],
      [2, 1, 1, 0, 1, 1, 0, 1, 0, 0, 0],
      [2, 2, 2, 0, 1, 0, 0, 0, 0, 1, 1],
      [0, 1, 0, 1, 1, 1, 0, 1, 0, 0, 0],
      [2, 0, 1, 2, 0, 1, 0, 1, 0, 1, 0],
      [0, 2, 1, 1, 1, 0, 0, 0, 1, 1, 0],
      [1, 0, 1, 1, 0, 1, 0, 1, 0, 0, 0],
      [2, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1],
      [2, 0, 2, 1, 0, 1, 0, 0, 1, 1, 0],
    ] as const,
    systemType: 'U',
    systemNum: 70,
    hasXpert: true,
  } as const,
  'U5-5-176': {
    guaranty: undefined,
    numFullHedges: 5,
    numHalfHedges: 5,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 0, 1, 1, 1, 0, 0, 1, 0, 0],
      [0, 1, 1, 0, 0, 1, 1, 0, 1, 1],
      [0, 2, 0, 2, 2, 0, 0, 1, 1, 1],
      [0, 1, 2, 2, 2, 1, 0, 0, 0, 0],
      [1, 2, 2, 1, 0, 0, 1, 0, 0, 0],
      [2, 0, 0, 2, 0, 1, 1, 1, 1, 0],
      [2, 1, 0, 2, 1, 0, 1, 0, 0, 1],
      [2, 2, 2, 0, 0, 1, 0, 1, 0, 1],
      [1, 0, 2, 0, 1, 0, 0, 0, 1, 1],
      [1, 0, 1, 0, 0, 0, 1, 1, 0, 1],
      [1, 2, 0, 0, 2, 1, 1, 0, 0, 1],
      [2, 1, 0, 1, 0, 0, 0, 0, 1, 0],
      [1, 0, 1, 1, 2, 1, 0, 0, 1, 0],
      [0, 0, 0, 1, 1, 1, 1, 0, 0, 0],
      [0, 1, 0, 0, 1, 1, 0, 1, 1, 0],
      [0, 0, 2, 1, 2, 0, 1, 1, 1, 0],
      [2, 2, 1, 0, 1, 0, 1, 0, 1, 0],
      [1, 1, 1, 2, 0, 0, 1, 0, 1, 0],
      [0, 0, 0, 0, 1, 0, 1, 1, 1, 1],
      [2, 0, 2, 0, 2, 1, 0, 1, 1, 0],
      [2, 2, 0, 1, 2, 1, 0, 0, 0, 0],
      [1, 0, 2, 0, 0, 1, 1, 0, 1, 0],
      [1, 1, 0, 1, 0, 0, 0, 1, 0, 1],
      [2, 1, 1, 0, 1, 1, 0, 0, 0, 1],
      [0, 0, 2, 2, 0, 1, 0, 1, 1, 1],
      [1, 2, 2, 0, 1, 1, 0, 0, 0, 0],
      [2, 1, 0, 0, 2, 1, 1, 0, 1, 0],
      [0, 0, 1, 0, 2, 1, 1, 1, 0, 0],
      [1, 1, 0, 0, 1, 0, 1, 1, 0, 0],
      [1, 0, 2, 2, 2, 0, 1, 0, 0, 1],
      [1, 1, 0, 2, 0, 1, 0, 0, 1, 1],
      [0, 2, 2, 0, 2, 1, 0, 0, 1, 1],
      [0, 2, 1, 2, 2, 0, 1, 0, 0, 0],
      [2, 0, 0, 0, 2, 0, 0, 1, 0, 1],
      [1, 2, 1, 1, 0, 0, 0, 0, 1, 1],
      [1, 2, 2, 0, 0, 0, 0, 1, 1, 0],
      [0, 2, 1, 2, 0, 1, 0, 0, 1, 0],
      [0, 1, 1, 2, 1, 0, 0, 1, 0, 1],
      [2, 0, 1, 1, 0, 1, 1, 0, 0, 1],
      [0, 2, 2, 2, 0, 0, 1, 0, 1, 1],
      [0, 2, 2, 1, 1, 0, 0, 0, 1, 0],
      [0, 1, 1, 1, 0, 1, 0, 1, 0, 0],
      [0, 2, 0, 1, 0, 1, 1, 1, 0, 1],
      [0, 0, 1, 1, 2, 0, 0, 0, 0, 1],
      [2, 1, 2, 2, 0, 0, 1, 1, 0, 0],
      [0, 1, 2, 0, 2, 0, 1, 1, 0, 1],
      [0, 1, 0, 1, 2, 0, 1, 0, 1, 1],
      [1, 0, 0, 2, 2, 1, 0, 1, 0, 0],
      [0, 2, 0, 2, 1, 1, 0, 0, 0, 1],
      [0, 2, 2, 1, 1, 0, 1, 0, 0, 1],
      [2, 1, 0, 0, 0, 0, 1, 1, 0, 1],
      [0, 1, 0, 2, 2, 0, 1, 1, 1, 0],
      [0, 0, 2, 2, 1, 0, 1, 1, 0, 1],
      [0, 1, 0, 0, 0, 1, 0, 1, 0, 1],
      [1, 2, 1, 0, 1, 0, 0, 1, 0, 0],
      [0, 1, 2, 0, 1, 0, 1, 0, 1, 0],
      [2, 1, 2, 1, 0, 0, 0, 0, 0, 1],
      [0, 0, 1, 2, 1, 0, 1, 1, 1, 0],
      [2, 1, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 2, 1, 0, 2, 0, 1, 0, 1, 1],
      [2, 2, 0, 1, 1, 0, 1, 0, 0, 0],
      [2, 0, 2, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 2, 1, 2, 1, 0, 1, 0, 1],
      [0, 0, 0, 1, 1, 1, 0, 0, 1, 1],
      [0, 2, 0, 2, 1, 0, 1, 1, 0, 0],
      [0, 0, 0, 2, 2, 1, 1, 1, 0, 1],
      [0, 0, 1, 2, 1, 1, 0, 1, 0, 0],
      [2, 0, 2, 0, 1, 1, 1, 0, 0, 1],
      [1, 0, 1, 0, 0, 1, 0, 0, 0, 1],
      [2, 2, 0, 0, 1, 1, 1, 1, 0, 0],
      [2, 0, 0, 0, 0, 1, 0, 0, 1, 1],
      [2, 0, 2, 1, 0, 0, 1, 1, 0, 1],
      [2, 1, 2, 0, 1, 0, 0, 1, 1, 0],
      [2, 1, 1, 1, 2, 0, 1, 0, 0, 0],
      [1, 2, 2, 1, 0, 1, 0, 0, 1, 0],
      [2, 1, 0, 1, 0, 1, 1, 1, 0, 0],
      [0, 1, 2, 1, 1, 0, 0, 1, 0, 0],
      [1, 0, 0, 2, 1, 0, 0, 0, 0, 1],
      [1, 1, 0, 0, 2, 1, 0, 0, 0, 0],
      [0, 2, 0, 0, 2, 1, 0, 1, 0, 0],
      [0, 0, 2, 0, 1, 1, 1, 1, 1, 0],
      [2, 0, 1, 1, 1, 0, 0, 0, 1, 1],
      [1, 0, 0, 0, 2, 1, 0, 1, 1, 1],
      [2, 0, 0, 2, 2, 1, 1, 0, 0, 0],
      [1, 2, 1, 0, 2, 0, 0, 0, 0, 1],
      [1, 1, 0, 1, 0, 0, 1, 1, 1, 0],
      [2, 1, 2, 0, 2, 0, 0, 0, 0, 0],
      [2, 0, 1, 2, 2, 0, 1, 1, 0, 0],
      [2, 2, 0, 0, 1, 0, 0, 1, 1, 1],
      [1, 2, 0, 1, 0, 1, 0, 0, 0, 1],
      [0, 2, 2, 2, 2, 0, 0, 0, 0, 1],
      [0, 2, 0, 1, 2, 1, 1, 0, 1, 0],
      [2, 2, 1, 2, 0, 0, 0, 1, 1, 0],
      [2, 0, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 1, 0, 0, 1, 0, 1, 0, 1, 1],
      [0, 1, 1, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 1, 2, 0, 0, 0, 1, 1, 1],
      [1, 2, 0, 0, 1, 1, 0, 0, 1, 1],
      [1, 0, 0, 1, 2, 0, 1, 1, 0, 0],
      [1, 1, 1, 1, 1, 0, 0, 0, 0, 1],
      [0, 0, 0, 1, 1, 0, 0, 1, 1, 0],
      [2, 2, 0, 2, 0, 0, 0, 0, 0, 1],
      [1, 2, 0, 0, 0, 0, 1, 1, 1, 1],
      [0, 1, 1, 1, 1, 1, 0, 0, 1, 0],
      [2, 2, 2, 0, 2, 0, 1, 1, 0, 0],
      [2, 0, 0, 2, 1, 0, 1, 0, 1, 0],
      [1, 2, 2, 1, 2, 0, 0, 1, 0, 0],
      [2, 0, 1, 0, 2, 0, 1, 0, 0, 1],
      [0, 0, 1, 2, 2, 0, 0, 0, 1, 0],
      [2, 2, 0, 0, 2, 0, 0, 0, 1, 0],
      [0, 1, 0, 2, 1, 0, 0, 0, 1, 0],
      [1, 2, 1, 0, 0, 1, 1, 0, 0, 0],
      [1, 1, 0, 0, 2, 0, 0, 1, 1, 0],
      [1, 1, 2, 2, 2, 0, 0, 0, 1, 0],
      [2, 0, 1, 2, 0, 1, 0, 1, 0, 1],
      [0, 2, 0, 0, 0, 1, 1, 1, 1, 0],
      [0, 2, 2, 2, 0, 1, 1, 1, 0, 0],
      [1, 0, 0, 2, 1, 1, 0, 0, 1, 0],
      [2, 2, 1, 1, 0, 0, 0, 0, 0, 0],
      [1, 1, 2, 0, 1, 0, 0, 1, 0, 1],
      [0, 1, 1, 1, 2, 0, 0, 1, 1, 0],
      [0, 0, 2, 0, 2, 0, 0, 1, 1, 1],
      [0, 2, 1, 0, 0, 0, 0, 1, 1, 1],
      [2, 1, 0, 1, 2, 0, 0, 1, 0, 0],
      [1, 0, 0, 1, 1, 1, 0, 1, 0, 1],
      [1, 2, 0, 2, 1, 0, 0, 1, 1, 0],
      [2, 0, 1, 0, 1, 1, 0, 0, 1, 0],
      [2, 2, 0, 1, 0, 1, 0, 1, 1, 0],
      [2, 1, 2, 0, 0, 0, 1, 0, 1, 1],
      [1, 1, 1, 2, 0, 1, 0, 0, 0, 0],
      [1, 0, 1, 1, 0, 1, 1, 1, 0, 0],
      [2, 2, 2, 0, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 1, 0, 1, 1, 0, 1, 0],
      [1, 1, 1, 0, 1, 0, 0, 0, 1, 0],
      [2, 0, 1, 2, 0, 0, 1, 0, 1, 1],
      [0, 0, 2, 0, 0, 1, 1, 1, 0, 1],
      [0, 1, 0, 1, 1, 0, 1, 1, 0, 1],
      [0, 2, 1, 2, 0, 1, 1, 0, 0, 1],
      [0, 2, 2, 0, 2, 1, 1, 0, 0, 0],
      [1, 1, 1, 2, 2, 0, 0, 1, 0, 0],
      [0, 1, 1, 2, 0, 0, 0, 0, 1, 1],
      [0, 2, 1, 1, 0, 0, 1, 1, 0, 0],
      [1, 0, 2, 2, 1, 1, 1, 0, 0, 0],
      [0, 1, 2, 1, 0, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 1, 1, 1, 1],
      [1, 1, 2, 0, 0, 1, 0, 1, 0, 0],
      [2, 1, 1, 0, 2, 0, 0, 0, 1, 1],
      [0, 0, 2, 2, 2, 0, 0, 1, 0, 0],
      [2, 1, 0, 2, 0, 0, 0, 1, 1, 1],
      [1, 2, 2, 0, 2, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 0, 1, 0, 0, 1, 1],
      [0, 1, 1, 1, 0, 0, 1, 0, 0, 1],
      [0, 2, 1, 0, 1, 0, 1, 1, 0, 1],
      [0, 1, 1, 0, 1, 1, 1, 0, 0, 0],
      [0, 1, 0, 1, 2, 1, 0, 0, 0, 1],
      [2, 0, 0, 2, 2, 0, 0, 1, 1, 0],
      [1, 0, 1, 0, 2, 0, 1, 1, 1, 0],
      [0, 0, 0, 2, 0, 1, 1, 0, 1, 1],
      [1, 2, 0, 2, 0, 1, 1, 0, 1, 0],
      [2, 1, 1, 2, 1, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 0, 1, 0, 0, 0],
      [1, 0, 0, 1, 2, 0, 0, 0, 1, 1],
      [1, 0, 2, 1, 0, 0, 1, 0, 1, 1],
      [2, 0, 2, 2, 2, 0, 0, 0, 1, 1],
      [2, 1, 2, 1, 1, 1, 0, 0, 0, 0],
      [1, 0, 2, 1, 1, 0, 0, 0, 0, 0],
      [0, 0, 2, 2, 2, 1, 1, 0, 1, 0],
      [2, 2, 0, 1, 0, 0, 1, 0, 1, 1],
      [0, 1, 2, 2, 0, 0, 0, 1, 1, 0],
      [2, 2, 2, 2, 1, 0, 0, 1, 0, 0],
      [1, 2, 2, 2, 0, 0, 0, 1, 0, 1],
      [1, 1, 0, 2, 2, 0, 1, 0, 0, 0],
      [0, 0, 1, 0, 1, 1, 0, 1, 1, 1],
      [2, 1, 0, 2, 1, 1, 0, 1, 0, 0],
      [1, 1, 2, 0, 0, 1, 1, 0, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 72,
    hasXpert: true,
  } as const,
  'U5-5-44': {
    guaranty: undefined,
    numFullHedges: 5,
    numHalfHedges: 5,
    rows: [
      [1, 0, 0, 2, 2, 1, 0, 0, 1, 1],
      [0, 1, 2, 0, 2, 0, 1, 1, 0, 1],
      [0, 2, 1, 2, 0, 0, 1, 1, 1, 0],
      [2, 0, 2, 1, 0, 1, 0, 1, 1, 0],
      [2, 2, 0, 0, 1, 1, 1, 0, 0, 1],
      [2, 1, 1, 0, 0, 1, 1, 1, 0, 0],
      [1, 2, 0, 1, 0, 1, 1, 0, 1, 0],
      [1, 0, 2, 0, 1, 1, 0, 1, 0, 1],
      [0, 1, 0, 2, 1, 0, 1, 0, 1, 1],
      [0, 0, 1, 1, 2, 0, 0, 1, 1, 1],
      [2, 0, 0, 1, 1, 1, 0, 0, 1, 1],
      [0, 2, 1, 0, 1, 0, 1, 1, 0, 1],
      [0, 1, 2, 1, 0, 0, 1, 1, 1, 0],
      [1, 0, 1, 2, 0, 1, 0, 1, 1, 0],
      [1, 1, 0, 0, 2, 1, 1, 0, 0, 1],
      [1, 2, 2, 0, 0, 1, 1, 1, 0, 0],
      [2, 1, 0, 2, 0, 1, 1, 0, 1, 0],
      [2, 0, 1, 0, 2, 1, 0, 1, 0, 1],
      [0, 2, 0, 1, 2, 0, 1, 0, 1, 1],
      [0, 0, 2, 2, 1, 0, 0, 1, 1, 1],
      [1, 0, 0, 2, 2, 0, 1, 1, 0, 0],
      [0, 1, 2, 0, 2, 1, 0, 0, 1, 0],
      [0, 2, 1, 2, 0, 1, 0, 0, 0, 1],
      [2, 0, 2, 1, 0, 0, 1, 0, 0, 1],
      [2, 2, 0, 0, 1, 0, 0, 1, 1, 0],
      [2, 1, 1, 0, 0, 0, 0, 0, 1, 1],
      [1, 2, 0, 1, 0, 0, 0, 1, 0, 1],
      [1, 0, 2, 0, 1, 0, 1, 0, 1, 0],
      [0, 1, 0, 2, 1, 1, 0, 1, 0, 0],
      [0, 0, 1, 1, 2, 1, 1, 0, 0, 0],
      [2, 0, 0, 1, 1, 0, 1, 1, 0, 0],
      [0, 2, 1, 0, 1, 1, 0, 0, 1, 0],
      [0, 1, 2, 1, 0, 1, 0, 0, 0, 1],
      [1, 0, 1, 2, 0, 0, 1, 0, 0, 1],
      [1, 1, 0, 0, 2, 0, 0, 1, 1, 0],
      [1, 2, 2, 0, 0, 0, 0, 0, 1, 1],
      [2, 1, 0, 2, 0, 0, 0, 1, 0, 1],
      [2, 0, 1, 0, 2, 0, 1, 0, 1, 0],
      [0, 2, 0, 1, 2, 1, 0, 1, 0, 0],
      [0, 0, 2, 2, 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
      [2, 2, 2, 2, 2, 0, 0, 0, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 71,
    hasXpert: true,
  } as const,
  'U5-6-274': {
    guaranty: undefined,
    numFullHedges: 5,
    numHalfHedges: 6,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 1, 0, 0, 0, 0, 0, 1, 1, 1, 1],
      [0, 2, 1, 2, 2, 1, 1, 0, 0, 0, 0],
      [1, 0, 0, 0, 1, 1, 1, 1, 0, 1, 0],
      [1, 0, 2, 2, 2, 0, 0, 1, 1, 0, 0],
      [1, 1, 1, 1, 0, 1, 0, 0, 0, 0, 1],
      [0, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1],
      [2, 2, 2, 1, 2, 0, 0, 0, 0, 1, 0],
      [0, 1, 1, 0, 1, 0, 1, 1, 0, 0, 1],
      [1, 0, 1, 0, 2, 0, 0, 0, 0, 1, 1],
      [2, 1, 0, 0, 2, 1, 0, 1, 0, 0, 0],
      [0, 2, 1, 0, 0, 1, 0, 1, 0, 1, 0],
      [0, 0, 2, 0, 2, 1, 1, 0, 1, 0, 1],
      [0, 2, 0, 2, 1, 0, 0, 1, 1, 0, 1],
      [0, 0, 0, 2, 0, 1, 1, 1, 1, 0, 0],
      [2, 2, 0, 2, 0, 0, 1, 0, 0, 0, 1],
      [0, 1, 2, 0, 1, 1, 0, 0, 1, 1, 0],
      [2, 0, 2, 1, 0, 0, 1, 0, 1, 0, 0],
      [1, 0, 0, 1, 0, 1, 0, 0, 1, 1, 0],
      [2, 2, 0, 0, 1, 1, 0, 0, 0, 1, 1],
      [1, 1, 0, 2, 1, 0, 1, 0, 1, 0, 0],
      [0, 0, 2, 2, 0, 0, 1, 1, 0, 1, 1],
      [1, 2, 2, 0, 0, 0, 1, 1, 0, 0, 0],
      [2, 0, 2, 2, 1, 1, 0, 0, 0, 0, 0],
      [0, 0, 1, 0, 2, 0, 1, 1, 1, 1, 0],
      [1, 1, 0, 1, 2, 1, 1, 0, 0, 0, 0],
      [0, 2, 0, 1, 2, 0, 1, 0, 1, 0, 0],
      [0, 1, 1, 2, 0, 0, 1, 0, 1, 0, 1],
      [0, 1, 2, 1, 1, 0, 0, 0, 1, 0, 1],
      [1, 1, 0, 0, 0, 1, 1, 1, 0, 0, 1],
      [2, 0, 2, 2, 0, 0, 0, 0, 1, 1, 1],
      [0, 1, 0, 2, 2, 0, 0, 0, 1, 1, 1],
      [0, 1, 2, 2, 2, 0, 1, 0, 0, 1, 0],
      [0, 2, 2, 2, 1, 0, 0, 1, 0, 1, 0],
      [0, 2, 0, 1, 1, 1, 0, 1, 0, 0, 0],
      [1, 0, 1, 2, 1, 0, 1, 0, 0, 0, 1],
      [1, 1, 1, 2, 2, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 1, 1, 1, 0, 0, 0, 1, 1],
      [0, 1, 1, 1, 0, 0, 1, 1, 0, 1, 0],
      [0, 2, 2, 2, 0, 1, 0, 0, 0, 0, 1],
      [1, 2, 1, 0, 0, 1, 1, 0, 1, 0, 0],
      [1, 2, 0, 1, 0, 0, 0, 0, 1, 0, 1],
      [0, 0, 0, 1, 2, 0, 0, 1, 0, 1, 1],
      [0, 1, 2, 2, 2, 0, 0, 1, 0, 0, 1],
      [2, 1, 1, 0, 1, 0, 0, 1, 1, 0, 0],
      [1, 1, 0, 1, 1, 0, 0, 0, 0, 1, 1],
      [0, 2, 0, 1, 0, 1, 1, 0, 0, 1, 1],
      [1, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1],
      [2, 0, 1, 1, 2, 0, 1, 1, 0, 0, 0],
      [2, 0, 1, 2, 0, 1, 0, 1, 0, 0, 1],
      [0, 2, 1, 1, 0, 0, 0, 0, 1, 1, 0],
      [2, 1, 0, 0, 2, 0, 1, 0, 1, 0, 1],
      [2, 2, 1, 0, 1, 0, 1, 0, 0, 0, 0],
      [1, 2, 0, 2, 0, 0, 0, 1, 0, 1, 1],
      [0, 2, 1, 1, 2, 0, 0, 0, 0, 0, 1],
      [1, 0, 2, 2, 0, 1, 0, 1, 0, 1, 0],
      [0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 0],
      [2, 2, 2, 1, 0, 0, 0, 1, 0, 0, 1],
      [2, 2, 2, 0, 0, 1, 1, 0, 0, 1, 0],
      [2, 0, 2, 0, 1, 0, 0, 1, 0, 1, 1],
      [2, 0, 1, 0, 2, 1, 0, 0, 1, 0, 0],
      [0, 1, 1, 1, 0, 1, 0, 1, 1, 0, 0],
      [1, 2, 0, 0, 1, 0, 0, 1, 1, 1, 0],
      [1, 0, 2, 1, 1, 0, 1, 0, 0, 1, 0],
      [2, 1, 2, 0, 0, 1, 0, 0, 1, 0, 1],
      [0, 1, 1, 1, 2, 1, 0, 0, 0, 1, 0],
      [2, 2, 0, 2, 0, 1, 0, 0, 1, 0, 0],
      [2, 1, 1, 0, 0, 0, 1, 0, 1, 1, 0],
      [2, 0, 0, 1, 1, 1, 1, 0, 0, 0, 1],
      [0, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1],
      [1, 2, 0, 0, 2, 0, 1, 0, 0, 1, 0],
      [0, 2, 2, 0, 0, 0, 1, 0, 1, 1, 1],
      [1, 0, 2, 0, 2, 1, 0, 1, 0, 0, 1],
      [0, 2, 2, 0, 2, 1, 0, 1, 1, 0, 0],
      [1, 0, 1, 2, 1, 0, 0, 0, 1, 1, 0],
      [1, 0, 0, 2, 2, 1, 0, 0, 1, 0, 1],
      [2, 0, 1, 1, 0, 0, 1, 0, 0, 1, 1],
      [2, 0, 0, 2, 2, 0, 1, 0, 1, 1, 0],
      [0, 1, 0, 2, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 0, 2, 1, 1, 1, 1, 0, 0, 1],
      [2, 0, 0, 2, 2, 1, 0, 0, 0, 1, 1],
      [1, 1, 1, 0, 0, 0, 1, 0, 0, 0, 1],
      [0, 2, 0, 1, 0, 0, 1, 1, 1, 1, 0],
      [2, 0, 2, 0, 1, 1, 1, 1, 0, 0, 0],
      [2, 2, 0, 1, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 2, 2, 2, 1, 0, 1, 0, 0, 0],
      [0, 0, 2, 1, 1, 0, 1, 1, 1, 0, 0],
      [1, 1, 0, 1, 0, 0, 0, 1, 1, 1, 0],
      [0, 0, 0, 2, 1, 1, 1, 0, 1, 1, 0],
      [2, 0, 0, 2, 1, 0, 0, 0, 1, 0, 1],
      [0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0],
      [1, 0, 0, 0, 2, 0, 1, 1, 0, 1, 1],
      [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0],
      [0, 2, 0, 2, 2, 0, 0, 1, 1, 1, 0],
      [2, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1],
      [0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 1],
      [0, 1, 2, 2, 1, 0, 1, 1, 0, 0, 0],
      [1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0],
      [2, 2, 0, 0, 2, 1, 0, 0, 1, 0, 1],
      [0, 2, 0, 0, 2, 1, 1, 0, 1, 1, 0],
      [2, 1, 1, 2, 0, 0, 0, 0, 0, 0, 1],
      [2, 0, 2, 2, 0, 0, 1, 1, 0, 0, 0],
      [1, 0, 2, 0, 2, 0, 1, 0, 0, 0, 1],
      [1, 0, 2, 0, 0, 1, 0, 0, 1, 1, 1],
      [2, 2, 1, 0, 2, 0, 0, 1, 0, 0, 1],
      [1, 2, 0, 1, 1, 0, 1, 0, 0, 0, 1],
      [2, 0, 1, 0, 1, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 2, 1, 1, 0, 0, 0, 1, 0],
      [0, 2, 0, 0, 0, 1, 0, 1, 1, 0, 1],
      [1, 2, 0, 0, 2, 0, 1, 1, 1, 0, 0],
      [1, 2, 1, 1, 0, 1, 0, 1, 0, 0, 0],
      [0, 1, 2, 0, 0, 1, 1, 0, 1, 0, 0],
      [0, 2, 1, 1, 2, 0, 0, 1, 0, 1, 0],
      [2, 0, 0, 0, 1, 0, 1, 1, 1, 1, 0],
      [1, 0, 1, 0, 1, 1, 0, 1, 0, 0, 0],
      [0, 2, 1, 0, 1, 0, 1, 1, 1, 0, 0],
      [0, 1, 0, 1, 2, 0, 1, 0, 0, 0, 1],
      [0, 1, 0, 2, 2, 1, 0, 0, 0, 0, 1],
      [0, 0, 0, 2, 0, 0, 0, 1, 1, 1, 1],
      [1, 1, 2, 1, 0, 1, 0, 0, 1, 0, 0],
      [0, 1, 0, 1, 2, 0, 0, 1, 1, 0, 1],
      [2, 0, 2, 1, 2, 1, 1, 0, 0, 0, 0],
      [0, 2, 2, 0, 2, 0, 1, 1, 0, 1, 0],
      [0, 1, 0, 2, 1, 1, 0, 1, 0, 1, 0],
      [1, 2, 0, 2, 2, 0, 0, 0, 1, 0, 0],
      [1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0],
      [2, 2, 1, 0, 1, 0, 0, 1, 0, 1, 0],
      [2, 0, 0, 1, 2, 1, 0, 1, 1, 0, 0],
      [0, 1, 2, 0, 2, 1, 0, 1, 0, 1, 0],
      [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1],
      [2, 1, 2, 2, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 2, 1, 1, 1, 0, 1, 0],
      [1, 2, 0, 2, 0, 1, 1, 1, 0, 0, 0],
      [1, 1, 0, 0, 2, 0, 0, 1, 0, 0, 1],
      [0, 1, 2, 0, 0, 0, 1, 1, 1, 1, 0],
      [1, 1, 2, 0, 2, 0, 0, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0],
      [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1],
      [1, 0, 0, 0, 2, 1, 1, 0, 1, 0, 0],
      [2, 2, 0, 0, 0, 1, 0, 1, 1, 1, 0],
      [1, 0, 0, 2, 1, 1, 0, 1, 1, 0, 0],
      [1, 1, 2, 1, 1, 0, 0, 1, 0, 0, 0],
      [2, 1, 0, 1, 2, 0, 0, 0, 1, 0, 0],
      [0, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1],
      [1, 1, 0, 0, 1, 1, 0, 0, 0, 1, 0],
      [2, 1, 0, 0, 2, 1, 0, 0, 1, 1, 0],
      [2, 2, 2, 0, 2, 0, 1, 0, 1, 0, 0],
      [0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 1, 0, 0, 0, 1, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 2, 1, 1, 1, 0, 0, 0],
      [1, 2, 1, 2, 0, 0, 0, 1, 1, 0, 0],
      [1, 2, 2, 2, 0, 0, 0, 0, 0, 1, 0],
      [2, 1, 0, 0, 1, 0, 1, 0, 0, 1, 1],
      [2, 1, 2, 1, 1, 0, 1, 0, 0, 0, 0],
      [2, 0, 2, 0, 1, 0, 0, 0, 1, 1, 0],
      [1, 2, 2, 1, 2, 1, 0, 0, 0, 0, 0],
      [2, 2, 0, 2, 1, 0, 0, 0, 0, 1, 0],
      [1, 0, 0, 2, 0, 0, 1, 0, 0, 1, 1],
      [0, 2, 1, 1, 2, 1, 0, 0, 1, 0, 0],
      [0, 2, 1, 0, 1, 1, 1, 0, 0, 1, 0],
      [1, 0, 2, 0, 2, 1, 1, 0, 0, 1, 0],
      [1, 0, 2, 1, 1, 0, 0, 0, 0, 0, 1],
      [2, 0, 0, 1, 0, 0, 1, 1, 0, 1, 0],
      [2, 0, 2, 0, 0, 1, 1, 0, 0, 0, 1],
      [0, 0, 2, 0, 2, 0, 0, 1, 1, 1, 1],
      [2, 1, 0, 0, 0, 1, 1, 1, 1, 0, 0],
      [1, 1, 2, 0, 0, 0, 0, 1, 0, 1, 1],
      [2, 1, 2, 2, 0, 0, 0, 0, 1, 0, 0],
      [1, 0, 1, 2, 2, 0, 0, 1, 0, 0, 1],
      [1, 2, 2, 2, 1, 0, 1, 0, 0, 0, 0],
      [1, 1, 2, 0, 1, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 2, 1, 0, 1, 1, 0, 1, 0],
      [0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 1],
      [2, 1, 0, 1, 0, 0, 1, 1, 0, 0, 1],
      [2, 2, 2, 2, 0, 1, 0, 1, 0, 0, 0],
      [2, 1, 1, 0, 0, 1, 0, 0, 0, 1, 1],
      [1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1],
      [0, 2, 2, 0, 1, 1, 0, 1, 0, 0, 1],
      [0, 1, 2, 2, 2, 1, 0, 0, 1, 0, 0],
      [0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0],
      [0, 0, 2, 1, 2, 0, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 2, 1, 0, 0, 1, 0, 1],
      [0, 2, 0, 0, 2, 1, 1, 1, 0, 0, 1],
      [0, 2, 2, 0, 1, 0, 0, 0, 0, 1, 1],
      [2, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1],
      [2, 2, 1, 0, 2, 1, 0, 0, 0, 1, 0],
      [0, 2, 1, 2, 0, 0, 1, 0, 0, 1, 0],
      [0, 2, 0, 1, 1, 1, 0, 0, 1, 1, 0],
      [1, 2, 1, 1, 1, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 1, 1, 0, 0, 1, 0, 1, 0],
      [2, 0, 0, 2, 0, 1, 1, 0, 0, 1, 0],
      [0, 2, 0, 2, 0, 1, 1, 0, 1, 0, 1],
      [2, 2, 0, 1, 1, 0, 1, 1, 0, 0, 0],
      [2, 1, 0, 0, 2, 0, 1, 1, 0, 1, 0],
      [0, 0, 1, 1, 0, 1, 0, 0, 1, 1, 1],
      [1, 1, 0, 2, 0, 0, 1, 1, 0, 1, 0],
      [0, 2, 1, 0, 0, 0, 1, 1, 0, 1, 1],
      [2, 0, 0, 2, 2, 0, 1, 1, 0, 0, 1],
      [1, 2, 2, 0, 2, 0, 0, 0, 1, 0, 1],
      [2, 0, 0, 0, 2, 0, 0, 0, 1, 1, 1],
      [1, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 1, 0, 0, 1, 1, 1, 0, 0, 0, 1],
      [2, 2, 2, 2, 1, 0, 0, 0, 0, 0, 1],
      [0, 2, 2, 1, 0, 0, 0, 1, 1, 0, 0],
      [2, 2, 1, 0, 1, 0, 0, 0, 1, 0, 1],
      [0, 0, 1, 2, 1, 0, 0, 1, 1, 0, 0],
      [1, 2, 0, 0, 2, 1, 0, 1, 0, 1, 0],
      [2, 2, 0, 0, 0, 0, 1, 1, 1, 0, 1],
      [2, 0, 1, 2, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 2, 2, 1, 0, 1, 0, 1, 0, 1],
      [1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1],
      [0, 1, 1, 0, 2, 0, 1, 0, 0, 1, 1],
      [2, 2, 1, 0, 0, 1, 1, 1, 0, 0, 0],
      [1, 2, 0, 2, 1, 1, 0, 0, 0, 0, 1],
      [2, 1, 0, 2, 2, 0, 1, 0, 0, 0, 0],
      [2, 2, 2, 1, 1, 0, 0, 0, 1, 0, 0],
      [0, 0, 1, 2, 0, 1, 1, 0, 0, 1, 1],
      [1, 1, 1, 2, 0, 1, 0, 0, 0, 1, 0],
      [2, 0, 1, 0, 0, 0, 0, 1, 1, 0, 1],
      [2, 0, 2, 0, 0, 1, 0, 1, 1, 0, 0],
      [1, 0, 1, 0, 0, 0, 0, 1, 1, 1, 0],
      [2, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0],
      [0, 1, 0, 2, 2, 0, 1, 1, 1, 0, 0],
      [2, 0, 2, 1, 0, 1, 0, 0, 0, 1, 0],
      [0, 2, 0, 2, 2, 1, 0, 0, 0, 1, 0],
      [0, 0, 2, 1, 0, 1, 0, 1, 1, 0, 1],
      [0, 2, 2, 0, 2, 0, 0, 0, 1, 1, 0],
      [0, 0, 0, 0, 1, 1, 0, 1, 0, 1, 1],
      [1, 0, 1, 2, 2, 0, 1, 0, 0, 1, 0],
      [1, 0, 1, 1, 2, 0, 0, 0, 1, 0, 1],
      [2, 0, 1, 2, 2, 0, 0, 1, 0, 1, 0],
      [0, 1, 1, 0, 2, 0, 1, 0, 1, 0, 0],
      [2, 1, 1, 1, 0, 0, 0, 1, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 0, 1, 1, 0, 1],
      [1, 1, 0, 0, 1, 0, 1, 1, 0, 0, 0],
      [0, 0, 2, 0, 0, 1, 1, 1, 0, 1, 0],
      [2, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 0],
      [1, 0, 0, 1, 0, 1, 0, 1, 0, 0, 1],
      [1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0],
      [2, 0, 0, 1, 1, 1, 0, 1, 0, 1, 0],
      [1, 1, 0, 2, 0, 0, 0, 1, 1, 0, 1],
      [0, 0, 2, 2, 2, 0, 0, 0, 0, 1, 1],
      [1, 2, 0, 1, 2, 0, 0, 1, 0, 0, 0],
      [0, 1, 2, 1, 0, 1, 1, 1, 0, 0, 0],
      [2, 2, 0, 1, 0, 0, 0, 0, 0, 1, 1],
      [0, 2, 0, 2, 1, 0, 1, 0, 0, 1, 1],
      [0, 0, 0, 0, 2, 1, 1, 0, 0, 1, 1],
      [0, 2, 2, 1, 1, 1, 1, 0, 0, 0, 0],
      [0, 2, 1, 2, 0, 0, 0, 1, 0, 0, 1],
      [0, 0, 0, 0, 2, 1, 0, 1, 1, 1, 0],
      [0, 2, 2, 1, 0, 0, 1, 0, 0, 0, 1],
      [0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0],
      [2, 0, 1, 1, 2, 0, 0, 0, 1, 1, 0],
      [2, 2, 1, 2, 0, 0, 1, 0, 1, 0, 0],
      [2, 0, 2, 1, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 0, 2, 1, 1, 1, 0, 0, 0, 0],
      [1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 1],
      [0, 0, 1, 1, 2, 1, 0, 1, 0, 0, 1],
      [2, 0, 1, 2, 1, 0, 0, 0, 0, 1, 1],
      [2, 1, 0, 2, 1, 0, 0, 1, 0, 0, 0],
      [0, 1, 1, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0],
      [1, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1],
      [1, 1, 2, 0, 0, 1, 0, 1, 0, 0, 0],
      [1, 0, 2, 2, 0, 1, 1, 0, 1, 0, 0],
      [1, 2, 1, 0, 2, 1, 0, 0, 0, 0, 1],
      [1, 2, 0, 2, 0, 0, 1, 0, 1, 1, 0],
      [0, 1, 2, 0, 0, 1, 1, 0, 0, 1, 1],
      [0, 2, 1, 0, 0, 1, 1, 0, 0, 0, 1],
      [0, 2, 0, 0, 1, 0, 1, 0, 1, 0, 1],
      [2, 1, 2, 1, 2, 0, 0, 0, 0, 0, 1],
      [2, 1, 2, 2, 0, 0, 0, 1, 0, 1, 0],
      [2, 2, 0, 0, 1, 1, 1, 0, 1, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 73,
    hasXpert: true,
  } as const,
  'U6-3-36': {
    guaranty: undefined,
    numFullHedges: 6,
    numHalfHedges: 3,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 2, 1, 1, 0],
      [0, 1, 1, 1, 0, 0, 0, 0, 1],
      [2, 2, 2, 0, 1, 1, 0, 0, 0],
      [1, 0, 0, 2, 0, 1, 1, 0, 1],
      [0, 0, 2, 1, 1, 0, 1, 0, 0],
      [0, 2, 0, 2, 1, 0, 0, 1, 0],
      [2, 0, 1, 1, 0, 2, 0, 1, 0],
      [0, 2, 2, 0, 0, 2, 1, 0, 1],
      [2, 1, 2, 0, 0, 0, 1, 1, 0],
      [1, 1, 0, 1, 2, 1, 0, 0, 0],
      [1, 2, 0, 0, 1, 0, 1, 0, 1],
      [2, 1, 0, 0, 0, 1, 0, 0, 1],
      [0, 2, 1, 1, 0, 1, 1, 0, 0],
      [1, 2, 0, 2, 0, 2, 0, 0, 0],
      [0, 1, 1, 0, 1, 2, 0, 1, 0],
      [1, 2, 2, 1, 0, 0, 0, 1, 0],
      [2, 0, 0, 1, 2, 0, 0, 1, 1],
      [2, 2, 1, 0, 2, 0, 1, 0, 0],
      [0, 0, 0, 2, 0, 2, 0, 1, 1],
      [0, 2, 0, 1, 2, 2, 0, 0, 1],
      [2, 0, 2, 2, 1, 0, 0, 0, 1],
      [1, 0, 0, 0, 1, 1, 0, 1, 0],
      [0, 0, 1, 0, 2, 1, 0, 0, 1],
      [0, 0, 1, 0, 1, 0, 1, 1, 1],
      [1, 0, 1, 2, 2, 0, 0, 1, 0],
      [1, 0, 2, 0, 2, 2, 0, 0, 0],
      [2, 1, 0, 0, 1, 2, 1, 0, 0],
      [0, 0, 2, 1, 2, 1, 0, 1, 0],
      [0, 1, 0, 2, 2, 0, 1, 0, 1],
      [0, 1, 2, 2, 0, 1, 0, 0, 0],
      [0, 1, 2, 0, 2, 0, 0, 1, 1],
      [1, 1, 1, 2, 0, 0, 1, 0, 0],
      [0, 2, 0, 1, 0, 0, 1, 1, 1],
      [2, 0, 2, 2, 0, 2, 1, 0, 0],
      [2, 2, 1, 0, 0, 0, 0, 1, 1],
    ] as const,
    systemType: 'U',
    systemNum: 74,
    hasXpert: true,
  } as const,
  'U6-4-224': {
    guaranty: undefined,
    numFullHedges: 6,
    numHalfHedges: 4,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 1, 1, 2, 0, 0, 1, 0],
      [0, 2, 2, 2, 0, 1, 1, 1, 0, 0],
      [2, 0, 0, 0, 2, 0, 0, 1, 0, 1],
      [2, 1, 2, 0, 1, 0, 1, 0, 1, 0],
      [1, 2, 2, 2, 0, 0, 0, 0, 1, 1],
      [2, 0, 2, 1, 0, 2, 1, 0, 0, 1],
      [0, 1, 0, 0, 0, 2, 1, 1, 1, 1],
      [0, 1, 0, 2, 2, 2, 0, 0, 0, 0],
      [1, 0, 1, 2, 0, 1, 0, 1, 0, 1],
      [0, 1, 1, 1, 1, 0, 0, 1, 0, 1],
      [0, 0, 1, 0, 1, 1, 1, 0, 1, 1],
      [2, 2, 0, 1, 0, 1, 0, 1, 1, 0],
      [1, 1, 2, 0, 2, 1, 0, 0, 0, 1],
      [1, 0, 0, 2, 2, 0, 1, 0, 1, 0],
      [1, 2, 1, 0, 0, 2, 1, 0, 0, 0],
      [0, 0, 2, 0, 1, 2, 0, 1, 0, 0],
      [0, 2, 1, 0, 2, 0, 0, 0, 1, 0],
      [0, 0, 1, 1, 0, 0, 1, 1, 1, 0],
      [0, 2, 2, 0, 1, 2, 0, 0, 1, 1],
      [0, 0, 0, 1, 2, 1, 0, 0, 1, 0],
      [0, 0, 0, 2, 0, 1, 1, 0, 0, 1],
      [2, 1, 0, 1, 1, 2, 1, 0, 0, 0],
      [1, 0, 2, 0, 1, 1, 1, 0, 0, 0],
      [1, 0, 0, 1, 1, 2, 0, 1, 0, 1],
      [1, 2, 0, 1, 2, 0, 1, 0, 0, 1],
      [0, 0, 2, 2, 0, 2, 0, 0, 1, 0],
      [0, 0, 2, 0, 0, 1, 0, 1, 1, 1],
      [2, 1, 1, 1, 0, 2, 0, 1, 0, 0],
      [1, 2, 1, 2, 2, 0, 0, 1, 0, 0],
      [2, 1, 0, 2, 1, 1, 0, 0, 0, 1],
      [1, 2, 1, 0, 1, 0, 0, 0, 0, 1],
      [0, 1, 0, 1, 1, 0, 1, 0, 1, 1],
      [1, 1, 0, 1, 1, 0, 0, 1, 1, 0],
      [0, 0, 2, 1, 2, 0, 1, 1, 0, 1],
      [1, 2, 2, 0, 0, 0, 1, 1, 1, 0],
      [0, 2, 0, 0, 2, 1, 1, 1, 0, 1],
      [2, 0, 1, 0, 2, 2, 0, 1, 1, 0],
      [0, 2, 1, 1, 0, 2, 0, 0, 0, 1],
      [0, 2, 0, 2, 1, 0, 1, 0, 0, 0],
      [2, 0, 0, 2, 0, 0, 1, 1, 0, 0],
      [2, 2, 0, 2, 0, 2, 1, 0, 1, 0],
      [0, 0, 0, 2, 1, 1, 1, 1, 1, 0],
      [1, 1, 0, 0, 2, 2, 1, 1, 0, 0],
      [1, 1, 2, 1, 0, 0, 1, 0, 0, 0],
      [0, 2, 0, 2, 1, 0, 0, 1, 1, 1],
      [2, 1, 1, 0, 0, 0, 0, 1, 1, 1],
      [1, 1, 0, 0, 0, 1, 0, 0, 1, 0],
      [2, 2, 2, 1, 2, 0, 0, 0, 0, 0],
      [2, 0, 1, 2, 1, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 2, 2, 1, 0, 0, 1],
      [2, 2, 1, 2, 0, 0, 1, 0, 0, 1],
      [0, 1, 1, 2, 0, 1, 0, 0, 1, 1],
      [2, 0, 0, 0, 2, 2, 1, 0, 1, 1],
      [0, 1, 1, 0, 1, 1, 1, 1, 0, 0],
      [2, 0, 0, 1, 0, 0, 0, 0, 1, 1],
      [0, 0, 2, 1, 1, 1, 0, 0, 0, 1],
      [1, 2, 2, 2, 1, 2, 0, 0, 0, 0],
      [0, 1, 2, 1, 2, 1, 0, 1, 0, 0],
      [1, 2, 1, 0, 1, 0, 0, 1, 1, 0],
      [1, 0, 2, 1, 0, 2, 0, 1, 0, 0],
      [0, 2, 1, 0, 1, 2, 0, 0, 0, 0],
      [0, 2, 0, 1, 0, 2, 1, 0, 0, 0],
      [0, 1, 2, 1, 2, 2, 0, 0, 0, 1],
      [0, 2, 0, 0, 1, 2, 1, 0, 0, 1],
      [2, 2, 0, 2, 0, 1, 0, 1, 0, 1],
      [2, 0, 2, 0, 0, 0, 0, 1, 1, 0],
      [1, 1, 2, 0, 0, 0, 1, 0, 1, 1],
      [0, 1, 2, 0, 0, 0, 1, 1, 0, 1],
      [2, 1, 2, 2, 2, 0, 0, 0, 1, 0],
      [2, 0, 1, 1, 1, 1, 1, 0, 0, 0],
      [2, 0, 2, 0, 0, 1, 1, 0, 1, 1],
      [0, 2, 2, 2, 1, 0, 0, 0, 0, 1],
      [1, 2, 2, 0, 0, 2, 0, 1, 0, 1],
      [2, 0, 1, 1, 0, 0, 0, 1, 0, 1],
      [1, 0, 1, 2, 2, 0, 0, 0, 1, 1],
      [1, 0, 2, 1, 0, 1, 0, 0, 1, 1],
      [0, 1, 2, 1, 1, 0, 0, 0, 0, 0],
      [1, 0, 1, 1, 1, 0, 1, 1, 0, 0],
      [1, 0, 0, 2, 0, 2, 1, 0, 1, 1],
      [0, 2, 1, 0, 0, 2, 0, 1, 1, 0],
      [2, 0, 2, 0, 1, 1, 0, 1, 0, 1],
      [0, 1, 0, 2, 2, 1, 1, 0, 1, 0],
      [1, 2, 0, 1, 0, 0, 0, 0, 1, 0],
      [1, 0, 0, 1, 0, 1, 1, 1, 0, 1],
      [2, 2, 1, 1, 0, 1, 0, 0, 0, 0],
      [0, 0, 2, 0, 2, 2, 1, 0, 0, 0],
      [0, 1, 1, 0, 2, 1, 0, 1, 1, 0],
      [1, 2, 2, 0, 2, 2, 0, 0, 1, 0],
      [2, 1, 1, 2, 0, 2, 0, 0, 0, 1],
      [2, 1, 1, 0, 2, 0, 0, 1, 0, 0],
      [2, 2, 2, 0, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 1, 2, 0, 1, 1, 0, 0],
      [1, 2, 0, 0, 1, 1, 1, 1, 0, 0],
      [2, 0, 2, 0, 0, 2, 1, 1, 0, 0],
      [2, 1, 0, 1, 2, 2, 0, 0, 1, 0],
      [1, 1, 0, 2, 1, 0, 1, 1, 0, 0],
      [2, 0, 1, 2, 0, 1, 0, 0, 1, 0],
      [0, 0, 1, 2, 2, 1, 1, 0, 0, 0],
      [1, 0, 1, 0, 0, 0, 1, 0, 0, 1],
      [1, 1, 0, 1, 0, 0, 0, 0, 0, 1],
      [1, 1, 1, 1, 2, 2, 0, 0, 0, 0],
      [1, 0, 1, 0, 2, 1, 0, 0, 0, 0],
      [2, 2, 0, 0, 1, 1, 0, 0, 1, 1],
      [0, 0, 0, 1, 0, 2, 0, 1, 1, 0],
      [0, 1, 0, 2, 2, 0, 0, 0, 1, 1],
      [1, 0, 1, 0, 0, 1, 1, 1, 0, 0],
      [2, 0, 2, 2, 0, 1, 1, 0, 0, 0],
      [0, 0, 2, 0, 2, 0, 0, 0, 1, 1],
      [0, 0, 1, 1, 2, 2, 0, 0, 1, 1],
      [0, 0, 2, 2, 1, 0, 0, 1, 1, 0],
      [2, 0, 1, 0, 1, 2, 0, 0, 1, 1],
      [2, 1, 2, 0, 2, 1, 1, 0, 0, 0],
      [2, 1, 1, 0, 0, 1, 1, 0, 1, 0],
      [0, 2, 0, 1, 1, 1, 1, 0, 1, 0],
      [0, 0, 2, 2, 1, 2, 1, 0, 0, 1],
      [0, 1, 2, 0, 2, 0, 1, 1, 1, 0],
      [1, 0, 0, 2, 1, 1, 0, 1, 0, 0],
      [2, 1, 1, 0, 1, 0, 1, 0, 0, 1],
      [1, 0, 1, 0, 2, 2, 1, 0, 1, 0],
      [2, 1, 0, 2, 0, 0, 0, 1, 1, 0],
      [2, 1, 0, 1, 0, 1, 1, 1, 0, 0],
      [0, 2, 2, 0, 2, 1, 1, 0, 1, 0],
      [1, 2, 0, 0, 0, 2, 0, 0, 1, 1],
      [0, 1, 1, 2, 1, 2, 1, 0, 0, 0],
      [2, 2, 2, 0, 2, 2, 0, 1, 0, 0],
      [1, 0, 1, 2, 0, 2, 0, 0, 0, 0],
      [2, 1, 2, 0, 0, 2, 0, 0, 1, 0],
      [2, 2, 0, 1, 2, 0, 1, 1, 0, 0],
      [0, 2, 2, 1, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 2, 2, 0, 1, 0, 1],
      [1, 0, 1, 0, 2, 2, 0, 1, 0, 1],
      [1, 1, 2, 2, 0, 1, 0, 0, 0, 0],
      [0, 1, 2, 2, 0, 1, 0, 1, 1, 0],
      [0, 0, 0, 1, 1, 2, 1, 1, 0, 0],
      [2, 0, 2, 2, 2, 2, 0, 0, 0, 1],
      [0, 1, 1, 0, 0, 2, 0, 1, 0, 1],
      [1, 1, 0, 2, 2, 0, 0, 1, 0, 1],
      [1, 0, 0, 0, 0, 0, 1, 1, 1, 1],
      [1, 1, 0, 0, 1, 1, 0, 1, 0, 1],
      [2, 0, 1, 0, 1, 0, 1, 1, 1, 0],
      [1, 2, 0, 1, 2, 2, 0, 1, 0, 0],
      [1, 2, 2, 0, 2, 0, 1, 0, 0, 0],
      [0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
      [2, 2, 0, 1, 2, 1, 0, 0, 0, 1],
      [2, 2, 2, 0, 1, 0, 1, 1, 0, 0],
      [2, 2, 0, 0, 0, 0, 1, 0, 1, 1],
      [0, 0, 0, 1, 2, 2, 1, 0, 0, 1],
      [2, 1, 0, 2, 2, 1, 0, 1, 0, 0],
      [1, 0, 0, 0, 2, 1, 1, 1, 1, 0],
      [1, 0, 2, 2, 1, 1, 0, 0, 1, 0],
      [0, 0, 1, 2, 0, 0, 1, 0, 1, 1],
      [0, 2, 1, 0, 0, 1, 1, 0, 0, 1],
      [0, 1, 1, 0, 1, 1, 0, 0, 0, 1],
      [1, 0, 0, 2, 1, 2, 1, 0, 0, 0],
      [2, 2, 1, 0, 2, 2, 0, 0, 0, 1],
      [0, 2, 0, 2, 1, 2, 0, 1, 0, 0],
      [1, 0, 1, 1, 2, 0, 0, 1, 1, 0],
      [1, 2, 0, 2, 0, 2, 1, 1, 0, 0],
      [0, 0, 1, 1, 0, 1, 0, 1, 0, 0],
      [1, 1, 0, 2, 1, 2, 0, 0, 1, 0],
      [1, 2, 0, 0, 2, 0, 0, 1, 1, 1],
      [0, 2, 1, 1, 1, 0, 0, 0, 1, 1],
      [2, 0, 0, 2, 2, 0, 1, 0, 0, 1],
      [1, 0, 0, 2, 2, 2, 0, 1, 1, 0],
      [1, 1, 2, 0, 0, 0, 0, 1, 0, 0],
      [2, 1, 0, 0, 0, 1, 1, 0, 0, 1],
      [0, 2, 0, 2, 2, 0, 1, 1, 1, 0],
      [0, 2, 0, 1, 0, 0, 1, 1, 1, 1],
      [1, 0, 0, 0, 2, 1, 0, 0, 1, 1],
      [0, 2, 2, 0, 1, 1, 0, 1, 1, 0],
      [0, 2, 0, 0, 1, 2, 1, 1, 1, 0],
      [0, 2, 1, 2, 0, 0, 0, 1, 0, 1],
      [1, 2, 0, 2, 2, 2, 0, 0, 0, 1],
      [1, 0, 2, 2, 2, 0, 0, 0, 0, 0],
      [0, 2, 2, 2, 2, 1, 0, 0, 0, 0],
      [1, 2, 0, 1, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 1, 0, 1, 1, 0, 1],
      [1, 1, 0, 1, 2, 1, 1, 0, 0, 0],
      [2, 1, 1, 1, 0, 0, 0, 0, 1, 0],
      [0, 2, 2, 1, 0, 0, 1, 0, 0, 1],
      [1, 0, 2, 1, 1, 0, 1, 0, 0, 1],
      [1, 0, 1, 1, 0, 1, 1, 0, 1, 0],
      [1, 0, 2, 0, 1, 0, 0, 1, 1, 1],
      [0, 0, 1, 2, 0, 2, 1, 1, 0, 0],
      [0, 1, 0, 1, 0, 2, 0, 0, 1, 1],
      [2, 0, 0, 0, 0, 2, 0, 1, 1, 1],
      [0, 2, 1, 0, 2, 2, 1, 1, 0, 0],
      [0, 2, 2, 2, 0, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 0, 2, 1, 0, 1, 0],
      [1, 0, 0, 2, 1, 0, 0, 0, 0, 1],
      [0, 2, 0, 1, 2, 0, 0, 1, 0, 1],
      [2, 2, 0, 2, 2, 1, 1, 0, 0, 0],
      [2, 1, 1, 2, 2, 0, 1, 0, 0, 0],
      [2, 0, 0, 1, 1, 0, 1, 0, 1, 0],
      [0, 1, 1, 2, 1, 0, 0, 0, 1, 0],
      [0, 0, 2, 1, 2, 0, 1, 0, 1, 0],
      [2, 2, 0, 0, 1, 2, 0, 1, 0, 1],
      [2, 0, 1, 0, 2, 1, 1, 0, 0, 1],
      [1, 0, 2, 2, 0, 0, 1, 1, 0, 1],
      [0, 0, 1, 0, 2, 0, 1, 1, 1, 1],
      [2, 1, 2, 2, 0, 0, 0, 1, 0, 1],
      [2, 2, 1, 1, 1, 0, 0, 1, 0, 0],
      [1, 0, 2, 0, 1, 2, 0, 0, 0, 1],
      [0, 2, 1, 0, 1, 0, 1, 1, 0, 1],
      [2, 2, 0, 2, 1, 0, 0, 0, 1, 0],
      [0, 0, 0, 1, 1, 1, 0, 1, 1, 1],
      [2, 1, 1, 1, 2, 0, 0, 0, 0, 1],
      [0, 2, 0, 2, 0, 1, 0, 0, 1, 0],
      [2, 1, 0, 0, 1, 2, 0, 1, 1, 0],
      [1, 1, 0, 0, 1, 0, 0, 0, 1, 1],
      [0, 0, 0, 2, 1, 2, 0, 0, 1, 1],
      [2, 0, 2, 0, 2, 1, 0, 0, 1, 0],
      [1, 1, 1, 0, 1, 2, 0, 1, 0, 0],
      [1, 1, 1, 2, 0, 0, 1, 0, 1, 0],
      [1, 2, 0, 0, 1, 0, 1, 0, 1, 0],
      [0, 1, 1, 1, 0, 1, 1, 0, 0, 0],
      [0, 1, 2, 1, 0, 0, 0, 1, 1, 1],
      [0, 1, 2, 2, 2, 0, 1, 0, 0, 1],
      [0, 0, 1, 2, 0, 2, 0, 1, 1, 1],
      [2, 1, 2, 1, 0, 1, 0, 0, 0, 1],
      [2, 0, 2, 1, 1, 2, 0, 0, 0, 0],
      [2, 0, 2, 2, 1, 0, 0, 0, 1, 1],
      [2, 2, 2, 0, 0, 0, 0, 0, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 76,
    hasXpert: true,
  } as const,
  'U6-4-66': {
    guaranty: undefined,
    numFullHedges: 6,
    numHalfHedges: 4,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 2, 0, 2, 0, 1, 1, 0, 0],
      [2, 2, 1, 2, 0, 1, 0, 0, 1, 0],
      [0, 1, 0, 1, 1, 2, 0, 0, 0, 1],
      [0, 0, 0, 2, 0, 0, 1, 1, 1, 1],
      [2, 0, 1, 0, 0, 2, 1, 0, 0, 1],
      [1, 0, 2, 2, 2, 1, 0, 0, 0, 1],
      [2, 0, 2, 1, 1, 0, 1, 0, 1, 0],
      [0, 2, 2, 0, 1, 2, 0, 1, 1, 0],
      [1, 2, 1, 1, 2, 0, 0, 0, 0, 0],
      [0, 0, 2, 1, 0, 1, 1, 1, 0, 0],
      [0, 1, 2, 1, 2, 1, 0, 0, 1, 0],
      [1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 1, 0, 1, 1, 0, 0, 1, 1, 0],
      [2, 2, 0, 2, 0, 2, 1, 1, 0, 0],
      [1, 2, 0, 2, 1, 0, 1, 0, 0, 1],
      [1, 2, 0, 0, 2, 2, 0, 0, 1, 1],
      [0, 1, 1, 2, 0, 1, 0, 1, 0, 1],
      [0, 2, 2, 0, 0, 1, 1, 0, 1, 1],
      [2, 2, 2, 1, 0, 0, 0, 1, 0, 1],
      [0, 1, 1, 2, 2, 2, 1, 0, 0, 0],
      [2, 0, 0, 0, 2, 1, 0, 1, 0, 0],
      [0, 2, 0, 1, 2, 1, 1, 0, 0, 1],
      [0, 2, 0, 0, 2, 0, 1, 1, 1, 0],
      [0, 2, 2, 2, 1, 1, 1, 0, 0, 0],
      [1, 1, 0, 0, 1, 2, 1, 0, 0, 0],
      [0, 2, 0, 2, 1, 0, 0, 1, 0, 0],
      [2, 0, 1, 2, 1, 2, 0, 0, 0, 0],
      [1, 1, 2, 0, 0, 1, 0, 0, 0, 0],
      [2, 1, 0, 0, 0, 2, 0, 1, 1, 0],
      [2, 0, 0, 1, 2, 0, 0, 1, 1, 1],
      [1, 0, 2, 2, 0, 2, 1, 0, 0, 0],
      [0, 1, 1, 0, 1, 0, 0, 0, 1, 1],
      [2, 1, 0, 2, 2, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 1, 1, 1, 0, 1, 1],
      [0, 0, 1, 0, 1, 2, 1, 0, 1, 0],
      [0, 0, 1, 2, 2, 0, 0, 0, 1, 0],
      [0, 0, 1, 1, 0, 2, 0, 1, 1, 1],
      [0, 0, 2, 0, 2, 2, 0, 0, 0, 0],
      [1, 2, 2, 2, 1, 0, 0, 0, 1, 0],
      [0, 1, 0, 0, 2, 2, 1, 1, 0, 1],
      [0, 1, 0, 1, 0, 0, 1, 0, 1, 0],
      [2, 0, 2, 2, 0, 2, 0, 0, 1, 1],
      [1, 2, 0, 0, 0, 1, 0, 1, 0, 1],
      [0, 1, 1, 0, 1, 1, 1, 1, 0, 0],
      [1, 0, 0, 1, 0, 1, 0, 0, 1, 0],
      [1, 2, 1, 0, 0, 0, 0, 1, 1, 0],
      [2, 0, 0, 2, 2, 1, 1, 0, 1, 0],
      [2, 2, 2, 0, 1, 1, 0, 0, 0, 1],
      [2, 0, 1, 0, 0, 1, 1, 1, 1, 0],
      [0, 2, 2, 0, 1, 0, 1, 1, 0, 1],
      [1, 0, 1, 1, 0, 0, 1, 0, 1, 1],
      [2, 0, 1, 1, 2, 0, 1, 1, 0, 0],
      [1, 0, 0, 2, 2, 2, 0, 1, 1, 0],
      [1, 0, 0, 2, 1, 1, 1, 1, 0, 0],
      [0, 0, 2, 0, 2, 1, 0, 1, 1, 1],
      [2, 2, 1, 0, 2, 1, 1, 0, 0, 0],
      [0, 0, 2, 2, 1, 2, 0, 1, 0, 1],
      [1, 2, 1, 2, 0, 2, 0, 0, 0, 1],
      [2, 0, 2, 0, 1, 2, 1, 1, 0, 0],
      [1, 0, 0, 1, 0, 2, 1, 1, 0, 1],
      [2, 2, 0, 1, 1, 2, 0, 0, 1, 0],
      [0, 1, 2, 2, 0, 0, 0, 1, 1, 0],
      [0, 1, 2, 2, 0, 0, 1, 0, 0, 1],
      [1, 1, 1, 1, 0, 2, 0, 1, 0, 0],
      [0, 2, 0, 2, 1, 1, 0, 0, 1, 1],
    ] as const,
    systemType: 'U',
    systemNum: 75,
    hasXpert: true,
  } as const,
  'U7-3-100': {
    guaranty: undefined,
    numFullHedges: 7,
    numHalfHedges: 3,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 2, 1, 1, 0, 1, 1, 1, 1],
      [0, 2, 0, 2, 2, 1, 2, 0, 1, 0],
      [2, 1, 0, 0, 1, 1, 2, 1, 0, 1],
      [2, 0, 2, 1, 0, 0, 2, 0, 0, 0],
      [2, 2, 1, 1, 2, 0, 0, 0, 1, 1],
      [2, 1, 1, 2, 2, 0, 1, 1, 0, 0],
      [0, 2, 1, 1, 0, 2, 2, 1, 0, 1],
      [1, 2, 0, 2, 1, 2, 1, 0, 0, 1],
      [1, 0, 2, 2, 0, 1, 0, 1, 0, 1],
      [1, 0, 2, 0, 2, 2, 2, 0, 1, 1],
      [2, 2, 2, 0, 0, 2, 1, 1, 1, 0],
      [0, 0, 1, 0, 0, 1, 2, 1, 1, 0],
      [1, 1, 2, 2, 1, 0, 2, 0, 1, 0],
      [0, 2, 0, 1, 2, 0, 0, 1, 0, 0],
      [0, 1, 1, 1, 1, 2, 1, 0, 1, 0],
      [2, 1, 0, 2, 0, 0, 1, 0, 1, 1],
      [1, 1, 1, 0, 1, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 1, 1, 0, 0, 1, 1],
      [0, 1, 2, 0, 2, 0, 1, 0, 0, 1],
      [2, 0, 0, 1, 0, 2, 0, 1, 1, 1],
      [2, 1, 2, 1, 1, 2, 0, 0, 0, 1],
      [1, 0, 0, 0, 2, 1, 1, 0, 0, 0],
      [1, 2, 1, 0, 0, 1, 1, 0, 1, 1],
      [1, 1, 0, 2, 2, 2, 0, 1, 1, 0],
      [0, 0, 1, 2, 1, 0, 2, 0, 0, 1],
      [1, 0, 0, 1, 1, 2, 2, 1, 0, 0],
      [0, 2, 2, 2, 1, 1, 1, 1, 0, 0],
      [2, 1, 0, 1, 0, 1, 0, 0, 0, 0],
      [2, 0, 0, 1, 2, 1, 1, 0, 1, 1],
      [0, 0, 1, 2, 2, 2, 1, 0, 0, 0],
      [2, 0, 2, 0, 1, 0, 1, 0, 1, 0],
      [0, 1, 2, 0, 2, 2, 0, 1, 0, 0],
      [2, 2, 1, 2, 0, 2, 2, 0, 0, 0],
      [2, 0, 1, 0, 1, 2, 1, 1, 0, 1],
      [2, 2, 2, 2, 1, 1, 0, 0, 1, 0],
      [0, 2, 2, 2, 0, 2, 0, 1, 1, 1],
      [2, 0, 0, 0, 2, 2, 0, 0, 1, 0],
      [1, 2, 2, 1, 2, 2, 0, 0, 0, 0],
      [2, 2, 1, 0, 0, 0, 0, 1, 0, 1],
      [0, 0, 2, 1, 2, 1, 2, 1, 0, 0],
      [2, 2, 0, 2, 2, 2, 0, 1, 0, 1],
      [1, 2, 0, 1, 0, 2, 2, 0, 1, 0],
      [2, 2, 0, 0, 2, 0, 2, 1, 1, 1],
      [1, 0, 1, 1, 2, 0, 0, 1, 0, 1],
      [1, 2, 0, 1, 1, 1, 0, 1, 1, 0],
      [2, 0, 0, 2, 0, 1, 1, 1, 0, 0],
      [2, 0, 2, 1, 2, 0, 0, 1, 1, 0],
      [1, 1, 2, 0, 1, 0, 1, 1, 0, 0],
      [1, 0, 1, 1, 1, 1, 0, 0, 0, 0],
      [0, 1, 2, 0, 1, 1, 2, 0, 0, 0],
      [2, 2, 1, 1, 2, 1, 1, 0, 0, 0],
      [2, 0, 2, 0, 0, 1, 1, 0, 0, 1],
      [1, 1, 0, 0, 0, 2, 2, 1, 1, 1],
      [1, 1, 0, 2, 0, 1, 2, 0, 0, 1],
      [1, 0, 1, 2, 0, 0, 0, 1, 1, 0],
      [0, 1, 0, 2, 2, 1, 1, 1, 0, 1],
      [0, 1, 0, 1, 2, 2, 2, 0, 0, 1],
      [0, 2, 2, 1, 0, 0, 2, 0, 1, 1],
      [1, 2, 2, 0, 0, 0, 0, 0, 1, 0],
      [0, 1, 1, 1, 2, 1, 0, 1, 1, 0],
      [0, 0, 0, 1, 2, 2, 1, 1, 1, 0],
      [0, 0, 1, 0, 2, 2, 0, 1, 1, 1],
      [2, 1, 2, 0, 0, 1, 0, 1, 1, 1],
      [0, 1, 1, 1, 0, 1, 1, 0, 0, 1],
      [0, 1, 0, 2, 1, 0, 2, 1, 1, 1],
      [0, 2, 2, 0, 1, 2, 1, 0, 1, 1],
      [0, 0, 2, 0, 0, 0, 2, 1, 0, 1],
      [2, 0, 0, 2, 1, 2, 2, 0, 1, 1],
      [0, 0, 1, 1, 2, 0, 2, 0, 1, 0],
      [0, 1, 0, 0, 0, 1, 1, 0, 1, 0],
      [1, 2, 0, 0, 1, 0, 2, 0, 0, 0],
      [1, 1, 1, 0, 2, 1, 2, 1, 0, 0],
      [0, 2, 1, 2, 2, 1, 0, 0, 0, 1],
      [0, 2, 0, 2, 0, 0, 1, 1, 1, 0],
      [1, 0, 1, 2, 2, 0, 1, 0, 1, 1],
      [1, 1, 2, 2, 0, 2, 2, 1, 0, 0],
      [1, 2, 2, 1, 0, 0, 1, 1, 0, 1],
      [1, 0, 2, 2, 0, 2, 1, 0, 1, 0],
      [0, 2, 0, 0, 1, 2, 2, 1, 1, 0],
      [1, 0, 2, 0, 1, 0, 0, 0, 0, 1],
      [0, 2, 0, 0, 1, 0, 1, 1, 0, 1],
      [0, 1, 1, 0, 2, 1, 2, 0, 1, 1],
      [1, 1, 0, 1, 2, 0, 1, 0, 1, 0],
      [1, 0, 2, 0, 1, 2, 0, 1, 1, 0],
      [1, 2, 1, 0, 2, 0, 1, 1, 1, 0],
      [1, 2, 1, 2, 1, 2, 0, 1, 0, 0],
      [1, 2, 2, 2, 2, 0, 2, 0, 0, 1],
      [0, 1, 1, 1, 1, 0, 2, 1, 0, 0],
      [0, 1, 0, 2, 1, 0, 1, 0, 0, 0],
      [0, 0, 2, 1, 0, 1, 0, 0, 1, 0],
      [2, 1, 1, 0, 0, 0, 2, 0, 1, 0],
      [2, 0, 1, 2, 0, 1, 0, 0, 1, 1],
      [1, 0, 0, 2, 2, 1, 2, 1, 1, 1],
      [1, 1, 2, 1, 2, 1, 0, 0, 1, 1],
      [2, 0, 1, 1, 1, 1, 1, 1, 1, 0],
      [2, 2, 1, 2, 1, 0, 2, 1, 1, 0],
      [2, 1, 2, 1, 2, 2, 2, 0, 1, 0],
      [1, 2, 2, 0, 1, 2, 2, 1, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 77,
    hasXpert: true,
  } as const,
  'U7-4-464': {
    guaranty: undefined,
    numFullHedges: 7,
    numHalfHedges: 4,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 0, 2, 1, 1, 0, 1],
      [2, 0, 1, 1, 1, 2, 0, 0, 0, 0, 0],
      [0, 2, 2, 2, 0, 1, 1, 0, 1, 0, 0],
      [1, 1, 0, 0, 2, 1, 0, 0, 1, 1, 0],
      [0, 0, 2, 1, 2, 0, 1, 1, 0, 1, 0],
      [2, 2, 0, 2, 0, 1, 0, 1, 0, 0, 1],
      [1, 1, 2, 0, 0, 2, 0, 1, 0, 0, 0],
      [0, 2, 0, 0, 1, 2, 0, 0, 1, 0, 1],
      [2, 0, 1, 0, 0, 1, 1, 0, 0, 1, 1],
      [2, 1, 2, 0, 1, 0, 2, 0, 0, 0, 1],
      [0, 0, 0, 1, 0, 2, 2, 0, 1, 1, 0],
      [1, 2, 1, 2, 0, 0, 0, 0, 0, 1, 0],
      [2, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0],
      [0, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1],
      [1, 0, 2, 1, 2, 1, 0, 0, 0, 0, 1],
      [0, 2, 1, 0, 1, 2, 2, 0, 0, 1, 0],
      [0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 1],
      [1, 1, 0, 1, 1, 0, 1, 1, 0, 0, 0],
      [0, 2, 0, 2, 0, 2, 1, 0, 0, 1, 1],
      [0, 0, 2, 2, 0, 2, 0, 1, 1, 0, 1],
      [0, 1, 2, 2, 2, 2, 0, 0, 0, 1, 0],
      [1, 0, 1, 0, 0, 2, 1, 0, 1, 0, 0],
      [0, 1, 2, 0, 1, 0, 1, 0, 1, 1, 0],
      [0, 1, 1, 2, 0, 1, 2, 1, 0, 0, 0],
      [0, 0, 1, 2, 2, 0, 1, 0, 1, 0, 1],
      [0, 0, 1, 1, 1, 0, 2, 1, 1, 0, 0],
      [1, 0, 0, 2, 2, 2, 2, 0, 0, 0, 0],
      [0, 2, 0, 1, 1, 1, 0, 1, 0, 1, 0],
      [1, 0, 2, 0, 1, 0, 0, 1, 0, 1, 1],
      [2, 0, 0, 1, 2, 1, 1, 0, 1, 0, 0],
      [2, 1, 0, 1, 2, 0, 2, 0, 0, 1, 0],
      [2, 2, 2, 0, 0, 2, 0, 0, 1, 1, 0],
      [0, 1, 0, 1, 2, 2, 0, 1, 0, 0, 1],
      [2, 0, 0, 2, 1, 0, 0, 0, 1, 1, 1],
      [1, 0, 2, 0, 1, 0, 1, 0, 1, 0, 1],
      [1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 0],
      [0, 1, 0, 0, 1, 1, 2, 1, 1, 0, 0],
      [2, 0, 2, 0, 0, 2, 2, 0, 1, 0, 1],
      [0, 2, 2, 1, 1, 2, 1, 0, 0, 0, 0],
      [1, 2, 0, 0, 2, 2, 1, 0, 0, 1, 0],
      [0, 2, 0, 0, 0, 0, 1, 1, 1, 1, 0],
      [0, 2, 1, 1, 0, 0, 0, 0, 1, 0, 1],
      [2, 2, 0, 2, 1, 0, 1, 0, 1, 0, 0],
      [0, 1, 0, 1, 0, 1, 2, 0, 0, 0, 1],
      [2, 1, 0, 0, 0, 2, 0, 1, 1, 0, 1],
      [2, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1],
      [2, 1, 0, 0, 1, 2, 0, 1, 0, 1, 0],
      [1, 1, 2, 1, 1, 0, 0, 0, 0, 1, 0],
      [2, 2, 1, 1, 0, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 2, 1, 1, 0, 0, 0, 0, 1],
      [2, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0],
      [1, 0, 0, 2, 2, 0, 0, 1, 0, 1, 0],
      [0, 1, 2, 1, 0, 1, 1, 0, 0, 1, 0],
      [2, 2, 0, 2, 2, 0, 2, 1, 0, 0, 0],
      [1, 2, 0, 1, 0, 0, 1, 0, 0, 0, 1],
      [1, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1],
      [0, 1, 2, 0, 0, 0, 2, 1, 0, 1, 0],
      [1, 1, 1, 2, 0, 0, 0, 1, 1, 0, 0],
      [2, 0, 2, 0, 1, 1, 0, 1, 1, 0, 0],
      [2, 1, 2, 2, 2, 0, 0, 0, 1, 0, 0],
      [1, 1, 2, 0, 0, 0, 1, 0, 0, 1, 1],
      [1, 0, 0, 1, 0, 1, 2, 1, 0, 0, 0],
      [2, 0, 0, 0, 1, 2, 1, 0, 1, 1, 0],
      [0, 0, 0, 2, 2, 1, 0, 1, 1, 0, 0],
      [0, 2, 2, 0, 0, 1, 0, 0, 0, 1, 1],
      [0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1],
      [2, 0, 1, 0, 2, 0, 2, 1, 0, 1, 0],
      [2, 0, 0, 2, 0, 0, 1, 1, 0, 1, 1],
      [1, 0, 2, 2, 0, 2, 1, 0, 0, 1, 0],
      [0, 2, 0, 2, 1, 1, 2, 0, 0, 0, 0],
      [0, 1, 2, 0, 2, 2, 1, 0, 0, 0, 1],
      [2, 1, 0, 0, 2, 0, 1, 1, 0, 0, 1],
      [0, 2, 1, 0, 1, 0, 2, 1, 0, 0, 1],
      [0, 1, 1, 0, 1, 2, 1, 1, 0, 0, 0],
      [1, 0, 1, 0, 2, 1, 0, 1, 0, 0, 0],
      [0, 1, 1, 0, 2, 2, 2, 0, 1, 0, 0],
      [0, 2, 0, 2, 2, 0, 2, 0, 1, 1, 0],
      [0, 0, 0, 2, 1, 2, 0, 1, 0, 1, 1],
      [1, 1, 1, 0, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 1, 2, 0, 0, 1, 1],
      [1, 2, 2, 1, 2, 0, 2, 0, 0, 0, 0],
      [0, 2, 0, 1, 2, 0, 0, 0, 0, 1, 1],
      [2, 2, 2, 0, 1, 0, 1, 1, 0, 0, 0],
      [2, 0, 2, 2, 0, 1, 1, 1, 0, 0, 0],
      [0, 1, 1, 2, 0, 1, 0, 0, 1, 1, 0],
      [0, 1, 1, 2, 1, 0, 0, 1, 0, 1, 0],
      [0, 0, 2, 2, 0, 0, 2, 0, 1, 1, 1],
      [1, 0, 1, 0, 1, 0, 2, 0, 1, 1, 0],
      [1, 0, 2, 1, 0, 0, 1, 1, 1, 0, 0],
      [0, 0, 1, 1, 0, 2, 1, 1, 0, 0, 1],
      [2, 0, 2, 0, 2, 1, 2, 0, 0, 0, 0],
      [0, 1, 2, 1, 0, 2, 0, 0, 1, 0, 0],
      [2, 1, 2, 2, 0, 2, 2, 0, 0, 0, 0],
      [2, 0, 2, 2, 1, 1, 0, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 2, 0, 1, 0, 1, 0],
      [0, 1, 2, 2, 0, 0, 1, 1, 0, 0, 1],
      [0, 0, 2, 2, 1, 2, 2, 1, 0, 0, 0],
      [2, 2, 0, 0, 0, 0, 2, 0, 1, 1, 1],
      [0, 2, 1, 2, 2, 2, 0, 1, 0, 0, 0],
      [1, 2, 0, 2, 2, 0, 0, 0, 1, 0, 1],
      [0, 1, 0, 1, 2, 0, 0, 1, 1, 1, 0],
      [0, 2, 0, 2, 0, 2, 2, 1, 1, 0, 0],
      [2, 0, 1, 2, 0, 0, 2, 0, 0, 0, 1],
      [1, 2, 1, 0, 2, 2, 0, 0, 0, 0, 1],
      [1, 2, 0, 0, 0, 1, 0, 1, 1, 0, 0],
      [0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 1],
      [1, 1, 1, 0, 0, 1, 2, 0, 0, 1, 0],
      [2, 0, 2, 1, 0, 0, 0, 1, 0, 0, 1],
      [1, 0, 2, 2, 1, 2, 0, 0, 1, 0, 0],
      [0, 1, 0, 0, 2, 1, 1, 1, 0, 1, 0],
      [1, 1, 0, 1, 0, 0, 2, 0, 1, 0, 0],
      [2, 2, 1, 0, 2, 1, 0, 0, 0, 1, 0],
      [0, 2, 2, 0, 2, 0, 2, 0, 1, 0, 1],
      [0, 0, 1, 1, 1, 0, 2, 0, 0, 1, 1],
      [0, 0, 1, 0, 2, 2, 0, 1, 1, 1, 0],
      [0, 2, 2, 2, 0, 1, 0, 1, 0, 1, 0],
      [0, 2, 1, 0, 0, 0, 2, 0, 1, 1, 0],
      [2, 1, 1, 0, 1, 0, 0, 0, 1, 0, 1],
      [0, 1, 0, 0, 1, 1, 2, 0, 0, 1, 0],
      [0, 0, 0, 1, 2, 2, 1, 0, 0, 1, 1],
      [0, 0, 0, 2, 1, 1, 1, 0, 0, 1, 1],
      [0, 1, 1, 1, 2, 2, 0, 0, 0, 0, 0],
      [1, 0, 2, 0, 0, 0, 0, 0, 1, 1, 1],
      [2, 0, 0, 1, 2, 2, 0, 0, 1, 1, 0],
      [0, 2, 2, 1, 0, 1, 2, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0],
      [0, 1, 0, 0, 0, 2, 2, 1, 0, 0, 1],
      [2, 0, 0, 1, 0, 1, 1, 1, 0, 0, 1],
      [0, 1, 0, 1, 1, 1, 0, 0, 1, 1, 0],
      [0, 1, 0, 2, 1, 2, 0, 1, 1, 0, 0],
      [1, 1, 0, 2, 2, 0, 0, 1, 0, 0, 1],
      [1, 1, 0, 0, 0, 2, 0, 0, 0, 1, 1],
      [1, 0, 0, 0, 1, 1, 0, 1, 1, 1, 0],
      [2, 0, 0, 2, 1, 0, 0, 1, 0, 0, 1],
      [2, 0, 0, 0, 1, 0, 1, 0, 0, 1, 1],
      [2, 2, 2, 0, 0, 0, 1, 0, 1, 0, 1],
      [1, 2, 1, 1, 1, 1, 0, 0, 0, 0, 0],
      [1, 2, 1, 2, 0, 2, 1, 0, 0, 0, 0],
      [1, 2, 2, 0, 0, 1, 2, 0, 0, 0, 1],
      [1, 0, 2, 1, 2, 2, 1, 0, 0, 0, 0],
      [2, 2, 0, 2, 2, 0, 1, 0, 0, 1, 0],
      [1, 2, 2, 0, 2, 2, 0, 0, 1, 0, 0],
      [1, 1, 2, 1, 0, 1, 0, 0, 0, 0, 0],
      [2, 2, 1, 1, 2, 0, 0, 0, 0, 0, 0],
      [1, 1, 2, 0, 0, 1, 2, 0, 1, 0, 0],
      [1, 1, 0, 1, 1, 2, 0, 0, 1, 0, 0],
      [2, 2, 0, 2, 0, 0, 0, 1, 1, 1, 0],
      [0, 0, 2, 2, 0, 1, 2, 1, 1, 0, 0],
      [2, 2, 1, 0, 1, 0, 2, 0, 1, 0, 0],
      [2, 1, 0, 2, 0, 0, 2, 1, 0, 1, 0],
      [2, 2, 0, 1, 0, 0, 0, 1, 1, 0, 1],
      [0, 1, 0, 1, 1, 0, 2, 1, 0, 1, 0],
      [1, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0],
      [2, 0, 1, 0, 2, 2, 1, 0, 0, 1, 0],
      [2, 0, 2, 0, 0, 0, 2, 1, 1, 0, 0],
      [2, 0, 2, 2, 1, 0, 2, 0, 1, 0, 0],
      [2, 0, 1, 0, 0, 0, 1, 1, 1, 0, 1],
      [2, 1, 1, 0, 1, 1, 0, 1, 0, 0, 0],
      [0, 1, 2, 1, 2, 0, 0, 1, 0, 0, 0],
      [0, 2, 0, 0, 1, 1, 1, 0, 1, 1, 0],
      [2, 0, 1, 0, 2, 0, 0, 1, 0, 0, 1],
      [2, 0, 2, 1, 0, 0, 1, 0, 0, 1, 0],
      [1, 0, 0, 2, 0, 0, 1, 1, 1, 1, 0],
      [2, 1, 1, 1, 0, 0, 2, 1, 0, 0, 0],
      [1, 2, 0, 0, 2, 1, 0, 0, 0, 1, 1],
      [0, 0, 1, 0, 2, 2, 2, 0, 0, 0, 1],
      [0, 2, 1, 1, 2, 0, 2, 1, 0, 0, 0],
      [1, 2, 0, 1, 1, 2, 2, 0, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 1, 0, 1, 0, 0, 2, 0, 1, 1, 1],
      [1, 2, 1, 0, 0, 1, 0, 1, 0, 0, 1],
      [0, 1, 1, 2, 2, 0, 1, 1, 0, 0, 0],
      [1, 2, 0, 2, 1, 2, 0, 0, 0, 1, 0],
      [0, 2, 0, 1, 0, 2, 1, 1, 0, 1, 0],
      [0, 1, 1, 0, 2, 0, 0, 0, 0, 1, 1],
      [0, 0, 2, 1, 0, 1, 2, 0, 0, 1, 1],
      [2, 2, 2, 1, 0, 0, 2, 0, 1, 0, 0],
      [0, 2, 2, 0, 2, 0, 1, 1, 0, 0, 1],
      [0, 1, 2, 1, 0, 2, 0, 0, 0, 1, 1],
      [0, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0],
      [2, 2, 0, 2, 0, 2, 2, 0, 0, 0, 1],
      [0, 2, 2, 2, 2, 0, 0, 0, 0, 0, 1],
      [0, 0, 1, 1, 2, 1, 2, 0, 1, 0, 0],
      [0, 0, 0, 1, 1, 2, 2, 1, 0, 0, 1],
      [2, 2, 2, 0, 2, 0, 0, 1, 0, 1, 0],
      [2, 0, 1, 2, 0, 1, 0, 1, 1, 0, 0],
      [1, 0, 0, 0, 1, 1, 1, 0, 1, 0, 0],
      [0, 0, 1, 2, 0, 1, 0, 0, 1, 0, 1],
      [0, 0, 2, 1, 2, 2, 0, 1, 1, 0, 0],
      [2, 1, 0, 0, 2, 2, 2, 0, 0, 0, 0],
      [2, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0],
      [1, 0, 2, 1, 0, 2, 0, 0, 1, 0, 1],
      [1, 1, 2, 0, 1, 2, 2, 0, 0, 0, 0],
      [1, 2, 0, 2, 0, 0, 1, 1, 0, 0, 0],
      [1, 2, 2, 0, 1, 1, 1, 0, 0, 0, 0],
      [2, 0, 2, 0, 0, 1, 2, 0, 1, 1, 0],
      [0, 0, 2, 1, 0, 1, 1, 0, 1, 0, 1],
      [2, 1, 0, 0, 0, 0, 0, 1, 0, 1, 1],
      [0, 0, 1, 0, 0, 1, 2, 1, 0, 0, 1],
      [2, 0, 1, 0, 0, 2, 1, 1, 0, 0, 0],
      [1, 0, 0, 2, 0, 2, 0, 1, 0, 0, 1],
      [1, 0, 0, 0, 2, 0, 2, 1, 1, 1, 0],
      [0, 2, 1, 1, 0, 0, 1, 0, 0, 1, 0],
      [1, 0, 0, 2, 1, 0, 2, 0, 0, 1, 0],
      [0, 0, 0, 2, 2, 2, 1, 0, 1, 1, 0],
      [2, 0, 0, 0, 1, 1, 2, 1, 0, 1, 0],
      [0, 1, 2, 1, 2, 0, 0, 0, 1, 0, 1],
      [1, 0, 0, 0, 2, 1, 0, 1, 1, 0, 1],
      [0, 1, 2, 2, 2, 1, 1, 0, 0, 0, 0],
      [1, 0, 1, 0, 0, 0, 2, 1, 0, 1, 1],
      [1, 1, 0, 0, 1, 1, 2, 0, 0, 0, 1],
      [0, 0, 1, 0, 0, 2, 1, 0, 1, 1, 1],
      [0, 0, 0, 0, 2, 0, 1, 1, 1, 0, 1],
      [1, 2, 0, 1, 0, 0, 2, 0, 0, 1, 0],
      [1, 2, 1, 1, 0, 0, 1, 0, 1, 0, 0],
      [1, 2, 0, 0, 2, 0, 2, 0, 0, 0, 1],
      [2, 0, 0, 0, 2, 0, 2, 0, 1, 0, 1],
      [2, 2, 2, 0, 0, 2, 0, 1, 0, 0, 1],
      [2, 1, 1, 2, 1, 0, 2, 0, 0, 0, 0],
      [1, 1, 2, 0, 2, 0, 2, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0],
      [1, 1, 2, 2, 0, 2, 0, 0, 0, 0, 1],
      [2, 1, 0, 2, 2, 2, 0, 0, 0, 0, 1],
      [1, 0, 2, 2, 0, 0, 2, 1, 0, 0, 0],
      [2, 2, 1, 1, 0, 2, 0, 0, 1, 0, 0],
      [0, 0, 1, 2, 0, 0, 2, 1, 0, 1, 0],
      [0, 0, 2, 1, 2, 0, 2, 0, 1, 1, 0],
      [0, 1, 0, 0, 2, 0, 2, 1, 0, 1, 1],
      [0, 2, 1, 0, 0, 2, 0, 1, 1, 0, 1],
      [2, 0, 1, 0, 2, 2, 0, 0, 1, 0, 1],
      [0, 0, 1, 2, 2, 0, 0, 0, 1, 1, 0],
      [0, 0, 2, 0, 0, 1, 0, 1, 1, 1, 0],
      [0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0],
      [0, 2, 2, 2, 1, 0, 0, 1, 0, 0, 0],
      [2, 0, 1, 1, 0, 0, 2, 0, 1, 1, 0],
      [0, 1, 2, 2, 1, 0, 0, 0, 0, 1, 1],
      [0, 2, 0, 1, 2, 2, 2, 0, 0, 0, 1],
      [0, 0, 2, 2, 2, 0, 1, 1, 1, 0, 0],
      [2, 0, 2, 1, 2, 0, 2, 1, 0, 0, 0],
      [2, 2, 0, 2, 0, 1, 2, 0, 1, 0, 0],
      [1, 0, 1, 2, 1, 1, 2, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 2, 1, 0, 0, 0, 1],
      [0, 0, 0, 2, 0, 2, 1, 0, 1, 0, 1],
      [2, 2, 0, 1, 2, 2, 0, 1, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 1, 0, 1, 1],
      [2, 0, 0, 1, 1, 0, 2, 0, 0, 0, 1],
      [1, 2, 1, 0, 2, 0, 0, 0, 1, 1, 0],
      [2, 2, 0, 2, 0, 1, 0, 0, 0, 1, 0],
      [1, 0, 2, 2, 0, 0, 1, 0, 0, 0, 1],
      [0, 0, 0, 2, 1, 2, 2, 0, 1, 0, 0],
      [2, 2, 0, 0, 0, 2, 2, 1, 0, 0, 0],
      [1, 2, 0, 0, 1, 0, 0, 1, 0, 0, 1],
      [2, 0, 2, 0, 2, 2, 0, 0, 0, 1, 1],
      [1, 0, 2, 0, 2, 2, 0, 1, 0, 0, 1],
      [2, 2, 2, 0, 1, 0, 0, 0, 0, 1, 1],
      [2, 1, 1, 0, 0, 0, 1, 0, 1, 1, 0],
      [0, 0, 2, 0, 1, 2, 0, 0, 1, 1, 0],
      [1, 2, 0, 0, 0, 2, 2, 0, 1, 1, 0],
      [1, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1],
      [1, 2, 0, 0, 1, 0, 2, 1, 1, 0, 0],
      [0, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0],
      [0, 0, 0, 1, 2, 2, 0, 1, 0, 1, 0],
      [1, 0, 1, 1, 2, 0, 0, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 2, 2, 0, 0, 0, 1],
      [0, 0, 1, 1, 2, 1, 0, 0, 0, 1, 1],
      [0, 2, 0, 0, 0, 1, 2, 1, 0, 1, 0],
      [0, 2, 0, 1, 2, 1, 1, 0, 0, 1, 0],
      [0, 0, 0, 1, 2, 1, 1, 1, 0, 0, 0],
      [1, 0, 0, 2, 0, 1, 2, 0, 0, 0, 1],
      [2, 0, 0, 1, 1, 2, 2, 0, 0, 1, 0],
      [2, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
      [2, 0, 2, 0, 0, 1, 0, 1, 0, 1, 1],
      [1, 0, 1, 1, 2, 0, 1, 1, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 1, 0, 1, 0],
      [2, 0, 1, 2, 2, 0, 1, 0, 0, 0, 0],
      [1, 0, 2, 0, 2, 0, 2, 0, 1, 0, 0],
      [1, 1, 0, 0, 0, 2, 2, 1, 1, 0, 0],
      [0, 0, 2, 1, 0, 0, 2, 1, 1, 0, 1],
      [0, 0, 2, 2, 1, 1, 2, 0, 0, 0, 1],
      [0, 0, 1, 1, 1, 0, 1, 0, 1, 1, 0],
      [2, 0, 2, 2, 0, 2, 1, 0, 1, 0, 0],
      [2, 1, 0, 0, 1, 0, 1, 1, 1, 0, 0],
      [0, 0, 2, 2, 1, 0, 1, 0, 0, 1, 0],
      [0, 0, 2, 0, 1, 2, 1, 1, 1, 0, 0],
      [2, 1, 0, 1, 0, 2, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 2, 2, 2, 1, 1, 0, 0],
      [2, 2, 0, 1, 1, 0, 0, 0, 0, 1, 0],
      [0, 1, 0, 2, 2, 0, 2, 1, 1, 0, 0],
      [1, 0, 1, 2, 1, 0, 0, 0, 0, 1, 1],
      [0, 1, 1, 1, 1, 1, 2, 0, 0, 0, 0],
      [1, 1, 0, 2, 1, 0, 1, 0, 0, 0, 1],
      [2, 2, 2, 2, 0, 0, 2, 0, 0, 1, 0],
      [1, 0, 2, 1, 1, 0, 0, 1, 0, 0, 0],
      [0, 2, 2, 1, 2, 0, 1, 0, 1, 0, 0],
      [1, 2, 2, 0, 0, 0, 1, 0, 1, 1, 0],
      [1, 0, 0, 2, 0, 2, 2, 1, 0, 1, 0],
      [2, 1, 2, 0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 1, 0, 2, 1, 1, 1, 1, 0, 0],
      [0, 2, 0, 0, 1, 0, 1, 1, 0, 1, 1],
      [0, 1, 1, 0, 0, 2, 2, 0, 0, 1, 1],
      [0, 0, 1, 0, 2, 0, 1, 1, 0, 1, 1],
      [0, 1, 0, 0, 2, 1, 1, 0, 1, 0, 0],
      [1, 1, 0, 2, 0, 1, 0, 1, 0, 1, 0],
      [0, 1, 0, 0, 0, 2, 0, 1, 1, 1, 0],
      [2, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1],
      [1, 2, 1, 0, 0, 0, 2, 1, 0, 0, 0],
      [0, 2, 0, 0, 2, 0, 0, 1, 1, 1, 1],
      [1, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1],
      [1, 2, 0, 0, 0, 2, 1, 1, 0, 0, 1],
      [0, 2, 2, 1, 0, 0, 1, 1, 0, 0, 0],
      [0, 2, 1, 0, 2, 1, 1, 0, 0, 0, 1],
      [0, 0, 0, 2, 2, 1, 0, 0, 1, 1, 1],
      [2, 2, 0, 0, 1, 1, 1, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 1, 2, 0, 1, 1, 1],
      [0, 0, 1, 1, 1, 2, 0, 0, 1, 0, 1],
      [2, 0, 0, 2, 2, 0, 2, 0, 0, 1, 1],
      [1, 0, 0, 1, 1, 2, 0, 0, 0, 0, 1],
      [0, 0, 1, 2, 2, 1, 2, 0, 0, 1, 0],
      [0, 1, 0, 0, 0, 1, 1, 1, 1, 0, 1],
      [2, 0, 1, 0, 1, 1, 0, 0, 0, 0, 1],
      [0, 1, 0, 2, 1, 2, 1, 0, 0, 1, 0],
      [2, 0, 2, 0, 2, 0, 1, 0, 1, 1, 0],
      [2, 1, 1, 2, 0, 0, 0, 1, 0, 0, 1],
      [0, 2, 2, 0, 1, 1, 2, 0, 1, 0, 0],
      [1, 0, 0, 0, 2, 2, 1, 0, 1, 0, 1],
      [0, 1, 1, 2, 2, 0, 2, 0, 0, 0, 1],
      [2, 1, 1, 2, 2, 0, 0, 0, 0, 1, 0],
      [2, 1, 0, 0, 2, 0, 0, 0, 1, 1, 1],
      [1, 1, 0, 2, 0, 2, 0, 0, 1, 1, 0],
      [1, 0, 0, 1, 2, 0, 0, 1, 1, 0, 0],
      [0, 1, 0, 1, 0, 2, 1, 1, 1, 0, 0],
      [0, 0, 1, 2, 1, 2, 0, 0, 0, 1, 0],
      [0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1],
      [1, 1, 0, 1, 2, 1, 2, 0, 0, 0, 0],
      [1, 1, 0, 2, 0, 0, 1, 0, 0, 1, 0],
      [1, 0, 0, 2, 1, 1, 1, 1, 0, 0, 0],
      [1, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0],
      [1, 2, 2, 2, 0, 0, 0, 1, 0, 0, 1],
      [1, 1, 2, 0, 2, 0, 0, 1, 1, 0, 0],
      [2, 2, 0, 0, 2, 1, 0, 0, 1, 0, 0],
      [0, 2, 2, 0, 0, 2, 1, 0, 0, 1, 0],
      [1, 0, 2, 2, 0, 1, 0, 0, 0, 1, 1],
      [1, 0, 1, 2, 1, 0, 1, 0, 1, 0, 0],
      [0, 0, 0, 1, 1, 1, 2, 0, 1, 0, 1],
      [0, 1, 0, 2, 0, 1, 0, 0, 0, 1, 1],
      [1, 0, 0, 1, 1, 0, 0, 0, 1, 1, 0],
      [0, 2, 1, 0, 0, 2, 0, 1, 0, 1, 0],
      [1, 2, 0, 2, 1, 1, 0, 0, 0, 0, 1],
      [2, 1, 0, 1, 0, 2, 1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0, 1, 1, 0, 1, 0, 0],
      [1, 0, 2, 0, 0, 1, 2, 1, 0, 1, 0],
      [0, 2, 1, 2, 0, 0, 1, 0, 0, 0, 1],
      [0, 2, 1, 2, 0, 0, 1, 1, 1, 0, 0],
      [0, 2, 2, 0, 1, 1, 0, 1, 0, 0, 1],
      [0, 0, 0, 2, 1, 0, 2, 1, 1, 0, 1],
      [0, 0, 1, 0, 1, 2, 0, 1, 0, 0, 1],
      [1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 0],
      [2, 2, 2, 1, 0, 1, 0, 0, 0, 0, 1],
      [2, 0, 0, 1, 0, 2, 2, 1, 1, 0, 0],
      [1, 0, 2, 0, 0, 2, 2, 0, 0, 1, 1],
      [0, 2, 1, 0, 0, 1, 2, 0, 1, 0, 1],
      [1, 2, 2, 1, 0, 0, 0, 1, 0, 1, 0],
      [1, 2, 0, 1, 0, 1, 0, 0, 1, 1, 0],
      [2, 1, 1, 2, 0, 1, 0, 0, 0, 0, 0],
      [1, 2, 0, 0, 2, 1, 1, 1, 0, 0, 0],
      [0, 1, 2, 2, 0, 0, 0, 1, 1, 1, 0],
      [2, 0, 2, 0, 1, 0, 2, 0, 0, 1, 0],
      [2, 0, 0, 0, 0, 2, 2, 1, 0, 1, 1],
      [2, 0, 2, 2, 1, 2, 0, 0, 0, 0, 1],
      [0, 0, 2, 1, 0, 2, 2, 1, 0, 1, 0],
      [1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 2, 0, 1, 2, 1, 0, 0, 1, 1],
      [0, 1, 2, 1, 1, 0, 2, 0, 1, 0, 0],
      [2, 0, 0, 2, 2, 1, 1, 0, 0, 0, 1],
      [1, 0, 1, 1, 2, 0, 0, 0, 1, 0, 1],
      [1, 1, 2, 0, 2, 0, 0, 0, 0, 0, 1],
      [2, 0, 0, 2, 0, 1, 1, 0, 1, 1, 0],
      [2, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1],
      [0, 1, 0, 2, 2, 0, 1, 0, 0, 1, 1],
      [0, 2, 0, 1, 1, 0, 1, 1, 1, 0, 0],
      [1, 2, 2, 1, 1, 0, 0, 0, 0, 0, 1],
      [0, 2, 0, 0, 2, 1, 2, 1, 0, 0, 1],
      [2, 2, 1, 2, 1, 0, 0, 0, 0, 0, 1],
      [0, 2, 0, 1, 0, 2, 0, 0, 1, 1, 1],
      [0, 2, 0, 2, 0, 0, 2, 0, 1, 0, 1],
      [2, 0, 2, 1, 1, 0, 0, 0, 1, 0, 1],
      [0, 0, 2, 0, 2, 1, 0, 0, 1, 0, 1],
      [0, 2, 1, 2, 2, 1, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 0, 1, 2, 1, 0, 1, 1],
      [2, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 0, 0, 2, 2, 2, 0, 0, 0, 1, 1],
      [0, 0, 2, 1, 1, 0, 1, 1, 0, 0, 1],
      [2, 0, 1, 2, 0, 2, 2, 0, 0, 1, 0],
      [2, 2, 1, 0, 0, 2, 0, 0, 0, 1, 1],
      [1, 2, 0, 0, 0, 1, 1, 0, 1, 0, 1],
      [0, 0, 2, 1, 1, 0, 0, 1, 1, 1, 0],
      [1, 0, 2, 0, 2, 1, 0, 0, 0, 1, 0],
      [2, 0, 2, 2, 2, 2, 0, 1, 0, 0, 0],
      [0, 0, 2, 1, 1, 1, 0, 0, 1, 0, 0],
      [2, 0, 0, 1, 1, 2, 1, 1, 0, 0, 0],
      [1, 1, 2, 0, 0, 0, 2, 1, 0, 0, 1],
      [2, 1, 1, 0, 0, 0, 1, 0, 0, 0, 1],
      [0, 0, 1, 0, 2, 0, 2, 0, 1, 1, 1],
      [2, 0, 2, 0, 2, 0, 1, 0, 0, 0, 1],
      [0, 2, 0, 2, 1, 2, 1, 1, 0, 0, 0],
      [0, 0, 0, 2, 2, 2, 1, 1, 0, 0, 1],
      [1, 2, 2, 2, 0, 0, 0, 0, 1, 0, 0],
      [0, 2, 0, 0, 2, 2, 0, 0, 1, 1, 0],
      [1, 1, 1, 0, 1, 2, 0, 0, 0, 1, 0],
      [2, 2, 0, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 0, 2, 2, 2, 0, 0, 1, 0, 1, 1],
      [1, 0, 0, 0, 1, 2, 0, 0, 1, 1, 1],
      [1, 2, 1, 0, 1, 2, 0, 1, 0, 0, 0],
      [0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1],
      [0, 2, 0, 1, 2, 1, 0, 0, 1, 0, 1],
      [2, 2, 0, 0, 1, 2, 0, 1, 1, 0, 0],
      [2, 1, 2, 0, 1, 2, 0, 0, 1, 0, 0],
      [2, 1, 0, 2, 0, 2, 0, 1, 0, 0, 0],
      [0, 0, 2, 0, 1, 0, 0, 1, 1, 0, 1],
      [1, 1, 0, 0, 2, 0, 2, 1, 0, 0, 0],
      [0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 1],
      [2, 1, 2, 1, 0, 0, 0, 1, 1, 0, 0],
      [2, 0, 2, 2, 0, 0, 0, 1, 0, 1, 0],
      [1, 0, 1, 0, 0, 1, 2, 1, 1, 0, 0],
      [1, 0, 0, 1, 2, 0, 2, 1, 0, 0, 1],
      [0, 2, 1, 1, 0, 0, 0, 1, 1, 1, 0],
      [1, 2, 1, 0, 1, 0, 1, 0, 0, 1, 0],
      [0, 1, 2, 0, 0, 2, 2, 0, 1, 1, 0],
      [2, 1, 0, 0, 1, 1, 0, 0, 0, 1, 1],
      [0, 2, 0, 2, 0, 0, 0, 1, 0, 1, 1],
      [0, 0, 2, 0, 2, 2, 2, 0, 0, 1, 0],
      [2, 0, 2, 1, 1, 1, 1, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 2, 1, 1, 0, 1, 0],
      [1, 1, 0, 2, 0, 1, 1, 0, 1, 0, 0],
      [1, 0, 1, 1, 0, 0, 1, 0, 0, 1, 1],
      [1, 0, 1, 0, 1, 0, 0, 1, 1, 0, 0],
      [1, 2, 1, 0, 2, 1, 2, 0, 0, 0, 0],
      [1, 2, 0, 0, 2, 0, 1, 0, 1, 0, 0],
      [0, 1, 1, 2, 0, 0, 2, 0, 1, 0, 0],
      [0, 1, 0, 2, 1, 2, 2, 0, 0, 0, 1],
      [0, 1, 0, 2, 0, 0, 0, 1, 1, 0, 1],
      [0, 1, 2, 0, 2, 1, 2, 1, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 1],
      [0, 0, 1, 2, 2, 1, 0, 1, 0, 0, 1],
      [0, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1],
      [0, 0, 2, 1, 2, 0, 2, 0, 0, 0, 1],
      [0, 0, 2, 0, 0, 0, 1, 1, 1, 1, 1],
      [0, 2, 0, 1, 0, 0, 2, 1, 0, 0, 1],
      [0, 2, 0, 2, 1, 0, 2, 0, 0, 1, 1],
      [0, 2, 2, 1, 1, 0, 2, 0, 0, 1, 0],
      [0, 2, 2, 1, 0, 1, 0, 1, 1, 0, 0],
      [0, 2, 2, 0, 1, 2, 2, 0, 0, 0, 1],
      [0, 2, 2, 2, 1, 0, 0, 0, 1, 1, 0],
      [2, 1, 0, 0, 1, 0, 2, 0, 1, 1, 0],
      [2, 1, 0, 0, 0, 2, 1, 0, 1, 0, 0],
      [2, 1, 2, 1, 2, 0, 1, 0, 0, 0, 0],
      [2, 0, 1, 1, 1, 0, 0, 1, 0, 1, 0],
      [2, 0, 1, 0, 0, 0, 0, 1, 1, 1, 0],
      [2, 0, 0, 1, 2, 0, 0, 1, 0, 1, 1],
      [2, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0],
      [2, 0, 0, 2, 1, 1, 0, 0, 1, 0, 0],
      [2, 2, 1, 0, 1, 2, 1, 0, 0, 0, 0],
      [2, 2, 1, 0, 0, 0, 1, 1, 0, 1, 0],
    ] as const,
    systemType: 'U',
    systemNum: 78,
    hasXpert: true,
  } as const,
  'U8-2-253': {
    guaranty: undefined,
    numFullHedges: 8,
    numHalfHedges: 2,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [1, 2, 0, 1, 0, 0, 2, 0, 0, 1],
      [0, 1, 1, 0, 2, 2, 0, 1, 0, 0],
      [0, 0, 2, 2, 0, 0, 1, 2, 1, 0],
      [2, 0, 0, 2, 1, 1, 0, 0, 0, 0],
      [1, 2, 1, 0, 0, 1, 0, 0, 1, 0],
      [1, 0, 0, 0, 1, 0, 0, 2, 1, 1],
      [2, 2, 0, 0, 2, 0, 1, 2, 0, 0],
      [0, 0, 2, 0, 2, 1, 1, 0, 0, 1],
      [2, 0, 2, 0, 2, 0, 0, 0, 1, 0],
      [2, 0, 1, 2, 0, 0, 0, 2, 0, 1],
      [2, 1, 2, 1, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 2, 2, 1, 1, 0],
      [1, 0, 2, 0, 0, 2, 2, 2, 0, 0],
      [1, 0, 0, 2, 2, 0, 2, 1, 0, 0],
      [0, 0, 0, 1, 0, 2, 0, 1, 0, 1],
      [0, 2, 1, 0, 0, 0, 1, 1, 0, 1],
      [1, 1, 0, 0, 0, 0, 1, 1, 1, 0],
      [0, 1, 0, 2, 0, 1, 0, 0, 1, 1],
      [0, 1, 0, 1, 1, 0, 2, 2, 0, 0],
      [0, 0, 1, 1, 0, 1, 2, 0, 0, 0],
      [0, 0, 0, 1, 2, 1, 0, 2, 1, 0],
      [0, 2, 2, 2, 1, 0, 0, 1, 0, 0],
      [2, 2, 2, 0, 0, 2, 0, 0, 0, 1],
      [1, 0, 2, 1, 0, 0, 2, 0, 1, 0],
      [1, 1, 0, 1, 1, 2, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
      [2, 1, 0, 0, 0, 1, 0, 2, 0, 1],
      [0, 0, 0, 1, 2, 0, 1, 2, 0, 1],
      [0, 2, 0, 0, 1, 0, 1, 0, 1, 1],
      [0, 2, 0, 0, 0, 2, 0, 2, 1, 0],
      [2, 1, 0, 0, 1, 0, 2, 0, 1, 0],
      [2, 2, 2, 0, 0, 0, 2, 1, 0, 0],
      [0, 0, 1, 0, 2, 0, 2, 0, 1, 1],
      [1, 2, 1, 1, 2, 0, 0, 0, 0, 0],
      [0, 2, 0, 2, 0, 0, 2, 1, 1, 0],
      [1, 0, 2, 1, 1, 0, 0, 0, 0, 1],
      [0, 1, 1, 2, 0, 2, 1, 0, 0, 0],
      [2, 0, 2, 0, 1, 2, 1, 0, 0, 0],
      [1, 0, 0, 2, 0, 2, 0, 1, 1, 0],
      [2, 2, 0, 0, 0, 0, 0, 1, 1, 1],
      [0, 1, 0, 0, 2, 1, 2, 0, 0, 0],
      [0, 2, 1, 0, 1, 2, 2, 0, 0, 0],
      [1, 0, 1, 0, 0, 1, 1, 1, 0, 0],
      [1, 2, 0, 0, 1, 1, 0, 2, 0, 0],
      [0, 0, 2, 1, 2, 2, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 0, 0, 0, 1, 0],
      [1, 2, 0, 0, 0, 2, 1, 0, 0, 0],
      [0, 0, 1, 0, 1, 0, 0, 2, 0, 0],
      [0, 1, 0, 0, 1, 0, 0, 1, 0, 1],
      [0, 1, 2, 2, 2, 0, 0, 0, 0, 1],
      [0, 0, 0, 2, 2, 2, 2, 0, 0, 1],
      [0, 2, 2, 0, 0, 1, 1, 2, 0, 0],
      [0, 0, 2, 2, 0, 0, 2, 1, 0, 1],
      [0, 2, 2, 1, 0, 0, 0, 2, 0, 1],
      [2, 0, 0, 2, 0, 2, 1, 2, 0, 0],
      [2, 1, 0, 2, 0, 0, 0, 1, 0, 0],
      [1, 0, 0, 0, 2, 1, 0, 1, 0, 1],
      [2, 0, 0, 0, 0, 1, 2, 2, 1, 0],
      [2, 0, 0, 1, 1, 0, 1, 1, 0, 0],
      [0, 1, 1, 0, 0, 0, 2, 2, 1, 0],
      [1, 1, 2, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 1, 2, 1, 0, 1, 0, 0, 1],
      [2, 1, 1, 0, 0, 0, 2, 0, 0, 1],
      [1, 2, 0, 2, 1, 0, 0, 0, 1, 0],
      [2, 0, 1, 1, 0, 0, 0, 1, 1, 0],
      [0, 1, 0, 1, 0, 1, 1, 1, 0, 0],
      [0, 0, 0, 2, 2, 0, 0, 1, 1, 1],
      [1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
      [0, 0, 0, 1, 0, 2, 1, 0, 1, 0],
      [2, 0, 0, 1, 0, 1, 1, 0, 0, 1],
      [1, 0, 0, 2, 0, 0, 1, 0, 1, 1],
      [0, 2, 0, 1, 1, 1, 0, 0, 0, 1],
      [1, 0, 0, 1, 0, 0, 0, 2, 0, 0],
      [1, 1, 2, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 2, 0, 1, 2, 0, 0, 1, 1],
      [0, 1, 2, 0, 0, 1, 0, 1, 1, 0],
      [1, 1, 0, 0, 2, 0, 1, 0, 0, 1],
      [0, 0, 0, 0, 1, 1, 2, 2, 0, 1],
      [1, 1, 2, 0, 2, 0, 0, 2, 0, 0],
      [0, 1, 0, 2, 2, 0, 1, 0, 1, 0],
      [2, 0, 0, 0, 2, 2, 1, 1, 0, 0],
      [1, 1, 0, 2, 2, 0, 0, 0, 0, 0],
      [1, 1, 0, 1, 0, 0, 0, 1, 0, 1],
      [2, 0, 0, 2, 0, 0, 1, 1, 1, 0],
      [2, 0, 2, 2, 0, 0, 2, 2, 0, 0],
      [0, 1, 0, 0, 1, 0, 1, 2, 1, 0],
      [1, 2, 1, 0, 1, 0, 0, 1, 0, 0],
      [0, 2, 1, 2, 0, 0, 0, 0, 1, 1],
      [0, 1, 1, 0, 0, 2, 0, 2, 0, 1],
      [2, 0, 1, 0, 2, 0, 2, 0, 0, 0],
      [2, 2, 0, 1, 0, 0, 0, 2, 1, 0],
      [1, 0, 0, 0, 0, 2, 2, 0, 1, 1],
      [1, 0, 1, 2, 2, 1, 0, 0, 0, 0],
      [0, 1, 1, 2, 0, 1, 0, 2, 0, 0],
      [0, 0, 1, 1, 2, 0, 0, 1, 0, 1],
      [1, 0, 0, 0, 0, 0, 2, 1, 0, 1],
      [2, 1, 1, 0, 1, 0, 1, 0, 0, 0],
      [1, 0, 2, 0, 0, 2, 1, 0, 1, 0],
      [2, 1, 1, 1, 0, 0, 0, 2, 0, 0],
      [0, 2, 0, 2, 0, 2, 2, 2, 0, 0],
      [2, 0, 0, 2, 2, 0, 0, 2, 0, 0],
      [2, 2, 1, 0, 0, 1, 0, 1, 0, 0],
      [0, 0, 1, 0, 2, 1, 0, 0, 1, 0],
      [2, 2, 1, 0, 1, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 2, 0, 2, 2, 1, 0],
      [0, 0, 1, 2, 0, 1, 1, 0, 1, 0],
      [0, 0, 1, 0, 0, 0, 1, 1, 1, 0],
      [0, 2, 0, 0, 2, 0, 2, 0, 1, 0],
      [0, 0, 0, 1, 2, 0, 2, 1, 1, 0],
      [0, 2, 2, 1, 2, 0, 1, 0, 0, 0],
      [0, 1, 0, 0, 0, 2, 1, 1, 0, 1],
      [0, 0, 2, 1, 1, 0, 1, 0, 1, 0],
      [2, 0, 2, 2, 2, 0, 1, 0, 0, 0],
      [0, 2, 1, 2, 0, 0, 2, 0, 0, 0],
      [1, 1, 0, 0, 1, 1, 0, 0, 1, 0],
      [2, 0, 0, 0, 2, 1, 1, 0, 1, 0],
      [0, 0, 0, 1, 1, 2, 1, 0, 0, 1],
      [2, 0, 0, 0, 1, 2, 2, 0, 0, 1],
      [0, 1, 2, 0, 1, 2, 0, 2, 0, 0],
      [1, 0, 1, 2, 0, 0, 1, 2, 0, 0],
      [0, 2, 2, 0, 2, 1, 0, 1, 0, 0],
      [2, 2, 0, 1, 2, 2, 0, 0, 0, 0],
      [0, 2, 0, 0, 1, 2, 1, 1, 0, 0],
      [0, 0, 2, 0, 2, 2, 1, 2, 0, 0],
      [0, 2, 1, 0, 2, 0, 0, 2, 1, 0],
      [0, 0, 0, 0, 0, 1, 2, 1, 0, 0],
      [2, 1, 2, 0, 2, 1, 0, 0, 0, 0],
      [0, 1, 2, 0, 1, 0, 1, 0, 0, 1],
      [1, 0, 2, 0, 2, 0, 1, 1, 0, 0],
      [0, 0, 0, 1, 1, 2, 0, 2, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 2, 1, 1],
      [1, 0, 2, 0, 0, 1, 0, 0, 0, 1],
      [2, 0, 2, 1, 0, 1, 0, 0, 1, 0],
      [1, 1, 0, 0, 0, 1, 0, 1, 0, 0],
      [2, 2, 0, 0, 0, 1, 2, 0, 0, 0],
      [0, 1, 0, 2, 1, 2, 0, 0, 0, 1],
      [1, 2, 0, 0, 1, 0, 2, 0, 0, 0],
      [1, 0, 1, 0, 1, 0, 2, 0, 0, 1],
      [0, 0, 2, 0, 0, 0, 0, 1, 1, 1],
      [0, 2, 0, 0, 0, 0, 2, 2, 1, 1],
      [2, 0, 2, 0, 1, 0, 0, 1, 0, 0],
      [2, 0, 1, 0, 2, 2, 0, 2, 0, 0],
      [0, 0, 0, 2, 2, 1, 1, 1, 0, 0],
      [0, 2, 0, 1, 0, 1, 0, 0, 1, 0],
      [2, 0, 2, 2, 0, 2, 0, 0, 0, 0],
      [2, 1, 2, 2, 0, 0, 0, 0, 1, 0],
      [1, 2, 2, 1, 0, 2, 0, 0, 0, 0],
      [0, 2, 0, 0, 2, 2, 0, 0, 0, 1],
      [0, 0, 0, 1, 1, 0, 0, 0, 1, 1],
      [0, 2, 2, 0, 2, 0, 0, 0, 1, 1],
      [2, 1, 0, 1, 2, 0, 2, 0, 0, 0],
      [0, 1, 2, 0, 2, 2, 0, 0, 1, 0],
      [0, 0, 2, 0, 2, 0, 0, 2, 0, 1],
      [0, 2, 1, 0, 0, 1, 2, 0, 0, 1],
      [0, 1, 0, 2, 1, 1, 1, 0, 0, 0],
      [0, 2, 0, 1, 2, 0, 0, 1, 0, 0],
      [0, 0, 2, 2, 0, 2, 1, 0, 0, 1],
      [2, 1, 0, 0, 2, 0, 0, 2, 1, 0],
      [0, 1, 1, 0, 2, 1, 0, 0, 0, 1],
      [2, 0, 2, 0, 0, 0, 1, 0, 1, 1],
      [2, 1, 0, 0, 0, 2, 1, 0, 1, 0],
      [0, 0, 0, 2, 1, 0, 2, 0, 0, 0],
      [0, 2, 1, 0, 2, 1, 1, 0, 0, 0],
      [1, 2, 0, 0, 2, 2, 0, 0, 1, 0],
      [1, 0, 0, 1, 1, 0, 0, 1, 1, 0],
      [1, 2, 0, 0, 0, 0, 0, 2, 0, 1],
      [1, 0, 1, 1, 0, 2, 1, 0, 0, 0],
      [0, 2, 0, 2, 2, 0, 0, 2, 0, 1],
      [1, 0, 0, 2, 0, 1, 2, 0, 0, 1],
      [1, 2, 0, 1, 0, 0, 1, 0, 1, 0],
      [1, 0, 2, 0, 2, 1, 2, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 1, 0, 1, 1],
      [0, 0, 1, 2, 1, 2, 0, 0, 0, 0],
      [0, 1, 0, 1, 0, 0, 2, 0, 1, 0],
      [1, 0, 0, 0, 1, 1, 1, 0, 0, 1],
      [2, 1, 2, 0, 0, 2, 2, 0, 0, 0],
      [0, 0, 2, 0, 0, 2, 0, 1, 0, 0],
      [0, 0, 2, 2, 2, 1, 0, 2, 0, 0],
      [2, 0, 0, 0, 1, 0, 2, 2, 0, 0],
      [0, 1, 1, 1, 0, 0, 2, 1, 0, 0],
      [2, 0, 2, 0, 0, 1, 0, 2, 0, 0],
      [1, 1, 0, 0, 0, 2, 0, 0, 0, 1],
      [1, 0, 2, 2, 0, 0, 0, 1, 0, 0],
      [0, 2, 0, 2, 0, 1, 0, 1, 0, 0],
      [1, 2, 2, 2, 0, 0, 0, 0, 0, 1],
      [0, 0, 2, 1, 1, 0, 2, 1, 0, 0],
      [0, 0, 0, 2, 1, 0, 0, 2, 1, 0],
      [0, 1, 1, 0, 2, 0, 1, 2, 0, 0],
      [2, 0, 2, 1, 0, 0, 0, 1, 0, 1],
      [0, 0, 0, 0, 2, 2, 1, 0, 1, 1],
      [0, 2, 0, 2, 1, 0, 1, 2, 0, 0],
      [1, 0, 1, 2, 0, 0, 0, 0, 1, 0],
      [1, 0, 0, 0, 1, 2, 0, 1, 0, 0],
      [2, 1, 0, 1, 0, 0, 0, 0, 1, 1],
      [2, 0, 0, 1, 2, 0, 0, 0, 0, 1],
      [2, 0, 1, 1, 0, 2, 0, 0, 0, 1],
      [1, 0, 1, 0, 2, 0, 0, 1, 1, 0],
      [1, 1, 0, 2, 0, 0, 2, 2, 0, 0],
      [0, 0, 2, 2, 1, 1, 0, 0, 0, 1],
      [2, 0, 0, 0, 1, 1, 0, 1, 1, 0],
      [0, 0, 2, 0, 0, 1, 2, 0, 1, 0],
      [1, 0, 1, 0, 2, 2, 0, 0, 0, 1],
      [0, 1, 0, 1, 0, 0, 1, 0, 0, 1],
      [0, 0, 0, 2, 0, 1, 1, 2, 0, 1],
      [2, 2, 0, 2, 0, 0, 1, 0, 0, 0],
      [1, 0, 2, 0, 0, 0, 0, 2, 1, 0],
      [0, 0, 1, 0, 2, 1, 2, 2, 0, 0],
      [2, 0, 0, 1, 0, 0, 2, 2, 0, 1],
      [0, 1, 0, 2, 2, 2, 0, 2, 0, 0],
      [0, 1, 2, 1, 0, 2, 0, 0, 0, 1],
      [2, 2, 0, 2, 0, 1, 0, 0, 0, 1],
      [2, 0, 0, 2, 2, 2, 0, 0, 1, 0],
      [2, 2, 2, 1, 1, 0, 0, 0, 0, 0],
      [0, 2, 2, 2, 0, 2, 0, 0, 1, 0],
      [0, 0, 1, 0, 1, 2, 0, 1, 0, 1],
      [1, 2, 1, 0, 0, 2, 0, 2, 0, 0],
      [1, 0, 2, 0, 0, 0, 1, 2, 0, 1],
      [0, 0, 0, 2, 2, 1, 2, 0, 1, 0],
      [0, 2, 0, 2, 2, 2, 1, 0, 0, 0],
      [0, 1, 1, 2, 0, 0, 0, 1, 0, 1],
      [2, 0, 0, 0, 0, 1, 0, 0, 1, 1],
      [2, 2, 0, 0, 2, 0, 2, 0, 0, 1],
      [1, 0, 0, 1, 2, 2, 2, 0, 0, 0],
      [0, 0, 0, 2, 0, 2, 0, 2, 1, 1],
      [2, 0, 1, 0, 1, 2, 0, 0, 1, 0],
      [1, 0, 0, 2, 1, 0, 0, 1, 0, 1],
      [0, 2, 2, 0, 0, 0, 1, 0, 1, 0],
      [0, 2, 2, 1, 0, 0, 0, 1, 1, 0],
      [2, 0, 0, 1, 2, 1, 0, 1, 0, 0],
      [2, 1, 0, 1, 0, 1, 0, 0, 0, 0],
      [2, 0, 0, 1, 0, 2, 2, 1, 0, 0],
      [0, 0, 0, 1, 0, 1, 2, 0, 1, 1],
      [0, 2, 1, 1, 0, 0, 1, 2, 0, 0],
      [0, 2, 2, 0, 2, 0, 2, 2, 0, 0],
      [0, 0, 1, 0, 0, 0, 2, 2, 0, 1],
      [0, 2, 2, 0, 1, 1, 0, 0, 1, 0],
      [0, 1, 0, 1, 0, 2, 0, 1, 1, 0],
      [2, 2, 1, 0, 0, 0, 2, 0, 1, 0],
      [0, 0, 2, 0, 1, 0, 2, 2, 1, 0],
      [0, 2, 1, 1, 0, 2, 0, 1, 0, 0],
      [0, 0, 2, 1, 2, 0, 2, 0, 0, 1],
      [0, 0, 2, 0, 1, 1, 1, 1, 0, 0],
      [0, 1, 0, 0, 2, 0, 2, 2, 0, 1],
      [0, 2, 0, 0, 1, 0, 0, 1, 1, 0],
      [0, 1, 2, 1, 1, 1, 0, 0, 0, 0],
      [0, 0, 1, 2, 0, 2, 2, 1, 0, 0],
      [1, 0, 0, 0, 2, 1, 1, 2, 0, 0],
      [1, 0, 0, 2, 1, 2, 1, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 1, 0, 0],
      [0, 0, 2, 1, 0, 2, 0, 2, 1, 0],
    ] as const,
    systemType: 'U',
    systemNum: 79,
    hasXpert: true,
  } as const,
  'U8-3-171': {
    guaranty: undefined,
    numFullHedges: 8,
    numHalfHedges: 3,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 2, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 2, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 2, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 2, 0, 1, 0, 1],
      [0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0, 2, 0, 0, 1, 1, 0],
      [0, 0, 0, 0, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 0, 0, 2, 0, 0, 0, 1, 1, 0],
      [0, 0, 0, 0, 1, 0, 0, 0, 1, 1, 0],
      [0, 2, 0, 0, 0, 0, 0, 0, 1, 1, 0],
      [0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0],
      [2, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
      [1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
      [0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 1],
      [0, 0, 2, 0, 0, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 0, 0, 2, 0, 0, 0, 0, 1],
      [0, 0, 2, 0, 0, 2, 0, 0, 0, 0, 1],
      [0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1],
      [0, 2, 0, 0, 1, 0, 0, 0, 0, 0, 1],
      [0, 1, 0, 0, 2, 0, 0, 0, 0, 0, 1],
      [0, 2, 0, 0, 2, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1],
      [2, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 2, 0, 0, 0, 0, 0, 0, 1],
      [2, 0, 0, 2, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 2, 1, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 1, 2, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 2, 2, 0, 1, 0],
      [0, 0, 0, 0, 1, 1, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 2, 1, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 1, 2, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 2, 2, 0, 0, 0, 1, 0],
      [0, 0, 1, 1, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 2, 1, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 1, 2, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 2, 2, 0, 0, 0, 0, 0, 1, 0],
      [1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0],
      [2, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0],
      [1, 2, 0, 0, 0, 0, 0, 0, 0, 1, 0],
      [2, 2, 0, 0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 2, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 2, 2, 1, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 2, 1, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 1, 2, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 2, 2, 0, 0, 1, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 2, 1, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 1, 2, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 2, 2, 0, 0, 0, 0, 1, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      [2, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      [1, 2, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      [2, 2, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      [1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0],
      [2, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0],
      [1, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0],
      [2, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0],
      [1, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0],
      [2, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0],
      [1, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0],
      [2, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0],
      [0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0],
      [0, 2, 0, 0, 1, 0, 0, 1, 0, 0, 0],
      [0, 1, 0, 0, 2, 0, 0, 1, 0, 0, 0],
      [0, 2, 0, 0, 2, 0, 0, 1, 0, 0, 0],
      [0, 1, 0, 0, 1, 0, 0, 2, 0, 0, 0],
      [0, 2, 0, 0, 1, 0, 0, 2, 0, 0, 0],
      [0, 1, 0, 0, 2, 0, 0, 2, 0, 0, 0],
      [0, 2, 0, 0, 2, 0, 0, 2, 0, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 0],
      [0, 0, 2, 0, 0, 1, 0, 1, 0, 0, 0],
      [0, 0, 1, 0, 0, 2, 0, 1, 0, 0, 0],
      [0, 0, 2, 0, 0, 2, 0, 1, 0, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 2, 0, 0, 0],
      [0, 0, 2, 0, 0, 1, 0, 2, 0, 0, 0],
      [0, 0, 1, 0, 0, 2, 0, 2, 0, 0, 0],
      [0, 0, 2, 0, 0, 2, 0, 2, 0, 0, 0],
      [1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 2, 1, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 2, 1, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 1, 2, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 1, 2, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 1, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 2, 1, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 1, 2, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 2, 2, 0, 2, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 2, 1, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 2, 2, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 2, 1, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 2, 2, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0],
      [0, 2, 0, 1, 0, 1, 0, 0, 0, 0, 0],
      [0, 1, 0, 2, 0, 1, 0, 0, 0, 0, 0],
      [0, 2, 0, 2, 0, 1, 0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0, 2, 0, 0, 0, 0, 0],
      [0, 2, 0, 1, 0, 2, 0, 0, 0, 0, 0],
      [0, 1, 0, 2, 0, 2, 0, 0, 0, 0, 0],
      [0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0],
      [2, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0],
      [1, 0, 2, 0, 1, 0, 0, 0, 0, 0, 0],
      [2, 0, 2, 0, 1, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 2, 0, 0, 0, 0, 0, 0],
      [2, 0, 1, 0, 2, 0, 0, 0, 0, 0, 0],
      [1, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0],
      [2, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 2, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0],
      [0, 1, 0, 0, 0, 0, 2, 0, 0, 0, 0],
      [0, 2, 0, 0, 0, 0, 2, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0],
      [2, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 2, 1, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 2, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 1],
      [0, 0, 0, 0, 0, 2, 0, 1, 0, 0, 1],
      [0, 0, 0, 0, 0, 1, 0, 2, 0, 0, 1],
      [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1],
      [0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1],
      [0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 1],
      [0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 1],
      [0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 1],
      [0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 1],
      [0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 1],
      [0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 1],
      [0, 0, 2, 0, 0, 0, 0, 2, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1],
      [2, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 2, 0, 0, 1],
      [2, 0, 0, 0, 0, 0, 0, 2, 0, 0, 1],
    ] as const,
    systemType: 'U',
    systemNum: 80,
    hasXpert: true,
  } as const,
  'U8-3-598': {
    guaranty: undefined,
    numFullHedges: 8,
    numHalfHedges: 3,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 2, 2, 0, 1, 2, 0, 0, 0, 0],
      [2, 0, 0, 2, 1, 0, 0, 2, 0, 1, 1],
      [0, 0, 2, 0, 2, 2, 0, 1, 1, 1, 0],
      [2, 2, 1, 0, 1, 2, 1, 0, 0, 0, 0],
      [1, 1, 1, 0, 2, 0, 0, 0, 1, 0, 1],
      [1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 0],
      [0, 0, 1, 1, 0, 1, 0, 2, 1, 0, 1],
      [0, 1, 1, 1, 2, 0, 1, 2, 0, 0, 0],
      [2, 0, 0, 2, 0, 2, 2, 2, 1, 0, 0],
      [1, 2, 2, 1, 2, 0, 0, 0, 0, 1, 0],
      [2, 1, 2, 0, 0, 0, 1, 0, 0, 1, 1],
      [1, 2, 0, 0, 1, 1, 0, 2, 1, 0, 0],
      [0, 2, 0, 0, 2, 0, 2, 1, 0, 0, 1],
      [0, 2, 0, 0, 2, 1, 1, 0, 0, 1, 0],
      [0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 1],
      [1, 1, 0, 2, 2, 0, 0, 1, 0, 0, 0],
      [0, 2, 2, 0, 0, 0, 1, 2, 1, 0, 1],
      [0, 2, 0, 1, 1, 0, 0, 0, 1, 0, 1],
      [2, 0, 0, 2, 2, 1, 0, 0, 1, 0, 1],
      [1, 1, 2, 0, 0, 1, 0, 2, 0, 0, 1],
      [0, 2, 0, 1, 0, 1, 2, 1, 1, 0, 0],
      [0, 0, 2, 0, 1, 0, 2, 0, 1, 1, 1],
      [2, 0, 2, 2, 0, 0, 0, 0, 1, 1, 0],
      [1, 0, 1, 2, 2, 2, 2, 0, 0, 0, 0],
      [0, 1, 0, 0, 1, 2, 0, 2, 0, 1, 0],
      [0, 2, 1, 0, 0, 0, 2, 2, 0, 1, 0],
      [0, 2, 2, 2, 1, 0, 0, 2, 0, 0, 0],
      [2, 2, 2, 1, 0, 2, 0, 1, 0, 0, 0],
      [1, 0, 2, 1, 0, 0, 2, 0, 0, 0, 1],
      [1, 0, 0, 0, 1, 2, 1, 0, 0, 1, 1],
      [2, 0, 1, 0, 2, 2, 0, 2, 0, 0, 1],
      [0, 0, 1, 1, 1, 1, 0, 0, 0, 1, 0],
      [1, 2, 2, 0, 0, 2, 2, 0, 1, 0, 0],
      [1, 0, 0, 2, 0, 0, 1, 1, 1, 0, 1],
      [2, 1, 0, 1, 1, 0, 2, 0, 0, 1, 0],
      [0, 1, 0, 2, 0, 2, 1, 0, 1, 1, 0],
      [0, 2, 1, 2, 0, 2, 0, 0, 0, 0, 1],
      [2, 0, 0, 0, 1, 0, 1, 1, 1, 1, 0],
      [2, 0, 2, 0, 2, 1, 2, 1, 0, 0, 0],
      [1, 0, 2, 0, 2, 0, 1, 2, 0, 1, 0],
      [2, 0, 1, 1, 0, 2, 0, 0, 1, 0, 0],
      [2, 1, 0, 0, 1, 1, 0, 0, 0, 1, 1],
      [0, 1, 1, 0, 1, 1, 2, 0, 1, 0, 0],
      [2, 1, 0, 0, 2, 0, 1, 2, 1, 0, 0],
      [1, 0, 2, 1, 0, 1, 0, 1, 1, 0, 0],
      [1, 0, 2, 1, 1, 2, 0, 2, 0, 0, 0],
      [0, 0, 1, 1, 1, 2, 0, 1, 0, 0, 1],
      [0, 2, 0, 2, 0, 0, 0, 2, 1, 1, 1],
      [0, 0, 1, 0, 2, 0, 0, 2, 1, 1, 1],
      [0, 1, 0, 1, 2, 2, 0, 0, 0, 0, 1],
      [2, 2, 0, 1, 0, 1, 0, 0, 0, 1, 0],
      [0, 1, 1, 2, 0, 2, 0, 2, 1, 0, 0],
      [0, 2, 1, 2, 0, 0, 2, 0, 1, 0, 0],
      [0, 0, 0, 1, 2, 0, 2, 2, 0, 1, 0],
      [1, 0, 2, 0, 0, 1, 1, 0, 1, 1, 0],
      [0, 2, 2, 0, 0, 2, 2, 0, 0, 1, 1],
      [1, 1, 0, 0, 0, 2, 2, 1, 0, 0, 1],
      [2, 2, 0, 0, 0, 2, 1, 1, 0, 1, 0],
      [1, 1, 1, 2, 1, 0, 0, 0, 0, 1, 0],
      [1, 2, 0, 1, 0, 0, 0, 2, 0, 0, 1],
      [0, 2, 1, 0, 2, 0, 1, 1, 1, 0, 0],
      [1, 1, 2, 0, 0, 0, 0, 1, 1, 1, 0],
      [0, 2, 1, 0, 0, 2, 0, 0, 1, 1, 0],
      [0, 0, 1, 0, 2, 2, 2, 0, 1, 0, 1],
      [2, 0, 0, 2, 2, 2, 0, 0, 0, 1, 0],
      [0, 0, 2, 2, 0, 0, 1, 1, 0, 1, 0],
      [0, 1, 2, 1, 0, 0, 1, 1, 1, 0, 0],
      [0, 2, 0, 1, 1, 1, 1, 2, 0, 0, 0],
      [1, 0, 0, 0, 2, 0, 0, 1, 0, 1, 1],
      [2, 0, 1, 0, 0, 0, 2, 1, 1, 0, 1],
      [2, 1, 2, 0, 0, 2, 2, 2, 0, 0, 0],
      [0, 0, 1, 0, 0, 1, 1, 2, 0, 1, 1],
      [0, 2, 2, 0, 1, 1, 1, 0, 0, 0, 1],
      [0, 0, 0, 2, 2, 0, 2, 2, 1, 0, 1],
      [0, 1, 0, 0, 2, 0, 1, 2, 0, 1, 1],
      [1, 1, 0, 1, 0, 0, 2, 0, 1, 0, 0],
      [0, 2, 0, 0, 2, 2, 0, 2, 1, 0, 1],
      [1, 0, 1, 0, 1, 1, 2, 2, 0, 0, 0],
      [1, 2, 0, 1, 1, 2, 2, 0, 0, 0, 0],
      [0, 2, 2, 0, 0, 1, 0, 1, 0, 1, 0],
      [2, 0, 2, 2, 2, 0, 1, 0, 0, 0, 0],
      [2, 0, 0, 1, 1, 2, 1, 1, 0, 0, 0],
      [2, 0, 1, 2, 0, 1, 0, 1, 0, 1, 0],
      [0, 0, 0, 2, 1, 1, 2, 1, 0, 1, 0],
      [0, 1, 1, 2, 0, 0, 2, 0, 0, 1, 1],
      [1, 0, 0, 2, 2, 0, 0, 2, 1, 1, 0],
      [0, 2, 0, 1, 2, 0, 0, 1, 1, 1, 0],
      [0, 0, 2, 1, 0, 2, 1, 2, 0, 0, 1],
      [1, 1, 1, 0, 0, 2, 0, 0, 0, 1, 1],
      [2, 2, 0, 0, 0, 1, 1, 0, 1, 0, 0],
      [0, 1, 0, 0, 2, 1, 0, 1, 1, 0, 0],
      [1, 2, 0, 0, 1, 0, 1, 1, 0, 0, 0],
      [0, 0, 2, 2, 1, 2, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1],
      [2, 2, 0, 2, 0, 1, 0, 1, 0, 0, 1],
      [0, 0, 2, 1, 1, 1, 1, 0, 1, 0, 0],
      [1, 0, 1, 0, 2, 1, 1, 0, 0, 0, 1],
      [1, 0, 2, 2, 1, 0, 2, 1, 0, 0, 0],
      [1, 2, 0, 2, 0, 2, 0, 2, 0, 1, 0],
      [0, 0, 1, 2, 1, 0, 1, 2, 0, 0, 1],
      [2, 1, 2, 1, 2, 0, 0, 0, 1, 0, 0],
      [2, 1, 0, 2, 0, 2, 1, 0, 0, 0, 1],
      [1, 1, 1, 1, 0, 1, 0, 0, 0, 0, 0],
      [2, 2, 1, 1, 0, 0, 1, 0, 0, 0, 1],
      [2, 1, 1, 0, 0, 1, 2, 0, 0, 0, 1],
      [1, 2, 0, 0, 0, 0, 2, 0, 1, 1, 1],
      [0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0],
      [1, 0, 0, 0, 0, 1, 2, 2, 1, 0, 1],
      [2, 2, 2, 0, 2, 0, 0, 0, 0, 0, 1],
      [2, 2, 0, 0, 2, 0, 0, 2, 0, 1, 0],
      [2, 0, 2, 0, 0, 2, 0, 1, 0, 1, 1],
      [1, 0, 1, 0, 0, 2, 1, 1, 0, 0, 0],
      [2, 1, 0, 2, 1, 1, 0, 2, 0, 0, 0],
      [2, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 1, 0, 2, 0, 0, 1, 1, 1],
      [0, 1, 0, 1, 0, 1, 2, 2, 0, 0, 1],
      [2, 1, 0, 0, 1, 0, 2, 2, 0, 0, 1],
      [1, 2, 0, 2, 2, 0, 1, 0, 1, 0, 0],
      [1, 0, 0, 2, 2, 1, 1, 2, 0, 0, 0],
      [1, 2, 1, 1, 0, 0, 2, 1, 0, 0, 0],
      [0, 2, 1, 2, 2, 1, 0, 1, 0, 0, 0],
      [0, 0, 1, 1, 2, 0, 1, 0, 1, 1, 0],
      [1, 1, 2, 2, 0, 0, 1, 2, 0, 0, 0],
      [0, 1, 1, 0, 2, 2, 2, 1, 0, 0, 0],
      [0, 0, 2, 2, 1, 0, 0, 1, 1, 0, 1],
      [0, 0, 1, 1, 0, 2, 2, 1, 0, 1, 0],
      [1, 1, 2, 0, 2, 2, 1, 0, 0, 0, 0],
      [2, 0, 2, 0, 1, 0, 2, 2, 1, 0, 0],
      [2, 0, 1, 2, 2, 0, 0, 1, 1, 0, 0],
      [2, 1, 0, 0, 1, 2, 0, 0, 1, 0, 0],
      [1, 0, 0, 0, 2, 2, 2, 1, 1, 0, 0],
      [1, 2, 2, 2, 0, 0, 0, 0, 1, 0, 1],
      [0, 1, 2, 1, 0, 1, 0, 0, 1, 1, 0],
      [0, 1, 0, 0, 0, 1, 2, 2, 1, 1, 0],
      [0, 0, 1, 2, 0, 1, 1, 1, 1, 0, 0],
      [1, 2, 1, 0, 1, 0, 2, 0, 0, 0, 1],
      [2, 1, 1, 2, 0, 0, 0, 2, 0, 0, 1],
      [2, 0, 2, 0, 1, 1, 0, 2, 0, 1, 0],
      [1, 0, 0, 1, 1, 1, 0, 0, 0, 0, 1],
      [0, 0, 1, 0, 1, 2, 1, 2, 1, 0, 0],
      [2, 0, 1, 1, 2, 0, 0, 0, 0, 1, 1],
      [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0],
      [0, 1, 2, 0, 2, 0, 2, 0, 0, 1, 0],
      [0, 0, 2, 2, 2, 1, 0, 2, 1, 0, 0],
      [2, 2, 2, 0, 2, 2, 0, 2, 0, 0, 0],
      [1, 2, 2, 0, 0, 0, 1, 1, 1, 0, 0],
      [2, 0, 0, 2, 1, 0, 1, 0, 0, 0, 1],
      [0, 2, 0, 2, 2, 2, 2, 1, 0, 0, 0],
      [0, 2, 1, 0, 1, 0, 0, 0, 1, 1, 1],
      [0, 0, 1, 0, 1, 1, 1, 1, 0, 0, 0],
      [2, 0, 1, 2, 0, 0, 1, 1, 0, 0, 1],
      [2, 0, 0, 1, 2, 1, 0, 1, 1, 0, 0],
      [0, 0, 2, 2, 1, 1, 0, 1, 0, 0, 0],
      [0, 2, 0, 1, 0, 1, 1, 0, 1, 1, 0],
      [2, 0, 0, 0, 1, 1, 2, 0, 0, 0, 1],
      [0, 1, 0, 0, 1, 2, 0, 1, 1, 0, 1],
      [1, 0, 2, 2, 0, 0, 0, 2, 0, 0, 1],
      [1, 0, 2, 1, 2, 2, 0, 0, 0, 0, 1],
      [0, 0, 0, 2, 2, 1, 1, 0, 1, 1, 0],
      [1, 0, 0, 2, 2, 2, 0, 1, 0, 0, 1],
      [2, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0],
      [2, 0, 2, 0, 1, 2, 0, 1, 1, 0, 0],
      [1, 0, 1, 2, 0, 0, 1, 0, 0, 1, 1],
      [1, 2, 0, 0, 1, 0, 2, 0, 1, 0, 0],
      [1, 2, 1, 1, 2, 0, 0, 0, 1, 0, 0],
      [2, 1, 0, 2, 0, 0, 2, 0, 1, 0, 1],
      [2, 2, 2, 0, 0, 0, 2, 1, 0, 1, 0],
      [1, 2, 0, 2, 0, 0, 2, 1, 0, 1, 0],
      [0, 0, 0, 0, 2, 2, 1, 1, 0, 1, 0],
      [0, 0, 2, 0, 1, 0, 1, 2, 0, 1, 1],
      [0, 1, 0, 2, 0, 1, 1, 1, 0, 0, 1],
      [1, 0, 2, 0, 2, 0, 0, 2, 1, 0, 0],
      [0, 0, 1, 2, 1, 0, 0, 1, 1, 1, 0],
      [0, 2, 0, 1, 1, 0, 1, 0, 0, 1, 0],
      [0, 0, 2, 0, 2, 0, 2, 1, 1, 0, 0],
      [1, 1, 0, 2, 0, 1, 2, 0, 0, 1, 0],
      [0, 1, 0, 0, 0, 1, 2, 0, 0, 1, 1],
      [0, 1, 0, 1, 0, 1, 1, 2, 1, 0, 0],
      [0, 2, 0, 1, 0, 1, 1, 0, 0, 0, 1],
      [2, 2, 0, 2, 0, 2, 2, 0, 0, 1, 0],
      [0, 0, 1, 1, 2, 0, 2, 2, 0, 0, 1],
      [0, 1, 1, 1, 1, 0, 0, 0, 1, 0, 0],
      [1, 1, 1, 0, 0, 0, 1, 0, 0, 0, 1],
      [0, 1, 2, 0, 1, 0, 0, 0, 1, 1, 0],
      [2, 2, 1, 0, 0, 0, 1, 0, 0, 1, 0],
      [0, 0, 2, 2, 0, 2, 2, 0, 0, 1, 0],
      [2, 0, 0, 0, 1, 2, 0, 1, 0, 1, 0],
      [0, 1, 1, 0, 0, 2, 1, 2, 0, 0, 1],
      [2, 0, 2, 2, 0, 1, 2, 0, 0, 0, 1],
      [1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0],
      [1, 0, 1, 0, 0, 0, 0, 2, 1, 0, 1],
      [0, 0, 2, 2, 0, 2, 2, 0, 1, 0, 1],
      [0, 1, 0, 1, 0, 1, 2, 1, 0, 1, 0],
      [0, 0, 1, 0, 1, 1, 0, 2, 0, 0, 1],
      [2, 2, 2, 1, 0, 0, 2, 2, 0, 0, 0],
      [2, 0, 0, 2, 0, 1, 0, 2, 1, 1, 0],
      [2, 0, 0, 0, 0, 2, 2, 2, 0, 0, 1],
      [0, 0, 1, 0, 0, 0, 1, 1, 1, 1, 0],
      [0, 0, 0, 1, 0, 1, 2, 0, 1, 0, 1],
      [0, 1, 1, 1, 0, 2, 1, 1, 0, 0, 0],
      [1, 1, 1, 1, 0, 0, 0, 1, 0, 1, 0],
      [2, 0, 0, 2, 2, 0, 2, 1, 0, 0, 1],
      [2, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 2, 1, 0, 0, 1, 1, 2, 1, 0, 0],
      [2, 1, 2, 0, 2, 1, 0, 0, 0, 1, 0],
      [2, 1, 1, 0, 0, 1, 0, 0, 1, 1, 0],
      [1, 0, 1, 1, 0, 0, 1, 2, 1, 0, 0],
      [0, 0, 1, 0, 2, 0, 2, 1, 0, 1, 1],
      [1, 0, 0, 1, 2, 2, 1, 0, 0, 1, 0],
      [0, 1, 0, 2, 2, 1, 2, 0, 1, 0, 0],
      [2, 2, 0, 0, 0, 2, 0, 2, 1, 1, 0],
      [1, 0, 0, 1, 1, 2, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 2, 1, 0, 2, 0, 0, 1],
      [0, 1, 0, 2, 1, 0, 0, 1, 1, 0, 0],
      [0, 1, 0, 2, 2, 0, 2, 0, 0, 0, 1],
      [0, 0, 2, 1, 1, 2, 2, 0, 0, 0, 1],
      [0, 2, 0, 1, 1, 2, 0, 0, 0, 1, 1],
      [0, 2, 0, 2, 0, 2, 1, 0, 1, 0, 1],
      [2, 0, 1, 1, 2, 0, 2, 0, 1, 0, 0],
      [0, 0, 1, 2, 1, 0, 2, 2, 1, 0, 0],
      [2, 2, 1, 0, 0, 1, 0, 2, 0, 0, 1],
      [2, 0, 0, 1, 0, 2, 2, 0, 1, 1, 0],
      [0, 1, 2, 1, 2, 1, 0, 0, 0, 0, 0],
      [0, 2, 0, 0, 2, 1, 2, 0, 1, 0, 1],
      [1, 0, 1, 0, 0, 0, 2, 2, 1, 1, 0],
      [2, 1, 0, 0, 1, 0, 0, 2, 1, 1, 0],
      [2, 2, 0, 0, 2, 0, 2, 0, 1, 1, 0],
      [0, 1, 2, 1, 2, 0, 1, 0, 0, 0, 1],
      [1, 1, 0, 1, 2, 1, 0, 2, 0, 0, 0],
      [0, 0, 1, 1, 2, 2, 1, 0, 0, 0, 0],
      [0, 1, 1, 2, 0, 1, 0, 2, 0, 1, 0],
      [1, 1, 2, 0, 1, 0, 0, 1, 0, 0, 0],
      [2, 1, 2, 0, 0, 2, 0, 0, 1, 0, 1],
      [0, 2, 1, 0, 2, 0, 1, 0, 0, 1, 1],
      [2, 1, 0, 2, 1, 2, 2, 0, 0, 0, 0],
      [0, 2, 2, 0, 2, 1, 0, 0, 0, 1, 1],
      [0, 0, 1, 0, 2, 2, 0, 2, 0, 1, 0],
      [0, 0, 0, 2, 1, 2, 0, 2, 1, 0, 0],
      [1, 1, 0, 1, 2, 0, 0, 0, 1, 1, 0],
      [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
      [0, 0, 2, 1, 2, 2, 0, 0, 1, 0, 0],
      [2, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1],
      [0, 1, 1, 1, 2, 0, 0, 0, 0, 1, 0],
      [2, 0, 0, 1, 2, 1, 2, 0, 0, 1, 0],
      [0, 1, 2, 1, 1, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 2, 1, 1, 0],
      [1, 0, 0, 0, 1, 1, 2, 0, 1, 1, 0],
      [1, 2, 1, 0, 1, 0, 0, 2, 0, 0, 0],
      [0, 1, 2, 1, 0, 0, 0, 2, 0, 0, 1],
      [1, 2, 0, 0, 0, 1, 1, 2, 0, 0, 1],
      [0, 1, 1, 2, 1, 1, 0, 0, 0, 0, 1],
      [1, 2, 0, 1, 0, 1, 2, 2, 0, 0, 0],
      [0, 0, 2, 1, 0, 1, 0, 1, 0, 0, 1],
      [0, 1, 2, 2, 2, 0, 0, 1, 0, 1, 0],
      [1, 0, 1, 2, 1, 1, 0, 0, 1, 0, 0],
      [0, 2, 0, 0, 0, 2, 1, 1, 0, 0, 1],
      [0, 0, 0, 2, 0, 2, 0, 2, 0, 1, 1],
      [0, 0, 0, 1, 1, 2, 1, 2, 0, 1, 0],
      [1, 0, 0, 0, 2, 2, 0, 0, 1, 1, 1],
      [2, 0, 2, 0, 0, 1, 1, 1, 0, 0, 1],
      [1, 1, 2, 0, 2, 1, 0, 0, 1, 0, 0],
      [0, 0, 2, 1, 1, 0, 2, 1, 0, 1, 0],
      [2, 1, 1, 0, 0, 2, 0, 1, 1, 0, 0],
      [0, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0],
      [0, 0, 0, 2, 2, 1, 2, 0, 0, 1, 1],
      [0, 1, 0, 2, 0, 1, 0, 1, 1, 1, 0],
      [0, 2, 2, 0, 1, 1, 0, 1, 1, 0, 0],
      [0, 0, 1, 0, 0, 1, 2, 1, 0, 0, 1],
      [0, 1, 2, 0, 1, 2, 1, 2, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 2, 1, 1, 1, 1],
      [1, 2, 1, 0, 0, 2, 2, 2, 0, 0, 0],
      [2, 0, 2, 1, 1, 0, 0, 0, 0, 0, 1],
      [0, 0, 2, 1, 2, 1, 1, 0, 0, 1, 0],
      [2, 2, 0, 0, 1, 0, 0, 1, 1, 0, 0],
      [2, 0, 1, 0, 0, 2, 2, 2, 0, 1, 0],
      [1, 1, 0, 2, 0, 0, 0, 2, 1, 0, 0],
      [1, 2, 2, 0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 2, 0, 2, 2, 1, 1, 0, 0, 1],
      [0, 1, 0, 0, 1, 2, 1, 0, 0, 0, 1],
      [2, 0, 1, 0, 2, 0, 1, 1, 0, 1, 0],
      [0, 2, 2, 2, 0, 0, 0, 1, 0, 0, 1],
      [2, 2, 0, 2, 2, 1, 0, 0, 0, 0, 0],
      [0, 0, 1, 2, 0, 1, 2, 0, 1, 1, 0],
      [2, 1, 0, 1, 0, 0, 0, 1, 1, 0, 1],
      [2, 0, 2, 2, 0, 0, 1, 1, 1, 0, 0],
      [1, 1, 0, 0, 0, 2, 0, 2, 1, 0, 1],
      [1, 1, 0, 0, 0, 0, 1, 1, 0, 1, 0],
      [1, 1, 1, 0, 0, 2, 1, 0, 1, 0, 0],
      [1, 0, 0, 0, 2, 0, 2, 2, 0, 0, 1],
      [0, 2, 1, 0, 0, 2, 0, 1, 1, 0, 1],
      [0, 0, 0, 2, 0, 0, 1, 2, 1, 1, 0],
      [0, 0, 0, 1, 0, 0, 1, 2, 1, 0, 1],
      [2, 0, 2, 1, 2, 1, 0, 2, 0, 0, 0],
      [1, 2, 0, 0, 2, 1, 2, 1, 0, 0, 0],
      [0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0],
      [0, 2, 0, 2, 1, 2, 2, 0, 0, 0, 1],
      [0, 1, 2, 2, 0, 0, 1, 0, 1, 0, 1],
      [2, 0, 1, 0, 2, 2, 0, 0, 1, 1, 0],
      [2, 2, 2, 2, 1, 0, 2, 0, 0, 0, 0],
      [0, 2, 2, 0, 2, 0, 2, 2, 0, 0, 0],
      [2, 1, 2, 0, 1, 1, 2, 0, 0, 0, 0],
      [2, 1, 0, 1, 0, 0, 2, 1, 0, 0, 0],
      [0, 0, 1, 2, 0, 2, 2, 2, 0, 0, 1],
      [1, 1, 0, 0, 0, 2, 2, 2, 0, 1, 0],
      [0, 2, 0, 1, 2, 0, 1, 1, 0, 0, 0],
      [1, 0, 1, 0, 1, 2, 2, 0, 0, 1, 0],
      [0, 1, 0, 1, 0, 2, 0, 1, 1, 0, 0],
      [2, 2, 2, 0, 0, 0, 0, 0, 1, 1, 1],
      [1, 1, 0, 2, 1, 2, 0, 0, 0, 0, 1],
      [2, 1, 1, 1, 0, 0, 0, 2, 1, 0, 0],
      [2, 1, 0, 0, 2, 0, 0, 0, 1, 1, 1],
      [0, 1, 2, 1, 1, 0, 0, 2, 0, 1, 0],
      [0, 2, 0, 1, 2, 0, 2, 2, 1, 0, 0],
      [2, 2, 0, 2, 0, 0, 0, 1, 1, 1, 0],
      [1, 2, 0, 0, 2, 2, 2, 0, 0, 1, 0],
      [2, 2, 1, 1, 1, 1, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 2, 2, 1, 0, 0],
      [2, 1, 0, 2, 2, 0, 2, 2, 0, 0, 0],
      [1, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0],
      [2, 1, 2, 2, 0, 1, 0, 0, 1, 0, 0],
      [0, 1, 1, 1, 0, 2, 2, 0, 0, 0, 1],
      [2, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 0, 1, 0, 1, 1, 1, 0],
      [0, 2, 1, 1, 0, 2, 1, 0, 1, 0, 0],
      [2, 2, 0, 2, 0, 0, 1, 2, 0, 0, 0],
      [1, 2, 0, 2, 0, 1, 0, 1, 1, 0, 0],
      [0, 2, 2, 2, 0, 1, 1, 0, 1, 0, 0],
      [1, 0, 1, 1, 2, 1, 0, 1, 0, 0, 0],
      [1, 0, 0, 2, 2, 1, 0, 1, 0, 1, 0],
      [0, 0, 0, 0, 1, 2, 2, 2, 0, 1, 1],
      [0, 0, 1, 1, 1, 2, 2, 0, 1, 0, 0],
      [0, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1],
      [0, 0, 1, 0, 0, 1, 1, 0, 1, 0, 1],
      [2, 0, 0, 0, 2, 0, 1, 0, 1, 0, 1],
      [2, 1, 1, 2, 0, 2, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 2, 0, 2, 2, 1, 0, 0],
      [2, 2, 0, 2, 0, 0, 0, 0, 0, 1, 1],
      [0, 2, 1, 1, 0, 0, 1, 1, 0, 1, 0],
      [2, 0, 1, 0, 1, 1, 0, 2, 1, 0, 0],
      [0, 2, 1, 1, 0, 0, 0, 2, 1, 1, 0],
      [0, 0, 2, 0, 0, 2, 2, 2, 1, 0, 0],
      [1, 1, 0, 0, 2, 1, 0, 0, 0, 0, 1],
      [1, 2, 2, 0, 0, 2, 0, 0, 0, 1, 0],
      [2, 0, 2, 2, 0, 2, 1, 2, 0, 0, 0],
      [2, 1, 0, 1, 0, 2, 0, 2, 0, 0, 0],
      [2, 0, 2, 0, 0, 1, 0, 1, 1, 1, 0],
      [0, 0, 0, 0, 1, 1, 0, 1, 0, 1, 1],
      [0, 2, 1, 0, 2, 2, 1, 2, 0, 0, 0],
      [1, 2, 2, 1, 0, 1, 0, 0, 0, 0, 1],
      [0, 1, 2, 0, 0, 0, 0, 1, 1, 0, 1],
      [2, 1, 0, 1, 2, 2, 1, 0, 0, 0, 0],
      [0, 2, 2, 1, 0, 0, 2, 0, 0, 1, 0],
      [2, 0, 2, 0, 1, 0, 1, 1, 0, 0, 0],
      [1, 2, 0, 1, 0, 2, 1, 1, 0, 0, 0],
      [1, 0, 2, 1, 0, 0, 1, 1, 0, 0, 0],
      [1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0],
      [1, 0, 1, 1, 0, 0, 0, 2, 0, 1, 1],
      [0, 1, 0, 0, 2, 2, 2, 0, 1, 1, 0],
      [0, 2, 2, 1, 0, 1, 1, 1, 0, 0, 0],
      [0, 1, 0, 0, 2, 1, 1, 2, 0, 0, 0],
      [1, 2, 2, 0, 0, 0, 0, 2, 0, 1, 1],
      [0, 1, 0, 1, 1, 0, 1, 1, 0, 0, 1],
      [2, 2, 0, 1, 2, 0, 2, 0, 0, 0, 0],
      [0, 2, 1, 1, 2, 1, 2, 0, 0, 0, 0],
      [0, 2, 2, 2, 1, 1, 0, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 0, 2, 0, 0, 1, 0],
      [2, 1, 1, 0, 1, 2, 0, 2, 0, 0, 0],
      [2, 0, 0, 1, 0, 0, 2, 1, 0, 1, 1],
      [2, 0, 1, 0, 1, 2, 2, 1, 0, 0, 0],
      [2, 2, 2, 0, 0, 1, 0, 2, 1, 0, 0],
      [1, 0, 0, 1, 0, 1, 2, 1, 0, 0, 1],
      [2, 0, 1, 0, 2, 1, 1, 2, 0, 0, 0],
      [0, 0, 2, 0, 2, 1, 0, 0, 1, 0, 1],
      [0, 0, 2, 0, 2, 1, 2, 0, 1, 1, 0],
      [0, 0, 1, 1, 2, 0, 0, 2, 1, 0, 0],
      [1, 1, 0, 1, 1, 1, 1, 0, 0, 0, 0],
      [2, 0, 2, 1, 0, 2, 0, 2, 0, 1, 0],
      [2, 0, 0, 0, 0, 0, 0, 2, 1, 1, 1],
      [0, 2, 1, 1, 1, 2, 0, 2, 0, 0, 0],
      [0, 2, 1, 0, 2, 0, 0, 2, 0, 0, 1],
      [0, 2, 0, 2, 1, 0, 0, 1, 0, 1, 1],
      [0, 0, 0, 2, 2, 0, 1, 1, 1, 0, 0],
      [0, 0, 2, 2, 2, 0, 1, 0, 0, 1, 1],
      [1, 1, 2, 0, 0, 0, 2, 2, 1, 0, 0],
      [0, 0, 1, 1, 0, 0, 2, 1, 1, 0, 0],
      [2, 1, 0, 2, 1, 0, 1, 0, 1, 0, 0],
      [2, 0, 0, 0, 2, 1, 2, 0, 1, 0, 0],
      [2, 0, 2, 0, 2, 0, 1, 2, 0, 0, 1],
      [0, 2, 2, 2, 2, 0, 0, 1, 1, 0, 0],
      [2, 2, 0, 0, 0, 0, 2, 2, 1, 0, 1],
      [1, 0, 2, 1, 0, 0, 0, 2, 1, 1, 0],
      [0, 2, 1, 2, 0, 2, 1, 0, 0, 1, 0],
      [0, 0, 0, 0, 1, 2, 2, 1, 1, 1, 0],
      [2, 0, 2, 0, 0, 1, 2, 0, 0, 1, 0],
      [0, 0, 0, 1, 2, 0, 1, 1, 0, 1, 1],
      [1, 1, 0, 1, 1, 0, 2, 2, 0, 0, 0],
      [1, 0, 2, 0, 2, 1, 0, 1, 0, 0, 1],
      [0, 0, 1, 2, 2, 1, 2, 2, 0, 0, 0],
      [2, 2, 0, 0, 2, 2, 1, 0, 0, 0, 1],
      [0, 0, 2, 1, 2, 2, 2, 1, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 2, 0, 1, 0, 1],
      [2, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1],
      [2, 2, 1, 0, 2, 0, 0, 2, 1, 0, 0],
      [1, 0, 0, 1, 1, 0, 2, 0, 0, 1, 1],
      [1, 0, 1, 0, 0, 1, 2, 1, 1, 0, 0],
      [1, 0, 0, 1, 2, 2, 2, 2, 0, 0, 0],
      [2, 0, 0, 0, 2, 2, 0, 2, 1, 0, 0],
      [0, 0, 1, 2, 2, 0, 0, 1, 0, 0, 1],
      [2, 1, 0, 0, 2, 2, 0, 1, 0, 0, 1],
      [2, 1, 0, 0, 0, 1, 0, 2, 0, 1, 0],
      [1, 0, 0, 2, 1, 0, 1, 0, 0, 1, 0],
      [1, 0, 2, 0, 2, 0, 2, 0, 0, 1, 1],
      [0, 0, 1, 1, 2, 1, 0, 0, 0, 0, 1],
      [2, 0, 1, 0, 1, 2, 0, 0, 1, 0, 1],
      [1, 0, 0, 0, 0, 1, 0, 2, 0, 1, 1],
      [2, 1, 2, 0, 0, 0, 2, 1, 0, 0, 1],
      [2, 0, 0, 0, 0, 2, 1, 1, 1, 0, 1],
      [2, 2, 1, 2, 0, 0, 0, 1, 0, 0, 0],
      [0, 2, 0, 0, 1, 0, 2, 2, 1, 1, 0],
      [1, 0, 2, 2, 0, 0, 2, 0, 1, 0, 0],
      [0, 2, 2, 0, 2, 0, 0, 2, 1, 1, 0],
      [1, 0, 0, 0, 1, 2, 0, 2, 0, 0, 1],
      [1, 0, 1, 2, 1, 0, 0, 0, 0, 0, 1],
      [0, 0, 2, 0, 1, 2, 1, 0, 0, 1, 0],
      [1, 2, 1, 2, 0, 1, 0, 2, 0, 0, 0],
      [0, 1, 0, 2, 0, 1, 0, 2, 1, 0, 1],
      [1, 0, 0, 0, 2, 1, 2, 2, 0, 1, 0],
      [0, 2, 1, 0, 1, 1, 2, 0, 0, 1, 0],
      [0, 0, 2, 0, 0, 1, 0, 2, 1, 1, 1],
      [1, 2, 0, 1, 1, 0, 0, 2, 0, 1, 0],
      [0, 0, 1, 1, 0, 2, 1, 0, 0, 1, 1],
      [2, 0, 0, 1, 2, 0, 0, 2, 0, 0, 1],
      [0, 1, 2, 0, 1, 1, 0, 1, 0, 0, 1],
      [1, 2, 0, 0, 1, 2, 0, 0, 1, 1, 0],
      [1, 1, 1, 0, 0, 1, 0, 2, 1, 0, 0],
      [0, 0, 1, 1, 0, 0, 2, 0, 1, 1, 1],
      [2, 2, 0, 1, 0, 0, 1, 1, 1, 0, 0],
      [1, 0, 2, 0, 0, 0, 1, 1, 0, 1, 1],
      [0, 1, 2, 2, 0, 0, 2, 0, 1, 1, 0],
      [0, 2, 2, 1, 2, 0, 1, 0, 1, 0, 0],
      [1, 2, 2, 2, 1, 2, 0, 0, 0, 0, 0],
      [1, 0, 0, 2, 0, 1, 0, 0, 1, 1, 1],
      [0, 1, 1, 2, 0, 0, 2, 2, 0, 0, 0],
      [1, 2, 1, 0, 2, 1, 0, 0, 0, 1, 0],
      [1, 2, 1, 0, 0, 0, 0, 1, 0, 0, 1],
      [1, 1, 0, 1, 0, 2, 0, 0, 0, 1, 0],
      [2, 2, 1, 0, 0, 1, 2, 1, 0, 0, 0],
      [1, 2, 0, 0, 2, 0, 0, 1, 1, 0, 1],
      [1, 0, 0, 0, 1, 0, 2, 1, 0, 1, 0],
      [0, 2, 1, 2, 2, 0, 2, 0, 0, 1, 0],
      [2, 0, 2, 1, 2, 0, 0, 1, 0, 1, 0],
      [1, 1, 0, 2, 2, 0, 0, 0, 0, 1, 1],
      [0, 1, 2, 2, 1, 0, 1, 0, 0, 1, 0],
      [0, 2, 1, 2, 1, 0, 2, 1, 0, 0, 0],
      [0, 1, 2, 0, 0, 0, 1, 2, 1, 1, 0],
      [2, 2, 0, 1, 0, 2, 0, 0, 1, 0, 1],
      [0, 2, 0, 0, 1, 1, 2, 2, 0, 0, 1],
      [0, 2, 2, 1, 0, 2, 0, 2, 1, 0, 0],
      [0, 2, 2, 0, 0, 2, 1, 2, 0, 1, 0],
      [2, 1, 0, 2, 1, 0, 0, 1, 0, 0, 1],
      [0, 0, 2, 0, 1, 2, 1, 0, 1, 0, 1],
      [0, 0, 0, 2, 2, 0, 0, 1, 1, 1, 1],
      [0, 2, 0, 1, 2, 0, 0, 2, 0, 1, 1],
      [1, 1, 2, 0, 1, 0, 1, 0, 1, 0, 0],
      [1, 0, 2, 2, 2, 1, 0, 0, 0, 0, 0],
      [2, 0, 1, 0, 2, 0, 2, 0, 0, 0, 1],
      [2, 1, 2, 2, 0, 0, 0, 2, 0, 1, 0],
      [0, 1, 0, 0, 1, 1, 1, 0, 1, 1, 0],
      [0, 2, 0, 0, 2, 2, 1, 0, 1, 0, 0],
      [2, 0, 0, 2, 1, 0, 2, 1, 1, 0, 0],
      [0, 0, 2, 1, 2, 0, 0, 0, 1, 1, 1],
      [1, 0, 0, 2, 0, 2, 1, 2, 0, 0, 1],
      [1, 2, 1, 2, 0, 2, 0, 0, 1, 0, 0],
      [1, 0, 0, 2, 1, 0, 2, 0, 1, 0, 1],
      [1, 0, 1, 0, 2, 0, 0, 1, 1, 1, 0],
      [2, 0, 0, 1, 0, 0, 1, 2, 0, 1, 0],
      [0, 1, 0, 2, 0, 2, 1, 2, 0, 0, 0],
      [2, 1, 0, 2, 0, 2, 0, 1, 0, 1, 0],
      [0, 2, 0, 0, 0, 1, 0, 0, 1, 1, 1],
      [0, 2, 0, 1, 0, 2, 2, 2, 0, 1, 0],
      [1, 1, 1, 2, 2, 0, 1, 0, 0, 0, 0],
      [2, 0, 0, 0, 1, 1, 1, 0, 0, 1, 0],
      [0, 2, 0, 2, 2, 0, 1, 2, 0, 1, 0],
      [0, 2, 0, 0, 0, 0, 1, 1, 1, 1, 1],
      [0, 2, 1, 1, 0, 1, 0, 0, 0, 1, 1],
      [0, 2, 1, 0, 1, 2, 0, 1, 0, 1, 0],
      [1, 2, 0, 1, 1, 1, 0, 1, 0, 0, 0],
      [1, 2, 0, 1, 0, 0, 1, 0, 0, 1, 1],
      [2, 0, 0, 2, 2, 2, 1, 0, 1, 0, 0],
      [2, 0, 2, 0, 0, 0, 2, 2, 0, 1, 1],
      [1, 0, 1, 0, 0, 1, 2, 0, 0, 1, 1],
      [2, 0, 0, 0, 2, 2, 2, 0, 0, 1, 1],
      [0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 1],
      [2, 0, 2, 1, 1, 0, 1, 0, 0, 1, 0],
      [2, 1, 0, 0, 2, 0, 2, 1, 0, 1, 0],
      [1, 1, 2, 1, 0, 2, 0, 0, 1, 0, 0],
      [1, 2, 1, 0, 0, 1, 0, 0, 1, 0, 1],
      [0, 1, 2, 0, 2, 2, 0, 2, 0, 0, 1],
      [2, 1, 2, 1, 1, 2, 0, 0, 0, 0, 0],
      [1, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1],
      [1, 1, 0, 0, 2, 0, 1, 1, 0, 0, 1],
      [2, 0, 2, 1, 0, 0, 0, 2, 1, 0, 1],
      [2, 0, 1, 0, 1, 0, 2, 0, 1, 1, 0],
      [1, 0, 2, 0, 1, 1, 0, 0, 0, 1, 1],
      [0, 2, 0, 2, 1, 0, 0, 0, 1, 1, 0],
      [1, 0, 0, 0, 0, 2, 0, 1, 1, 1, 0],
      [0, 2, 2, 0, 1, 2, 2, 1, 0, 0, 0],
      [1, 1, 0, 0, 1, 0, 0, 2, 0, 1, 1],
      [2, 0, 2, 2, 2, 2, 0, 1, 0, 0, 0],
      [0, 2, 2, 2, 0, 2, 2, 2, 0, 0, 0],
      [0, 0, 0, 2, 1, 2, 1, 1, 0, 0, 1],
      [0, 1, 0, 0, 2, 0, 1, 1, 1, 1, 0],
      [2, 1, 1, 0, 2, 1, 0, 1, 0, 0, 0],
      [0, 1, 2, 1, 0, 2, 0, 0, 0, 1, 1],
      [2, 2, 2, 0, 1, 0, 0, 0, 0, 1, 0],
      [2, 0, 2, 0, 0, 2, 1, 0, 1, 0, 0],
      [1, 1, 2, 1, 0, 0, 1, 0, 0, 1, 0],
      [1, 0, 2, 2, 0, 1, 2, 2, 0, 0, 0],
      [1, 0, 0, 2, 0, 0, 2, 2, 0, 1, 1],
      [1, 0, 0, 2, 1, 0, 1, 2, 1, 0, 0],
      [0, 0, 2, 1, 0, 1, 2, 0, 0, 1, 1],
      [0, 1, 2, 0, 2, 0, 1, 1, 0, 0, 0],
      [0, 1, 0, 1, 1, 2, 0, 0, 1, 1, 0],
      [2, 2, 0, 0, 1, 1, 0, 0, 1, 0, 1],
      [1, 2, 0, 0, 0, 2, 1, 2, 1, 0, 0],
      [2, 0, 1, 1, 1, 0, 0, 2, 0, 1, 0],
      [1, 1, 0, 0, 2, 2, 0, 1, 0, 1, 0],
      [0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 1],
      [1, 2, 0, 2, 0, 1, 2, 0, 0, 0, 1],
      [1, 0, 0, 1, 1, 0, 0, 2, 1, 0, 1],
      [2, 0, 0, 1, 1, 1, 0, 0, 1, 1, 0],
      [1, 0, 2, 1, 0, 1, 0, 0, 0, 1, 0],
      [0, 1, 0, 2, 2, 1, 0, 0, 0, 1, 0],
      [1, 0, 2, 1, 1, 1, 2, 0, 0, 0, 0],
      [0, 2, 0, 2, 0, 0, 2, 1, 1, 0, 1],
      [0, 1, 1, 2, 1, 2, 0, 1, 0, 0, 0],
      [2, 1, 0, 1, 0, 0, 1, 2, 0, 0, 1],
      [0, 0, 0, 1, 2, 2, 1, 2, 1, 0, 0],
      [2, 2, 0, 0, 1, 2, 2, 2, 0, 0, 0],
      [0, 1, 2, 0, 0, 1, 2, 1, 1, 0, 0],
      [0, 1, 0, 0, 1, 1, 2, 1, 0, 0, 0],
      [1, 1, 1, 0, 2, 1, 2, 0, 0, 0, 0],
      [1, 2, 0, 0, 0, 2, 0, 1, 0, 1, 1],
      [1, 0, 1, 0, 2, 0, 2, 1, 0, 0, 0],
      [2, 0, 0, 2, 0, 0, 1, 0, 1, 1, 1],
      [0, 1, 1, 0, 1, 0, 0, 2, 1, 0, 1],
      [2, 1, 1, 0, 1, 0, 0, 0, 0, 0, 1],
      [2, 1, 1, 0, 0, 0, 1, 2, 0, 0, 0],
      [2, 2, 1, 2, 1, 0, 0, 0, 1, 0, 0],
      [1, 0, 2, 2, 1, 0, 0, 2, 0, 1, 0],
      [0, 2, 1, 0, 0, 2, 0, 2, 0, 1, 1],
      [0, 0, 0, 1, 1, 0, 2, 1, 1, 0, 1],
      [0, 0, 2, 0, 1, 0, 2, 1, 0, 0, 1],
      [0, 1, 1, 0, 2, 2, 1, 0, 0, 1, 0],
      [1, 0, 2, 2, 0, 2, 0, 2, 1, 0, 0],
      [0, 1, 2, 2, 1, 2, 0, 0, 1, 0, 0],
      [0, 2, 0, 2, 0, 1, 1, 1, 0, 1, 0],
      [2, 0, 2, 1, 0, 1, 2, 0, 1, 0, 0],
      [2, 2, 0, 2, 1, 2, 0, 1, 0, 0, 0],
      [1, 0, 0, 0, 2, 0, 1, 0, 1, 1, 0],
      [1, 2, 1, 0, 2, 2, 0, 1, 0, 0, 0],
      [2, 0, 0, 1, 0, 2, 0, 1, 0, 0, 1],
      [2, 0, 1, 2, 0, 0, 0, 0, 1, 0, 1],
      [2, 2, 0, 0, 0, 0, 1, 2, 0, 1, 1],
      [1, 0, 2, 0, 0, 2, 0, 1, 1, 0, 1],
      [0, 1, 0, 0, 1, 2, 2, 2, 1, 0, 0],
      [0, 2, 0, 1, 2, 1, 0, 0, 1, 0, 0],
      [1, 1, 1, 0, 2, 0, 0, 2, 0, 1, 0],
      [1, 0, 1, 2, 0, 2, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 2, 1, 2, 1, 1, 1],
      [1, 1, 0, 2, 2, 2, 0, 0, 1, 0, 0],
      [1, 0, 1, 2, 2, 0, 0, 2, 0, 0, 0],
      [0, 1, 2, 0, 2, 1, 2, 0, 0, 0, 1],
      [2, 0, 0, 2, 0, 1, 2, 1, 0, 0, 0],
      [2, 0, 1, 0, 0, 2, 1, 0, 0, 0, 1],
      [2, 1, 0, 2, 2, 0, 1, 0, 0, 1, 0],
      [0, 2, 1, 2, 2, 0, 0, 0, 1, 0, 1],
      [0, 2, 1, 2, 1, 1, 1, 0, 0, 0, 0],
      [1, 1, 2, 2, 0, 2, 0, 1, 0, 0, 0],
      [0, 2, 0, 1, 2, 1, 0, 1, 0, 0, 1],
      [1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
      [1, 0, 1, 2, 0, 1, 0, 1, 0, 0, 1],
      [1, 0, 0, 1, 2, 0, 1, 0, 0, 0, 1],
      [1, 0, 2, 0, 0, 2, 2, 1, 0, 1, 0],
      [0, 1, 1, 0, 2, 2, 0, 0, 1, 0, 0],
      [0, 1, 0, 1, 2, 0, 0, 2, 1, 0, 1],
      [0, 1, 0, 0, 1, 0, 2, 1, 0, 1, 1],
      [0, 1, 0, 2, 1, 0, 2, 2, 0, 1, 0],
      [0, 0, 0, 1, 0, 2, 1, 1, 1, 1, 0],
      [0, 0, 2, 1, 1, 0, 1, 2, 0, 0, 0],
      [0, 2, 1, 0, 1, 0, 1, 1, 0, 0, 1],
      [0, 2, 2, 1, 0, 0, 2, 0, 1, 0, 1],
      [2, 0, 1, 2, 1, 1, 2, 0, 0, 0, 0],
      [2, 0, 2, 0, 2, 0, 0, 1, 1, 0, 1],
      [2, 2, 1, 1, 0, 2, 2, 0, 0, 0, 0],
      [2, 2, 0, 0, 1, 0, 2, 0, 0, 1, 1],
      [2, 2, 0, 0, 0, 2, 2, 1, 1, 0, 0],
    ] as const,
    systemType: 'U',
    systemNum: 81,
    hasXpert: true,
  } as const,
  'U9-2-202': {
    guaranty: undefined,
    numFullHedges: 9,
    numHalfHedges: 2,
    rows: [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [2, 2, 0, 0, 1, 0, 1, 2, 1, 0, 0],
      [0, 0, 2, 2, 2, 1, 2, 0, 0, 1, 0],
      [1, 0, 1, 1, 0, 2, 0, 1, 2, 0, 0],
      [1, 1, 0, 0, 1, 2, 0, 0, 0, 1, 1],
      [0, 1, 0, 2, 0, 0, 1, 1, 2, 1, 0],
      [0, 0, 2, 0, 2, 0, 0, 2, 2, 0, 1],
      [0, 2, 1, 0, 0, 1, 2, 0, 1, 0, 1],
      [2, 0, 0, 1, 0, 0, 2, 2, 0, 1, 1],
      [1, 2, 0, 2, 0, 1, 1, 0, 0, 0, 0],
      [2, 1, 2, 1, 2, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 2, 1, 0, 2, 1, 1, 0, 1],
      [2, 0, 0, 0, 0, 1, 0, 1, 1, 1, 0],
      [0, 2, 2, 1, 0, 2, 2, 2, 0, 0, 0],
      [1, 2, 0, 0, 2, 0, 2, 1, 0, 1, 0],
      [1, 0, 2, 1, 0, 0, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 1, 1, 1, 1, 0, 0, 0],
      [2, 0, 0, 1, 1, 1, 0, 0, 2, 0, 1],
      [0, 2, 1, 2, 1, 0, 0, 0, 2, 0, 0],
      [2, 0, 1, 0, 2, 2, 1, 0, 0, 0, 1],
      [1, 1, 0, 1, 0, 1, 0, 2, 1, 0, 0],
      [0, 0, 1, 0, 1, 2, 1, 0, 1, 1, 0],
      [0, 0, 1, 1, 0, 2, 0, 0, 0, 1, 1],
      [2, 1, 1, 0, 0, 0, 1, 2, 0, 1, 0],
      [2, 2, 2, 0, 1, 2, 0, 1, 0, 0, 0],
      [2, 1, 1, 2, 0, 2, 2, 0, 0, 0, 0],
      [0, 2, 0, 0, 1, 1, 0, 2, 0, 0, 1],
      [0, 0, 2, 0, 0, 1, 1, 2, 2, 1, 0],
      [1, 0, 0, 0, 0, 2, 1, 1, 1, 0, 1],
      [1, 1, 2, 0, 0, 0, 2, 0, 0, 0, 1],
      [0, 2, 0, 2, 0, 0, 0, 2, 1, 1, 1],
      [1, 0, 1, 0, 2, 1, 0, 2, 0, 1, 0],
      [0, 0, 0, 1, 2, 2, 0, 2, 2, 1, 0],
      [0, 2, 0, 1, 2, 0, 2, 0, 1, 0, 0],
      [0, 2, 2, 1, 1, 0, 1, 0, 0, 0, 1],
      [0, 2, 0, 0, 2, 0, 1, 0, 2, 1, 1],
      [2, 0, 2, 1, 0, 1, 1, 1, 0, 0, 0],
      [1, 0, 1, 2, 1, 0, 1, 2, 0, 0, 0],
      [1, 0, 1, 2, 0, 0, 0, 0, 1, 0, 1],
      [1, 1, 0, 1, 1, 0, 1, 0, 2, 0, 0],
      [2, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1],
      [0, 1, 0, 1, 0, 1, 2, 1, 0, 0, 1],
      [0, 0, 1, 2, 2, 0, 0, 1, 1, 1, 0],
      [1, 2, 2, 0, 2, 1, 0, 0, 2, 0, 0],
      [1, 1, 0, 2, 2, 2, 0, 1, 0, 0, 0],
      [2, 0, 0, 0, 2, 1, 2, 2, 2, 0, 0],
      [2, 2, 2, 0, 0, 1, 0, 0, 0, 1, 1],
      [0, 2, 1, 0, 2, 2, 0, 2, 1, 0, 0],
      [2, 0, 2, 2, 0, 2, 0, 2, 1, 0, 0],
      [1, 2, 1, 0, 0, 0, 2, 2, 2, 0, 0],
      [2, 2, 0, 0, 0, 0, 0, 1, 2, 0, 1],
      [2, 1, 0, 2, 1, 0, 0, 0, 1, 1, 0],
      [0, 1, 1, 1, 1, 0, 2, 0, 0, 1, 0],
      [0, 1, 0, 2, 0, 2, 0, 0, 2, 0, 1],
      [0, 1, 0, 2, 2, 0, 1, 2, 0, 0, 1],
      [1, 0, 0, 2, 0, 2, 2, 0, 2, 1, 0],
      [2, 0, 2, 0, 1, 0, 2, 0, 2, 1, 0],
      [1, 2, 2, 2, 0, 0, 2, 0, 0, 1, 0],
      [2, 2, 2, 2, 0, 0, 1, 0, 1, 0, 0],
      [2, 0, 2, 0, 1, 0, 1, 0, 1, 0, 1],
      [1, 2, 1, 0, 0, 2, 0, 0, 1, 1, 0],
      [2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 1],
      [0, 2, 1, 2, 0, 2, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 0, 1, 2, 0, 2, 0, 0],
      [0, 0, 0, 1, 0, 0, 2, 1, 1, 1, 0],
      [0, 1, 0, 2, 2, 1, 0, 2, 2, 0, 0],
      [0, 0, 0, 1, 1, 2, 1, 1, 0, 0, 0],
      [1, 0, 2, 0, 1, 1, 2, 2, 0, 0, 0],
      [0, 1, 2, 2, 0, 2, 0, 2, 0, 1, 0],
      [0, 0, 0, 1, 1, 1, 0, 1, 0, 1, 1],
      [1, 2, 0, 1, 0, 0, 1, 1, 1, 0, 0],
      [0, 2, 2, 0, 1, 2, 0, 0, 1, 0, 1],
      [0, 0, 2, 0, 0, 2, 0, 2, 1, 1, 1],
      [2, 2, 0, 0, 0, 2, 2, 2, 0, 1, 0],
      [0, 2, 0, 2, 1, 0, 2, 2, 0, 0, 0],
      [1, 0, 0, 0, 2, 0, 2, 0, 2, 0, 1],
      [1, 0, 2, 0, 0, 0, 2, 1, 1, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 1, 2, 1, 1],
      [0, 0, 0, 1, 2, 1, 0, 2, 1, 0, 1],
      [0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 0],
      [0, 2, 1, 0, 0, 0, 1, 2, 0, 0, 1],
      [0, 2, 0, 0, 2, 1, 0, 1, 2, 1, 0],
      [2, 0, 1, 1, 1, 1, 0, 2, 0, 0, 0],
      [2, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1],
      [0, 2, 2, 0, 1, 2, 2, 0, 0, 1, 0],
      [0, 2, 1, 2, 2, 2, 0, 0, 0, 1, 0],
      [0, 1, 2, 0, 1, 0, 2, 2, 1, 0, 0],
      [1, 0, 0, 0, 0, 1, 0, 2, 2, 0, 1],
      [0, 0, 2, 1, 1, 2, 0, 0, 2, 0, 0],
      [2, 2, 0, 1, 0, 2, 0, 2, 2, 0, 0],
      [0, 1, 1, 1, 0, 0, 0, 2, 1, 1, 0],
      [2, 0, 2, 2, 2, 0, 2, 1, 0, 0, 0],
      [1, 0, 1, 1, 2, 0, 0, 1, 0, 0, 1],
      [0, 1, 0, 0, 1, 1, 2, 0, 2, 1, 0],
      [0, 1, 2, 1, 0, 1, 0, 0, 1, 0, 1],
      [2, 1, 0, 0, 2, 1, 0, 0, 1, 0, 1],
      [0, 0, 2, 1, 0, 0, 2, 2, 1, 0, 1],
      [0, 0, 2, 2, 2, 0, 1, 2, 1, 0, 0],
      [0, 0, 0, 0, 1, 0, 1, 2, 1, 1, 1],
      [2, 0, 2, 0, 2, 0, 0, 2, 1, 1, 0],
      [1, 0, 0, 2, 2, 1, 0, 0, 1, 0, 0],
      [0, 0, 2, 0, 0, 0, 0, 1, 0, 1, 0],
      [2, 1, 1, 2, 0, 0, 0, 1, 1, 0, 0],
      [1, 2, 1, 1, 1, 2, 0, 0, 0, 0, 0],
      [0, 1, 2, 2, 0, 1, 1, 0, 2, 0, 0],
      [0, 2, 2, 2, 0, 0, 0, 1, 0, 0, 1],
      [0, 1, 0, 0, 0, 0, 2, 2, 2, 1, 1],
      [1, 0, 0, 2, 1, 1, 2, 0, 0, 0, 1],
      [2, 2, 0, 1, 0, 0, 1, 0, 0, 1, 0],
      [2, 1, 0, 0, 0, 2, 1, 0, 1, 1, 0],
      [2, 1, 1, 0, 0, 1, 0, 0, 2, 1, 0],
      [0, 1, 1, 0, 2, 0, 1, 0, 1, 0, 0],
      [2, 0, 0, 2, 0, 2, 1, 2, 0, 0, 1],
      [2, 1, 0, 1, 0, 0, 0, 0, 2, 1, 1],
      [0, 0, 0, 0, 2, 1, 1, 1, 2, 0, 1],
      [0, 1, 2, 2, 2, 0, 0, 0, 0, 1, 1],
      [1, 1, 2, 0, 2, 2, 1, 0, 0, 0, 0],
      [1, 1, 2, 0, 1, 0, 0, 2, 0, 1, 0],
      [0, 1, 2, 0, 0, 2, 1, 1, 1, 0, 0],
      [1, 0, 2, 1, 0, 2, 0, 2, 0, 0, 1],
      [1, 2, 0, 1, 1, 0, 0, 0, 1, 0, 1],
      [2, 0, 0, 0, 2, 2, 0, 0, 2, 1, 1],
      [1, 0, 0, 1, 2, 0, 2, 2, 0, 0, 0],
      [1, 0, 1, 1, 2, 0, 0, 0, 2, 1, 0],
      [2, 1, 0, 0, 2, 0, 1, 1, 2, 0, 0],
      [0, 2, 0, 0, 0, 1, 1, 1, 0, 1, 1],
      [2, 0, 2, 0, 2, 2, 2, 0, 1, 0, 0],
      [2, 0, 1, 2, 0, 1, 0, 1, 0, 0, 1],
      [1, 0, 0, 0, 2, 1, 1, 0, 0, 1, 1],
      [1, 1, 2, 2, 0, 0, 1, 1, 0, 0, 0],
      [2, 0, 1, 2, 2, 0, 0, 2, 2, 0, 0],
      [0, 2, 2, 1, 1, 0, 0, 0, 1, 1, 0],
      [0, 2, 0, 1, 2, 1, 1, 2, 0, 0, 0],
      [0, 1, 2, 0, 2, 1, 0, 0, 1, 1, 0],
      [0, 0, 2, 1, 1, 0, 1, 2, 0, 1, 0],
      [0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0],
      [2, 0, 1, 1, 0, 0, 1, 2, 1, 0, 0],
      [1, 0, 2, 2, 0, 0, 0, 2, 2, 1, 0],
      [1, 0, 1, 0, 0, 0, 1, 0, 2, 1, 1],
      [1, 0, 0, 1, 1, 2, 2, 0, 1, 0, 0],
      [0, 2, 2, 0, 1, 0, 1, 1, 2, 0, 0],
      [0, 1, 0, 2, 1, 2, 1, 0, 0, 1, 0],
      [1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0],
      [1, 0, 0, 2, 0, 0, 0, 1, 0, 1, 1],
      [1, 1, 1, 0, 1, 0, 0, 1, 2, 0, 0],
      [1, 2, 0, 0, 0, 0, 2, 0, 1, 1, 1],
      [2, 0, 0, 0, 1, 2, 2, 1, 0, 0, 1],
      [2, 1, 0, 1, 0, 2, 0, 1, 0, 1, 0],
      [2, 2, 1, 0, 2, 0, 2, 0, 0, 0, 0],
      [0, 0, 1, 2, 1, 0, 1, 0, 0, 1, 1],
      [0, 2, 0, 1, 0, 2, 1, 0, 1, 0, 1],
      [1, 0, 0, 2, 1, 2, 0, 2, 2, 0, 0],
      [0, 0, 1, 2, 1, 2, 0, 2, 0, 0, 1],
      [0, 2, 0, 0, 0, 2, 2, 1, 2, 0, 0],
      [0, 1, 2, 1, 0, 0, 2, 1, 2, 0, 0],
      [2, 1, 0, 2, 0, 0, 2, 2, 2, 0, 0],
      [0, 0, 1, 1, 0, 0, 1, 1, 2, 0, 1],
      [0, 1, 1, 0, 1, 1, 0, 0, 2, 0, 1],
      [1, 2, 1, 0, 1, 0, 1, 0, 0, 1, 0],
      [0, 0, 2, 0, 1, 1, 0, 1, 1, 0, 0],
      [1, 0, 0, 0, 1, 2, 1, 2, 0, 1, 0],
      [0, 0, 1, 0, 2, 2, 2, 1, 0, 1, 0],
      [2, 0, 0, 1, 2, 2, 1, 0, 2, 0, 0],
      [1, 2, 1, 0, 0, 2, 0, 1, 0, 0, 1],
      [2, 1, 0, 0, 2, 0, 0, 2, 0, 1, 1],
      [0, 2, 0, 2, 0, 1, 0, 1, 1, 0, 0],
      [0, 1, 0, 0, 1, 2, 1, 2, 2, 0, 0],
      [1, 2, 1, 1, 0, 0, 0, 1, 0, 1, 0],
      [2, 0, 1, 1, 1, 0, 2, 0, 0, 0, 1],
      [2, 0, 0, 2, 2, 0, 1, 2, 0, 1, 0],
      [0, 0, 0, 1, 1, 0, 2, 0, 2, 1, 1],
      [2, 0, 0, 2, 0, 0, 1, 0, 1, 1, 1],
      [0, 1, 2, 0, 0, 2, 1, 0, 0, 1, 1],
      [0, 0, 1, 0, 2, 0, 2, 0, 1, 1, 1],
      [0, 0, 2, 1, 2, 2, 2, 0, 0, 0, 1],
      [0, 0, 1, 0, 2, 1, 2, 2, 0, 0, 1],
      [0, 1, 2, 0, 2, 2, 0, 1, 0, 0, 1],
      [0, 1, 0, 0, 2, 1, 2, 1, 1, 0, 0],
      [2, 0, 1, 2, 0, 1, 1, 0, 0, 1, 0],
      [0, 0, 1, 2, 0, 0, 2, 2, 0, 1, 0],
      [1, 2, 2, 0, 0, 0, 0, 2, 1, 0, 1],
      [2, 2, 1, 0, 1, 1, 0, 0, 1, 0, 0],
      [2, 2, 1, 0, 0, 2, 1, 0, 2, 0, 0],
      [0, 2, 1, 0, 0, 0, 1, 1, 1, 1, 0],
      [0, 0, 0, 2, 0, 2, 1, 2, 1, 1, 0],
      [2, 0, 0, 1, 1, 0, 0, 1, 2, 1, 0],
      [2, 1, 2, 0, 0, 1, 0, 2, 0, 0, 0],
      [2, 0, 2, 2, 1, 2, 0, 0, 0, 1, 0],
      [0, 2, 1, 1, 2, 1, 0, 0, 0, 0, 1],
      [1, 0, 1, 0, 1, 1, 1, 0, 2, 0, 0],
      [0, 2, 0, 2, 0, 2, 2, 0, 0, 1, 1],
      [2, 0, 2, 0, 0, 1, 2, 0, 2, 0, 1],
      [1, 2, 2, 2, 2, 0, 0, 2, 0, 0, 0],
      [1, 0, 2, 1, 1, 0, 0, 0, 0, 1, 1],
      [1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1],
      [0, 0, 1, 0, 1, 0, 0, 2, 2, 1, 0],
      [0, 0, 0, 2, 1, 2, 0, 0, 1, 1, 1],
      [1, 1, 1, 1, 0, 0, 2, 0, 1, 0, 0],
      [1, 1, 0, 0, 0, 2, 0, 2, 2, 1, 0],
      [1, 0, 2, 1, 1, 0, 0, 2, 1, 0, 0],
      [1, 2, 0, 0, 1, 0, 1, 1, 0, 0, 1],
      [0, 1, 0, 0, 1, 2, 0, 1, 1, 1, 0],
    ] as const,
    systemType: 'U',
    systemNum: 82,
    hasXpert: true,
  } as const,
} as const;
